import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
  createContext,
  memo,
} from "react";
import styles from "./style.module.scss";
import KPIBubbleChart from "../../components/WelcomePage/KPIBubbleChart";
import KPILineChart from "../../components/WelcomePage/KPILineChart";
import KPIDoughnutChart from "../../components/WelcomePage/KPIDoughnutChart";
import WelcomeReviewStatisticsChart, {
  normalizeWelcomeReviewStatisticsPayload,
} from "../../components/WelcomePage/WelcomeReviewStatisticsChart";
import WelcomeBrandKpiHeroCard from "../../components/WelcomePage/WelcomeBrandKpiHeroCard";
import WelcomeBrandKpiHeroTopicTabs from "../../components/WelcomePage/WelcomeBrandKpiHeroTopicTabs";
import {
  resolveBrandKpiHeroHeader,
  welcomeWidgetUsesBrandKpiHero,
  welcomeWidgetUsesDoubleGridColumn,
  WELCOME_WIDGET_SCOPE_REVIEW_METRIC_IDS,
} from "../../components/WelcomePage/welcomeBrandKpiHero";
import WelcomeTabReviewCountButton from "../../components/WelcomePage/WelcomeTabReviewCountButton";
import WelcomeDualSentimentDoughnutCharts from "../../components/WelcomePage/WelcomeDualSentimentDoughnutCharts";
import WelcomeDualIntentDoughnutCharts from "../../components/WelcomePage/WelcomeDualIntentDoughnutCharts";
import KPIBarChart from "../../components/WelcomePage/KPIBarChart";
import KPIStackedBarChart from "../../components/WelcomePage/KPIStackedBarChart";
import WelcomeTopicSentimentBarChart from "../../components/WelcomePage/WelcomeTopicSentimentBarChart";
import WelcomeTopicParticipationBarChart from "../../components/WelcomePage/WelcomeTopicParticipationBarChart";
import WelcomeTopicIntentBarChart from "../../components/WelcomePage/WelcomeTopicIntentBarChart";
import VOCScoreChart from "../../components/WelcomePage/VOCScoreChart";
import { useHistory, useLocation, Link } from "react-router-dom";
import { notification, message } from "antd";
import { UNLOGGED } from "util/constants";
import { apiRequest } from "util/services";
import {
  appendWorkspaceUserId,
  applyWorkspaceUserIdToSearchParams,
  buildWorkspaceGroupsUrl,
  buildWorkspaceArchivedGroupsUrl,
  getEffectiveWorkspaceUserId,
  readWorkspaceUserIdFromSearch,
} from "util/workspaceOwner";
import { readWorkspaceDeepLinkFromSearch } from "util/workspaceDeepLink";
import {
  useQueries,
  useQuery,
  useQueryClient,
  useMutation,
} from "@tanstack/react-query";
import {
  welcomeWidgetKeys,
  fetchWelcomeWidgetData,
  fetchWelcomeGroupWidgetsData,
  buildWelcomeGroupWidgetsBatchPayload,
  seedWelcomeWidgetMainDataFromBatch,
  buildWelcomeWidgetDataKpiPayload,
  buildWelcomeWidgetMainFetchPayload,
  getWelcomeWidgetKpiQueryKey,
  welcomeWidgetUsesLazyTopicTabs,
  mergeWelcomePartialTopicData,
  mergeWelcomeWidgetRowDataWithKpiEnvelope,
  refetchWelcomeWidgetMainData,
  clearWelcomeWidgetMainDataCache,
  useWelcomeWidgetCache,
} from "queries/welcomeWidgetData";
import {
  WelcomeWidgetDataStateMessage,
  WelcomeWidgetGenaiPendingState,
  WelcomeWidgetInsufficientOrEmpty,
  WELCOME_WIDGET_DATA_STATUS_EMPTY,
  WELCOME_WIDGET_DATA_STATUS_FAILED,
  WELCOME_WIDGET_DATA_STATUS_INSUFFICIENT,
  isWelcomeGenAiContentMetricWidget,
  resolveWelcomeWidgetDataState,
  welcomeKpiErrorMeansNoData,
  welcomeGenaiRegenerateSkipsCreditCharge,
  resolveWelcomeInsufficientReviewCounts,
  welcomeRegenerateSkipsQuotaCheck,
  welcomeWidgetShowsEmptyGenaiSignal,
  welcomeWidgetFailedJobShowsContentState,
  welcomeWidgetJobErrorIsEmptyGenaiSignal,
  welcomeWidgetJobErrorIsInsufficientData,
} from "pages/Welcome/welcomeWidgetDataState";
import {
  formatWelcomeWidgetDuration,
  getWelcomeWidgetJobProgressClassNames,
  mergeWelcomeWidgetJobTimingFields,
  WelcomeWidgetStatusTiming,
} from "pages/Welcome/welcomeWidgetJobTiming";
import { downloadOrgLlmPromptsCsv } from "pages/Welcome/downloadOrgLlmPromptsCsv";
import { fetchWelcomeWidgetMetricReviews } from "queries/welcomeWidgetMetricReviews";
import {
  mergeWidgetInfoPayload,
  resolveWidgetInfoDisplayName,
  resolveWidgetInfoMetricTypeName,
  welcomeMetricNameLooksStaleForId,
} from "pages/Welcome/welcomeWidgetInfoLabels";
import {
  formatWelcomePivotFilterBooleanExpr,
  welcomePivotFilterFromWidget,
  resolveWelcomeWidgetPivotFilter,
} from "pages/Welcome/welcomePivotBooleanLogic";
import {
  formatWelcomeReviewScopeLabel,
  isWelcomeGenaiReviewScopeCapped,
  resolveWelcomeDisplayReviewCount,
  resolveWelcomeReviewScopeFromData,
  WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
} from "pages/Welcome/welcomeReviewScopeLabel";
import {
  formatWelcomeAiCreditBreakdown,
  resolveQuotaNotApplicableMessage,
  resolveWelcomeQuotaDisplayCredits,
  welcomeAiCreditsInsufficient,
  welcomeGenaiReviewsInsufficient,
  welcomeRegenerateCanProceedWithoutQuotaModal,
} from "util/quotaCheckDisplay";
import {
  trackWelcomePageViewed,
  trackWelcomeWidgetRegenerated,
  trackWelcomeWidgetAction,
  trackWelcomeReviewsOpened,
} from "util/productAnalytics";
import { useEngagementQueryFilterTracking } from "util/useEngagementQueryFilterTracking";
import { useDispatch, useSelector } from "react-redux";
import DateFilterPopUp from "../../components/Dashboard/DateFilter/index";
import {
  Layout,
  Row,
  Col,
  Card,
  Button,
  Tooltip,
  Select,
  Space,
  Input,
  Modal,
  Spin,
  Skeleton,
  List,
  Table,
  Radio,
  DatePicker,
  Dropdown,
  Tag,
  Badge,
  Alert,
  Tabs,
  Checkbox,
} from "antd";
import moment from "moment";
import { getIntlLocale } from "util/locale";
import { formatAppDate, formatAppDateTime } from "util/formatAppDate";
import { useTranslation, Trans } from "react-i18next";
import {
  EditOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  CreditCardOutlined,
  FileTextOutlined,
  DeleteOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  FolderAddOutlined,
  CalendarOutlined,
  PieChartOutlined,
  BarChartOutlined,
  PlayCircleOutlined,
  CopyOutlined,
  CheckOutlined,
  RobotOutlined,
} from "@ant-design/icons";

import {
  FileDoneOutlined,
  FilePdfOutlined,
  DownloadOutlined,
  ThunderboltOutlined,
  ClockCircleOutlined,
  DatabaseOutlined,
  DashboardOutlined,
  TeamOutlined,
  InfoCircleOutlined,
  AlertOutlined,
  LineChartOutlined,
  UnorderedListOutlined,
  TableOutlined,
  CalendarFilled,
  MoreOutlined,
  FilterOutlined,
  ReloadOutlined,
  SyncOutlined,
  LeftOutlined,
  RightOutlined,
  DownOutlined,
  InboxOutlined,
  StarOutlined,
  SmileOutlined,
  LikeOutlined,
  BulbOutlined,
  RiseOutlined,
  FireOutlined,
  MessageOutlined,
  AimOutlined,
  HighlightOutlined,
  SearchOutlined,
  FundOutlined,
  RadarChartOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  SwapOutlined,
  HolderOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import dayjs from "dayjs";
import WelcomeReviewsDrawerHost, {
  WelcomeReviewsDrawerRefContext,
} from "pages/Welcome/WelcomeReviewsDrawerHost";
import { collectGenaiItemReviewIds } from "pages/Welcome/welcomeGenaiReviewIds";
import { renderWelcomeGenaiInlineMarkdown } from "pages/Welcome/welcomeGenaiInlineMarkdown";
import {
  sortWelcomeGroupWidgets,
  withWelcomeWidgetDisplayOrder,
} from "pages/Welcome/welcomeWidgetOrder";
import { extractWelcomeReviewsFromApiResponse } from "pages/Welcome/welcomeDrawerReviewDoc";
import {
  isGenericWelcomeTopicTabLabel,
  resolveWelcomeReviewsDrawerTopicTitle,
} from "pages/Welcome/welcomeReviewsDrawerTitle";
import { StatusUpdateComponent } from "pages/Dashboard/TopProblems";
import { useCopilotShell } from "contexts/CopilotShellContext";
import { useEnterprisePowerUser } from "hooks/useEnterprisePowerUser";
import SearchableTopicChecklist from "helperComponents/SearchableTopicChecklist";
import WelcomePivotWizardStep, {
  WelcomePivotCompressedStepper,
} from "./WelcomePivotWizardStep";
import { Braces, PanelLeft, Sparkles, Wand2 } from "lucide-react";

import { WelcomeHighlightsStructuredBody } from "./welcomeHighlightsStructured";
import WelcomeHighlightsInsightDashboard from "./WelcomeHighlightsInsightDashboard";
import PivonyInsightWidget from "components/WelcomePage/PivonyInsightWidget";
import {
  WelcomeGenaiFeedback,
  welcomeWidgetSupportsGenaiFeedback,
} from "components/WelcomePage/WelcomeGenaiFeedback";
import GroupConfigureEmptyState from "components/WelcomePage/GroupConfigureEmptyState";
import { getPromptVariableGroupsForMetric } from "./promptVariables";
import { PromptUnknownTokensNote } from "./PromptUnknownTokensNote";
import { PromptMapReduceAccordion } from "components/WelcomePage/PromptMapReduceAccordion";
import HighlightMetric25TabEditorPane from "./HighlightMetric25TabEditorPane";
import KeyDriverMetric23TabEditorPane from "./KeyDriverMetric23TabEditorPane";
import WelcomeMarketIntelligencePlanGate from "./WelcomeMarketIntelligencePlanGate";
import {
  hasMarketIntelligencePlan,
} from "util/marketIntelligenceAccess";

const { Content } = Layout;

const welcomeWidgetJobProgressClassNames =
  getWelcomeWidgetJobProgressClassNames(styles);

/** Workspace widget card inner render: theme, i18n, setters, topic-tab loader (see WelcomeWidgetRenderBody). */
const WelcomeWorkspaceWidgetRenderContext = createContext(null);

/** Matches API — only Root Cause (20) uses table. */
export const WELCOME_GENAI_TABLE_METRIC_IDS = new Set([20]);

/** Fallback until welcome/groups/all returns workspace_limits. */
const DEFAULT_WORKSPACE_WIDGET_LIMITS = {
  max_widgets: 0,
  total_widgets: 0,
  remaining_widgets: 0,
  limit_reached: false,
};

const WORKSPACE_GROUP_DOM_ID_PREFIX = "workspace-group-";
const WORKSPACE_WIDGET_DOM_ID_PREFIX = "workspace-widget-";

const workspaceGroupDomId = (groupId) =>
  `${WORKSPACE_GROUP_DOM_ID_PREFIX}${groupId}`;

const workspaceWidgetDomId = (widgetId) =>
  `${WORKSPACE_WIDGET_DOM_ID_PREFIX}${widgetId}`;

/** Ant Design Select may emit string values; group ids from the API are numeric. */
const normalizeWorkspaceGroupId = (groupId) => {
  if (groupId == null || groupId === "") return null;
  const asNumber = Number(groupId);
  return Number.isFinite(asNumber) ? asNumber : groupId;
};

const workspaceGroupIdsMatch = (a, b) =>
  normalizeWorkspaceGroupId(a) === normalizeWorkspaceGroupId(b);

const WORKSPACE_SCROLL_CONTAINER_SELECTOR = ".consoleLayoutRoot-content";
const WORKSPACE_GROUP_SCROLL_OFFSET = 88;
const WORKSPACE_WIDGET_SCROLL_OFFSET = 96;

const getWorkspaceScrollContainer = () =>
  document.querySelector(WORKSPACE_SCROLL_CONTAINER_SELECTOR);

const getScrollContainerForElement = (el) => {
  if (el) {
    let parent = el.parentElement;
    while (parent) {
      const { overflowY } = window.getComputedStyle(parent);
      if (
        /(auto|scroll|overlay)/.test(overflowY) &&
        parent.scrollHeight > parent.clientHeight
      ) {
        return parent;
      }
      parent = parent.parentElement;
    }
  }
  return getWorkspaceScrollContainer();
};

const scrollElementWithinWorkspaceContainer = (
  el,
  { behavior = "auto", block = "start", offset = WORKSPACE_GROUP_SCROLL_OFFSET } = {},
) => {
  if (!el) return false;

  const workspaceRoot = getWorkspaceScrollContainer();
  const scrollParent =
    workspaceRoot && workspaceRoot.contains(el)
      ? workspaceRoot
      : getScrollContainerForElement(el);
  if (scrollParent && scrollParent.contains(el)) {
    const parentRect = scrollParent.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    let nextTop =
      scrollParent.scrollTop + (elRect.top - parentRect.top) - offset;

    if (block === "center") {
      nextTop =
        scrollParent.scrollTop +
        (elRect.top - parentRect.top) -
        scrollParent.clientHeight / 2 +
        elRect.height / 2;
    }

    scrollParent.scrollTo({
      top: Math.max(0, nextTop),
      behavior,
    });
    return true;
  }

  el.scrollIntoView({
    behavior,
    block: block === "center" ? "center" : "start",
    inline: "nearest",
  });
  return true;
};

const scrollToWorkspaceGroupElement = (groupId, behavior = "smooth") => {
  const el = document.getElementById(workspaceGroupDomId(groupId));
  if (!el) return false;
  return scrollElementWithinWorkspaceContainer(el, {
    behavior,
    block: "start",
    offset: WORKSPACE_GROUP_SCROLL_OFFSET,
  });
};
const findWorkspaceWidgetElement = (widgetId) => {
  const normalizedWidgetId = Number(widgetId);
  if (!Number.isFinite(normalizedWidgetId) || normalizedWidgetId <= 0) {
    return null;
  }
  return (
    document.getElementById(workspaceWidgetDomId(normalizedWidgetId)) ||
    document.querySelector(`[data-widget-id="${normalizedWidgetId}"]`)
  );
};

const scrollToWorkspaceWidgetElement = (widgetId, behavior = "auto") => {
  const el = findWorkspaceWidgetElement(widgetId);
  if (!el) return false;
  return scrollElementWithinWorkspaceContainer(el, {
    behavior,
    block: "center",
    offset: WORKSPACE_WIDGET_SCROLL_OFFSET,
  });
};

const focusWorkspaceWidgetInGroup = (
  groupId,
  widgetId,
  behavior = "smooth",
) => {
  const normalizedGroupId = normalizeWorkspaceGroupId(groupId);
  if (normalizedGroupId == null || widgetId == null) return;

  const run = () => {
    scrollToWorkspaceGroupElement(normalizedGroupId, behavior);
    scrollToWorkspaceWidgetElement(widgetId, behavior);
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(run);
  });
};

const WORKSPACE_DEEP_LINK_HIGHLIGHT_MS = 5000;
let workspaceDeepLinkHighlightTimer = null;

const clearWorkspaceWidgetDeepLinkHighlights = () => {
  document
    .querySelectorAll("[data-workspace-deep-link-highlight='1']")
    .forEach((node) => {
      node.removeAttribute("data-workspace-deep-link-highlight");
      node.classList.remove(styles.widgetCardDeepLinkHighlight);
    });
};

const highlightWorkspaceWidgetElement = (
  widgetId,
  durationMs = WORKSPACE_DEEP_LINK_HIGHLIGHT_MS,
) => {
  const el = document.getElementById(workspaceWidgetDomId(widgetId));
  if (!el) return false;

  if (workspaceDeepLinkHighlightTimer) {
    clearTimeout(workspaceDeepLinkHighlightTimer);
    workspaceDeepLinkHighlightTimer = null;
  }
  clearWorkspaceWidgetDeepLinkHighlights();
  el.classList.add(styles.widgetCardDeepLinkHighlight);
  el.setAttribute("data-workspace-deep-link-highlight", "1");
  workspaceDeepLinkHighlightTimer = setTimeout(() => {
    el.classList.remove(styles.widgetCardDeepLinkHighlight);
    el.removeAttribute("data-workspace-deep-link-highlight");
    workspaceDeepLinkHighlightTimer = null;
  }, durationMs);
  return true;
};

const waitForWorkspaceWidgetElement = (
  widgetId,
  { timeoutMs = 15000, intervalMs = 100 } = {},
) =>
  new Promise((resolve) => {
    const startedAt = Date.now();
    const tick = () => {
      const el = findWorkspaceWidgetElement(widgetId);
      if (el) {
        resolve(el);
        return;
      }
      if (Date.now() - startedAt >= timeoutMs) {
        resolve(null);
        return;
      }
      setTimeout(tick, intervalMs);
    };
    tick();
  });

const focusWorkspaceDeepLinkTarget = async ({
  groupId = null,
  widgetId = null,
  behavior = "auto",
  onFocused = null,
} = {}) => {
  const normalizedWidgetId = Number(widgetId);
  if (!Number.isFinite(normalizedWidgetId) || normalizedWidgetId <= 0) {
    return false;
  }

  const normalizedGroupId =
    groupId != null ? normalizeWorkspaceGroupId(groupId) : null;
  if (normalizedGroupId != null) {
    scrollToWorkspaceGroupElement(normalizedGroupId, behavior);
  }

  const el = await waitForWorkspaceWidgetElement(normalizedWidgetId);
  if (!el) return false;

  scrollToWorkspaceWidgetElement(normalizedWidgetId, behavior);
  if (typeof onFocused === "function") {
    onFocused(normalizedWidgetId);
  }
  return true;
};

/** Matches API — hierarchical summary metrics (smart_narrative, representation_type 4). */
export const WELCOME_GENAI_NARRATIVE_METRIC_IDS = new Set([21, 23, 25]);

function WelcomeWidgetEmptyState({
  t,
  className,
  insufficientClassName,
  data,
  metricId,
  widgetRow,
}) {
  return (
    <WelcomeWidgetInsufficientOrEmpty
      data={data}
      metricId={metricId ?? widgetRow?.metric_id}
      widgetRow={widgetRow}
      t={t}
      className={className}
      insufficientClassName={insufficientClassName || styles.widgetInsufficientData}
    />
  );
}
/** Narrative metrics (repr 4): TabView when summary_tabs (or client fallback) has multiple tabs. */
export const WELCOME_HIERARCHICAL_SUMMARY_METRIC_IDS = new Set([21, 23, 25]);
/** Brand GenAI metrics: same multi-topic wizard step as General Summary (tabs = selected categories). */
const WELCOME_BRAND_MULTITOPIC_WIZARD_METRIC_IDS = new Set([20, 21, 23, 25]);
/** Sentiment / Intent Distribution: at least one industry topic is required. */
const WELCOME_BRAND_TOPIC_REQUIRED_METRIC_IDS = new Set([11, 12]);

function normalizeWelcomeIndustryTopicIds(topicIds) {
  return (topicIds || [])
    .map((x) => Number(x))
    .filter((n) => !Number.isNaN(n) && n > 0);
}

/** Topic ids for widget/create — GenAI metrics use AI topic step; 11/12 reuse it when optional topics empty. */
function resolveWelcomeBrandWidgetTopicIds(
  metricId,
  selectedBrandAiTopicIds,
  selectedBrandOptionalTopicIds,
) {
  const mid = Number(metricId);
  // The wizard has a single topic step that writes to exactly one of these arrays
  // depending on the selected-metric mix (AI array when any multitopic metric is
  // present, optional array otherwise). Since only one is ever populated, every
  // metric must fall back to whichever array holds the user's single selection —
  // otherwise metrics reading the "wrong" array end up with no topics.
  const ai = normalizeWelcomeIndustryTopicIds(selectedBrandAiTopicIds);
  const optional = normalizeWelcomeIndustryTopicIds(selectedBrandOptionalTopicIds);
  if (WELCOME_BRAND_MULTITOPIC_WIZARD_METRIC_IDS.has(mid)) {
    const ids = ai.length > 0 ? ai : optional;
    return ids.length > 0 ? ids : undefined;
  }
  const ids = optional.length > 0 ? optional : ai;
  return ids.length > 0 ? ids : undefined;
}

function selectedBrandMetricsNeedDistTopics(selectedBrandMetrics) {
  return [...selectedBrandMetrics].some((m) =>
    WELCOME_BRAND_TOPIC_REQUIRED_METRIC_IDS.has(Number(m)),
  );
}

function selectedBrandDistTopicIds(
  selectedBrandAiTopicIds,
  selectedBrandOptionalTopicIds,
) {
  const optional = normalizeWelcomeIndustryTopicIds(selectedBrandOptionalTopicIds);
  if (optional.length > 0) return optional;
  return normalizeWelcomeIndustryTopicIds(selectedBrandAiTopicIds);
}

/** Default widget representation per metric (wizard no longer asks the user). */
const WELCOME_METRIC_DEFAULT_PREFERED_VIEW = {
  8: "chart",
  9: "chart",
  10: "chart",
  29: "chart",
  11: "chart",
  12: "chart",
  13: "chart",
  14: "chart",
  15: "chart",
  16: "chart",
  17: "chart",
  18: "chart",
  19: "smart_narrative",
  27: "chart",
  28: "chart",
};

/** General Summary only: dedicated narrative layout on Welcome (repr 4). */
export const WELCOME_GENERAL_SUMMARY_METRIC_ID = 21;
export const GENERAL_SUMMARY_READ_MORE_MIN_CHARS = 220;

/**
 * When only one topic is in scope, avoid redundant "General" + topic tabs.
 * Returns one tab (the topic row) with body: topic content if non-empty, else general.
 */
export function mergeGeneralAndSingleTopicHierarchicalTabs(tabs) {
  const list = Array.isArray(tabs) ? tabs : [];
  if (list.length !== 2) {
    return list;
  }
  const lower = (id) => String(id ?? "").trim().toLowerCase();
  const isGeneralLike = (id) => {
    const x = lower(id);
    return x === "general" || x === "global";
  };
  const generalTab = list.find((t) => t && isGeneralLike(t.id));
  const topicTab = list.find((t) => t && !isGeneralLike(t.id));
  if (!generalTab || !topicTab) {
    return list;
  }
  const topicBody = String(topicTab.content ?? "").trim();
  const generalBody = String(generalTab.content ?? "").trim();
  const mergedBody = topicBody || generalBody;
  const mergedPending =
    Boolean(topicTab.content_pending || topicTab.payload_pending) ||
    Boolean(generalTab.content_pending || generalTab.payload_pending);
  return [
    {
      ...topicTab,
      content: mergedBody,
      content_pending: mergedPending,
      review_count:
        topicTab.review_count ??
        topicTab.reviewCount ??
        generalTab.review_count ??
        generalTab.reviewCount,
    },
  ];
}

export function WelcomeGeneralSummaryNarrative({
  narrative,
  widgetName,
  topicScopeLabels,
  data = null,
  widgetRow = null,
}) {
  const { t, i18n } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const singleTopicLabel = (() => {
    const labs = Array.isArray(topicScopeLabels)
      ? topicScopeLabels.filter((l) => l != null && String(l).trim() !== "")
      : [];
    if (labs.length !== 1) return null;
    return decodeBasicHtmlEntities(String(labs[0]).trim());
  })();

  const rawHeadline =
    String(narrative?.headline ?? "").trim() ||
    String(narrative?.title ?? "").trim() ||
    String(widgetName ?? "").trim();

  const headlineGenericLower = new Set(
    [
      t("welcome.metricName_21"),
      t("welcome.generalSummarySectionLabel"),
      "genel özet",
      "general summary",
    ]
      .filter(Boolean)
      .map((s) => String(s).trim().toLowerCase()),
  );

  const headline =
    singleTopicLabel &&
    (!rawHeadline || headlineGenericLower.has(rawHeadline.toLowerCase()))
      ? singleTopicLabel
      : rawHeadline;

  const summaryRaw = decodeBasicHtmlEntities(String(narrative?.summary ?? "").trim());
  const ratingNum = narrative?.rating;
  const ratingFallback = String(narrative?.rating_display ?? "").trim();

  const ratingLabel = (() => {
    if (ratingFallback) {
      const rf = String(ratingFallback).trim().toLowerCase();
      if (["n/a", "na", "-", "—", "none", "null", "nan"].includes(rf)) return null;
      return String(ratingFallback).trim();
    }
    if (ratingNum == null || ratingNum === "") return null;
    const n = Number(ratingNum);
    if (!Number.isFinite(n)) return null;
    const locale = getIntlLocale(i18n.language);
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 1,
      minimumFractionDigits: Number.isInteger(n) ? 0 : 1,
    }).format(n);
  })();

  const bullets = Array.isArray(narrative?.bullets)
    ? narrative.bullets.map((b) => String(b ?? "").trim()).filter(Boolean)
    : [];

  const showReadMore = summaryRaw.length >= GENERAL_SUMMARY_READ_MORE_MIN_CHARS;

  if (!summaryRaw && bullets.length === 0) {
    return (
      <WelcomeWidgetDataStateMessage
        status={WELCOME_WIDGET_DATA_STATUS_EMPTY}
        t={t}
        emptyClassName={styles.noDataMessage}
        data={data}
        widgetRow={widgetRow}
        emptyGenaiSignal={welcomeWidgetShowsEmptyGenaiSignal(data, widgetRow)}
      />
    );
  }

  return (
    <div className={styles.welcomeGeneralSummary}>
      <div className={styles.welcomeGeneralSummaryTopRow}>
        <h3 className={styles.welcomeGeneralSummaryHeadline}>{headline}</h3>
        {ratingLabel ? (
          <div className={styles.welcomeGeneralSummaryRating} title={t("welcome.generalSummaryRatingHint")}>
            {ratingLabel}
          </div>
        ) : null}
      </div>
      <div className={styles.welcomeGeneralSummaryMetaRow}>
        <span className={styles.welcomeGeneralSummarySectionLabel}>
          {singleTopicLabel
            ? t("welcome.generalSummarySectionLabelWithTopic", {
                topic: singleTopicLabel,
              })
            : t("welcome.generalSummarySectionLabel")}
        </span>
        <span className={styles.welcomeGeneralSummaryBrandBadge}>
          <RobotOutlined className={styles.welcomeGeneralSummaryBrandIcon} aria-hidden />
          PIVONY
        </span>
      </div>
      {summaryRaw ? (
        <div className={styles.welcomeGeneralSummaryBody}>
          <p
            className={`${styles.welcomeGeneralSummaryText} ${
              showReadMore && !expanded ? styles.welcomeGeneralSummaryTextCollapsed : ""
            }`}
            title={
              showReadMore && !expanded && summaryRaw
                ? summaryRaw
                : undefined
            }
          >
            {renderWelcomeGenaiInlineMarkdown(summaryRaw)}
          </p>
          {showReadMore ? (
            <button
              type="button"
              className={styles.welcomeGeneralSummaryReadMore}
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded
                ? t("welcome.generalSummaryReadLess")
                : t("welcome.generalSummaryReadMore")}
            </button>
          ) : null}
        </div>
      ) : null}
      {expanded && bullets.length > 0 ? (
        <ul className={styles.welcomeGeneralSummaryBullets}>
          {bullets.map((line, idx) => (
            <li key={`gs-bullet-${idx}`}>
              {renderWelcomeGenaiInlineMarkdown(decodeBasicHtmlEntities(line))}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

/** Layout classes per metric — duplicated structure today; split so 21 / 23 / 25 can diverge later. */
export function welcomeHierarchicalTabLayoutForMetric(metricId) {
  const mid = Number(metricId);
  if (mid === WELCOME_GENERAL_SUMMARY_METRIC_ID) {
    return {
      panel: styles.welcomeGeneralSummaryHierarchicalTabPanel,
      meta: styles.welcomeGeneralSummaryHierarchicalTabMeta,
      reviewCount: styles.welcomeGeneralSummaryHierarchicalTabReviewCount,
      text: styles.welcomeGeneralSummaryHierarchicalTabText,
    };
  }
  if (mid === 23) {
    return {
      panel: styles.welcomeKeyDriversHierarchicalTabPanel,
      meta: styles.welcomeKeyDriversHierarchicalTabMeta,
      reviewCount: styles.welcomeKeyDriversHierarchicalTabReviewCount,
      text: styles.welcomeKeyDriversHierarchicalTabText,
    };
  }
  if (mid === 25) {
    return {
      panel: styles.welcomeHighlightsHierarchicalTabPanel,
      meta: styles.welcomeHighlightsHierarchicalTabMeta,
      reviewCount: styles.welcomeHighlightsHierarchicalTabReviewCount,
      text: styles.welcomeHighlightsHierarchicalTabText,
    };
  }
  return {
    panel: styles.welcomeGeneralSummaryHierarchicalTabPanel,
    meta: styles.welcomeGeneralSummaryHierarchicalTabMeta,
    reviewCount: styles.welcomeGeneralSummaryHierarchicalTabReviewCount,
    text: styles.welcomeGeneralSummaryHierarchicalTabText,
  };
}

/** Read-only tabbed body for multi-topic hierarchical summaries (metrics 21 / 23 / 25). */
export function WelcomeHierarchicalSummaryTabBody({
  layout,
  reviewCountLabel,
  reviewCount,
  onReviewCountClick,
  bodyText,
  titleAttr,
  metricId,
  showGeneralSummaryInfo = false,
}) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [showReadToggle, setShowReadToggle] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const textEl = textRef.current;
    if (!textEl) return;

    if (expanded) {
      setShowReadToggle(true);
      return;
    }

    // Only show read-more when clamped content truly overflows.
    const hasOverflow = textEl.scrollHeight - textEl.clientHeight > 1;
    setShowReadToggle(hasOverflow);
  }, [bodyText, expanded]);

  useEffect(() => {
    const onResize = () => {
      const textEl = textRef.current;
      if (!textEl || expanded) return;
      const hasOverflow = textEl.scrollHeight - textEl.clientHeight > 1;
      setShowReadToggle(hasOverflow);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [expanded]);

  return (
    <div className={layout.panel}>
      {reviewCountLabel ? (
        <div className={layout.meta}>
          <WelcomeTabReviewCountButton
            label={reviewCountLabel}
            reviewCount={reviewCount}
            onClick={onReviewCountClick}
          />
        </div>
      ) : null}
      {showGeneralSummaryInfo ? (
        <Alert
          type="info"
          showIcon
          className={styles.welcomeGeneralSummaryTabInfo}
          message={t("welcome.generalSummaryOfSummariesInfo")}
        />
      ) : null}
      <div
        ref={textRef}
        className={`${layout.text} ${expanded ? styles.welcomeHierarchicalTabTextExpanded : ""}`.trim()}
        title={titleAttr || undefined}
      >
        {Number(metricId) === 25 ? (
          <WelcomeHighlightsStructuredBody bodyText={bodyText} />
        ) : (
          renderWelcomeGenaiInlineMarkdown(bodyText)
        )}
      </div>
      {showReadToggle && (
        <button
          type="button"
          className={styles.welcomeHierarchicalTabReadMore}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded
            ? t("welcome.generalSummaryReadLess")
            : t("welcome.generalSummaryReadMore")}
        </button>
      )}
    </div>
  );
}

export function WelcomeHierarchicalSummaryReadOnly({
  tabs,
  metricId,
  onTabChange,
  widget,
  activeTabKey,
  onActiveTabKeyChange,
  narrativeData,
  highlightsTopicLabels,
  parseTopicLibId,
  onTabReviewCountClick,
}) {
  const { t, i18n } = useTranslation();
  if (Number(metricId) === 25) {
    return (
      <WelcomeHighlightsInsightDashboard
        tabs={tabs}
        widget={widget}
        narrativeData={narrativeData}
        topicLabelsAligned={highlightsTopicLabels}
      />
    );
  }
  if (Number(metricId) === 23) {
    const llmItems = Array.isArray(narrativeData?.items)
      ? narrativeData.items
      : [];
    const summaryText = decodeBasicHtmlEntities(
      String(
        narrativeData?.narrative?.summary ||
          tabs?.find((tab) => String(tab?.id || "").toLowerCase() === "general")
            ?.content ||
          "",
      ),
    );
    return (
      <PivonyInsightWidget
        items={llmItems}
        tabs={tabs}
        summaryText={summaryText}
        activeTopicId={activeTabKey}
        widget={widget}
        widgetId={widget?.id}
        onTopicSelect={(key) => {
          if (onActiveTabKeyChange) onActiveTabKeyChange(key);
          if (!onTabChange || !widget) return;
          if (!welcomeWidgetUsesLazyTopicTabs(widget)) return;
          const lib = parseTopicLibIdFromWidgetTab(widget, key);
          if (lib == null) return;
          const row = (tabs || []).find((x) => String(x.id) === String(key));
          if (
            row &&
            !row.payload_pending &&
            !row.content_pending &&
            row.content != null &&
            String(row.content).trim() !== ""
          ) {
            return;
          }
          onTabChange(widget, lib);
        }}
      />
    );
  }
  const layout = welcomeHierarchicalTabLayoutForMetric(metricId);
  const effectiveTabs = mergeGeneralAndSingleTopicHierarchicalTabs(tabs);
  const nf = new Intl.NumberFormat(
    getIntlLocale(i18n.language),
  );
  const reviewScope = resolveWelcomeReviewScopeFromData(narrativeData, widget);
  const reviewScopeLabel = formatWelcomeReviewScopeLabel(t, nf, reviewScope);
  const items = (effectiveTabs || []).map((tab) => {
    const tabRcRaw = tab?.review_count;
    const hasNumericReviewCount =
      tabRcRaw != null &&
      tabRcRaw !== "" &&
      Number.isFinite(Number(tabRcRaw));
    const tabCountLabel = hasNumericReviewCount
      ? nf.format(Number(tabRcRaw))
      : null;
    const tabIdLower = String(tab.id || "").toLowerCase();
    const isGeneralTab = tabIdLower === "general" || tabIdLower === "global";
    const bodyText = decodeBasicHtmlEntities(String(tab.content ?? ""));
    const titleAttr = bodyText.replace(/\s+/g, " ").trim();
    const pending =
      widget &&
      welcomeWidgetUsesLazyTopicTabs(widget) &&
      String(tab.id || "").toLowerCase() !== "general" &&
      String(tab.id || "").toLowerCase() !== "global" &&
      (tab.content_pending ||
        tab.payload_pending ||
        (tab.content == null || String(tab.content).trim() === ""));
    const isGeneralSummaryMetric =
      Number(metricId) === WELCOME_GENERAL_SUMMARY_METRIC_ID;
    const tabReviewCountNum = isGeneralTab
      ? resolveWelcomeDisplayReviewCount(narrativeData, widget, {
          tabReviewCount: tabRcRaw,
        })
      : hasNumericReviewCount
        ? Number(tabRcRaw)
        : null;
    const topicLibId =
      !isGeneralTab && parseTopicLibId && widget
        ? parseTopicLibId(widget, tab.id)
        : null;
    const topicLabel =
      isGeneralTab && isGeneralSummaryMetric
        ? t("welcome.generalSummaryOfSummariesTab")
        : isGeneralTab
          ? t("welcome.genaiMultiTopicGeneralTab")
          : decodeBasicHtmlEntities(String(tab.label || tab.id));
    return {
      key: String(tab.id),
      label:
        isGeneralTab && isGeneralSummaryMetric
          ? t("welcome.generalSummaryOfSummariesTab")
          : decodeBasicHtmlEntities(String(tab.label || tab.id)),
      children: pending ? (
        <div className={styles.tabLoadingCenter}>
          <Spin size="large" />
        </div>
      ) : (
        <WelcomeHierarchicalSummaryTabBody
          layout={layout}
          reviewCountLabel={
            isGeneralTab && reviewScopeLabel
              ? reviewScopeLabel
              : tabCountLabel != null
                ? t("welcome.hierarchicalTabReviewCount", {
                    count: tabCountLabel,
                  })
                : null
          }
          reviewCount={tabReviewCountNum}
          onReviewCountClick={
            typeof onTabReviewCountClick === "function" &&
            tabReviewCountNum != null &&
            Number(tabReviewCountNum) > 0
              ? () =>
                  onTabReviewCountClick({
                    tab,
                    reviewCount: Number(tabReviewCountNum),
                    topicLibId,
                    topicLabel,
                  })
              : undefined
          }
          bodyText={bodyText}
          titleAttr={titleAttr}
          metricId={metricId}
          showGeneralSummaryInfo={isGeneralTab && isGeneralSummaryMetric}
        />
      ),
    };
  });
  const lazyTabs =
    widget && welcomeWidgetUsesLazyTopicTabs(widget) && onActiveTabKeyChange;
  const firstTabKey = String(
    (effectiveTabs || [])[0]?.id ??
      (Number(metricId) === 25 ? "topic-1" : "general"),
  );
  const resolvedActiveKey =
    lazyTabs && activeTabKey !== undefined && activeTabKey !== null
      ? String(activeTabKey)
      : firstTabKey;
  if (items.length === 1) {
    return (
      <div className={styles.welcomeHierarchicalTabs}>{items[0].children}</div>
    );
  }
  return (
    <Tabs
      items={items}
      className={styles.welcomeHierarchicalTabs}
      {...(lazyTabs ? { activeKey: resolvedActiveKey } : {})}
      onChange={(key) => {
        if (lazyTabs) {
          onActiveTabKeyChange(key);
        }
        if (!onTabChange || !widget) return;
        if (!welcomeWidgetUsesLazyTopicTabs(widget)) return;
        const lib = parseTopicLibIdFromWidgetTab(widget, key);
        if (lib == null) return;
        const row = (effectiveTabs || []).find((x) => String(x.id) === String(key));
        if (
          row &&
          !row.payload_pending &&
          !row.content_pending &&
          row.content != null &&
          String(row.content).trim() !== ""
        ) {
          return;
        }
        onTabChange(widget, lib);
      }}
    />
  );
}

const TABLE_WIDGET_SCHEMAS = {
  ROOT_CAUSE_VIEW: (t) => ({
    columns: [
      { key: "rc_id", title: t("welcome.insightTableColId", "ID"), sourceKey: "rc_id" },
      { key: "root_cause", title: t("welcome.insightTableColRootCause", "Root Cause"), sourceKey: "root_cause" },
      {
        key: "recommendation",
        title: t("welcome.insightTableColRecommendation", "Recommendation"),
        sourceKey: "recommendation",
      },
      { key: "status", title: t("welcome.insightTableColStatus", "Status"), sourceKey: "status" },
    ],
    fallback: "—",
  }),
};

export function getWidgetTableSchema(widget, t) {
  if (Number(widget?.metric_id) === 20 && typeof t === "function") {
    return TABLE_WIDGET_SCHEMAS.ROOT_CAUSE_VIEW(t);
  }
  return null;
}

/** Readable labels: Duygu_Analizi → Duygu Analizi */
function humanizeUnderscoresForDisplay(text) {
  if (text == null || text === "") return "";
  return String(text).replace(/_/g, " ").replace(/\s+/g, " ").trim();
}

/** Decode common HTML entities in API/widget titles (e.g. &amp; → &). */
export function decodeBasicHtmlEntities(text) {
  if (text == null) return text;
  const s = String(text);
  return s
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#x27;/gi, "'");
}

/**
 * Edit prompt modal title: unwrap repeated &amp; from API/i18n, then replace & joiners with
 * middle dots so the header never shows raw ampersands or entity artifacts.
 */
export function formatNameForPromptModalChrome(raw) {
  let s = String(raw ?? "").trim();
  if (!s) return "";
  let prev;
  do {
    prev = s;
    s = decodeBasicHtmlEntities(s);
  } while (s !== prev);
  return s.replace(/\s*&\s*/g, " · ");
}

/** Human-readable column titles in the Edit content table (keys are lowercased for lookup). */
function getInsightEditTableColumnLabel(columnKey, metricId, t) {
  const k = String(columnKey ?? "").trim();
  if (!k) return "";
  const lower = k.toLowerCase();
  if (lower === "label" && Number(metricId) === 20) {
    return t("welcome.insightEditColTag");
  }
  const map = {
    rc_id: "welcome.insightTableColId",
    label: "welcome.insightTableColArea",
    topic: "welcome.reviewSummaryTopic",
    root_cause: "welcome.insightTableColRootCause",
    recommendation: "welcome.insightTableColRecommendation",
    status: "welcome.insightTableColStatus",
  };
  const i18nKey = map[lower];
  if (i18nKey) return t(i18nKey);
  return k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

/** rem min-widths for ID / Tag / Status (used with table-layout: fixed). */
function getInsightEditShortColumnMinWidth(columnKey) {
  const k = String(columnKey ?? "").toLowerCase();
  if (k === "rc_id") return "3.5rem";
  if (k === "label") return "5.5rem";
  if (k === "topic") return "7.5rem";
  if (k === "status") return "12rem";
  return undefined;
}

/** Fixed column widths for edit modal table (prevents squashed / overlapping cells). */
function getInsightEditColumnWidthStyle(columnKey) {
  const k = String(columnKey ?? "").toLowerCase();
  if (k === "rc_id") return { width: 72 };
  if (k === "label") return { width: "11%" };
  if (k.includes("root_cause")) return { width: "32%" };
  if (k.includes("recommendation")) return { width: "32%" };
  if (k === "status") return { width: 240 };
  return {};
}

/** Put Status after Recommendation; drop comment and legacy insight from visible columns. */
function orderInsightTableColumnsForEdit(columns) {
  const list = Array.isArray(columns) ? [...columns] : [];
  const lower = (c) => String(c).toLowerCase();
  const filtered = list.filter((c) => {
    const l = lower(c);
    return l !== "comment" && l !== "insight";
  });
  const byLower = {};
  filtered.forEach((c) => {
    byLower[lower(c)] = c;
  });
  const priority = ["rc_id", "label", "topic", "root_cause", "recommendation"];
  const ordered = [];
  priority.forEach((name) => {
    if (byLower[name]) ordered.push(byLower[name]);
  });
  const existingStatus = byLower.status;
  const statusKey = existingStatus != null ? existingStatus : "status";
  const statusAlreadyPlaced = ordered.some((c) => lower(c) === "status");
  if (!statusAlreadyPlaced) {
    const rIdx = ordered.findIndex((c) => lower(c) === "recommendation");
    if (rIdx >= 0) ordered.splice(rIdx + 1, 0, statusKey);
    else ordered.push(statusKey);
  }
  filtered.forEach((c) => {
    if (lower(c) === "status") return;
    if (!ordered.includes(c)) ordered.push(c);
  });
  return ordered.map((c) => (lower(c) === "status" ? "status" : c));
}

/** Edit modal for metric 20: ID + narratives only (status edited on widget table). */
const INSIGHT_EDIT_MODAL_METRIC_20_ORDER = [
  "rc_id",
  "root_cause",
  "recommendation",
];

function orderInsightTableColumnsForEditModal(columns, metricId) {
  const mid = Number(metricId);
  if (mid !== 20) {
    return orderInsightTableColumnsForEdit(columns);
  }
  const lower = (c) => String(c).toLowerCase();
  const byLower = {};
  (Array.isArray(columns) ? columns : []).forEach((c) => {
    byLower[lower(c)] = c;
  });
  const out = [];
  INSIGHT_EDIT_MODAL_METRIC_20_ORDER.forEach((name) => {
    if (byLower[name]) out.push(byLower[name]);
  });
  return out;
}

/** Columns rendered as fields inside each edit-modal card (excludes id + status). */
function getInsightEditCardBodyColumnKeys(columns) {
  if (!Array.isArray(columns)) return [];
  return columns.filter((c) => {
    const l = String(c).toLowerCase();
    return l !== "rc_id" && l !== "status";
  });
}

/** Metric 20 edit modal: dirty check uses only narratives (not status/decisions). */
function serializeWelcomeMetric20InsightRowsContentOnly(rows) {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows
    .map((row) => ({
      rc_id: String(getInsightRowFieldInsensitive(row, "rc_id") ?? "").trim(),
      root_cause: String(getInsightRowFieldInsensitive(row, "root_cause") ?? "").trim(),
      recommendation: String(
        getInsightRowFieldInsensitive(row, "recommendation") ?? "",
      ).trim(),
    }))
    .filter(
      (row) =>
        row.rc_id !== "" ||
        row.root_cause !== "" ||
        row.recommendation !== "",
    )
    .sort((a, b) =>
      String(a.rc_id).localeCompare(String(b.rc_id), undefined, {
        numeric: true,
      }),
    );
}

/** Canonical row keys for status + comment (matches TopProblems / insight PATCH). */
function normalizeInsightRowsForEdit(rows) {
  return (Array.isArray(rows) ? rows : []).map((row) => {
    const lk = {};
    Object.keys(row || {}).forEach((k) => {
      lk[String(k).toLowerCase()] = k;
    });
    const sk = lk.status;
    const ck = lk.comment;
    const next = { ...row };
    if (sk && sk !== "status") delete next[sk];
    if (ck && ck !== "comment") delete next[ck];
    const statusRaw = sk != null ? row[sk] : "";
    const commentRaw = ck != null ? row[ck] : "";
    next.status = decodeBasicHtmlEntities(String(statusRaw ?? "")).trim();
    next.comment = decodeBasicHtmlEntities(String(commentRaw ?? "")).trim();
    return next;
  });
}

/** Map API / legacy status strings to TopProblems StatusUpdateComponent option values. */
function mapInsightEditStatusToSelectValue(raw) {
  const s = String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (!s || s === "open") return "planning";
  if (s === "planning" || s === "planning_to_take_action") return "planning";
  if (s === "completed" || s === "action_taken") return "completed";
  if (s === "no_action" || s === "no_action_needed") return "no_action";
  return "planning";
}

/** Empty / open → undefined so Select shows CTA placeholder (not forced "planning"). */
function welcomeRootCauseInitialSelectValue(raw) {
  if (raw == null) return undefined;
  const trimmed = String(raw).trim();
  if (trimmed === "") return undefined;
  if (trimmed.toLowerCase() === "open") return undefined;
  return mapInsightEditStatusToSelectValue(raw);
}

function welcomeRootCauseHasSetStatus(raw) {
  if (raw?.status == null) return false;
  const s = String(raw.status).trim();
  return s !== "" && s.toLowerCase() !== "open";
}

/** Card-stack status accent: planning | in_progress | completed | no_action | unset */
function welcomeRootCauseStatusVisualTone(raw) {
  const s = String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (
    s === "in_progress" ||
    s === "inprogress" ||
    s.includes("in_progress") ||
    (s.includes("progress") &&
      !s.includes("planning") &&
      !s.includes("take_action") &&
      !s.includes("no_action"))
  ) {
    return "in_progress";
  }
  const v = mapInsightEditStatusToSelectValue(raw);
  if (v === "completed") return "completed";
  if (v === "no_action") return "no_action";
  return "planning";
}

export function normalizeRowsBySchema(items, schema, widget) {
  const safeItems = Array.isArray(items) ? items : [];
  const safeColumns = Array.isArray(schema?.columns) ? schema.columns : [];
  const fallback = schema?.fallback ?? "-";
  return safeItems.map((item, index) => {
    const row = { key: index };
    safeColumns.forEach((column) => {
      if (column.computed === "pivot_filter") {
        row[column.key] = formatPivotFilterForView(widget);
      } else {
        const sk = column.sourceKey ?? column.key;
        row[column.key] = item?.[sk] ?? fallback;
      }
    });
    return row;
  });
}

const METRIC_20_INSIGHT_PATCH_KEYS = [
  "rc_id",
  "label",
  "topic",
  "root_cause",
  "recommendation",
  "status",
];

function getInsightRowFieldInsensitive(row, key) {
  if (row == null) return "";
  if (Object.prototype.hasOwnProperty.call(row, key) && row[key] != null) {
    return row[key];
  }
  const lk = String(key).toLowerCase();
  const found = Object.keys(row).find((k) => String(k).toLowerCase() === lk);
  return found != null ? row[found] : "";
}

/** Full row payload for PATCH (metric 20: narratives in edit modal; status on widget table). */
function serializeWelcomeMetric20InsightRowsForPatch(rows) {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows
    .map((row) => {
      const acc = {};
      METRIC_20_INSIGHT_PATCH_KEYS.forEach((k) => {
        acc[k] = String(getInsightRowFieldInsensitive(row, k) ?? "").trim();
      });
      acc.comment = String(row?.comment ?? "").trim();
      return acc;
    })
    .filter(
      (row) =>
        row.rc_id !== "" ||
        row.root_cause !== "" ||
        row.recommendation !== "" ||
        row.topic !== "" ||
        row.label !== "",
    );
}

function welcomeRootCauseRowMatchesRc(record, item) {
  const a = String(record?.rc_id ?? record?.ID ?? "");
  const b = String(item?.rc_id ?? item?.ID ?? "");
  return a !== "" && a === b;
}

/** Metric 20 widget table: status dropdown + PATCH welcome/widget/insight-items */
function WelcomeRootCauseStatusCell({
  widgetId,
  groupId,
  record,
  sourceItems,
  setWidgets,
  setGroups,
  workspaceContentEditable = false,
}) {
  const { t } = useTranslation();
  const raw = (Array.isArray(sourceItems) ? sourceItems : []).find((it) =>
    welcomeRootCauseRowMatchesRc(record, it),
  );

  const persistFromWidget = async ({ status, comment }) => {
    const nextItems = (Array.isArray(sourceItems) ? sourceItems : []).map(
      (it) => {
        if (!welcomeRootCauseRowMatchesRc(record, it)) {
          return { ...it };
        }
        return { ...it, status, comment: comment ?? "" };
      },
    );
    const bodyItems = serializeWelcomeMetric20InsightRowsForPatch(
      normalizeInsightRowsForEdit(nextItems),
    );
    if (!bodyItems.length) {
      throw new Error(t("welcome.infoInsightItemsRequired"));
    }
    const resp = await apiRequest(
      "welcome/widget/insight-items",
      "PATCH",
      { widget_id: widgetId, items: bodyItems },
      true,
    );
    if (!resp?.success) {
      const err =
        typeof resp?.error === "string" && resp.error.trim()
          ? resp.error
          : t("welcome.infoInsightSaveError");
      throw new Error(err);
    }
    setWidgets((prev) =>
      prev.map((w) =>
        w.id === widgetId
          ? { ...w, data: { ...w.data, items: nextItems } }
          : w,
      ),
    );
    setGroups((prevGroups) =>
      prevGroups.map((g) =>
        g.id !== groupId
          ? g
          : {
              ...g,
              widgets: (g.widgets || []).map((w) =>
                w.id === widgetId
                  ? { ...w, data: { ...w.data, items: nextItems } }
                  : w,
              ),
            },
      ),
    );
    message.success(t("welcome.rootCauseStatusSaved"));
  };

  const initialStatus = welcomeRootCauseInitialSelectValue(raw?.status);

  if (!workspaceContentEditable) {
    const st = raw?.status != null && String(raw.status).trim() !== "" ? String(raw.status) : "—";
    return (
      <span style={{ fontSize: 13, opacity: 0.85 }} title={t("welcome.editContentReadOnlyHint")}>
        {st}
      </span>
    );
  }

  return (
    <StatusUpdateComponent
      record={{
        rc_id: record.rc_id ?? record.ID,
        ID: record.rc_id ?? record.ID,
        status: initialStatus,
        Status: initialStatus,
        comment: raw?.comment ?? "",
      }}
      persistMode="local"
      onLocalPersist={(p) => persistFromWidget(p)}
      getPopupContainer={() => document.body}
      compact
      containerStyle={{ width: "100%", maxWidth: 200 }}
      placeholder={t("welcome.rootCauseStatusPlaceholder")}
      statusRequiredError={t("welcome.rootCauseStatusRequired")}
    />
  );
}

/** Metric 20: vertical cards (replaces wide table; status still PATCHes via WelcomeRootCauseStatusCell). */
export function WelcomeRootCauseCardStack({
  rows,
  widgetId,
  groupId,
  sourceItems,
  setWidgets,
  setGroups,
  onViewAssociatedReviews,
  topicTabLabel,
  workspaceContentEditable = false,
}) {
  const { t } = useTranslation();
  const toneClass = {
    unset: styles.welcomeGenaiRootCauseStatusTone_unset,
    planning: styles.welcomeGenaiRootCauseStatusTone_planning,
    in_progress: styles.welcomeGenaiRootCauseStatusTone_in_progress,
    completed: styles.welcomeGenaiRootCauseStatusTone_completed,
    no_action: styles.welcomeGenaiRootCauseStatusTone_no_action,
  };
  return (
    <div className={styles.welcomeGenaiRootCauseCardStack}>
      {(Array.isArray(rows) ? rows : []).map((row, idx) => {
        const raw = (Array.isArray(sourceItems) ? sourceItems : []).find((it) =>
          welcomeRootCauseRowMatchesRc(row, it),
        );
        const tone = welcomeRootCauseHasSetStatus(raw)
          ? welcomeRootCauseStatusVisualTone(raw?.status)
          : "unset";
        const toneStyles = toneClass[tone] || toneClass.unset;
        const rcText = String(row?.root_cause ?? "").trim();
        const recText = String(row?.recommendation ?? "").trim();
        const rcDisplay =
          rcText === ""
            ? "—"
            : humanizeUnderscoresForDisplay(decodeBasicHtmlEntities(rcText));
        const recDisplay =
          recText === ""
            ? "—"
            : humanizeUnderscoresForDisplay(decodeBasicHtmlEntities(recText));
        const idLabel =
          row?.rc_id != null && String(row.rc_id).trim() !== ""
            ? String(row.rc_id).trim()
            : String(idx + 1);
        return (
          <div
            key={row.key ?? `rc-${idLabel}-${idx}`}
            className={styles.welcomeGenaiRootCauseCard}
          >
            <div className={styles.welcomeGenaiRootCauseCardHeader}>
              <span className={styles.welcomeGenaiRootCauseCardId}>
                #{idLabel}
              </span>
              <div
                className={`${styles.welcomeGenaiRootCauseCardStatus} ${toneStyles}`}
              >
                <WelcomeRootCauseStatusCell
                  widgetId={widgetId}
                  groupId={groupId}
                  record={row}
                  sourceItems={sourceItems}
                  setWidgets={setWidgets}
                  setGroups={setGroups}
                  workspaceContentEditable={workspaceContentEditable}
                />
              </div>
            </div>
            <div className={styles.welcomeGenaiRootCauseCardBody}>
              <div className={styles.welcomeGenaiRootCauseCardSectionLabel}>
                {t("welcome.rootCauseCardProblem")}
              </div>
              <div className={styles.welcomeGenaiRootCauseCardProblemText}>
                {rcDisplay}
              </div>
              <div className={styles.welcomeGenaiRootCauseCardSectionLabel}>
                {t("welcome.rootCauseCardSolution")}
              </div>
              <div className={styles.welcomeGenaiRootCauseCardRecommendationBox}>
                {recDisplay}
              </div>
              {typeof onViewAssociatedReviews === "function" ? (
                <button
                  type="button"
                  className={styles.welcomeGenaiRootCauseReviewsLink}
                  onClick={() =>
                    onViewAssociatedReviews(raw || row, row, topicTabLabel)
                  }
                >
                  {(() => {
                    const n = collectGenaiItemReviewIds(raw || row).length;
                    return n > 0
                      ? t("welcome.rootCauseViewReviews", { count: n })
                      : t("welcome.rootCauseViewReviewsExplore");
                  })()}
                  <ArrowUpOutlined
                    className={styles.welcomeGenaiRootCauseReviewsLinkIcon}
                    aria-hidden
                  />
                </button>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function genaiTableRowMatchesTopicLabel(rowTopic, label) {
  if (label == null || String(label).trim() === "") return false;
  if (rowTopic == null || String(rowTopic).trim() === "") return false;
  const l = String(label).trim().toLowerCase();
  const r = String(rowTopic).trim().toLowerCase();
  if (r === l) return true;
  if (r.includes(l)) return true;
  return String(r)
    .split(/[,;&]/)
    .map((x) => x.trim())
    .some((p) => p === l || p.includes(l));
}

function resolveWelcomeIndustryTopicLabels(topicIds, categories) {
  if (!Array.isArray(topicIds) || topicIds.length === 0) return [];
  return topicIds.map((rawId) => {
    const id = Number(rawId);
    const cat = (categories || []).find(
      (c) => Number(c.categoryId ?? c.category) === id,
    );
    const n = cat?.name ?? cat?.category;
    return n != null && String(n).trim() !== "" ? String(n) : `#${id}`;
  });
}

/**
 * Highlights (25): `topic_labels[i]` must stay aligned with `topic_ids[i]` (do not compact empties).
 * Prefer API labels, then `summary_tabs` row label, then industry library names from wizard.
 */
function buildHighlightsTopicLabelsAligned(widget, data, sumTabs, categories) {
  const tids = Array.isArray(widget?.topic_ids)
    ? widget.topic_ids.map((x) => Number(x)).filter((n) => n > 0)
    : [];
  const rawW = Array.isArray(widget?.topic_labels) ? widget.topic_labels : [];
  const rawD = Array.isArray(data?.topic_labels) ? data.topic_labels : [];
  const raw = rawW.length >= rawD.length ? rawW : rawD;
  const fromCat = resolveWelcomeIndustryTopicLabels(tids, categories);
  const topicTabRows = Array.isArray(sumTabs)
    ? sumTabs.filter((t) => /^topic-\d+$/i.test(String(t?.id ?? "").trim()))
    : [];
  const n = Math.max(
    tids.length,
    raw.length,
    topicTabRows.length,
    fromCat.length,
  );
  if (n === 0) return [];
  const out = [];
  for (let i = 0; i < n; i++) {
    const a = raw[i];
    if (a != null && String(a).trim() !== "") {
      out.push(String(a).trim());
      continue;
    }
    const tab = topicTabRows[i];
    const tabLab = tab?.label;
    if (tabLab != null && String(tabLab).trim() !== "") {
      out.push(decodeBasicHtmlEntities(String(tabLab).trim()));
      continue;
    }
    const b = fromCat[i];
    if (b != null && String(b).trim() !== "") {
      out.push(String(b).trim());
      continue;
    }
    out.push("");
  }
  return out;
}

/** Metric 20: General + one tab per wizard-selected category (filters rows by `topic`). */
export function WelcomeGenaiRootCauseTopicTabs({
  topicIds,
  topicLabels,
  topicReviewCounts,
  sourceItems,
  tableSchema,
  widget,
  groupId,
  setWidgets,
  setGroups,
  onViewAssociatedReviews,
  workspaceContentEditable = false,
  scopeData,
}) {
  const { t, i18n } = useTranslation();
  const nf = new Intl.NumberFormat(
    getIntlLocale(i18n.language),
  );
  const reviewScopeLabel = formatWelcomeReviewScopeLabel(
    t,
    nf,
    resolveWelcomeReviewScopeFromData(scopeData, widget),
  );
  const reviewCountByLibId = (() => {
    const raw = topicReviewCounts;
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
      return {};
    }
    const out = {};
    Object.entries(raw).forEach(([key, val]) => {
      const n = Number(val);
      if (Number.isFinite(n) && n >= 0) {
        out[String(key)] = n;
      }
    });
    return out;
  })();
  const reviewCountLine = (libId, tabItems) => {
    if (libId == null) {
      return t("welcome.hierarchicalTabReviewCountNA");
    }
    const raw = reviewCountByLibId[String(libId)];
    if (raw != null && Number.isFinite(Number(raw)) && Number(raw) >= 0) {
      const n = Number(raw);
      if (n > 0) {
        return t("welcome.hierarchicalTabReviewCount", {
          count: nf.format(n),
        });
      }
    }
    const items = Array.isArray(tabItems) ? tabItems : [];
    const fromRows = new Set();
    items.forEach((it) => {
      collectGenaiItemReviewIds(it).forEach((id) => fromRows.add(id));
    });
    if (fromRows.size > 0) {
      return t("welcome.hierarchicalTabReviewCount", {
        count: nf.format(fromRows.size),
      });
    }
    if (raw != null && Number.isFinite(Number(raw)) && Number(raw) >= 0) {
      return t("welcome.hierarchicalTabReviewCount", {
        count: nf.format(Number(raw)),
      });
    }
    return t("welcome.hierarchicalTabReviewCountNA");
  };
  const allItems = Array.isArray(sourceItems) ? sourceItems : [];
  /** Rows exist but no tab owns them (e.g. metric 20 single-topic worker omitted topic_lib_id). */
  const anyTabMatchesRow = topicLabels.some((lab, i) => {
    const libId = topicIds && topicIds[i] != null ? Number(topicIds[i]) : null;
    return allItems.some((it) => {
      if (libId != null && it?.topic_lib_id != null) {
        return Number(it.topic_lib_id) === libId;
      }
      return genaiTableRowMatchesTopicLabel(it?.topic, lab);
    });
  });
  const showOrphanInsightsStack =
    allItems.length > 0 &&
    topicLabels.length > 0 &&
    !anyTabMatchesRow &&
    Number(widget?.metric_id) === 20;
  const tabDefs = topicLabels.map((lab, i) => {
    const libId = topicIds && topicIds[i] != null ? Number(topicIds[i]) : null;
    return {
      key: `topic-${i}`,
      label: lab,
      libId,
      pick: () =>
        allItems.filter((it) => {
          // Prefer numeric lib ID match (reliable regardless of label formatting).
          if (libId != null && it?.topic_lib_id != null) {
            return Number(it.topic_lib_id) === libId;
          }
          return genaiTableRowMatchesTopicLabel(it?.topic, lab);
        }),
    };
  });
  if (showOrphanInsightsStack) {
    const triadRows = normalizeRowsBySchema(allItems, tableSchema, widget);
    const scrollMany = triadRows.length > 3;
    return (
      <div
        className={`${styles.tableWidget} ${styles.welcomeGenaiRootCauseCardStackWrap}${
          scrollMany ? ` ${styles.welcomeGenaiRootCauseCardStackScroll}` : ""
        }`}
      >
        {reviewScopeLabel ? (
          <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
            <span
              className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
            >
              {reviewScopeLabel}
            </span>
          </div>
        ) : null}
        <WelcomeRootCauseCardStack
          rows={triadRows}
          widgetId={widget.id}
          groupId={groupId}
          sourceItems={allItems}
          setWidgets={setWidgets}
          setGroups={setGroups}
          onViewAssociatedReviews={onViewAssociatedReviews}
          workspaceContentEditable={workspaceContentEditable}
        />
      </div>
    );
  }
  const items = tabDefs.map((def) => {
    const filtered = def.pick();
    const triadRows = normalizeRowsBySchema(filtered, tableSchema, widget);
    const rootCauseCount = triadRows.length;
    const scrollMany = triadRows.length > 3;
    const tabLabelText = decodeBasicHtmlEntities(String(def.label));
    return {
      key: def.key,
      label: (
        <span className={styles.welcomeRootCauseTabLabel}>
          <span className={styles.welcomeRootCauseTabName}>{tabLabelText}</span>
          <span
            className={styles.welcomeRootCauseTabCount}
            title={t("welcome.hierarchicalTabRootCauseCount", {
              count: nf.format(rootCauseCount),
            })}
          >
            ({nf.format(rootCauseCount)})
          </span>
        </span>
      ),
      children: (
        <div
          className={`${styles.tableWidget} ${styles.welcomeGenaiRootCauseCardStackWrap}${
            scrollMany ? ` ${styles.welcomeGenaiRootCauseCardStackScroll}` : ""
          }`}
        >
          <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
            <span
              className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
            >
              {reviewCountLine(def.libId, filtered)}
            </span>
          </div>
          {triadRows.length === 0 ? (
            <div className={styles.noDataMessage}>
              {t("welcome.rootCauseNoMeaningfulFinding")}
            </div>
          ) : (
            <WelcomeRootCauseCardStack
              rows={triadRows}
              widgetId={widget.id}
              groupId={groupId}
              sourceItems={filtered}
              setWidgets={setWidgets}
              setGroups={setGroups}
              topicTabLabel={def.label}
              onViewAssociatedReviews={onViewAssociatedReviews}
              workspaceContentEditable={workspaceContentEditable}
            />
          )}
        </div>
      ),
    };
  });
  return (
    <>
      {reviewScopeLabel ? (
        <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
          <span
            className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
          >
            {reviewScopeLabel}
          </span>
        </div>
      ) : null}
      <Tabs items={items} className={styles.welcomeHierarchicalTabs} />
    </>
  );
}

/**
 * welcomeWidgetJob.status from pivony-api (PostgreSQL): 1 pending, 2 in_progress,
 * 3 completed, 4 failed. Maps to UI: ready | loading | error.
 */
function mapWelcomeWidgetJobStatusToUi(apiStatus) {
  const s = apiStatus;
  if (s === 3) return "ready";
  if (s === 1 || s === 2) return "loading";
  if (s === 4) return "error";
  if (s === "completed") return "ready";
  if (s === "in_progress" || s === "pending") return "loading";
  if (s === "failed") return "error";
  // Unknown / missing job status: poll rather than showing a false ready/error (bbfe0937)
  if (s == null || s === "") return "loading";
  return "loading";
}

function welcomeWidgetRenderAsReady(widget) {
  if (widget?.status === "ready") return true;
  if (widget?.status === "error" && welcomeWidgetFailedJobShowsContentState(widget)) {
    return true;
  }
  return false;
}

function formatWidgetStatusForArchiveDisplay(widget) {
  if (widget?.status === "error") return "failed";
  if (widget?.status === "loading") return "in progress";
  if (widget?.status === "ready") return "ready";
  return widget?.status || "processing";
}

function countWorkspaceGroupWidgetStatuses(widgets) {
  const list = Array.isArray(widgets) ? widgets : [];
  let ready = 0;
  let inProgress = 0;
  for (const widget of list) {
    const status = widget?.status;
    if (status === "ready") {
      ready += 1;
    } else {
      inProgress += 1;
    }
  }
  return { ready, inProgress, total: list.length };
}

function WorkspaceGroupWidgetStatusBadges({
  widgets,
  className = "",
  compact = false,
}) {
  const { t } = useTranslation();
  const list = Array.isArray(widgets) ? widgets : [];
  if (list.length === 0) {
    return (
      <span
        className={`${styles.groupWidgetStatusSummary}${className ? ` ${className}` : ""}`.trim()}
        aria-label={t("welcome.groupNotConfiguredBadge")}
      >
        <span
          className={`${styles.groupWidgetStatusBadge} ${styles.groupWidgetStatusNotConfigured}`}
        >
          {t("welcome.groupNotConfiguredBadge")}
        </span>
      </span>
    );
  }
  const { ready, inProgress } = countWorkspaceGroupWidgetStatuses(list);
  if (ready === 0 && inProgress === 0) {
    return null;
  }
  const readyLabel = compact
    ? t("welcome.groupWidgetStatusReadyShort", { count: ready })
    : t("welcome.groupWidgetStatusReady", { count: ready });
  const inProgressLabel = compact
    ? t("welcome.groupWidgetStatusInProgressShort", { count: inProgress })
    : t("welcome.groupWidgetStatusInProgress", { count: inProgress });
  return (
    <span
      className={`${styles.groupWidgetStatusSummary}${className ? ` ${className}` : ""}`.trim()}
      aria-label={t("welcome.groupWidgetStatusAria", { ready, inProgress })}
    >
      {ready > 0 ? (
        <span
          className={`${styles.groupWidgetStatusBadge} ${styles.groupWidgetStatusReady}`}
        >
          {readyLabel}
        </span>
      ) : null}
      {inProgress > 0 ? (
        <span
          className={`${styles.groupWidgetStatusBadge} ${styles.groupWidgetStatusInProgress}`}
        >
          {inProgressLabel}
        </span>
      ) : null}
    </span>
  );
}

const GROUP_CONFIGURE_INLINE_STEP_KEYS = ["1", "2", "3"];

function WelcomeGroupConfigureEmptyState({
  t,
  onConfigure,
  configureDisabled = false,
  limitTooltip,
  showConfigureAction = true,
}) {
  const configureButton = (
    <Button
      type="primary"
      size="large"
      icon={<SettingOutlined />}
      onClick={onConfigure}
      className={styles.groupConfigureEmptyButton}
      disabled={configureDisabled}
    >
      {t("welcome.groupConfigureButton")}
    </Button>
  );

  return (
    <div className={styles.groupConfigureEmptyState}>
      <div className={styles.groupConfigureEmptyPanel}>
        <div className={styles.groupConfigureEmptyIconWrap} aria-hidden>
          <LineChartOutlined className={styles.groupConfigureEmptyIcon} />
        </div>
        <h4 className={styles.groupConfigureEmptyTitle}>
          {t("welcome.groupConfigureEmptyTitle")}
        </h4>
        <p className={styles.groupConfigureEmptyDescription}>
          {t("welcome.groupConfigureEmptyDescription")}
        </p>

        <p className={styles.groupConfigureStepsInline}>
          {GROUP_CONFIGURE_INLINE_STEP_KEYS.map((stepKey, index) => (
            <React.Fragment key={stepKey}>
              {index > 0 ? (
                <span className={styles.groupConfigureStepsSep} aria-hidden>
                  ·
                </span>
              ) : null}
              <span className={styles.groupConfigureStepsItem}>
                <span className={styles.groupConfigureStepsNum}>{stepKey}</span>
                {t(`welcome.groupConfigureStep${stepKey}Title`)}
              </span>
            </React.Fragment>
          ))}
        </p>

        {showConfigureAction ? (
          <div className={styles.groupConfigureEmptyActions}>
            {limitTooltip ? (
              <Tooltip title={limitTooltip}>
                <span className={styles.groupConfigureEmptyButtonWrap}>
                  {configureButton}
                </span>
              </Tooltip>
            ) : (
              configureButton
            )}
            <p className={styles.groupConfigureDurationHint}>
              {t("welcome.groupConfigureDurationHint")}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

function showArchiveGroupValidationToast(t, validationType, widgets = []) {
  if (validationType === "empty") {
    notification.error({
      message: t("common.error"),
      description: t("welcome.archiveGroupEmptyError"),
      duration: 6,
    });
    return;
  }
  notification.error({
    message: t("common.error"),
    description: (
      <div>
        <div>{t("welcome.archiveGroupNotReadyError")}</div>
        {widgets.map((widget) => (
          <div key={widget.id}>
            • {widget.name} — {formatWidgetStatusForArchiveDisplay(widget)}
          </div>
        ))}
      </div>
    ),
    duration: 8,
  });
}

function showRestoreGroupLimitToast(t, current, group, max, total) {
  notification.error({
    message: t("common.error"),
    description: (
      <div>
        <div>{t("welcome.restoreGroupLimitLead", { max })}</div>
        <div>
          {t("welcome.restoreGroupLimitMath", {
            current,
            group,
            total,
          })}
        </div>
      </div>
    ),
    duration: 10,
  });
}

const getDefaultWidgetTypeForMetric = (metricType, metricId, fallback = "chart") => {
  if (metricType !== "brand") return fallback;
  const mid = Number(metricId);
  if (WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(mid)) return "smart_narrative";
  if (WELCOME_GENAI_TABLE_METRIC_IDS.has(mid)) return "table";
  return WELCOME_METRIC_DEFAULT_PREFERED_VIEW[mid] ?? fallback;
};

/** Canonical representation view string for widget/add (not user-selected). */
function resolveWelcomeRepresentationView(metricType, metricId, context = {}) {
  const { findBrandMetric, accountMetricsOptions, selectedAccountMetric } =
    context;
  if (metricType === "brand") {
    const mid = Number(metricId);
    const pref =
      findBrandMetric?.(mid)?.preferedView ??
      WELCOME_METRIC_DEFAULT_PREFERED_VIEW[mid];
    return getDefaultWidgetTypeForMetric("brand", mid, pref || "chart");
  }
  if (metricType === "account") {
    const mid = Number(selectedAccountMetric ?? metricId);
    const opt = accountMetricsOptions?.find((o) => o.value === mid);
    return opt?.preferedView || "list";
  }
  return "chart";
}

function buildWelcomePivotLevelOptions(pivotData) {
  const merged = {};
  const ensureColumn = (col) => {
    if (!col || !String(col).trim()) return;
    const key = String(col).trim();
    if (!merged[key]) merged[key] = new Set();
  };
  const addValues = (col, values) => {
    ensureColumn(col);
    const key = String(col).trim();
    if (Array.isArray(values)) {
      values.forEach((v) => {
        if (v != null && String(v).trim()) merged[key].add(String(v).trim());
      });
    } else if (values && typeof values === "object") {
      Object.keys(values).forEach((v) => {
        if (v != null && String(v).trim()) merged[key].add(String(v).trim());
      });
    }
  };
  const ingestDist = (dist) => {
    if (typeof dist === "string") {
      try {
        const parsed = JSON.parse(dist);
        if (parsed && typeof parsed === "object") {
          ingestDist(parsed);
        }
      } catch {
        /* ignore malformed pivotColDist */
      }
      return;
    }
    if (!dist || typeof dist !== "object") return;
    // Match legacy getPivots: list every pivot column key from the API payload.
    Object.keys(dist).forEach(ensureColumn);
    Object.entries(dist).forEach(([col, values]) => addValues(col, values));
  };
  (pivotData || []).forEach((item) => {
    Object.values(item || {}).forEach((dist) => {
      ingestDist(dist);
    });
  });
  const level1 = Object.keys(merged)
    .sort((a, b) => a.localeCompare(b))
    .map((key) => ({ id: key, label: key, value: key }));
  const level2 = {};
  level1.forEach(({ id }) => {
    level2[id] = [...merged[id]]
      .sort((a, b) => a.localeCompare(b))
      .map((v) => ({ id: v, label: v, value: v }));
  });
  return { level1, level2 };
}

function pivotSelectionsToFilter(selections) {
  const out = {};
  Object.entries(selections || {}).forEach(([key, valMap]) => {
    const vals = Object.keys(valMap || {}).filter(Boolean);
    if (vals.length) out[key] = vals;
  });
  return Object.keys(out).length ? out : null;
}

function renderWelcomePivotReviewTags(selections, t, styleClasses) {
  const pivotFilter = pivotSelectionsToFilter(selections);
  const expr = formatWelcomePivotFilterBooleanExpr(pivotFilter);
  if (!expr) return null;
  return (
    <>
      <div className={styleClasses.requestSummaryCardSubLabel}>
        {t("welcome.pivotFilterBooleanLogic").toUpperCase()}
      </div>
      <div className={styleClasses.requestSummaryPivotBooleanExpr}>{expr}</div>
    </>
  );
}

function renderWelcomeQuotaCreditPills(quotaResult, t, styleClasses, mode = "success") {
  const { available, required, afterAction } =
    resolveWelcomeQuotaDisplayCredits(quotaResult);
  if (available == null) return null;

  const displayAvailable = available;
  const displayRequired = required ?? 0;
  const displayAfter =
    afterAction != null
      ? afterAction
      : Math.max(0, displayAvailable - displayRequired);

  if (mode === "insufficient") {
    const shortfall = Math.max(0, displayRequired - displayAvailable);
    return (
      <div className={styleClasses.quotaPillRow}>
        <div className={styleClasses.quotaPillGroup}>
          <span className={styleClasses.quotaPillLabel}>{t("welcome.currentQuota")}</span>
          <span className={`${styleClasses.quotaPill} ${styleClasses.quotaPillPurple}`}>
            {displayAvailable}
          </span>
        </div>
        <span className={styleClasses.quotaPillArrow}>→</span>
        <div className={styleClasses.quotaPillGroup}>
          <span className={styleClasses.quotaPillLabel}>{t("welcome.required")}</span>
          <span className={`${styleClasses.quotaPill} ${styleClasses.quotaPillOrange}`}>
            {displayRequired}
          </span>
        </div>
        <span className={styleClasses.quotaPillArrow}>→</span>
        <div className={styleClasses.quotaPillGroup}>
          <span className={styleClasses.quotaPillLabel}>{t("welcome.shortfall")}</span>
          <span className={`${styleClasses.quotaPill} ${styleClasses.quotaPillRed}`}>
            -{shortfall}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={styleClasses.quotaPillRow}>
      <div className={styleClasses.quotaPillGroup}>
        <span className={styleClasses.quotaPillLabel}>{t("welcome.currentQuota")}</span>
        <span className={`${styleClasses.quotaPill} ${styleClasses.quotaPillPurple}`}>
          {displayAvailable}
        </span>
      </div>
      <span className={styleClasses.quotaPillArrow}>→</span>
      <div className={styleClasses.quotaPillGroup}>
        <span className={styleClasses.quotaPillLabel}>{t("welcome.willUse")}</span>
        <span className={`${styleClasses.quotaPill} ${styleClasses.quotaPillOrange}`}>
          {displayRequired}
        </span>
      </div>
      <span className={styleClasses.quotaPillArrow}>→</span>
      <div className={styleClasses.quotaPillGroup}>
        <span className={styleClasses.quotaPillLabel}>{t("welcome.remainingQuota")}</span>
        <span className={`${styleClasses.quotaPill} ${styleClasses.quotaPillPurple}`}>
          {displayAfter}
        </span>
      </div>
    </div>
  );
}

function pivotFilterToLevelSelections(pivotFilter) {
  if (!pivotFilter || typeof pivotFilter !== "object") return {};
  const out = {};
  Object.entries(pivotFilter).forEach(([key, vals]) => {
    const list = Array.isArray(vals) ? vals : vals != null ? [vals] : [];
    const map = {};
    list.forEach((v) => {
      if (v != null && String(v).trim()) map[String(v).trim()] = {};
    });
    if (Object.keys(map).length) out[key] = map;
  });
  return out;
}

function buildWelcomePivotPayload(selections, operator = "AND") {
  const pivot_filter = pivotSelectionsToFilter(selections);
  if (!pivot_filter) return {};
  const keys = Object.keys(pivot_filter);
  const payload = {
    pivot_filter,
    pivots_operator: operator,
  };
  if (keys.length >= 1) {
    payload.pivot_key = keys[0];
    payload.pivot_values = pivot_filter[keys[0]];
  }
  return payload;
}

/** User-facing pivot label (values only — no vendorName: technical prefix). */
function deriveWelcomePivotDisplayLabel(widget) {
  const pf = welcomePivotFilterFromWidget(widget);
  if (!pf) return "";
  return Object.entries(pf)
    .map(([key, vals]) => {
      const valsStr = (Array.isArray(vals) ? vals : [vals])
        .map((v) => humanizeUnderscoresForDisplay(String(v)))
        .join(", ");
      const keyH = humanizeUnderscoresForDisplay(key);
      return valsStr ? `${keyH}: ${valsStr}` : keyH;
    })
    .join(" · ");
}

/** Derive "pivot_key: v1, v2" from persisted pivot scope. */
function deriveWelcomePivotTitleDetail(widget) {
  const pf = welcomePivotFilterFromWidget(widget);
  if (!pf) return "";
  return Object.entries(pf)
    .map(([key, vals]) => {
      const valsStr = (Array.isArray(vals) ? vals : [vals])
        .map((v) => humanizeUnderscoresForDisplay(String(v)))
        .join(", ");
      const keyH = humanizeUnderscoresForDisplay(key);
      return keyH && valsStr ? `${keyH}: ${valsStr}` : keyH || valsStr;
    })
    .join(" · ");
}

function formatPivotFilterForView(widget) {
  const d = deriveWelcomePivotTitleDetail(widget);
  return d || "—";
}

/** Topic scope for widget chrome: API topic_scope_label or joined topic_labels. */
export function welcomeWidgetTopicScopeLine(widget) {
  const fromApi = String(widget?.topic_scope_label ?? "").trim();
  if (fromApi) return decodeBasicHtmlEntities(fromApi);
  const labs = Array.isArray(widget?.topic_labels)
    ? widget.topic_labels.filter((l) => l != null && String(l).trim() !== "")
    : [];
  if (labs.length) return decodeBasicHtmlEntities(labs.join(", "));
  return "";
}

/** Header line: widget name · pivot (if any) · topic scope (if parent topic was chosen). */
export function buildWelcomeWidgetTitleLine(widget, baseTitle) {
  const segments = [];
  const b = String(baseTitle ?? "").trim();
  if (b) segments.push(decodeBasicHtmlEntities(b));
  const pivot = deriveWelcomePivotDisplayLabel(widget);
  if (pivot) segments.push(decodeBasicHtmlEntities(pivot));
  const topic = welcomeWidgetTopicScopeLine(widget);
  if (topic) segments.push(topic);
  return segments.join(" · ");
}

/** Widget header date range from welcomeWidget since/until (locale-aware). */
export function formatWelcomeWidgetDateRangeLabel(widget, language) {
  const since = widget?.since;
  const until = widget?.until;
  if (!since && !until) return "";

  const locale = getIntlLocale(language);

  const fmt = (iso) => {
    if (iso == null || iso === "") return null;
    const parsed = dayjs(iso);
    if (parsed.isValid()) {
      return parsed.toDate().toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
    return String(iso).trim() || null;
  };

  const start = fmt(since);
  const end = fmt(until);
  if (start && end) return `${start} – ${end}`;
  if (start) return start;
  if (end) return end;
  return "";
}

const SmartNarrativeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <path d="M5 8.5H16.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M5 13.5H18.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M5 18.5H14.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M20.5 6.5L21.3 8.7L23.5 9.5L21.3 10.3L20.5 12.5L19.7 10.3L17.5 9.5L19.7 8.7L20.5 6.5Z" fill="currentColor" />
    <path d="M22.5 15L22.98 16.27L24.25 16.75L22.98 17.23L22.5 18.5L22.02 17.23L20.75 16.75L22.02 16.27L22.5 15Z" fill="currentColor" />
  </svg>
);

/** Limit parallel welcome/widgets/load calls (reduces backend/Dynamo burst). */
const WIDGET_LOAD_GROUP_CONCURRENCY = 3;

async function mapWithConcurrency(items, concurrency, mapper) {
  const ret = new Array(items.length);
  let nextIndex = 0;
  const workerCount = Math.min(concurrency, items.length);
  const workers = Array.from({ length: workerCount }, async () => {
    while (true) {
      const i = nextIndex++;
      if (i >= items.length) break;
      ret[i] = await mapper(items[i], i);
    }
  });
  await Promise.all(workers);
  return ret;
}

/** Max concurrent welcome/widget/data requests. A wide workspace renders many
 *  widgets at once; useQueries would otherwise fire one heavy KPI request per
 *  visible widget in parallel and overwhelm the backend's few workers. */
const WELCOME_WIDGET_DATA_CONCURRENCY = 10;

/** Promise-returning gate that runs at most `maxConcurrent` tasks at a time;
 *  extra tasks queue (FIFO) until a slot frees up. */
function createConcurrencyLimiter(maxConcurrent) {
  let active = 0;
  const queue = [];
  const runNext = () => {
    if (active >= maxConcurrent || queue.length === 0) return;
    active += 1;
    const { task, resolve, reject } = queue.shift();
    Promise.resolve()
      .then(task)
      .then(resolve, reject)
      .finally(() => {
        active -= 1;
        runNext();
      });
  };
  return (task) =>
    new Promise((resolve, reject) => {
      queue.push({ task, resolve, reject });
      runNext();
    });
}

const limitWelcomeWidgetData = createConcurrencyLimiter(
  WELCOME_WIDGET_DATA_CONCURRENCY,
);

/** A widget must stay in view this long before its data is fetched. Fast
 *  scrolling past a wide workspace would otherwise fire a request for every
 *  widget that briefly crossed the viewport; the dwell delay ignores those. */
const WELCOME_WIDGET_VISIBILITY_DWELL_MS = 100;

/** Default English titles from API when widget uses stock metric name — enables TR i18n. */
const WELCOME_METRIC_DEFAULT_EN = {
  1: "Most Increasing KPI",
  2: "Most Decreasing KPI",
  3: "Subscription Details",
  4: "Latest Reports",
  5: "Latest Exports",
  6: "Alarms Hit",
  7: "Insight Notes Created",
  8: "Review Statistics",
  9: "Average Rating",
  10: "Positive Sentiment Score",
  29: "Praise Intent Score",
  11: "Sentiment Distribution",
  12: "Intent Distribution",
  13: "Rating per Topic",
  14: "Sentiment per Topic",
  15: "Participation per Topic",
  16: "Emergent Topics",
  17: "Intent per Topic",
  18: "Digital Experience Score",
  19: "AI Insights (Root Cause)",
  20: "Root Cause & Recommendations",
  21: "General Summary",
  22: "Topic-wise Summary",
  23: "Key Drivers Analysis",
  24: "Topic-wise Key Drivers Analysis",
  25: "Highlights Summary",
  27: "Decision Analysis",
  28: "Hot Terms",
};

export const DECISION_DISTRIBUTION_CONFIG = [
  {
    key: "publish",
    titleKey: "welcome.decisionPublishTitle",
    labels: ["welcome.decisionDoNotPublish", "welcome.decisionPublish"],
    colors: ["#4A99E3", "#35D0BA"],
  },
  {
    key: "opencase",
    titleKey: "welcome.decisionOpenCaseTitle",
    labels: ["welcome.decisionDoNotOpenCase", "welcome.decisionOpenCase"],
    colors: ["#FF3B7F", "#C084FC"],
  },
  {
    key: "takeaction",
    titleKey: "welcome.decisionTakeActionTitle",
    labels: ["welcome.decisionDoNotTakeAction", "welcome.decisionTakeAction"],
    colors: ["#60A5FA", "#E2E8F0"],
  },
];

function normalizeDecisionDistributionRows(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.filter((row) => row && row.decision);
}

function decisionDistributionToMap(rows) {
  return new Map(
    normalizeDecisionDistributionRows(rows).map((row) => [
      String(row.decision).toLowerCase(),
      row,
    ]),
  );
}

function hasDecisionDistributionData(rows) {
  return normalizeDecisionDistributionRows(rows).some((row) => {
    const dist = row?.dist || {};
    const trueCount = Number(dist.True ?? dist.true ?? 0) || 0;
    const falseCount = Number(dist.False ?? dist.false ?? 0) || 0;
    return trueCount + falseCount > 0;
  });
}

function resolveDecisionTabReviewCount(tab) {
  const raw = tab?.review_count ?? tab?.reviewCount;
  if (raw != null && raw !== "" && Number.isFinite(Number(raw))) {
    return Number(raw);
  }
  return null;
}

/** General tab count comes from API only; do not sum topic tabs (OR vs double-count). */
function resolveGeneralDecisionTabReviewCount(rawTabs) {
  const g = Array.isArray(rawTabs)
    ? rawTabs.find(
        (x) => x && String(x.id || "").toLowerCase() === "general",
      )
    : null;
  const raw = g?.review_count ?? g?.reviewCount;
  if (raw != null && raw !== "" && Number.isFinite(Number(raw))) {
    return Number(raw);
  }
  return null;
}

/** Map API decision keys (e.g. open_case) to Welcome UI slugs (opencase). */
function normalizeWelcomeDecisionSlug(decision) {
  if (decision == null || decision === "") return decision;
  const lower = String(decision).trim().toLowerCase();
  if (lower === "open_case") return "opencase";
  if (lower === "take_action") return "takeaction";
  return lower.replace(/_/g, "").replace(/\s+/g, "");
}

export function normalizeWelcomeDecisionRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    if (!row || typeof row !== "object") return row;
    const slug = normalizeWelcomeDecisionSlug(row.decision);
    if (slug === row.decision) return row;
    return { ...row, decision: slug };
  });
}

/**
 * Match Dashboard DateFilter + URL: prefer explicit since/until; else apply
 * daysRange using dynamic window or DashboardReducer.end_date like DateFilter.
 */
function getWelcomeKpiSinceUntil(searchParams, dashboardReducer) {
  const sinceUrl = searchParams.get("since");
  const untilUrl = searchParams.get("until");
  if (sinceUrl && untilUrl) {
    return { since: sinceUrl, until: untilUrl };
  }
  const daysRangeId = searchParams.get("daysRange") || "last7d";
  const presetDaysBack = {
    last7d: 6,
    last14d: 13,
    last30d: 29,
    last90d: 89,
  };
  const back =
    typeof presetDaysBack[daysRangeId] === "number"
      ? presetDaysBack[daysRangeId]
      : 6;

  const isDynamic = Boolean(dashboardReducer?.dashboard?.RefreshRate);
  if (isDynamic) {
    const until = dayjs();
    return {
      since: until.subtract(back, "day").format("YYYY-MM-DD"),
      until: until.format("YYYY-MM-DD"),
    };
  }
  const endDateRaw = dashboardReducer?.end_date;
  if (endDateRaw && String(endDateRaw).trim() !== "") {
    const end = dayjs(endDateRaw);
    if (end.isValid()) {
      return {
        since: end.subtract(back, "day").format("YYYY-MM-DD"),
        until: end.format("YYYY-MM-DD"),
      };
    }
  }
  const until = dayjs();
  return {
    since: until.subtract(back, "day").format("YYYY-MM-DD"),
    until: until.format("YYYY-MM-DD"),
  };
}

function welcomeGroupsEligibleForPdfExport(groups) {
  return (groups || []).filter(
    (g) => g && !g.is_archived && !g.is_auto_report,
  );
}

const WelcomePdfExportContext = createContext(null);

function WelcomePdfExportProvider({
  children,
  groups,
  archivedGroups = [],
  loadingGroups,
  loadingArchivedGroups = false,
  dashboardReducer,
  workspaceOwnerId,
  currentUserId,
}) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [pdfExportModalOpen, setPdfExportModalOpen] = useState(false);
  const [pdfExportGroupIds, setPdfExportGroupIds] = useState([]);
  const [pdfExportArchivedOnly, setPdfExportArchivedOnly] = useState(false);
  const [pdfExportModalGroups, setPdfExportModalGroups] = useState([]);
  const [isCreatingReport, setIsCreatingReport] = useState(false);
  const exportableGroups = useMemo(
    () => welcomeGroupsEligibleForPdfExport(groups),
    [groups],
  );
  const exportableArchivedGroups = useMemo(
    () => (archivedGroups || []).filter((g) => g && g.id != null),
    [archivedGroups],
  );

  const openPdfExportModal = useCallback(
    (options = {}) => {
      const archived = options?.archived === true;
      const pool = archived ? exportableArchivedGroups : exportableGroups;
      const poolLoading = archived ? loadingArchivedGroups : loadingGroups;
      if (isCreatingReport || poolLoading || !pool.length) return;
      setPdfExportArchivedOnly(archived);
      setPdfExportModalGroups(pool);
      const allIds = pool.map((g) => g.id).filter((id) => id != null);
      setPdfExportGroupIds(allIds);
      setPdfExportModalOpen(true);
    },
    [
      isCreatingReport,
      loadingGroups,
      loadingArchivedGroups,
      exportableGroups,
      exportableArchivedGroups,
    ],
  );

  const submitPdfExport = useCallback(() => {
    if (pdfExportGroupIds.length === 0) {
      message.warning(t("welcome.generatePdfNoGroupsSelected"));
      return;
    }
    setIsCreatingReport(true);
    setPdfExportModalOpen(false);
    const sp = new URLSearchParams(location.search);
    const { since, until } = getWelcomeKpiSinceUntil(sp, dashboardReducer);
    const idSet = new Set(pdfExportGroupIds.map((id) => Number(id)));
    const selectedGroups = pdfExportModalGroups
      .filter((g) => idSet.has(Number(g.id)))
      .sort((a, b) => (a.order || 0) - (b.order || 0));
    const groupLabels = selectedGroups.map(
      (g) =>
        (g.name && String(g.name).trim()) ||
        `${t("welcome.enterGroupNameLabel")} #${g.id}`,
    );
    const groupsPart = groupLabels.join(" · ");
    const baseReportTitle = t("welcome.workspacePdfReportBase");
    const report_name = groupsPart
      ? t("welcome.pdfReportNameWithGroups", { base: baseReportTitle, groups: groupsPart })
      : baseReportTitle;
    apiRequest(
      "report/create",
      "POST",
      appendWorkspaceUserId(
        {
          report_name,
          type: 3,
          report_type: 3,
          welcome_group_ids: pdfExportGroupIds,
          welcome_pdf_archived_groups: pdfExportArchivedOnly,
          since,
          until,
        },
        workspaceOwnerId,
        currentUserId,
      ),
      true,
    )
      .then((result) => {
        if (result?.cancel) return;
        if (result?.error) {
          notification.error({
            message: t("common.error"),
            description:
              typeof result.error === "string"
                ? result.error
                : t("welcome.generatePdfRequestFailed"),
          });
          return;
        }
        notification.success({
          message: t("common.success"),
          description: (
            <div style={{ lineHeight: 1.55, paddingBottom: 6 }}>
              <p style={{ margin: "0 0 10px" }}>
                {t("welcome.50")} {t("welcome.52")}
              </p>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  history.push("/console/report?page=report");
                }}
                style={{
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  color: "#1890ff",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {t("welcome.51")}
              </a>
            </div>
          ),
          duration: 6,
        });
      })
      .catch((error) => {
        console.error("Error creating report:", error);
        notification.error({
          message: t("common.error"),
          description: t("welcome.generatePdfRequestFailed"),
        });
      })
      .finally(() => {
        setIsCreatingReport(false);
      });
  }, [
    pdfExportGroupIds,
    pdfExportModalGroups,
    pdfExportArchivedOnly,
    t,
    location.search,
    dashboardReducer,
    history,
    workspaceOwnerId,
    currentUserId,
  ]);

  const pdfExportContextValue = useMemo(
    () => ({
      openPdfExportModal,
      isCreatingReport,
      hasExportableGroups: exportableGroups.length > 0,
      hasArchivedExportableGroups: exportableArchivedGroups.length > 0,
    }),
    [
      openPdfExportModal,
      isCreatingReport,
      exportableGroups.length,
      exportableArchivedGroups.length,
    ],
  );

  return (
    <WelcomePdfExportContext.Provider value={pdfExportContextValue}>
      {children}
      <Modal
        title={
          pdfExportArchivedOnly
            ? t("welcome.generatePdfModalTitleArchived")
            : t("welcome.generatePdfModalTitle")
        }
        open={pdfExportModalOpen}
        onCancel={() => {
          setPdfExportModalOpen(false);
          setPdfExportModalGroups([]);
          setPdfExportArchivedOnly(false);
        }}
        destroyOnClose
        okText={t("welcome.generatePdfOk")}
        cancelText={t("common.cancel")}
        onOk={() => submitPdfExport()}
        width={480}
      >
        <p style={{ marginBottom: 12 }}>
          {pdfExportArchivedOnly
            ? t("welcome.generatePdfModalHintArchived")
            : t("welcome.generatePdfModalHint")}
        </p>
        <Space style={{ marginBottom: 0 }}>
          <Button
            type="link"
            size="small"
            onClick={() =>
              setPdfExportGroupIds(
                pdfExportModalGroups.map((g) => g.id).filter((id) => id != null),
              )
            }
          >
            {t("welcome.selectAll")}
          </Button>
          <Button type="link" size="small" danger onClick={() => setPdfExportGroupIds([])}>
            {t("welcome.clearAll")}
          </Button>
        </Space>
        <Checkbox.Group
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginTop: 20,
            paddingTop: 8,
          }}
          value={pdfExportGroupIds}
          onChange={(vals) => setPdfExportGroupIds(vals.map((v) => Number(v)))}
        >
          {[...pdfExportModalGroups]
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((g) => (
              <Checkbox key={g.id} value={g.id}>
                {g.name || `${t("welcome.enterGroupNameLabel")} #${g.id}`}
                {Array.isArray(g.widgets) ? (
                  <span style={{ color: "#888", marginLeft: 8, fontSize: 12 }}>
                    ({g.widgets.length})
                  </span>
                ) : null}
              </Checkbox>
            ))}
        </Checkbox.Group>
      </Modal>
    </WelcomePdfExportContext.Provider>
  );
}

function useWelcomePdfExport() {
  const ctx = useContext(WelcomePdfExportContext);
  if (!ctx) {
    throw new Error("useWelcomePdfExport must be used within WelcomePdfExportProvider");
  }
  return ctx;
}

/** After raw KPI dependency strings stop changing, update kpiEffectStableKey so the batched KPI useEffect runs once per settle (not on every Redux commit). */
const WELCOME_WIDGET_DATA_DEBOUNCE_MS = 400;

function parseTopicLibIdFromWidgetTab(widget, tabKey) {
  const s = String(tabKey || "").trim();
  const lower = s.toLowerCase();
  if (!s || lower === "general" || lower === "global") return null;
  const rawIds =
    widget?.topic_ids ?? widget?.industry_topic_ids ?? widget?.data?.topic_ids ?? [];
  const tids = Array.isArray(rawIds)
    ? rawIds
        .map((x) => Number(x))
        .filter((x) => Number.isFinite(x) && x > 0)
    : [];
  // Mongo / worker tab ids: topic_<libraryId>
  const under = s.match(/^topic_(\d+)$/i);
  if (under) {
    const n = Number(under[1]);
    if (Number.isFinite(n) && n > 0) return n;
  }
  // Synthetic / KPI index ids: topic-1 … or topic-<libraryId>
  if (!s.toLowerCase().startsWith("topic-")) return null;
  const rest = s.slice("topic-".length);
  const n = Number(rest);
  if (!Number.isFinite(n)) return null;
  if (tids.includes(n)) return n;
  if (n >= 1 && n <= tids.length) return tids[n - 1];
  return null;
}

function welcomeTopicTabPartialLoadingKey(widgetId, topicLibId) {
  return `${widgetId}:${topicLibId}`;
}

/**
 * Group list from `/welcome/groups` (or similar) usually omits KPI `data`.
 * When the widget list identity changes (e.g. a new widget is added), syncing raw rows
 * would wipe in-memory chart payloads and show "No Data" for every widget.
 */
function mergeWelcomeWidgetRowFromGroupSync(incoming, previous) {
  const decoded =
    incoming?.name != null
      ? { ...incoming, name: decodeBasicHtmlEntities(incoming.name) }
      : { ...incoming };
  if (!previous) return decoded;

  if (String(decoded.status) !== String(previous.status)) {
    return decoded;
  }

  const incomingDataEmpty =
    !decoded.data ||
    typeof decoded.data !== "object" ||
    Object.keys(decoded.data).length === 0;
  const prevHasKpi =
    previous.data &&
    typeof previous.data === "object" &&
    Object.keys(previous.data).length > 0;

  if (incomingDataEmpty && prevHasKpi) {
    return {
      ...decoded,
      data: previous.data,
    };
  }

  return decoded;
}

export function WelcomeDecisionDistributionCards({
  rows,
  theme,
  t,
  onDecisionCardSliceClick,
  topicLibId,
}) {
  const decisionMap = new Map(
    normalizeDecisionDistributionRows(rows).map((row) => [
      String(row.decision).toLowerCase(),
      row,
    ]),
  );

  return (
    <div className={styles.welcomeDecisionGrid}>
      {DECISION_DISTRIBUTION_CONFIG.map((cfg) => {
        const row = decisionMap.get(cfg.key);
        const dist = row?.dist || {};
        const trueCount = Number(dist.True ?? dist.true ?? 0) || 0;
        const falseCount = Number(dist.False ?? dist.false ?? 0) || 0;
        const total = trueCount + falseCount;
        const valueMode = String(row?.value_mode || "").toLowerCase();
        const isPercentageMode = valueMode === "percentage";
        const falsePct = total > 0 ? Number(((falseCount / total) * 100).toFixed(1)) : 0;
        const truePct = total > 0 ? Number(((trueCount / total) * 100).toFixed(1)) : 0;
        const labels = cfg.labels.map((k) => t(k));

        return (
          <div key={cfg.key} className={styles.welcomeDecisionCard}>
            <div className={styles.welcomeDecisionCardTitle}>{t(cfg.titleKey)}</div>
            <KPIDoughnutChart
              data={{
                labels,
                datasets: [
                  {
                    data: [falsePct, truePct],
                    backgroundColor: cfg.colors,
                    borderWidth: 0,
                  },
                ],
              }}
              theme={theme}
              showLegend={false}
              valueAsPercent={isPercentageMode}
              customLabels={
                isPercentageMode ? undefined : [falseCount, trueCount]
              }
              hideZeroLabels
              onSliceClick={
                onDecisionCardSliceClick
                  ? (isTrueSlice) =>
                      onDecisionCardSliceClick(cfg.key, isTrueSlice, topicLibId)
                  : undefined
              }
            />
            <div className={styles.welcomeDecisionLegend}>
              <span className={styles.welcomeDecisionLegendItem}>
                <span
                  className={styles.welcomeDecisionLegendDot}
                  style={{ backgroundColor: cfg.colors[0] }}
                />
                {labels[0]}
              </span>
              <span className={styles.welcomeDecisionLegendItem}>
                <span
                  className={styles.welcomeDecisionLegendDot}
                  style={{ backgroundColor: cfg.colors[1] }}
                />
                {labels[1]}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function WelcomeDecisionDistribution({
  data,
  theme,
  widget,
  onTopicTabLoad,
  activeTabKey,
  onActiveTabKeyChange,
  onDecisionSliceClick,
}) {
  const { t, i18n } = useTranslation();
  const nf = new Intl.NumberFormat(
    getIntlLocale(i18n.language),
  );
  const reviewCountLine = (count) => {
    if (count == null || !Number.isFinite(Number(count)) || Number(count) < 0) {
      return t("welcome.hierarchicalTabReviewCountNA");
    }
    return t("welcome.hierarchicalTabReviewCount", {
      count: nf.format(Number(count)),
    });
  };
  const rawDecisions = normalizeWelcomeDecisionRows(
    Array.isArray(data?.decisions)
      ? data.decisions
      : Array.isArray(data?.success)
        ? data.success
        : [],
  );
  const rawTabs = Array.isArray(data?.summary_tabs) ? data.summary_tabs : [];
  const generalTabRow = rawTabs.find(
    (tab) => String(tab.id || "").toLowerCase() === "general",
  );
  const topicTabs = rawTabs.filter((tab) => {
    if (!tab || String(tab.id || "").toLowerCase() === "general") {
      return false;
    }
    if (tab.payload_pending) return true;
    const decisions = normalizeWelcomeDecisionRows(tab.decisions);
    return hasDecisionDistributionData(decisions);
  });
  if (topicTabs.length > 0) {
    const topicTabsNormalized = topicTabs.map((tab) => ({
      ...tab,
      decisions: normalizeWelcomeDecisionRows(tab.decisions),
    }));
    const generalDecisionsFromApi = generalTabRow
      ? normalizeWelcomeDecisionRows(generalTabRow.decisions || [])
      : [];
    const pendingAnyTopic = topicTabs.some((t) => t.payload_pending);
    // Legacy payloads (single topic, no General tab): keep single panel.
    if (
      !generalTabRow &&
      topicTabsNormalized.length === 1
    ) {
      const tab = topicTabsNormalized[0];
      const singleTopicLibIdRaw = tab?.topic_id;
      const singleTopicLibId =
        singleTopicLibIdRaw != null &&
        Number.isFinite(Number(singleTopicLibIdRaw))
          ? Number(singleTopicLibIdRaw)
          : null;
      return (
        <div className={styles.welcomeGeneralSummaryHierarchicalTabPanel}>
          <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
            <span
              className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
            >
              {reviewCountLine(resolveDecisionTabReviewCount(tab))}
            </span>
          </div>
          {tab.payload_pending ||
          !hasDecisionDistributionData(tab.decisions) ? (
            <div className={styles.tabLoadingCenter}>
              <Spin size="large" />
            </div>
          ) : (
            <WelcomeDecisionDistributionCards
              rows={tab.decisions}
              theme={theme}
              t={t}
              onDecisionCardSliceClick={onDecisionSliceClick}
              topicLibId={singleTopicLibId}
            />
          )}
        </div>
      );
    }

    const generalRows = hasDecisionDistributionData(generalDecisionsFromApi)
      ? generalDecisionsFromApi
      : generalTabRow
        ? normalizeWelcomeDecisionRows(generalTabRow.decisions || [])
        : [];
    const generalLabel = t("welcome.genaiMultiTopicGeneralTab");
    const generalRc = resolveGeneralDecisionTabReviewCount(rawTabs);
    const items = [
      {
        key: "general",
        label: generalLabel,
        children: (
          <div className={styles.welcomeGeneralSummaryHierarchicalTabPanel}>
            <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
              <span
                className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
              >
                {reviewCountLine(generalRc)}
              </span>
            </div>
            {hasDecisionDistributionData(generalRows) ? (
              <WelcomeDecisionDistributionCards
                rows={generalRows}
                theme={theme}
                t={t}
                onDecisionCardSliceClick={onDecisionSliceClick}
                topicLibId={null}
              />
            ) : (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            )}
          </div>
        ),
      },
      ...topicTabsNormalized.map((tab, idx) => ({
        key: String(tab.id || `topic-${idx + 1}`),
        label: decodeBasicHtmlEntities(String(tab.label || `#${idx + 1}`)),
        children: (
          <div className={styles.welcomeGeneralSummaryHierarchicalTabPanel}>
            <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
              <span
                className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
              >
                {reviewCountLine(resolveDecisionTabReviewCount(tab))}
              </span>
            </div>
            {tab.payload_pending ||
            !hasDecisionDistributionData(tab.decisions) ? (
              <div className={styles.tabLoadingCenter}>
                <Spin size="large" />
              </div>
            ) : (
              <WelcomeDecisionDistributionCards
                rows={tab.decisions}
                theme={theme}
                t={t}
                onDecisionCardSliceClick={onDecisionSliceClick}
                topicLibId={
                  tab?.topic_id != null &&
                  Number.isFinite(Number(tab.topic_id))
                    ? Number(tab.topic_id)
                    : null
                }
              />
            )}
          </div>
        ),
      })),
    ];
    const lazyTabs =
      widget &&
      welcomeWidgetUsesLazyTopicTabs(widget) &&
      onActiveTabKeyChange;
    const firstKey = String(items[0]?.key ?? "general");
    const resolvedActiveKey =
      lazyTabs && activeTabKey !== undefined && activeTabKey !== null
        ? String(activeTabKey)
        : firstKey;
    return (
      <Tabs
        items={items}
        className={styles.welcomeHierarchicalTabs}
        {...(lazyTabs ? { activeKey: resolvedActiveKey } : {})}
        onChange={(key) => {
          if (lazyTabs) {
            onActiveTabKeyChange(key);
          }
          if (!onTopicTabLoad || !widget) return;
          if (!welcomeWidgetUsesLazyTopicTabs(widget)) return;
          const lib = parseTopicLibIdFromWidgetTab(widget, key);
          if (lib == null) return;
          const row = rawTabs.find((x) => String(x.id) === String(key));
          if (
            row &&
            !row.payload_pending &&
            hasDecisionDistributionData(
              normalizeWelcomeDecisionRows(row.decisions),
            )
          ) {
            return;
          }
          void onTopicTabLoad(widget, lib);
        }}
      />
    );
  }

  if (!hasDecisionDistributionData(rawDecisions)) {
    return (
      <WelcomeWidgetEmptyState
        t={t}
        className={styles.noDataMessage}
        data={data}
        metricId={widget?.metric_id}
        widgetRow={widget}
      />
    );
  }
  return (
    <WelcomeDecisionDistributionCards
      rows={rawDecisions}
      theme={theme}
      t={t}
      onDecisionCardSliceClick={onDecisionSliceClick}
      topicLibId={null}
    />
  );
}

function cloneWelcomeHottermsNgrams(src) {
  if (!src || typeof src !== "object") return {};
  const copy = {};
  Object.keys(src).forEach((k) => {
    const row = src[k];
    copy[k] = Array.isArray(row)
      ? row.map((item) =>
          item && typeof item === "object" ? { ...item } : item,
        )
      : row;
  });
  return copy;
}

/** One scope (General or topic): n-gram sub-tabs + review meta + tags. */
function WelcomeHotTermsNGramPanel({
  ngrams,
  reviewCount,
  sourceFallback,
  scopeData,
  widget,
}) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [ngState, setNgState] = useState(() => cloneWelcomeHottermsNgrams(ngrams));
  const [showBlacklistModal, setShowBlacklistModal] = useState(false);
  const [termToBlacklist, setTermToBlacklist] = useState(null);
  const [blacklistNgramType, setBlacklistNgramType] = useState(1);
  const [blacklisting, setBlacklisting] = useState(false);

  useEffect(() => {
    setNgState(cloneWelcomeHottermsNgrams(ngrams));
  }, [ngrams]);

  const nf = new Intl.NumberFormat(
    getIntlLocale(i18n.language),
  );
  const available = Object.keys(ngState)
    .map((k) => Number(k))
    .filter(
      (n) =>
        Number.isFinite(n) &&
        Array.isArray(ngState[String(n)]) &&
        ngState[String(n)].length > 0,
    )
    .sort((a, b) => a - b);

  if (available.length === 0) {
    return (
      <WelcomeWidgetEmptyState
        t={t}
        className={styles.noDataMessage}
        data={scopeData ?? widget?.data}
        metricId={widget?.metric_id}
        widgetRow={widget}
      />
    );
  }

  const reviewCountLine = () => {
    const scopeLabel = formatWelcomeReviewScopeLabel(
      t,
      nf,
      resolveWelcomeReviewScopeFromData(scopeData, widget),
    );
    if (scopeLabel) return scopeLabel;
    const rc =
      reviewCount != null && reviewCount !== ""
        ? reviewCount
        : sourceFallback;
    if (rc != null && rc !== "" && Number.isFinite(Number(rc))) {
      return t("welcome.hierarchicalTabReviewCount", {
        count: nf.format(Number(rc)),
      });
    }
    return t("welcome.hierarchicalTabReviewCountNA");
  };

  const handleBlacklistTerm = (termObj, ngramType, e) => {
    e.stopPropagation();
    setTermToBlacklist(termObj);
    setBlacklistNgramType(Number(ngramType));
    setShowBlacklistModal(true);
  };

  const confirmBlacklist = async () => {
    if (!termToBlacklist) return;
    setBlacklisting(true);
    try {
      const result = await apiRequest(
        "users/hotterms/blacklist/add",
        "POST",
        {
          term: termToBlacklist.terms,
          term_type: blacklistNgramType,
        },
        true,
      );
      if (result && result.success) {
        notification.success({
          message: t(
            "dashboard_tooltips.hotterms.blacklist.success",
            "Term successfully blacklisted",
          ),
        });
        setShowBlacklistModal(false);
        setTermToBlacklist(null);
        setNgState((prev) => {
          const key = String(blacklistNgramType);
          const row = Array.isArray(prev[key]) ? prev[key] : [];
          return {
            ...prev,
            [key]: row.filter((x) => x && x.terms !== termToBlacklist.terms),
          };
        });
      } else {
        notification.error({
          message:
            (result && result.error) ||
            t(
              "dashboard_tooltips.hotterms.blacklist.error",
              "Failed to blacklist term",
            ),
        });
      }
    } catch (err) {
      notification.error({
        message: t(
          "dashboard_tooltips.hotterms.blacklist.error",
          "Failed to blacklist term",
        ),
      });
    } finally {
      setBlacklisting(false);
    }
  };

  const items = available.map((n) => ({
    key: String(n),
    label: t("welcome.hotTermsNGramTab", { n }),
    children: (
      <div className={styles.welcomeGeneralSummaryHierarchicalTabPanel}>
        <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
          <span
            className={styles.welcomeGeneralSummaryHierarchicalTabReviewCount}
          >
            {reviewCountLine()}
          </span>
        </div>
        <div className={styles.welcomeHottermsTags}>
          {(ngState[String(n)] || []).map((term) => (
            <Tag
              key={String(term?.terms)}
              className={styles.welcomeHottermTag}
            >
              <Badge
                count={Number(term?.count || 0)}
                overflowCount={9999}
                className={styles.welcomeHottermBadge}
              />
              <span>{String(term?.terms || "")}</span>
              <Button
                type="text"
                icon={<CloseOutlined style={{ fontSize: 10 }} />}
                size="small"
                className={styles.welcomeHottermRemoveBtn}
                onClick={(e) => handleBlacklistTerm(term, n, e)}
                title={t(
                  "dashboard_tooltips.hotterms.remove",
                  "Remove term",
                )}
              />
            </Tag>
          ))}
        </div>
      </div>
    ),
  }));

  return (
    <>
      <Tabs
        defaultActiveKey={String(available[available.length - 1])}
        items={items}
        className={`${styles.welcomeHierarchicalTabs} ${styles.welcomeHottermsInnerTabs}`}
      />
      <Modal
        title={t(
          "dashboard_tooltips.hotterms.blacklist.confirm_title",
          "Blacklist Hot Term",
        )}
        open={showBlacklistModal}
        onOk={confirmBlacklist}
        onCancel={() => {
          setShowBlacklistModal(false);
          setTermToBlacklist(null);
        }}
        confirmLoading={blacklisting}
        okText={t(
          "dashboard_tooltips.hotterms.blacklist.confirm",
          "Blacklist",
        )}
        cancelText={t("button.cancel", "Cancel")}
      >
        <p>
          {t(
            "dashboard_tooltips.hotterms.blacklist.confirm_message",
            "Are you sure you want to blacklist the term",
          )}
          <span className={styles.welcomeHottermBlacklistQuote}>
            &ldquo;{termToBlacklist?.terms}&rdquo;
          </span>
          ?
        </p>
        <p>
          {t(
            "dashboard_tooltips.hotterms.blacklist.confirm_description",
            "This term will be hidden from all hot terms results for your organization. You can view and manage all blacklisted terms in the ",
          )}
          <a
            href="/settings/preferences"
            className={styles.welcomeHottermPrefsLink}
            onClick={(e) => {
              e.preventDefault();
              setShowBlacklistModal(false);
              setTermToBlacklist(null);
              history.push("/settings/preferences");
            }}
          >
            {t(
              "dashboard_tooltips.hotterms.blacklist.preferences_link",
              "Preferences page",
            )}
          </a>
          .
        </p>
      </Modal>
    </>
  );
}

export function WelcomeHotTermsWidget({
  data,
  widget,
  onTopicTabLoad,
  activeTabKey,
  onActiveTabKeyChange,
  isTopicTabPartialLoading = () => false,
}) {
  const { t } = useTranslation();
  const rawTabs = Array.isArray(data?.summary_tabs) ? data.summary_tabs : [];
  const hasTopicTabs =
    rawTabs.length > 1 &&
    rawTabs.some(
      (tab) => tab && String(tab.id || "").toLowerCase() !== "general",
    );

  if (hasTopicTabs) {
    const generalLabel = t("welcome.genaiMultiTopicGeneralTab");
    const outerItems = rawTabs.map((tab, idx) => {
      const isGeneral = String(tab.id || "").toLowerCase() === "general";
      const label = isGeneral
        ? generalLabel
        : decodeBasicHtmlEntities(
            String(tab.label || tab.id || `#${idx + 1}`),
          );
      const topicLibId = !isGeneral
        ? parseTopicLibIdFromWidgetTab(widget, tab.id)
        : null;
      const pending =
        widget &&
        welcomeWidgetUsesLazyTopicTabs(widget) &&
        !isGeneral &&
        (tab.payload_pending ||
          tab.ngrams == null ||
          (topicLibId != null &&
            isTopicTabPartialLoading(widget.id, topicLibId)));
      return {
        key: String(tab.id || `tab-${idx}`),
        label,
        children: pending ? (
          <div className={styles.tabLoadingCenter}>
            <Spin size="large" />
          </div>
        ) : (
          <WelcomeHotTermsNGramPanel
            ngrams={tab.ngrams}
            reviewCount={tab.review_count ?? tab.reviewCount}
            sourceFallback={
              hasTopicTabs
                ? undefined
                : data?.source_review_count ?? data?.review_count
            }
            scopeData={data}
            widget={widget}
          />
        ),
      };
    });
    const lazyTabs =
      widget &&
      welcomeWidgetUsesLazyTopicTabs(widget) &&
      onActiveTabKeyChange;
    const firstKey = String(outerItems[0]?.key ?? "general");
    const resolvedActiveKey =
      lazyTabs && activeTabKey !== undefined && activeTabKey !== null
        ? String(activeTabKey)
        : firstKey;
    return (
      <Tabs
        items={outerItems}
        className={styles.welcomeHierarchicalTabs}
        {...(lazyTabs ? { activeKey: resolvedActiveKey } : {})}
        onChange={(key) => {
          if (lazyTabs) {
            onActiveTabKeyChange(key);
          }
          if (!onTopicTabLoad || !widget) return;
          if (!welcomeWidgetUsesLazyTopicTabs(widget)) return;
          const lib = parseTopicLibIdFromWidgetTab(widget, key);
          if (lib == null) return;
          const row = rawTabs.find((x) => String(x.id) === String(key));
          if (row && !row.payload_pending && row.ngrams != null) return;
          void onTopicTabLoad(widget, lib);
        }}
      />
    );
  }

  return (
    <WelcomeHotTermsNGramPanel
      ngrams={data?.ngrams}
      reviewCount={data?.source_review_count ?? data?.review_count}
      sourceFallback={data?.source_review_count ?? data?.review_count}
      scopeData={data}
      widget={widget}
    />
  );
}
function WelcomeDesPlanGatedChart({ metricId, children, className }) {
  const subscriptionStatus = useSelector((state) => state.userReducer);
  return (
    <WelcomeMarketIntelligencePlanGate
      metricId={metricId}
      subscriptionRow={subscriptionStatus}
      className={className}
    >
      {children}
    </WelcomeMarketIntelligencePlanGate>
  );
}

function WelcomeWidgetRenderBody({
  widgetRow,
  plan,
  locationSearch,
}) {
  const ctx = useContext(WelcomeWorkspaceWidgetRenderContext);
  const cacheQuery = useWelcomeWidgetCache(plan);
  const cacheEnvelope = cacheQuery.data;
  const widget = useMemo(
    () => ({
      ...widgetRow,
      data: cacheEnvelope?.data ?? widgetRow?.data,
    }),
    [widgetRow, cacheEnvelope],
  );

  const params = useMemo(
    () => new URLSearchParams(locationSearch ?? ""),
    [locationSearch],
  );

  if (!ctx) {
    return null;
  }
  const {
    theme,
    t,
    i18n,
    groupId,
    setWidgets,
    setGroups,
    fetchWelcomeTopicTabPartial,
    welcomeLazyTopicTabKeyByWidget,
    setWelcomeLazyTopicTabKeyByWidget,
    isWelcomeTopicTabPartialLoading,
    brandDashboardCategories,
    aiInsightsColumn,
    fetchMetric27DecisionReviews,
    fetchMetric20GenaiReviews,
    fetchWelcomeWidgetScopeReviews,
    handleWelcomeWidgetRefresh,
    handleGenaiRequeue,
    isWelcomeRegenerableWidget,
    widgetRefreshLoading,
    loadingWidgets,
    isWelcomeWidgetPageDataLoading,
    isWelcomeWidgetVisible,
    resolveWelcomeWidgetPageDataLoadingForTiming,
    workspaceContentEditable,
  } = ctx;

  const queryFailed = cacheQuery.isError === true;
  const insufficientCounts = resolveWelcomeInsufficientReviewCounts(
    widget?.data,
    widget?.metric_id,
    widget,
  );
  const failedStateRegenerateProps = () => {
    if (!workspaceContentEditable || !isWelcomeRegenerableWidget?.(widgetRow)) {
      return {};
    }
    return {
      onRegenerate: () => handleGenaiRequeue(widgetRow.id),
      regenerating:
        widgetRow?.status === "loading" || !!loadingWidgets?.[widgetRow.id],
    };
  };
  const renderDataState = (status) => (
    <WelcomeWidgetDataStateMessage
      status={status}
      t={t}
      onRefresh={
        handleWelcomeWidgetRefresh
          ? () => handleWelcomeWidgetRefresh(widgetRow.id)
          : undefined
      }
      refreshing={!!widgetRefreshLoading?.[widgetRow.id]}
      {...(status === WELCOME_WIDGET_DATA_STATUS_FAILED
        ? failedStateRegenerateProps()
        : {})}
      emptyClassName={styles.noDataMessage}
      insufficientClassName={styles.widgetInsufficientData}
      failedClassName={styles.widgetDataLoadFailed}
      failedActionsClassName={styles.widgetDataLoadFailedActions}
      insufficientCounts={
        status === WELCOME_WIDGET_DATA_STATUS_INSUFFICIENT
          ? insufficientCounts
          : undefined
      }
    />
  );

  const hasRenderableWidgetData =
    widget?.data &&
    typeof widget.data === "object" &&
    Object.keys(widget.data).length > 0;

  // Plan yokken (viewport / stable KPI key gecikmesi) boş state'te "No Data" titremesini önle.
  if (
    !plan &&
    !widget?.data?.error &&
    !hasRenderableWidgetData &&
    !queryFailed
  ) {
    return (
      <div
        className={styles.widgetKpiLoading}
        style={{ minHeight: 150 }}
      >
        <Spin size="large" />
      </div>
    );
  }

  const resolvedDataState = resolveWelcomeWidgetDataState(widget?.data, {
    queryFailed,
    metricId: widget?.metric_id,
    widgetRow: widget,
  });
  if (resolvedDataState === WELCOME_WIDGET_DATA_STATUS_FAILED) {
    return renderDataState(WELCOME_WIDGET_DATA_STATUS_FAILED);
  }
  if (resolvedDataState === WELCOME_WIDGET_DATA_STATUS_INSUFFICIENT) {
    return renderDataState(WELCOME_WIDGET_DATA_STATUS_INSUFFICIENT);
  }

  // Check for no data or error cases
  if (!widget || !widget.data || Object.keys(widget.data).length === 0) {
    return renderDataState(WELCOME_WIDGET_DATA_STATUS_EMPTY);
  }

  // Legacy error payloads: empty vs failed resolved in resolvedDataState above.
  if (widget.data.error) {
    return renderDataState(
      welcomeKpiErrorMeansNoData(widget.data.error)
        ? WELCOME_WIDGET_DATA_STATUS_EMPTY
        : WELCOME_WIDGET_DATA_STATUS_FAILED,
    );
  }

  const { data } = widget;
      const hasTopicTabs =
        Array.isArray(data.topic_tabs) && data.topic_tabs.length > 0;

      // Check for empty data arrays in all formats (skip when API uses topic_tabs)
      if (
        !hasTopicTabs &&
        data.datasets &&
        Array.isArray(data.datasets) &&
        !welcomeWidgetUsesBrandKpiHero(widget)
      ) {
        const hasData = data.datasets.some(
          (dataset) =>
            dataset.data &&
            Array.isArray(dataset.data) &&
            dataset.data.length > 0,
        );
        if (!hasData) {
          return (
            <WelcomeWidgetEmptyState
              t={t}
              className={styles.noDataMessage}
              data={data}
              metricId={widget?.metric_id}
              widgetRow={widget}
            />
          );
        }
      }

      if (
        data.items &&
        Array.isArray(data.items) &&
        data.items.length === 0 &&
        !data.insufficient_reviews
      ) {
        return (
          <WelcomeWidgetEmptyState
            t={t}
            className={styles.noDataMessage}
            data={data}
            metricId={widget?.metric_id}
            widgetRow={widget}
          />
        );
      }

      // Handle competitive metrics
      if (widget?.metricType === "competitive") {
        // Category-based visualization
        if (widget?.data?.comparison_type === 1) {
          if (
            !widget?.data?.data?.topics ||
            widget?.data?.data?.topics.length === 0
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }

          // Check if any topic has actual data
          const hasTopicData = widget.data.data.topics.some(
            (topic) =>
              topic?.data?.datasets?.[0]?.data &&
              Array.isArray(topic.data.datasets[0].data) &&
              topic.data.datasets[0].data.length > 0,
          );

          if (!hasTopicData) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }

          if (widget?.representation_type === 1) {
            // chart
            return (
              <div className={styles.categoryChartsContainer}>
                <div className={styles.doughnutCharts}>
                  {widget?.data?.data?.topics
                    ?.map((topic) => {
                      // Check if this specific topic has data
                      if (!topic?.data?.datasets?.[0]?.data?.length) {
                        return null;
                      }
                      return (
                        <div key={topic?.id} className={styles.categoryChart}>
                          <KPIDoughnutChart
                            data={{
                              labels: topic?.data?.labels,
                              datasets: [
                                {
                                  data: topic?.data?.datasets?.[0]?.data,
                                  backgroundColor:
                                    topic?.data?.datasets?.[0]?.backgroundColor,
                                  borderWidth: 0,
                                },
                              ],
                            }}
                            title={topic?.name}
                            theme={theme}
                            showLegend={false}
                          />
                          <h4>{topic?.name}</h4>
                        </div>
                      );
                    })
                    .filter(Boolean)}
                </div>
                <div className={styles.Legend}>
                  {widget?.data?.data?.topics?.[0]?.data?.labels?.map(
                    (label, index) => (
                      <div key={index}>
                        <span
                          className={styles.legendColor}
                          style={{
                            backgroundColor:
                              widget?.data?.data?.topics?.[0]?.data
                                ?.datasets?.[0]?.backgroundColor?.[index],
                          }}
                        />
                        <span className={styles.legendLabel}>{label}</span>
                      </div>
                    ),
                  )}
                </div>
              </div>
            );
          } else if (widget?.representation_type === 1) {
            // list
            return (
              <div className={styles.listWidget}>
                <List
                  dataSource={widget?.data?.data?.topics?.map((topic) => ({
                    title: topic?.name,
                    description: `Brands: ${topic?.data?.labels?.join(", ")}`,
                  }))}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={item?.title}
                        description={item?.description}
                      />
                    </List.Item>
                  )}
                />
              </div>
            );
          } else if (widget?.representation_type === 3) {
            // table
            return (
              <div className={styles.tableWidget}>
                <Table
                  dataSource={widget?.data?.data?.topics?.map((topic) => ({
                    key: topic?.id,
                    topic: topic?.name,
                    brands: topic?.data?.labels?.join(", "),
                    counts: topic?.data?.datasets?.[0]?.data?.join(", "),
                  }))}
                  columns={[
                    {
                      title: t("welcome.reviewSummaryTopic"),
                      dataIndex: "topic",
                      key: "topic",
                    },
                    {
                      title: t("welcome.tableColBrands"),
                      dataIndex: "brands",
                      key: "brands",
                    },
                    {
                      title: t("welcome.tableColCounts"),
                      dataIndex: "counts",
                      key: "counts",
                    },
                  ]}
                />
              </div>
            );
          }
        }
        // Brand-based visualization
        else if (widget?.data?.comparison_type === 2) {
          if (
            !widget?.data?.data?.labels ||
            widget?.data?.data?.labels.length === 0 ||
            !widget?.data?.data?.datasets ||
            widget?.data?.data?.datasets.length === 0
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }

          // Check if any dataset has actual data
          const hasDatasetData = widget.data.data.datasets.some(
            (dataset) =>
              dataset?.data &&
              Array.isArray(dataset.data) &&
              dataset.data.length > 0,
          );

          if (!hasDatasetData) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }

          if (widget?.representation_type === 1) {
            // chart
            return (
              <div className={styles.brandChartContainer}>
                <KPIStackedBarChart
                  data={{
                    chart_type: "bar",
                    indexAxis: "y",
                    labels: widget?.data?.data?.labels,
                    datasets: widget?.data?.data?.datasets?.map((ds) => ({
                      ...ds,
                      barThickness: 16,
                      borderSkipped: false,
                      borderRadius: {
                        topLeft: 50,
                        topRight: 50,
                        bottomLeft: 50,
                        bottomRight: 50,
                      },
                    })),
                  }}
                  theme={theme}
                  applyDashboardIntentColors={
                    Number(widget?.metric_id) === 12
                  }
                />
              </div>
            );
          } else if (widget?.representation_type === 2) {
            // list
            return (
              <div className={styles.listWidget}>
                <List
                  dataSource={widget?.data?.data?.labels?.map(
                    (brand, index) => ({
                      title: brand,
                      description: `Topics: ${widget?.data?.data?.datasets
                        ?.map((ds) => `${ds?.label}: ${ds?.data?.[index]}`)
                        .join(", ")}`,
                    }),
                  )}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={item?.title}
                        description={item?.description}
                      />
                    </List.Item>
                  )}
                />
              </div>
            );
          } else if (widget?.representation_type === 3) {
            // table
            return (
              <div className={styles.tableWidget}>
                <Table
                  dataSource={widget?.data?.data?.labels?.map(
                    (brand, index) => ({
                      key: index,
                      brand: brand,
                      ...widget?.data?.data?.datasets?.reduce(
                        (acc, ds) => ({
                          ...acc,
                          [ds?.label]: ds?.data?.[index],
                        }),
                        {},
                      ),
                    }),
                  )}
                  columns={[
                    {
                      title: t("welcome.reviewSummaryBrand"),
                      dataIndex: "brand",
                      key: "brand",
                    },
                    ...widget?.data?.data?.datasets?.map((ds) => ({
                      title: ds?.label,
                      dataIndex: ds?.label,
                      key: ds?.label,
                    })),
                  ]}
                />
              </div>
            );
          }
        }
        // Time-based visualization
        else if (widget?.data?.comparison_type === 3) {
          if (
            !widget?.data?.data?.topics ||
            widget?.data?.data?.topics.length === 0
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }

          // Check if any topic has actual time series data
          const hasTimeSeriesData = widget.data.data.topics.some((topic) =>
            topic?.data?.datasets?.some(
              (dataset) =>
                dataset?.data &&
                Array.isArray(dataset.data) &&
                dataset.data.length > 0,
            ),
          );

          if (!hasTimeSeriesData) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }

          if (widget?.representation_type === 1) {
            // chart
            return (
              <div className={styles.timeChartsContainer}>
                {widget?.data?.data?.topics
                  ?.map((topic) => {
                    // Check if this specific topic has data
                    const hasData = topic?.data?.datasets?.some(
                      (dataset) =>
                        dataset?.data &&
                        Array.isArray(dataset.data) &&
                        dataset.data.length > 0,
                    );

                    if (!hasData) {
                      return null;
                    }

                    return (
                      <div key={topic?.id} className={styles.timeChart}>
                        <h4>{topic?.name}</h4>
                        <KPILineChart
                          theme={theme}
                          data={{
                            labels: topic?.data?.labels,
                            datasets: topic?.data?.datasets?.map((ds) => ({
                              ...ds,
                              tension: 0.4,
                              pointRadius: 0,
                              pointHoverRadius: 4,
                              borderWidth: 2,
                              fill: false,
                              pointBorderWidth: 0,
                              pointHitRadius: 10,
                            })),
                          }}
                          options={{
                            responsive: true,
                            maintainAspectRatio: true,
                            layout: {
                              padding: {
                                left: 5,
                                right: 5,
                                top: 5,
                                bottom: 5,
                              },
                            },
                            scales: {
                              x: {
                                grid: {
                                  display: false,
                                },
                                ticks: {
                                  display: false,
                                },
                              },
                              y: {
                                display: false,
                                beginAtZero: true,
                                grid: {
                                  display: false,
                                },
                              },
                            },
                            plugins: {
                              legend: {
                                position: "bottom",
                                align: "start",
                                labels: {
                                  boxWidth: 16,
                                  usePointStyle: false,
                                  padding: 15,
                                  font: {
                                    size: 11,
                                  },
                                },
                              },
                              tooltip: {
                                enabled: true,
                                mode: "index",
                                intersect: false,
                                titleColor: "white",
                                bodyColor: "white",
                                cornerRadius: 4,
                                padding: 8,
                                titleFont: {
                                  size: 12,
                                },
                                bodyFont: {
                                  size: 11,
                                },
                                displayColors: true,
                                boxWidth: 6,
                                boxHeight: 6,
                                usePointStyle: true,
                                callbacks: {
                                  title: (tooltipItems) => {
                                    return tooltipItems[0].label;
                                  },
                                  label: (context) => {
                                    return ` ${context.dataset.label}: ${context.parsed.y}`;
                                  },
                                },
                              },
                              datalabels: {
                                color: "white",
                                font: {
                                  size: 11,
                                },
                                formatter: (value) => {
                                  return value;
                                },
                                display: true,
                                align: "top",
                                anchor: "end",
                              },
                            },
                          }}
                        />
                      </div>
                    );
                  })
                  .filter(Boolean)}
              </div>
            );
          } else if (widget?.representation_type === 2) {
            // list
            return (
              <div className={styles.listWidget}>
                <List
                  dataSource={widget?.data?.data?.topics?.map((topic) => ({
                    title: topic?.name,
                    description: `Daily brand volumes: ${topic?.data?.datasets
                      ?.map((ds) => ds?.label)
                      .join(", ")}`,
                  }))}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={item?.title}
                        description={item?.description}
                      />
                    </List.Item>
                  )}
                />
              </div>
            );
          } else if (widget?.representation_type === 3) {
            // table
            return (
              <div className={styles.tableWidget}>
                <Table
                  dataSource={widget?.data?.data?.topics?.map((topic) => ({
                    key: topic?.id,
                    topic: topic?.name,
                    brands: topic?.data?.datasets
                      ?.map((ds) => ds?.label)
                      .join(", "),
                    dates: topic?.data?.labels?.join(", "),
                  }))}
                  columns={[
                    {
                      title: t("welcome.reviewSummaryTopic"),
                      dataIndex: "topic",
                      key: "topic",
                    },
                    {
                      title: t("welcome.tableColBrands"),
                      dataIndex: "brands",
                      key: "brands",
                    },
                    {
                      title: t("welcome.tableColDates"),
                      dataIndex: "dates",
                      key: "dates",
                    },
                  ]}
                />
              </div>
            );
          }
        } else if (widget?.data?.comparison_type === 4) {
          if (widget?.representation_type === 1) {
            return (
              <div className={styles.vocChartDynamic}>
                <VOCScoreChart
                  data={widget?.data?.data}
                  theme={theme}
                  widget_id={widget?.id}
                  since={params.get("since")}
                  until={params.get("until")}
                />
              </div>
            );
          } else if (widget?.representation_type === 2) {
            // Show each label:dataset pair as a List.Item
            return (
              <div className={styles.listWidget}>
                <List
                  dataSource={widget?.data?.data?.items}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          item.link ? (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.itemLink}
                            >
                              {item.title}
                            </a>
                          ) : (
                            item.title
                          )
                        }
                        description={
                          item.descriptionLink ? (
                            <a
                              href={item.descriptionLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.itemLink}
                            >
                              {item.description}
                            </a>
                          ) : (
                            item.description
                          )
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            );
          } else if (widget?.representation_type === 3) {
            const columns =
              data.columns ||
              Object.keys(widget?.data?.data?.items[0])
                .filter((key) => !key.endsWith("_link"))
                .map((key) => ({
                  title:
                    key.charAt(0).toUpperCase() +
                    key.slice(1).replace(/_/g, " "),
                  dataIndex: key,
                  key: key,
                  render: (text, record) => {
                    const linkField = `${key}_link`;
                    if (record[linkField]) {
                      return (
                        <a
                          href={record[linkField]}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.itemLink}
                        >
                          {text}
                        </a>
                      );
                    }
                    return text;
                  },
                }));

            return (
              <div className={styles.tableWidget}>
                <Table
                  dataSource={widget?.data?.data?.items?.map((item, index) => ({
                    ...item,
                    key: index,
                  }))}
                  columns={columns}
                  pagination={{
                    pageSize: 10,
                    position: ["bottomRight"],
                    showQuickJumper: false,
                    showSizeChanger: false,
                    size: "small",
                    className: styles.tablePagination,
                  }}
                  scroll={{ y: 400 }}
                  size="small"
                  className={styles.tableContainer}
              locale={{
                emptyText: (
                  <WelcomeWidgetEmptyState
                    t={t}
                    className={styles.noDataMessage}
                    data={data}
                    metricId={widget?.metric_id}
                    widgetRow={widget}
                  />
                ),
              }}
                />
              </div>
            );
          }
        }
      }

      // Handle non-competitive metrics
      if (widget.representation_type === 1) {
        // Brand KPIs with per-topic tabs (e.g. Review Statistics when industry topics selected)
        if (hasTopicTabs) {
          const mid = Number(widget.metric_id);
          const isReviewStats = mid === 8;
          const isVocTopicTabs = mid === 18;
          const lazyTopicTabs = welcomeWidgetUsesLazyTopicTabs(widget);
          const handleTopicTabSelect = (key) => {
            if (lazyTopicTabs) {
              setWelcomeLazyTopicTabKeyByWidget((prev) => ({
                ...prev,
                [widget.id]: key,
              }));
            }
            if (!lazyTopicTabs) return;
            const lib = parseTopicLibIdFromWidgetTab(widget, key);
            if (lib == null) return;
            const row = (data.topic_tabs || []).find(
              (t) => String(t.id) === String(key),
            );
            if (row && !row.payload_pending && row.payload != null) {
              return;
            }
            void fetchWelcomeTopicTabPartial(widget, lib);
          };
          return (
            <div
              className={`${styles.chartContainer} ${
                isReviewStats ? styles.reviewStatsContainer : ""
              } ${
                /* Topic tabs: left-align tab strip (default chartContainer centers content). */
                !isReviewStats ? styles.chartContainerVariableHeight : ""
              } ${isVocTopicTabs ? styles.vocChartContainer : ""}`}
            >
              <Tabs
                className={styles.welcomeHierarchicalTabs}
                {...(lazyTopicTabs
                  ? {
                      activeKey: String(
                        welcomeLazyTopicTabKeyByWidget[widget.id] ??
                          data.topic_tabs[0]?.id ??
                          "general",
                      ),
                    }
                  : {})}
                onChange={(key) => handleTopicTabSelect(key)}
                items={data.topic_tabs.map((tab) => {
                  const tp = tab.payload || {};
                  const topicLibId =
                    tab.id !== "general"
                      ? parseTopicLibIdFromWidgetTab(widget, tab.id)
                      : null;
                  const tabPending =
                    lazyTopicTabs &&
                    tab.id !== "general" &&
                    (tab.payload_pending ||
                      tab.payload == null ||
                      (topicLibId != null &&
                        isWelcomeTopicTabPartialLoading(widget.id, topicLibId)));
                  const stackedBarData =
                    (mid === 14 || mid === 12) &&
                    tab.id === "general" &&
                    tp.chart_type === "stacked_bar" &&
                    Array.isArray(tp.labels)
                      ? {
                          ...tp,
                          labels: tp.labels.map((lb) =>
                            lb === "Average"
                              ? t("welcome.topicSentimentGeneralBarLabel")
                              : lb,
                          ),
                        }
                      : tp;
                  const customLabels =
                    tp.legend && Array.isArray(tp.legend)
                      ? tp.legend.map((item) => item.count)
                      : null;
                  const tabRcRaw = tab?.review_count;
                  const hasNumericTopicReviewCount =
                    tabRcRaw != null &&
                    tabRcRaw !== "" &&
                    Number.isFinite(Number(tabRcRaw));
                  const topicReviewCountLabel = hasNumericTopicReviewCount
                    ? new Intl.NumberFormat(getIntlLocale(i18n.language)).format(Number(tabRcRaw))
                    : null;
                  const brandKpiHeroHeader = resolveBrandKpiHeroHeader(tp, mid);
                  const isBrandKpiHero =
                    welcomeWidgetUsesBrandKpiHero(widget) &&
                    brandKpiHeroHeader != null;
                  const tabHeader = isBrandKpiHero
                    ? {
                        ...brandKpiHeroHeader,
                        review_count:
                          tabRcRaw != null &&
                          tabRcRaw !== "" &&
                          Number.isFinite(Number(tabRcRaw))
                            ? Number(tabRcRaw)
                            : brandKpiHeroHeader?.review_count,
                      }
                    : tp.header;
                  return {
                    key: String(tab.id),
                    label:
                      tab.id === "general"
                        ? t("welcome.genaiMultiTopicGeneralTab")
                        : tab.label || String(tab.id),
                    children: tabPending ? (
                      <div
                        className={`${styles.chartContent} ${styles.tabLoadingCenterTall}`}
                      >
                        <Spin size="large" />
                      </div>
                    ) : (
                      <>
                        {topicReviewCountLabel != null && (
                          <div
                            className={styles.welcomeGeneralSummaryHierarchicalTabMeta}
                          >
                            <WelcomeTabReviewCountButton
                              label={t("welcome.hierarchicalTabReviewCount", {
                                count: topicReviewCountLabel,
                              })}
                              reviewCount={tabRcRaw}
                              onClick={
                                (isBrandKpiHero || isReviewStats) &&
                                fetchWelcomeWidgetScopeReviews
                                  ? () =>
                                      void fetchWelcomeWidgetScopeReviews(
                                        widget,
                                        mid,
                                        {
                                          topicLibId,
                                          topicLabel:
                                            tab.id === "general"
                                              ? t("welcome.genaiMultiTopicGeneralTab")
                                              : tab.label || String(tab.id),
                                          reviewCount: hasNumericTopicReviewCount
                                            ? Number(tabRcRaw)
                                            : undefined,
                                        },
                                      )
                                  : undefined
                              }
                            />
                          </div>
                        )}
                        {isReviewStats &&
                          tp.header?.value != null &&
                          !hasNumericTopicReviewCount && (
                          <div className={styles.headerContent}>
                            <div className={styles.headerValue}>
                              <span className={styles.headerValueText}>
                                {t("welcome.num_reviews")} : {tp.header.value}
                              </span>
                            </div>
                          </div>
                        )}
                        {!isReviewStats &&
                          !isBrandKpiHero &&
                          tp.header?.title && (
                          <div className={styles.headerContent}>
                            <div className={styles.headerTitle}>
                              <h4 title={tp.header.title}>{tp.header.title}</h4>
                            </div>
                          </div>
                        )}
                        {isBrandKpiHero ? (
                          <WelcomeBrandKpiHeroCard
                            metricId={mid}
                            header={tabHeader}
                            widget={widget}
                            since={params.get("since") || widget.since}
                            until={params.get("until") || widget.until}
                            t={t}
                            i18n={i18n}
                            isPageDataLoading={
                              resolveWelcomeWidgetPageDataLoadingForTiming
                                ? resolveWelcomeWidgetPageDataLoadingForTiming(widget)
                                : isWelcomeWidgetPageDataLoading
                                  ? isWelcomeWidgetPageDataLoading(widget)
                                  : false
                            }
                            isWidgetVisible={isWelcomeWidgetVisible?.(widget.id) ?? true}
                          />
                        ) : (
                        <div
                          className={
                            isReviewStats ? styles.reviewStatsChartRow : ""
                          }
                        >
                            <div className={styles.chartContent}>
                            {tp.chart_type === "topic_doughnut_grid" &&
                              Array.isArray(tp.topics) &&
                              tp.topics.length > 0 && (
                                <div className={styles.categoryChartsContainer}>
                                  <div className={styles.doughnutCharts}>
                                    {tp.topics.map((topic, ti) => {
                                      const td = {
                                        labels: topic.labels,
                                        legend: topic.legend,
                                        datasets: topic.datasets,
                                      };
                                      const cl =
                                        topic.legend &&
                                        Array.isArray(topic.legend)
                                          ? topic.legend.map((item) => item.count)
                                          : null;
                                      if (!td.datasets?.[0]?.data?.length) {
                                        return null;
                                      }
                                      return (
                                        <div
                                          key={`${topic.name || "t"}-${ti}`}
                                          className={styles.categoryChart}
                                        >
                                          <KPIDoughnutChart
                                            data={td}
                                            theme={theme}
                                            customLabels={cl}
                                            showLegend={mid === 12}
                                          />
                                          <h4>{topic.name}</h4>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            {tp.chart_type === "review_statistics" && (
                              <WelcomeReviewStatisticsChart
                                data={tp}
                                theme={theme}
                              />
                            )}
                            {tp.chart_type === "doughnut" && (
                              <KPIDoughnutChart
                                data={tp}
                                theme={theme}
                                customLabels={customLabels}
                                showLegend={mid === 12}
                              />
                            )}
                            {tp.chart_type === "bar" &&
                              (mid === 15 ? (
                                <WelcomeTopicParticipationBarChart payload={tp} />
                              ) : (
                                <KPIBarChart data={tp} theme={theme} />
                              ))}
                            {tp.chart_type === "dual_doughnut_sentiment" && (
                              <WelcomeDualSentimentDoughnutCharts
                                data={tp}
                                theme={theme}
                              />
                            )}
                            {tp.chart_type === "dual_doughnut_intent" && (
                              <WelcomeDualIntentDoughnutCharts
                                data={tp}
                                theme={theme}
                              />
                            )}
                            {tp.chart_type === "stacked_bar" && mid === 14 && (
                              <WelcomeTopicSentimentBarChart
                                payload={stackedBarData}
                                widgetId={widget?.id}
                              />
                            )}
                            {tp.chart_type === "stacked_bar" && mid === 12 && (
                              <WelcomeTopicIntentBarChart
                                payload={stackedBarData}
                              />
                            )}
                            {tp.chart_type === "stacked_bar" &&
                              mid !== 14 &&
                              mid !== 12 && (
                              <KPIStackedBarChart
                                data={stackedBarData}
                                theme={theme}
                              />
                            )}
                            {tp.chart_type === "bubble" && (
                              <KPIBubbleChart data={tp} theme={theme} />
                            )}
                            {tp.chart_type === "voc_chart" && (
                              <WelcomeDesPlanGatedChart metricId={widget?.metric_id}>
                                <VOCScoreChart
                                  data={tp.data}
                                  theme={theme}
                                  isSingleBrand={true}
                                  widget_id={widget?.id}
                                  since={params.get("since")}
                                  until={params.get("until")}
                                />
                              </WelcomeDesPlanGatedChart>
                            )}
                          </div>
                        </div>
                        )}
                      </>
                    ),
                  };
                })}
              />
            </div>
          );
        }
        //voc score special widget
        if (data.chart_type === "voc_chart") {
          return (
            <WelcomeDesPlanGatedChart metricId={widget?.metric_id}>
              <div className={styles.vocChartContainer}>
                <VOCScoreChart
                  data={widget?.data?.data}
                  theme={theme}
                  isSingleBrand={true}
                  widget_id={widget?.id}
                  since={params.get("since")}
                  until={params.get("until")}
                />
              </div>
            </WelcomeDesPlanGatedChart>
          );
        }
        // Brand KPI hero (metrics 9 & 10): render before bar empty checks so legacy
        // title-only headers and list-view items still show the hero card.
        const brandKpiHeroHeader = resolveBrandKpiHeroHeader(
          data,
          widget.metric_id,
        );
        if (welcomeWidgetUsesBrandKpiHero(widget) && brandKpiHeroHeader) {
          return (
            <div
              className={`${styles.chartContainer} ${styles.brandKpiHeroContainer}`}
            >
              <WelcomeBrandKpiHeroCard
                metricId={widget.metric_id}
                header={brandKpiHeroHeader}
                widget={widget}
                since={params.get("since") || widget.since}
                until={params.get("until") || widget.until}
                t={t}
                i18n={i18n}
                isPageDataLoading={
                  resolveWelcomeWidgetPageDataLoadingForTiming
                    ? resolveWelcomeWidgetPageDataLoadingForTiming(widget)
                    : isWelcomeWidgetPageDataLoading
                      ? isWelcomeWidgetPageDataLoading(widget)
                      : false
                }
                isWidgetVisible={isWelcomeWidgetVisible?.(widget.id) ?? true}
              />
            </div>
          );
        }

        // Chart
        // Check if there's actual data to display
        if (data.chart_type === "bar" || data.chart_type === "line") {
          if (
            !data.datasets?.[0]?.data?.length ||
            !data.labels?.length ||
            data.datasets.every((ds) => ds.data.every((val) => val === 0))
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        } else if (
          data.chart_type === "review_statistics" ||
          (widget?.metric_id === 8 &&
            normalizeWelcomeReviewStatisticsPayload(data))
        ) {
          const reviewStats =
            data.chart_type === "review_statistics"
              ? data
              : normalizeWelcomeReviewStatisticsPayload(data);
          const total = Number(reviewStats?.header?.value);
          const hasSeries =
            Array.isArray(reviewStats?.time_series?.labels) &&
            reviewStats.time_series.labels.length > 0;
          const hasDistribution =
            reviewStats?.distribution?.chart_type === "doughnut" &&
            Array.isArray(reviewStats?.distribution?.datasets?.[0]?.data) &&
            reviewStats.distribution.datasets[0].data.some(
              (v) => Number(v) > 0,
            );
          if (
            !(Number.isFinite(total) && total > 0) &&
            !hasSeries &&
            !hasDistribution
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        } else if (data.chart_type === "doughnut") {
          if (
            !data.datasets?.[0]?.data?.length ||
            data.datasets[0].data.every((val) => val === 0)
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        } else if (data.chart_type === "dual_doughnut_sentiment") {
          const pd = data.primary?.datasets?.[0]?.data;
          const md = data.mixed_breakdown?.datasets?.[0]?.data;
          const hasPrimary =
            Array.isArray(pd) && pd.some((v) => Number(v) > 0);
          const hasMixed =
            Array.isArray(md) && md.some((v) => Number(v) > 0);
          if (!hasPrimary && !hasMixed) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        } else if (data.chart_type === "dual_doughnut_intent") {
          const pd = data.primary?.datasets?.[0]?.data;
          const md = data.mixed_breakdown?.datasets?.[0]?.data;
          const hasPrimary =
            Array.isArray(pd) && pd.some((v) => Number(v) > 0);
          const hasMixed =
            Array.isArray(md) && md.some((v) => Number(v) > 0);
          if (!hasPrimary && !hasMixed) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        } else if (data.chart_type === "bubble") {
          if (
            !data.datasets?.[0]?.data?.length ||
            data.datasets[0].data.every((point) => point.r === 0)
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        } else if (data.chart_type === "stacked_bar") {
          if (
            !data.datasets?.length ||
            !data.labels?.length ||
            data.datasets.every((ds) => ds.data.every((val) => val === 0))
          ) {
            return (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            );
          }
        }

        // Render chart header if available
        const renderChartHeader = () => {
          if (!data.header) return null;

          const { title, subtitle, value, trend, icon, color } = data.header;

          // Brand KPI hero metrics: header rendered inside WelcomeBrandKpiHeroCard.
          if (welcomeWidgetUsesBrandKpiHero(widget)) {
            return null;
          }

          // Review Statistics: hero total lives inside WelcomeReviewStatisticsChart.
          if (
            widget?.metric_id === 8 &&
            (data.chart_type === "review_statistics" ||
              normalizeWelcomeReviewStatisticsPayload(data))
          ) {
            return null;
          }
          if (widget?.metric_id === 8) {
            return (
              <div className={styles.headerContent}>
                {value && (
                  <div className={styles.headerValue}>
                    <span className={styles.headerValueText}>
                      {" "}
                      {t("welcome.num_reviews")} : {value}
                    </span>
                  </div>
                )}
              </div>
            );
          }

          // Default header for other widgets (increase/decrease KPI)
          return (
            <div className={styles.headerContent}>
              <div className={styles.headerTitle}>
                <h4 title={title}>{title}</h4>
                {subtitle && (
                  <span className={styles.subtitle}>{subtitle}</span>
                )}
              </div>

              {value && (
                <div className={styles.headerValue}>
                  <span className={styles.trendIcon}>
                    {icon === "arrow-up" ? (
                      <ArrowUpOutlined />
                    ) : (
                      <ArrowDownOutlined />
                    )}
                  </span>
                  <span>{value}</span>
                </div>
              )}
            </div>
          );
        };

        const isReviewStatsLayout =
          widget?.metric_id === 8 &&
          (data.chart_type === "review_statistics" ||
            normalizeWelcomeReviewStatisticsPayload(data));

        return (
          <div
            className={`${styles.chartContainer} ${
              isReviewStatsLayout ? styles.reviewStatsContainer : ""
            } ${
              data.chart_type === "decision_distribution" ||
              data.chart_type === "hotterms" ||
              data.chart_type === "dual_doughnut_sentiment" ||
              data.chart_type === "dual_doughnut_intent"
                ? styles.chartContainerVariableHeight
                : ""
            }`}
          >
            {renderChartHeader()}

            {/* For Review Statistics widget, create separate sections */}
            {widget?.metric_id === 8 ? (
              <>
                {/* Chart in separate row below the header */}
                <div className={styles.reviewStatsChartRow}>
                  <div className={styles.chartContent}>
                    {(() => {
                      switch (data.chart_type) {
                        case "review_statistics":
                          return (
                            <WelcomeReviewStatisticsChart
                              data={data}
                              theme={theme}
                            />
                          );
                        case "bubble":
                          return <KPIBubbleChart data={data} theme={theme} />;
                        case "doughnut":
                          if (normalizeWelcomeReviewStatisticsPayload(data)) {
                            return (
                              <WelcomeReviewStatisticsChart
                                data={data}
                                theme={theme}
                              />
                            );
                          }
                          {
                            const customLabels_rs = data.legend
                              ? data.legend.map((item) => item.count)
                              : null;
                            return (
                              <KPIDoughnutChart
                                data={data}
                                theme={theme}
                                customLabels={customLabels_rs}
                              />
                            );
                          }
                        case "stacked_bar":
                          return (
                            <KPIStackedBarChart data={data} theme={theme} />
                          );
                        case "line":
                          return <KPILineChart data={data} theme={theme} />;
                        case "bar":
                        default:
                          return widget?.metric_id === 15 ? (
                            <WelcomeTopicParticipationBarChart payload={data} />
                          ) : (
                            <KPIBarChart data={data} theme={theme} />
                          );
                      }
                    })()}
              </div>
            </div>
          </>
        ) : (
          /* For other widgets, use the standard layout */
          <div className={styles.chartContent}>
            {(() => {
              switch (data.chart_type) {
                    case "bubble":
                      return <KPIBubbleChart data={data} theme={theme} />;
                    case "topic_doughnut_grid": {
                      const topics = data.topics || [];
                      return (
                        <div className={styles.categoryChartsContainer}>
                          <div className={styles.doughnutCharts}>
                            {topics.map((topic, ti) => {
                              const td = {
                                labels: topic.labels,
                                legend: topic.legend,
                                datasets: topic.datasets,
                              };
                              const cl =
                                topic.legend && Array.isArray(topic.legend)
                                  ? topic.legend.map((item) => item.count)
                                  : null;
                              if (!td.datasets?.[0]?.data?.length) {
                                return null;
                              }
                              return (
                                <div
                                  key={`${topic.name || "t"}-${ti}`}
                                  className={styles.categoryChart}
                                >
                                  <KPIDoughnutChart
                                    data={td}
                                    theme={theme}
                                    customLabels={cl}
                                    showLegend={widget?.metric_id === 12}
                                  />
                                  <h4>{topic.name}</h4>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    }
                    case "doughnut": {
                      const legendLabels =
                        data.legend && Array.isArray(data.legend)
                          ? data.legend.map((item) => item.count)
                          : null;
                      return (
                        <KPIDoughnutChart
                          data={data}
                          theme={theme}
                          customLabels={legendLabels}
                          showLegend={widget?.metric_id === 12}
                        />
                      );
                    }
                    case "stacked_bar":
                      return widget?.metric_id === 14 ? (
                        <WelcomeTopicSentimentBarChart
                          payload={data}
                          widgetId={widget?.id}
                        />
                      ) : widget?.metric_id === 12 ? (
                        <WelcomeTopicIntentBarChart payload={data} />
                      ) : (
                        <KPIStackedBarChart data={data} theme={theme} />
                      );
                    case "decision_distribution":
                      return (
                        <WelcomeDecisionDistribution
                          data={data}
                          theme={theme}
                          widget={widget}
                          onTopicTabLoad={fetchWelcomeTopicTabPartial}
                          activeTabKey={
                            welcomeWidgetUsesLazyTopicTabs(widget)
                              ? welcomeLazyTopicTabKeyByWidget[widget.id]
                              : undefined
                          }
                          onActiveTabKeyChange={
                            welcomeWidgetUsesLazyTopicTabs(widget)
                              ? (key) =>
                                  setWelcomeLazyTopicTabKeyByWidget((prev) => ({
                                    ...prev,
                                    [widget.id]: key,
                                  }))
                              : undefined
                          }
                          onDecisionSliceClick={
                            Number(widget?.metric_id) === 27
                              ? (decisionKey, decisionTrue, topicLibId) => {
                                  void fetchMetric27DecisionReviews(
                                    widget,
                                    decisionKey,
                                    decisionTrue,
                                    topicLibId,
                                  );
                                }
                              : undefined
                          }
                        />
                      );
                    case "hotterms":
                      return (
                        <WelcomeHotTermsWidget
                          data={data}
                          widget={widget}
                          onTopicTabLoad={fetchWelcomeTopicTabPartial}
                          isTopicTabPartialLoading={isWelcomeTopicTabPartialLoading}
                          activeTabKey={
                            welcomeWidgetUsesLazyTopicTabs(widget)
                              ? welcomeLazyTopicTabKeyByWidget[widget.id]
                              : undefined
                          }
                          onActiveTabKeyChange={
                            welcomeWidgetUsesLazyTopicTabs(widget)
                              ? (key) =>
                                  setWelcomeLazyTopicTabKeyByWidget((prev) => ({
                                    ...prev,
                                    [widget.id]: key,
                                  }))
                              : undefined
                          }
                        />
                      );
                    case "dual_doughnut_sentiment":
                      return (
                        <WelcomeDualSentimentDoughnutCharts
                          data={data}
                          theme={theme}
                        />
                      );
                    case "dual_doughnut_intent":
                      return (
                        <WelcomeDualIntentDoughnutCharts
                          data={data}
                          theme={theme}
                        />
                      );
                    case "line":
                      return <KPILineChart data={data} theme={theme} />;
                    case "bar":
                    default:
                      return widget?.metric_id === 15 ? (
                        <WelcomeTopicParticipationBarChart payload={data} />
                      ) : (
                        <KPIBarChart data={data} theme={theme} />
                      );
                  }
                })()}
              </div>
            )}
          </div>
        );
      }

      if (widget.representation_type === 4) {
        const narrative = data.narrative || {};
        const midNarrativeWidget = Number(widget.metric_id);
        let sumTabs = data.summary_tabs;
        if (midNarrativeWidget === 25 && Array.isArray(sumTabs)) {
          sumTabs = sumTabs.filter(
            (tab) =>
              tab &&
              !["general", "global"].includes(
                String(tab.id || "").toLowerCase(),
              ),
          );
        }
        const topicIdsNav = Array.isArray(widget.topic_ids)
          ? widget.topic_ids.map((x) => Number(x)).filter((n) => n > 0)
          : [];
        const topicLabNav = resolveWelcomeIndustryTopicLabels(
          topicIdsNav,
          brandDashboardCategories,
        );
        if (
          WELCOME_HIERARCHICAL_SUMMARY_METRIC_IDS.has(midNarrativeWidget) &&
          topicLabNav.length >= 1 &&
          (!Array.isArray(sumTabs) || sumTabs.length <= 1)
        ) {
          const baseText = (
            narrative?.summary ||
            (Array.isArray(data.items) && data.items[0]
              ? String(
                  data.items[0].description ??
                    data.items[0].summary ??
                    "",
                )
              : "")
          ).trim();
          if (baseText) {
            if (midNarrativeWidget === 25) {
              sumTabs = topicLabNav.map((lab, i) => ({
                id: `topic-${i + 1}`,
                label: lab,
                content: `${baseText}\n\n— ${lab}`,
              }));
            } else {
              sumTabs = [
                {
                  id: "general",
                  label:
                    midNarrativeWidget === WELCOME_GENERAL_SUMMARY_METRIC_ID
                      ? t("welcome.generalSummaryOfSummariesTab")
                      : t("welcome.genaiMultiTopicGeneralTab"),
                  content: baseText,
                },
                ...topicLabNav.map((lab, i) => ({
                  id: `topic-${i + 1}`,
                  label: lab,
                  content: `${baseText}\n\n— ${lab}`,
                })),
              ];
            }
          }
        }
        if (
          Array.isArray(sumTabs) &&
          (midNarrativeWidget === 25
            ? sumTabs.length >= 1
            : sumTabs.length > 1) &&
          WELCOME_HIERARCHICAL_SUMMARY_METRIC_IDS.has(midNarrativeWidget)
        ) {
          const highlightsTopicLabels =
            midNarrativeWidget === 25
              ? buildHighlightsTopicLabelsAligned(
                  widget,
                  data,
                  sumTabs,
                  brandDashboardCategories,
                )
              : undefined;
          return (
            <WelcomeHierarchicalSummaryReadOnly
              tabs={sumTabs}
              metricId={Number(widget.metric_id)}
              widget={widget}
              narrativeData={data}
              highlightsTopicLabels={highlightsTopicLabels}
              onTabChange={fetchWelcomeTopicTabPartial}
              parseTopicLibId={parseTopicLibIdFromWidgetTab}
              onTabReviewCountClick={
                WELCOME_WIDGET_SCOPE_REVIEW_METRIC_IDS.has(
                  Number(widget.metric_id),
                )
                  ? ({ topicLibId, topicLabel, reviewCount }) => {
                      if (!fetchWelcomeWidgetScopeReviews) return;
                      void fetchWelcomeWidgetScopeReviews(
                        widget,
                        widget.metric_id,
                        { topicLibId, topicLabel, reviewCount },
                      );
                    }
                  : undefined
              }
              activeTabKey={
                welcomeWidgetUsesLazyTopicTabs(widget)
                  ? welcomeLazyTopicTabKeyByWidget[widget.id]
                  : undefined
              }
              onActiveTabKeyChange={
                welcomeWidgetUsesLazyTopicTabs(widget)
                  ? (key) =>
                      setWelcomeLazyTopicTabKeyByWidget((prev) => ({
                        ...prev,
                        [widget.id]: key,
                      }))
                  : undefined
              }
            />
          );
        }
        if (Number(widget.metric_id) === WELCOME_GENERAL_SUMMARY_METRIC_ID) {
          return (
            <WelcomeGeneralSummaryNarrative
              narrative={narrative}
              widgetName={widget.name}
              topicScopeLabels={
                Array.isArray(widget.topic_labels) ? widget.topic_labels : []
              }
            />
          );
        }
        const midNarrative = Number(widget.metric_id);
        if (midNarrative === 25) {
          const combinedText = decodeBasicHtmlEntities(
            [
              narrative.summary,
              ...(Array.isArray(narrative.bullets) ? narrative.bullets : []),
            ]
              .filter((x) => x != null && String(x).trim() !== "")
              .join("\n\n"),
          );
          return (
            <div className={styles.smartNarrativeWidget}>
              {combinedText.trim() ? (
                <WelcomeHighlightsStructuredBody bodyText={combinedText} />
              ) : (
                <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
              )}
            </div>
          );
        }
        const narrativePrimaryLineClass =
          midNarrative === 23
            ? styles.welcomeKeyDriversNarrativePrimaryLine
            : styles.smartNarrativeSummary;
        const summaryPlain = narrative.summary
          ? String(narrative.summary).replace(/\s+/g, " ").trim()
          : "";
        return (
          <div className={styles.smartNarrativeWidget}>
            {narrative.summary ? (
              <p
                className={narrativePrimaryLineClass}
                title={
                  midNarrative === 23 && summaryPlain ? summaryPlain : undefined
                }
              >
                {narrative.summary}
              </p>
            ) : null}
            {Array.isArray(narrative.bullets) && narrative.bullets.length > 0 ? (
              <ul className={styles.smartNarrativeList}>
                {narrative.bullets.map((bullet, idx) => (
                  <li key={`${widget.id}-narrative-${idx}`}>{bullet}</li>
                ))}
              </ul>
            ) : (
              <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
            )}
          </div>
        );
      }

      // Handle list widgets
      if (widget.representation_type === 2) {
        const metric8ReviewStats =
          Number(widget.metric_id) === 8
            ? data?.chart_type === "review_statistics"
              ? data
              : normalizeWelcomeReviewStatisticsPayload(data)
            : null;
        if (metric8ReviewStats) {
          return (
            <div
              className={`${styles.chartContainer} ${styles.reviewStatsContainer}`}
            >
              <WelcomeReviewStatisticsChart
                data={metric8ReviewStats}
                theme={theme}
              />
            </div>
          );
        }

        if (
          welcomeWidgetUsesBrandKpiHero(widget) &&
          Array.isArray(data.topic_tabs) &&
          data.topic_tabs.length > 0
        ) {
          return (
            <WelcomeBrandKpiHeroTopicTabs
              widget={widget}
              data={data}
              since={params.get("since") || widget.since}
              until={params.get("until") || widget.until}
              t={t}
              i18n={i18n}
              lazyTopicTabKey={welcomeLazyTopicTabKeyByWidget[widget.id]}
              onLazyTopicTabKeyChange={(key) =>
                setWelcomeLazyTopicTabKeyByWidget((prev) => ({
                  ...prev,
                  [widget.id]: key,
                }))
              }
              onTopicTabLoad={fetchWelcomeTopicTabPartial}
              isTopicTabPartialLoading={isWelcomeTopicTabPartialLoading}
              isPageDataLoading={
                resolveWelcomeWidgetPageDataLoadingForTiming
                  ? resolveWelcomeWidgetPageDataLoadingForTiming(widget)
                  : isWelcomeWidgetPageDataLoading
                    ? isWelcomeWidgetPageDataLoading(widget)
                    : false
              }
              parseTopicLibId={parseTopicLibIdFromWidgetTab}
              onTabReviewCountClick={({ tab, topicLibId, topicLabel, reviewCount }) => {
                if (!fetchWelcomeWidgetScopeReviews) return;
                void fetchWelcomeWidgetScopeReviews(widget, widget.metric_id, {
                  topicLibId,
                  topicLabel,
                  reviewCount,
                });
              }}
            />
          );
        }

        const listBrandKpiHeroHeader = resolveBrandKpiHeroHeader(
          data,
          widget.metric_id,
        );
        if (welcomeWidgetUsesBrandKpiHero(widget) && listBrandKpiHeroHeader) {
          return (
            <div
              className={`${styles.chartContainer} ${styles.brandKpiHeroContainer}`}
            >
              <WelcomeBrandKpiHeroCard
                metricId={widget.metric_id}
                header={listBrandKpiHeroHeader}
                widget={widget}
                since={params.get("since") || widget.since}
                until={params.get("until") || widget.until}
                t={t}
                i18n={i18n}
                isPageDataLoading={
                  resolveWelcomeWidgetPageDataLoadingForTiming
                    ? resolveWelcomeWidgetPageDataLoadingForTiming(widget)
                    : isWelcomeWidgetPageDataLoading
                      ? isWelcomeWidgetPageDataLoading(widget)
                      : false
                }
                isWidgetVisible={isWelcomeWidgetVisible?.(widget.id) ?? true}
              />
            </div>
          );
        }

        // List
        if (
          !data.items ||
          data.items.length === 0 ||
          data.items.every((item) => !item.title && !item.description)
        ) {
          return (
            <WelcomeWidgetEmptyState
              t={t}
              className={styles.noDataMessage}
              data={data}
              metricId={widget?.metric_id}
              widgetRow={widget}
            />
          );
        }

        return (
          <div className={styles.listWidget}>
            <List
              dataSource={data.items}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      item.link ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.itemLink}
                        >
                          {item.title}
                        </a>
                      ) : (
                        item.title
                      )
                    }
                    description={
                      item.descriptionLink ? (
                        <a
                          href={item.descriptionLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.itemLink}
                        >
                          {item.description}
                        </a>
                      ) : (
                        item.description
                      )
                    }
                  />
                </List.Item>
              )}
            />
          </div>
        );
      }

      // Handle table widgets
      if (widget.representation_type === 3) {
        const tableSchema = getWidgetTableSchema(widget, t);
        const genaiTriadTable = !!tableSchema;
        const topicIdsRc = Array.isArray(widget.topic_ids)
          ? widget.topic_ids.map((x) => Number(x)).filter((n) => n > 0)
          : [];
        const apiTopicLabels = Array.isArray(widget.topic_labels)
          ? widget.topic_labels.filter((l) => l != null && String(l).trim() !== "")
          : [];
        const topicLabRc =
          apiTopicLabels.length >= topicIdsRc.length && topicIdsRc.length > 0
            ? apiTopicLabels.slice(0, topicIdsRc.length)
            : resolveWelcomeIndustryTopicLabels(
                topicIdsRc,
                brandDashboardCategories,
              );
        const useRootCauseTopicTabs =
          genaiTriadTable &&
          Number(widget.metric_id) === 20 &&
          topicLabRc.length >= 1;

        if (useRootCauseTopicTabs) {
          return (
            <WelcomeGenaiRootCauseTopicTabs
              topicIds={topicIdsRc}
              topicLabels={topicLabRc}
              topicReviewCounts={data?.topic_review_counts}
              sourceItems={Array.isArray(data.items) ? data.items : []}
              tableSchema={tableSchema}
              widget={widget}
              groupId={groupId}
              setWidgets={setWidgets}
              setGroups={setGroups}
              scopeData={data}
              onViewAssociatedReviews={(item, row, topicTabLabel) =>
                fetchMetric20GenaiReviews(
                  item,
                  row,
                  widget.id,
                  topicTabLabel,
                )
              }
              workspaceContentEditable={workspaceContentEditable}
            />
          );
        }

        // Table
        if (
          !data.insufficient_reviews &&
          (!data.items ||
            data.items.length === 0 ||
            data.items.every((item) => Object.values(item).every((val) => !val)))
        ) {
          return (
            <WelcomeWidgetEmptyState
              t={t}
              className={styles.noDataMessage}
              data={data}
              metricId={widget?.metric_id}
              widgetRow={widget}
            />
          );
        }

        if (genaiTriadTable) {
          const triadRows = normalizeRowsBySchema(
            data.items,
            tableSchema,
            widget,
          );
          const scrollMany = triadRows.length > 3;
          const nfRc = new Intl.NumberFormat(
            getIntlLocale(i18n.language),
          );
          const reviewScopeLabelRc = formatWelcomeReviewScopeLabel(
            t,
            nfRc,
            resolveWelcomeReviewScopeFromData(data, widget),
          );
          return (
            <div
              className={`${styles.tableWidget} ${styles.welcomeGenaiRootCauseCardStackWrap}${
                scrollMany ? ` ${styles.welcomeGenaiRootCauseCardStackScroll}` : ""
              }`}
            >
              {reviewScopeLabelRc ? (
                <div className={styles.welcomeGeneralSummaryHierarchicalTabMeta}>
                  <span
                    className={
                      styles.welcomeGeneralSummaryHierarchicalTabReviewCount
                    }
                  >
                    {reviewScopeLabelRc}
                  </span>
                </div>
              ) : null}
              <WelcomeRootCauseCardStack
                rows={triadRows}
                widgetId={widget.id}
                groupId={groupId}
                sourceItems={Array.isArray(data.items) ? data.items : []}
              setWidgets={setWidgets}
              setGroups={setGroups}
              scopeData={data}
              onViewAssociatedReviews={(item, row, topicTabLabel) =>
                  fetchMetric20GenaiReviews(
                    item,
                    row,
                    widget.id,
                    topicTabLabel,
                  )
                }
                workspaceContentEditable={workspaceContentEditable}
              />
            </div>
          );
        }

        const columns =
          widget?.metric_id === 19
            ? aiInsightsColumn
            : data.columns ||
                Object.keys(data.items[0])
                  .filter((key) => !key.endsWith("_link"))
                  .map((key) => ({
                    title:
                      key.charAt(0).toUpperCase() +
                      key.slice(1).replace(/_/g, " "),
                    dataIndex: key,
                    key: key,
                    render: (text, record) => {
                      const linkField = `${key}_link`;
                      if (record[linkField]) {
                        return (
                          <a
                            href={record[linkField]}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.itemLink}
                          >
                            {decodeBasicHtmlEntities(
                              text == null ? "" : String(text),
                            )}
                          </a>
                        );
                      }
                      return decodeBasicHtmlEntities(
                        text == null ? "" : String(text),
                      );
                    },
                  }));

        const triadDataSource = data.items.map((item, index) => ({
          ...item,
          key: index,
        }));

        return (
          <div className={styles.tableWidget}>
            <Table
              dataSource={triadDataSource}
              columns={columns}
              pagination={{
                pageSize: 10,
                position: ["bottomRight"],
                showQuickJumper: false,
                showSizeChanger: false,
                size: "small",
                className: styles.tablePagination,
              }}
              scroll={{ x: 1000, y: 400 }}
              size="small"
              className={styles.tableContainer}
              locale={{
                emptyText: (
                  <WelcomeWidgetEmptyState
                t={t}
                className={styles.noDataMessage}
                data={widget?.data}
                metricId={widget?.metric_id}
                widgetRow={widget}
              />
                ),
              }}
            />
          </div>
        );
      }

      return (
        <div className={styles.noDataMessage}>
          {t("welcome.unsupportedWidgetType")}
        </div>
      );
}

function WelcomeGroupWidgets({
  user,
  workspaceOwnerId,
  workspaceContentEditable = false,
  workspaceMembers = [],
  groupId,
  groupName,
  onRenameGroup,
  widgets: initialWidgets,
  groups,
  setGroups,
  workspaceWidgetLimits,
  setWorkspaceWidgetLimits,
  queryFilters,
  pollWidgetStatus,
  stopWelcomeWidgetStatusPoll,
  fetchGroupsAndWidgets,
  setWorkspaceLoading,
  suppressGroupTitle = false,
  isArchivedGroupView = false,
  onGroupArchived,
  onGroupRestored,
  showRestoreGroup = false,
  deepLinkWidgetId = null,
  deepLinkHighlightWidgetId = null,
  onDeepLinkWidgetFocused = null,
  isActiveGroup = true,
  onWidgetMovedToGroup,
}) {
  const welcomeReviewsDrawerRef = useContext(WelcomeReviewsDrawerRefContext);
  const { copilotOpen } = useCopilotShell();
  const { t, i18n } = useTranslation();
  const isEnterprisePowerUser = useEnterprisePowerUser();
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const effectiveWorkspaceUserId = getEffectiveWorkspaceUserId(
    workspaceOwnerId,
    user?.uid,
  );
  const groupInteractionsEnabled =
    workspaceContentEditable && !isArchivedGroupView;
  const subscriptionStatus = useSelector((state) => state.userReducer);
  const canAccessMarketIntelligence = hasMarketIntelligencePlan(subscriptionStatus);
  const dashboardReducer = useSelector((state) => state.DashboardReducer);
  const dashboardReducerRef = useRef(dashboardReducer);
  dashboardReducerRef.current = dashboardReducer;
  const [widgets, setWidgets] = useState(initialWidgets || []);
  const [isAddWidgetModalVisible, setIsAddWidgetModalVisible] = useState(
    false,
  );
  const [
    isEditWidgetNameModalVisible,
    setIsEditWidgetNameModalVisible,
  ] = useState(false);
  const [isDeleteGroupModalVisible, setIsDeleteGroupModalVisible] = useState(
    false,
  );
  const [isArchiveGroupModalVisible, setIsArchiveGroupModalVisible] =
    useState(false);
  const [archiveGroupLoading, setArchiveGroupLoading] = useState(false);
  const [restoreGroupLoading, setRestoreGroupLoading] = useState(false);
  const [isMoveGroupToUserModalVisible, setIsMoveGroupToUserModalVisible] =
    useState(false);
  const [moveGroupTargetUserId, setMoveGroupTargetUserId] = useState(null);
  const [moveGroupToUserLoading, setMoveGroupToUserLoading] = useState(false);
  const [isEditNameModalVisible, setIsEditNameModalVisible] = useState(false);
  const [moveModalOpen, setMoveModalOpen] = useState(false);
  const [moveWidgetId, setMoveWidgetId] = useState(null);
  const [moveLoading, setMoveLoading] = useState(false);
  const [widgetReorderLoading, setWidgetReorderLoading] = useState(false);
  const [newWidgetType, setNewWidgetType] = useState("chart");
  const [editingWidgetId, setEditingWidgetId] = useState(null);
  const [newWidgetName, setNewWidgetName] = useState("");
  const [loadingWidgets, setLoadingWidgets] = useState({});
  /** True while welcome/widget/data is in flight and this widget has no KPI payload yet (avoids "No data" flash). */
  const [widgetKpiLoading, setWidgetKpiLoading] = useState({});
  /** Per-topic lazy tab fetch (metric 14/28); must not block the whole widget card. */
  const [topicTabPartialLoading, setTopicTabPartialLoading] = useState({});
  const [widgetRefreshLoading, setWidgetRefreshLoading] = useState({});
  /** Keeps selected topic tab after partial KPI merge (Ant Design Tabs otherwise resets to first tab). */
  const [welcomeLazyTopicTabKeyByWidget, setWelcomeLazyTopicTabKeyByWidget] =
    useState({});
  /** True while welcome/widget/add is in flight — modal primary button shows loading. */
  const [isWidgetCreateSubmitting, setIsWidgetCreateSubmitting] = useState(false);
  const widgetCreateInFlightRef = useRef(false);
  const creditPreviewRequestRef = useRef(0);
  const pivotFetchRequestRef = useRef(0);

  /** Lazy loading: track which widget IDs are visible/near viewport. */
  const [visibleWidgetIds, setVisibleWidgetIds] = useState(() => new Set());
  const widgetsRef = useRef(widgets);
  widgetsRef.current = widgets;
  const visibleWidgetIdsRef = useRef(visibleWidgetIds);
  visibleWidgetIdsRef.current = visibleWidgetIds;
  const widgetRefs = useRef({});
  const intersectionObserverRef = useRef(null);
  // Pending "settle in view" timers keyed by widget id; a widget is only
  // marked visible (→ fetched) once it has dwelled in view long enough.
  const widgetVisibilityTimersRef = useRef(new Map());
  // --- Quota check for AI summary metrics ---
  const [quotaDateRange, setQuotaDateRange] = useState(["", ""]);
  const [quotaDaysRange, setQuotaDaysRange] = useState("last7d");
  const [quotaSince, setQuotaSince] = useState("");
  const [quotaUntil, setQuotaUntil] = useState("");
  const [quotaCheckResult, setQuotaCheckResult] = useState(null);
  const [quotaCheckLoading, setQuotaCheckLoading] = useState(false);
  const [regenerateQuotaModalOpen, setRegenerateQuotaModalOpen] = useState(false);
  const [regenerateQuotaWidget, setRegenerateQuotaWidget] = useState(null);
  const [regenerateQuotaResult, setRegenerateQuotaResult] = useState(null);
  const [regenerateQuotaLoading, setRegenerateQuotaLoading] = useState(false);
  const [metricCreditPreview, setMetricCreditPreview] = useState(null);
  const [metricCreditPreviewLoading, setMetricCreditPreviewLoading] = useState(false);
  const [aiCreditConfirmOpen, setAiCreditConfirmOpen] = useState(false);
  const [aiCreditConfirmMeta, setAiCreditConfirmMeta] = useState({
    hotel_count: 1,
  });
  const [aiCreditConfirmTargetStep, setAiCreditConfirmTargetStep] = useState(null);
  const aiCreditConfirmedRef = useRef(false);
  const quotaRangePresets = [
    { id: "last7d", label: t("welcome.quotaPresetLast7d"), days: 6 },
    { id: "last14d", label: t("welcome.quotaPresetLast14d"), days: 13 },
    { id: "last30d", label: t("welcome.quotaPresetLast30d"), days: 29 },
    { id: "last90d", label: t("welcome.quotaPresetLast90d"), days: 89 },
  ];
  // IDs belonging to "What do They Want to Say?" category that require AI quota
  const AI_SUMMARY_METRIC_IDS = [20, 21, 23, 25];
  const WELCOME_AI_CREDIT_BILLABLE_METRIC_IDS = new Set(AI_SUMMARY_METRIC_IDS);

  const normalizeWelcomeMetricId = (id) => {
    const n = Number(id);
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  const getSelectedBillableAiMetricIds = () =>
    [...selectedBrandMetrics]
      .map(normalizeWelcomeMetricId)
      .filter(
        (id) => id != null && WELCOME_AI_CREDIT_BILLABLE_METRIC_IDS.has(id),
      );

  const getSelectedNonBillableMetricIds = () =>
    [...selectedBrandMetrics]
      .map(normalizeWelcomeMetricId)
      .filter(
        (id) => id != null && !WELCOME_AI_CREDIT_BILLABLE_METRIC_IDS.has(id),
      );

  /** GenAI metrics selected that consume unified AI credits (20, 21, 23, 25). */
  const needsQuotaCheck = () =>
    metricType === "brand" && getSelectedBillableAiMetricIds().length > 0;

  const welcomeReviewStepCreateBlocked = () => {
    if (quotaCheckLoading || !quotaCheckResult || quotaCheckResult?.error === true) {
      return true;
    }
    if (quotaCheckResult?.applicable === false) {
      return true;
    }
    const billableIds = getSelectedBillableAiMetricIds();
    if (!billableIds.length) {
      return false;
    }
    if (welcomeGenaiReviewsInsufficient(quotaCheckResult)) {
      return true;
    }
    if (welcomeAiCreditsInsufficient(quotaCheckResult)) {
      return true;
    }
    return false;
  };
  /** GenAI "What do They Want to Say?" metrics: full grid row like Root Cause & General Summary. */
  const WELCOME_FULL_GRID_ROW_METRIC_IDS = new Set([
    ...AI_SUMMARY_METRIC_IDS,
    11,
    12,
    /* Topic-scoped chart KPIs: full row like Sentiment / Intent (not 3-column). */
    13,
    14,
    15,
    16,
    17,
    18,
    27,
    28,
  ]);
  const isWelcomeFullGridRowWidget = (w) =>
    WELCOME_FULL_GRID_ROW_METRIC_IDS.has(Number(w?.metric_id));
  const location = useLocation();
  /** Every brand widget uses wizard steps 7 (date range) and 8 (review & scope count). */
  const needsBrandDateRangeStep = () => metricType === "brand";

  const isWorkspaceWidgetLimitReached =
    workspaceWidgetLimits?.limit_reached === true;
  const maxWorkspaceWidgets =
    workspaceWidgetLimits?.max_widgets ?? DEFAULT_WORKSPACE_WIDGET_LIMITS.max_widgets;

  // Sync local widgets from parent only when structure identity changes (id, status, name, count).
  // Parent passes a new array reference on every setGroups (e.g. Regenerate) — syncing on that
  // re-ran this effect and replaced all rows, which felt like a full page reload.
  const initialWidgetsIdentityKey =
    initialWidgets == null
      ? "null"
      : initialWidgets.length === 0
        ? "0"
        : `${initialWidgets.length}|${initialWidgets
            .map((w) => `${w.id}:${w.status}:${String(w.name ?? "")}:${w.display_order ?? ""}`)
            .join(",")}`;

  useEffect(() => {
    if (initialWidgets == null) {
      return;
    }
    if (initialWidgets.length === 0) {
      setWidgets([]);
      return;
    }
    setWidgets((prev) => {
      const prevById = new Map((prev || []).map((w) => [w.id, w]));
      return sortWelcomeGroupWidgets(
        initialWidgets.map((w) =>
          mergeWelcomeWidgetRowFromGroupSync(w, prevById.get(w.id)),
        ),
      );
    });
    // Intentionally omit `widgets` / full `initialWidgets` deps: only re-sync when group widget list identity changes (names), not on every parent ref or data-only updates.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialWidgetsIdentityKey]);

  /** Start KPI fetch as soon as a widget job completes (do not wait for IO dwell). */
  const readyWidgetVisibilityKey = widgets
    .filter((w) => w?.status === "ready")
    .map((w) => w.id)
    .sort((a, b) => Number(a) - Number(b))
    .join(",");
  useEffect(() => {
    if (!readyWidgetVisibilityKey) return;
    const readyIds = readyWidgetVisibilityKey.split(",").map((x) => Number(x));
    setVisibleWidgetIds((prev) => {
      let changed = false;
      const next = new Set(prev);
      readyIds.forEach((id) => {
        if (!next.has(id)) {
          next.add(id);
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [readyWidgetVisibilityKey]);

  useEffect(() => {
    const wid = Number(deepLinkWidgetId);
    if (!Number.isFinite(wid) || wid <= 0) return;
    if (!isActiveGroup) return;
    if (!(widgets || []).some((w) => Number(w.id) === wid)) return;
    setVisibleWidgetIds((prev) => {
      const next = new Set(prev);
      let changed = false;
      (widgets || []).forEach((w) => {
        if (!next.has(w.id)) {
          next.add(w.id);
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [deepLinkWidgetId, isActiveGroup, widgets]);

  const loadingWidgetIdsKey = useMemo(() => {
    return (widgets || [])
      .filter((widget) => widget.status === "loading")
      .map((widget) => widget.id)
      .sort((a, b) => Number(a) - Number(b))
      .join(",");
  }, [widgets]);

  useEffect(() => {
    if (!isActiveGroup) {
      (widgetsRef.current || []).forEach((widget) => {
        if (stopWelcomeWidgetStatusPoll) {
          stopWelcomeWidgetStatusPoll(widget.id);
        }
      });
      return undefined;
    }
    (widgetsRef.current || []).forEach((widget) => {
      if (widget.status === "loading") {
        pollWidgetStatus(groupId, widget);
      } else if (stopWelcomeWidgetStatusPoll) {
        stopWelcomeWidgetStatusPoll(widget.id);
      }
    });
    // Do not stop polls in cleanup on dep changes — that restarted the timer and
    // fired an immediate groups/all on every parent re-render.
  }, [
    isActiveGroup,
    groupId,
    loadingWidgetIdsKey,
    pollWidgetStatus,
    stopWelcomeWidgetStatusPoll,
  ]);

  const deepLinkWidgetIdRef = useRef(deepLinkWidgetId);
  deepLinkWidgetIdRef.current = deepLinkWidgetId;

  /** IntersectionObserver: mark a widget visible only after it has dwelled in
   *  view for WELCOME_WIDGET_VISIBILITY_DWELL_MS (+300px prefetch margin). Fast
   *  scroll-through never fires a request because the widget leaves before the
   *  timer elapses. */
  useEffect(() => {
    if (!isActiveGroup) {
      setVisibleWidgetIds(new Set());
      const timers = widgetVisibilityTimersRef.current;
      timers.forEach((handle) => clearTimeout(handle));
      timers.clear();
      if (intersectionObserverRef.current) {
        intersectionObserverRef.current.disconnect();
      }
      return undefined;
    }

    if (intersectionObserverRef.current) {
      intersectionObserverRef.current.disconnect();
    }
    const timers = widgetVisibilityTimersRef.current;
    const clearWidgetTimer = (id) => {
      const handle = timers.get(id);
      if (handle != null) {
        clearTimeout(handle);
        timers.delete(id);
      }
    };
    intersectionObserverRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = parseInt(entry.target.dataset.widgetId, 10);
          if (isNaN(id)) return;
          if (entry.isIntersecting) {
            // Already visible or already waiting → nothing to do.
            if (visibleWidgetIdsRef.current.has(id) || timers.has(id)) return;
            const deepLinkWid = Number(deepLinkWidgetIdRef.current);
            const deepLinkActive =
              Number.isFinite(deepLinkWid) &&
              deepLinkWid > 0 &&
              (widgetsRef.current || []).some((w) => Number(w.id) === deepLinkWid);
            const markVisible = () => {
              setVisibleWidgetIds((prev) => {
                if (prev.has(id)) return prev;
                const next = new Set(prev);
                next.add(id);
                return next;
              });
            };
            if (deepLinkActive) {
              markVisible();
              return;
            }
            const handle = setTimeout(() => {
              timers.delete(id);
              markVisible();
            }, WELCOME_WIDGET_VISIBILITY_DWELL_MS);
            timers.set(id, handle);
          } else {
            // Left the viewport before settling → cancel the pending fetch.
            clearWidgetTimer(id);
          }
        });
      },
      { threshold: 0.01, rootMargin: "300px 0px" },
    );
    Object.values(widgetRefs.current).forEach((el) => {
      if (el) intersectionObserverRef.current.observe(el);
    });
    return () => {
      if (intersectionObserverRef.current) {
        intersectionObserverRef.current.disconnect();
      }
      timers.forEach((handle) => clearTimeout(handle));
      timers.clear();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgets.length, isActiveGroup]);

  /** Only KPI-fetch widgets that are visible; widgetKpiDependencyKey updates when visibility changes → triggers effect. */
  const widgetKpiDependencyKey = useMemo(
    () =>
      widgets
        .filter((w) => visibleWidgetIds.has(w.id))
        .map((w) => ({ id: w.id, line: `${w.id}:${w.status}` }))
        .sort((a, b) => Number(a.id) - Number(b.id))
        .map((x) => x.line)
        .join("|"),
    [widgets, visibleWidgetIds],
  );

  /** Changing date/URL/user/refresh invalidates KPI; a sibling widget toggling ready↔loading must not. */
  const globalKpiContextKey = [
    location.search,
    user?.uid ?? "",
    String(dashboardReducer?.end_date ?? ""),
    String(dashboardReducer?.dashboard?.RefreshRate ?? ""),
  ].join("|");
  /** Batches rapid raw key churn so the KPI effect does not re-run on every Redux commit (first load).
   *  Starts null so we never run the KPI batch on the first paint key and again after debounce (duplicate POSTs). */
  const kpiEffectRawKey = useMemo(
    () => `${globalKpiContextKey}\x1e${widgetKpiDependencyKey}`,
    [globalKpiContextKey, widgetKpiDependencyKey],
  );
  const [kpiEffectStableKey, setKpiEffectStableKey] = useState(null);
  useEffect(() => {
    const timerId = setTimeout(() => {
      setKpiEffectStableKey((prev) =>
        prev === kpiEffectRawKey ? prev : kpiEffectRawKey,
      );
    }, WELCOME_WIDGET_DATA_DEBOUNCE_MS);
    return () => clearTimeout(timerId);
  }, [kpiEffectRawKey]);
  const queryClient = useQueryClient();
  const locationRefForKpi = useRef(location);
  locationRefForKpi.current = location;
  const userRef = useRef(user);
  userRef.current = user;
  const effectiveWorkspaceUserIdRef = useRef(effectiveWorkspaceUserId);
  effectiveWorkspaceUserIdRef.current = effectiveWorkspaceUserId;
  const withWorkspaceOwnerPayload = useCallback(
    (payload) => appendWorkspaceUserId(payload, workspaceOwnerId, user?.uid),
    [workspaceOwnerId, user?.uid],
  );

  const moveGroupTargetOptions = useMemo(() => {
    return (workspaceMembers || [])
      .filter((member) => member.user_id && member.user_id !== effectiveWorkspaceUserId)
      .map((member) => ({
        value: member.user_id,
        label: member.display_name || member.email || member.user_id,
      }));
  }, [workspaceMembers, effectiveWorkspaceUserId]);

  const canMoveGroupToUser =
    workspaceContentEditable && moveGroupTargetOptions.length > 0;

  const closeMoveGroupToUserModal = () => {
    if (moveGroupToUserLoading) return;
    setIsMoveGroupToUserModalVisible(false);
    setMoveGroupTargetUserId(null);
  };

  const openMoveGroupToUserModal = () => {
    setMoveGroupTargetUserId(moveGroupTargetOptions[0]?.value ?? null);
    setIsMoveGroupToUserModalVisible(true);
  };

  const welcomeWidgetHasKpiPayload = (w) =>
    w?.data &&
    typeof w.data === "object" &&
    Object.keys(w.data).length > 0;

  const welcomeEnvelopeHasKpiData = (envelope) =>
    envelope?.data &&
    typeof envelope.data === "object" &&
    Object.keys(envelope.data).length > 0;

  /** One main /welcome/widget/data query per visible ready widget. */
  const welcomeMainDataPlan = useMemo(() => {
    if (kpiEffectStableKey == null || !effectiveWorkspaceUserId) {
      return [];
    }
    const sp = new URLSearchParams(location.search);
    let pivotFilterPayload = null;
    const pvt = sp.get("pivotFilter");
    if (pvt) {
      try {
        pivotFilterPayload = JSON.parse(pvt);
      } catch (e) {
        console.warn("[Welcome] WARN pivotFilter parse failed", e);
      }
    }
    const pivotDashboardIdRaw = sp.get("pivotDashboardId");
    const pageRange = getWelcomeKpiSinceUntil(sp, dashboardReducer);
    const candidates = widgets.filter(
      (w) =>
        isActiveGroup &&
        welcomeWidgetRenderAsReady(w) &&
        visibleWidgetIds.has(w.id),
    );
    candidates.sort((a, b) => Number(a.id) - Number(b.id));
    return candidates.map((widgetRow) => {
      const kpiQueryKey = getWelcomeWidgetKpiQueryKey(
        widgetRow,
        pageRange.since,
        pageRange.until,
        pivotFilterPayload,
        pivotDashboardIdRaw,
      );
      const payload = buildWelcomeWidgetMainFetchPayload(
        widgetRow,
        pageRange.since,
        pageRange.until,
        effectiveWorkspaceUserId,
        pivotFilterPayload,
        pivotDashboardIdRaw,
      );
      return {
        widgetRow,
        kpiQueryKey,
        payload,
        queryKey: welcomeWidgetKeys.mainData(
          effectiveWorkspaceUserId,
          widgetRow.id,
          kpiQueryKey,
        ),
      };
    });
  }, [
    kpiEffectStableKey,
    effectiveWorkspaceUserId,
    location.search,
    dashboardReducer,
    widgets,
    visibleWidgetIds,
    isActiveGroup,
  ]);

  const welcomeBatchEligiblePlans = useMemo(
    () =>
      welcomeMainDataPlan.filter(
        (plan) => !welcomeWidgetUsesLazyTopicTabs(plan.widgetRow),
      ),
    [welcomeMainDataPlan],
  );

  const welcomeBatchFetchContext = useMemo(() => {
    if (!isActiveGroup) {
      return null;
    }
    if (kpiEffectStableKey == null || !effectiveWorkspaceUserId || !groupId) {
      return null;
    }
    const sp = new URLSearchParams(location.search);
    let pivotFilterPayload = null;
    const pvt = sp.get("pivotFilter");
    if (pvt) {
      try {
        pivotFilterPayload = JSON.parse(pvt);
      } catch (e) {
        console.warn("[Welcome] WARN pivotFilter parse failed", e);
      }
    }
    const pivotDashboardIdRaw = sp.get("pivotDashboardId");
    const pageRange = getWelcomeKpiSinceUntil(sp, dashboardReducer);
    const widgetIds = welcomeBatchEligiblePlans
      .map((plan) => plan.widgetRow.id)
      .sort((a, b) => Number(a) - Number(b));
    if (widgetIds.length === 0) {
      return null;
    }
    return {
      pivotFilterPayload,
      pivotDashboardIdRaw,
      pageRange,
      widgetIds,
      queryKey: welcomeWidgetKeys.groupBatch(
        effectiveWorkspaceUserId,
        groupId,
        kpiEffectStableKey,
      ),
      payload: buildWelcomeGroupWidgetsBatchPayload({
        groupId,
        userId: effectiveWorkspaceUserId,
        pageSince: pageRange.since,
        pageUntil: pageRange.until,
        pivotFilterPayload,
        widgetIds,
      }),
    };
  }, [
    kpiEffectStableKey,
    effectiveWorkspaceUserId,
    groupId,
    location.search,
    dashboardReducer,
    welcomeBatchEligiblePlans,
    isActiveGroup,
  ]);

  const welcomeGroupBatchQuery = useQuery({
    queryKey:
      welcomeBatchFetchContext?.queryKey ?? [
        "welcome",
        "widgets",
        "_no_group_batch",
      ],
    queryFn: ({ signal }) =>
      limitWelcomeWidgetData(async () => {
        if (signal?.aborted) {
          throw new DOMException("Aborted", "AbortError");
        }
        const batchSuccess = await fetchWelcomeGroupWidgetsData(
          welcomeBatchFetchContext.payload,
          signal,
        );
        seedWelcomeWidgetMainDataFromBatch(
          queryClient,
          effectiveWorkspaceUserId,
          welcomeMainDataPlan,
          batchSuccess,
        );
        return batchSuccess;
      }),
    enabled: Boolean(welcomeBatchFetchContext),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const welcomeBatchWidgetIdsFromResponse = useMemo(() => {
    if (!welcomeGroupBatchQuery.isSuccess) {
      return null;
    }
    const rows = welcomeGroupBatchQuery.data?.widgets;
    if (!Array.isArray(rows)) {
      return null;
    }
    return new Set(
      rows.map((row) => Number(row?.id)).filter((id) => id > 0),
    );
  }, [welcomeGroupBatchQuery.isSuccess, welcomeGroupBatchQuery.data]);

  const welcomeBatchFetchActive = Boolean(welcomeBatchFetchContext);
  const welcomeBatchFetchSettled =
    !welcomeBatchFetchActive ||
    welcomeGroupBatchQuery.isSuccess ||
    welcomeGroupBatchQuery.isError ||
    (!welcomeGroupBatchQuery.isFetching && !welcomeGroupBatchQuery.isPending);
  const welcomeBatchFetchFailed =
    welcomeBatchFetchActive && welcomeGroupBatchQuery.isError;
  const welcomeBatchFetchSucceeded =
    welcomeBatchFetchActive && welcomeGroupBatchQuery.isSuccess;

  const welcomeMainDataResults = useQueries({
    queries: welcomeMainDataPlan.map((plan) => {
      const lazyTopicWidget = welcomeWidgetUsesLazyTopicTabs(plan.widgetRow);
      const batchListedWidget =
        welcomeBatchFetchSucceeded &&
        welcomeBatchWidgetIdsFromResponse?.has(plan.widgetRow.id);
      const batchEnvelope = batchListedWidget
        ? queryClient.getQueryData(plan.queryKey)
        : null;
      const batchHasUsableKpi = welcomeEnvelopeHasKpiData(batchEnvelope);
      const useIndividualFetch =
        !welcomeBatchFetchActive ||
        welcomeBatchFetchFailed ||
        lazyTopicWidget ||
        !batchListedWidget ||
        !batchHasUsableKpi;
      return {
        queryKey: plan.queryKey,
        queryFn: ({ signal }) =>
          limitWelcomeWidgetData(() => {
            if (signal?.aborted) {
              return Promise.reject(
                new DOMException("Aborted", "AbortError"),
              );
            }
            return fetchWelcomeWidgetData(plan.payload, signal);
          }),
        enabled: Boolean(
          effectiveWorkspaceUserId &&
            kpiEffectStableKey &&
            plan.widgetRow?.id &&
            welcomeBatchFetchSettled &&
            useIndividualFetch,
        ),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: 1,
        keepPreviousData: true,
      };
    }),
  });

  const welcomeMainDataFetchingById = useMemo(() => {
    const m = {};
    const batchBusy =
      welcomeBatchFetchActive &&
      (welcomeGroupBatchQuery.isFetching === true ||
        welcomeGroupBatchQuery.isLoading === true);
    welcomeMainDataPlan.forEach((plan, i) => {
      const lazyTopicWidget = welcomeWidgetUsesLazyTopicTabs(plan.widgetRow);
      const batchEligibleWidget = welcomeBatchEligiblePlans.some(
        (p) => p.widgetRow.id === plan.widgetRow.id,
      );
      if (batchEligibleWidget && !lazyTopicWidget && batchBusy) {
        m[plan.widgetRow.id] = true;
        return;
      }
      const batchListedWidget =
        welcomeBatchFetchSucceeded &&
        welcomeBatchWidgetIdsFromResponse?.has(plan.widgetRow.id);
      const batchEnvelope = batchListedWidget
        ? queryClient.getQueryData(plan.queryKey)
        : null;
      const batchHasUsableKpi = welcomeEnvelopeHasKpiData(batchEnvelope);
      if (batchListedWidget && !lazyTopicWidget && batchHasUsableKpi) {
        m[plan.widgetRow.id] = batchBusy;
        return;
      }
      const q = welcomeMainDataResults[i];
      m[plan.widgetRow.id] =
        q?.isFetching === true || q?.isLoading === true;
    });
    return m;
  }, [
    welcomeMainDataPlan,
    welcomeMainDataResults,
    welcomeBatchEligiblePlans,
    welcomeBatchFetchActive,
    welcomeBatchFetchSucceeded,
    welcomeBatchWidgetIdsFromResponse,
    welcomeGroupBatchQuery.isFetching,
    welcomeGroupBatchQuery.isLoading,
  ]);

  /** KPI fields for menus / quota / feedback when `widget.data` is empty but RQ cache is populated. */
  const getWelcomeWidgetEffectiveKpiData = useCallback(
    (widgetRow) => {
      const fallback =
        widgetRow?.data && typeof widgetRow.data === "object"
          ? widgetRow.data
          : {};
      if (!widgetRow?.id || !effectiveWorkspaceUserId) {
        return fallback;
      }
      const plan = welcomeMainDataPlan.find(
        (p) => p.widgetRow.id === widgetRow.id,
      );
      if (!plan) {
        return fallback;
      }
      const envelope = queryClient.getQueryData(plan.queryKey);
      return mergeWelcomeWidgetRowDataWithKpiEnvelope(widgetRow, envelope);
    },
    [welcomeMainDataPlan, queryClient, effectiveWorkspaceUserId],
  );

  const welcomeTopicTabPartialMutation = useMutation({
    mutationFn: async ({ widgetRow, topicLibId }) => {
      const userId = effectiveWorkspaceUserIdRef.current;
      if (!userId || !widgetRow?.id || topicLibId == null) {
        throw new Error("WELCOME_TOPIC_TAB_PARTIAL_INVALID");
      }
      const sp = new URLSearchParams(locationRefForKpi.current.search);
      let pivotFilterPayload = null;
      const pvt = sp.get("pivotFilter");
      if (pvt) {
        try {
          pivotFilterPayload = JSON.parse(pvt);
        } catch (e) {
          console.warn("[Welcome] WARN pivotFilter parse failed", e);
        }
      }
      const pivotDashboardIdRaw = sp.get("pivotDashboardId");
      const pageRange = getWelcomeKpiSinceUntil(
        sp,
        dashboardReducerRef.current,
      );
      const payload = {
        ...buildWelcomeWidgetDataKpiPayload(
          widgetRow,
          pageRange.since,
          pageRange.until,
          userId,
          pivotFilterPayload,
          pivotDashboardIdRaw,
        ),
        topic_tab_scope: "topic",
        topic_lib_id: topicLibId,
      };
      const envelope = await fetchWelcomeWidgetData(payload);
      const kpiQueryKey = getWelcomeWidgetKpiQueryKey(
        widgetRow,
        pageRange.since,
        pageRange.until,
        pivotFilterPayload,
        pivotDashboardIdRaw,
      );
      return { envelope, kpiQueryKey, widgetId: widgetRow.id };
    },
    onMutate: ({ widgetRow, topicLibId }) => {
      const loadKey = welcomeTopicTabPartialLoadingKey(
        widgetRow.id,
        topicLibId,
      );
      setTopicTabPartialLoading((prev) => ({
        ...prev,
        [loadKey]: true,
      }));
    },
    onSuccess: (result) => {
      const { envelope, kpiQueryKey, widgetId } = result;
      const partialKpi = envelope?.data;
      const uid = effectiveWorkspaceUserIdRef.current;
      if (
        partialKpi == null ||
        typeof partialKpi !== "object" ||
        Object.keys(partialKpi).length === 0 ||
        !uid
      ) {
        return;
      }
      const targetKey = welcomeWidgetKeys.mainData(
        uid,
        widgetId,
        kpiQueryKey,
      );
      queryClient.setQueryData(targetKey, (old) => {
        if (old == null) {
          return envelope;
        }
        const mergedWidgetShape = mergeWelcomePartialTopicData(
          { data: old.data },
          partialKpi,
        );
        return {
          ...old,
          data: mergedWidgetShape.data,
          representation_type:
            envelope.representation_type ?? old.representation_type,
          metricType: envelope.metricType ?? old.metricType,
        };
      });
    },
    onError: (err) => {
      console.error("[Welcome] topic tab partial failed", err);
    },
    onSettled: (_data, _err, variables) => {
      const wid = variables?.widgetRow?.id;
      const topicLibId = variables?.topicLibId;
      if (wid == null || topicLibId == null) return;
      const loadKey = welcomeTopicTabPartialLoadingKey(wid, topicLibId);
      setTopicTabPartialLoading((prev) => {
        if (!prev[loadKey]) return prev;
        const next = { ...prev };
        delete next[loadKey];
        return next;
      });
    },
  });

  const isWelcomeTopicTabPartialLoading = useCallback(
    (widgetId, topicLibId) =>
      !!topicTabPartialLoading[
        welcomeTopicTabPartialLoadingKey(widgetId, topicLibId)
      ],
    [topicTabPartialLoading],
  );

  const fetchWelcomeTopicTabPartial = useCallback(
    (widgetRow, topicLibId) =>
      welcomeTopicTabPartialMutation.mutateAsync({
        widgetRow,
        topicLibId,
      }),
    [welcomeTopicTabPartialMutation],
  );

  const isWelcomeMainOrTopicKpiBusy = useCallback(
    (widgetId) =>
      (welcomeMainDataFetchingById[widgetId] ?? false) ||
      !!widgetKpiLoading[widgetId],
    [welcomeMainDataFetchingById, widgetKpiLoading],
  );

  /** True only while this widget's KPI request is in flight and cache has no data yet. */
  const isWelcomeWidgetPageDataLoading = useCallback(
    (w) => {
      if (w?.status !== "ready" || !visibleWidgetIds.has(w.id)) {
        return false;
      }
      if (welcomeWidgetHasKpiPayload(w)) {
        return false;
      }
      const plan = welcomeMainDataPlan.find((p) => p.widgetRow.id === w.id);
      if (plan) {
        const envelope = queryClient.getQueryData(plan.queryKey);
        if (welcomeEnvelopeHasKpiData(envelope)) {
          return false;
        }
      }
      if (widgetKpiLoading[w?.id]) {
        return true;
      }
      return !!welcomeMainDataFetchingById[w?.id];
    },
    [
      visibleWidgetIds,
      widgetKpiLoading,
      welcomeMainDataFetchingById,
      welcomeMainDataPlan,
      queryClient,
    ],
  );

  const isWelcomeWidgetVisible = useCallback(
    (widgetId) => visibleWidgetIds.has(widgetId),
    [visibleWidgetIds],
  );

  const showWelcomeKpiBlockingSpin = (w) => {
    if (widgetKpiLoading[w?.id]) {
      return true;
    }
    if (w?.status !== "ready" || !visibleWidgetIds.has(w.id)) {
      return false;
    }
    if (welcomeWidgetHasKpiPayload(w)) {
      return false;
    }
    const planEarly = welcomeMainDataPlan.find((p) => p.widgetRow.id === w.id);
    if (
      planEarly &&
      welcomeEnvelopeHasKpiData(queryClient.getQueryData(planEarly.queryKey))
    ) {
      return false;
    }
    if (kpiEffectStableKey == null) {
      return true;
    }
    const plan = welcomeMainDataPlan.find((p) => p.widgetRow.id === w.id);
    if (!plan) {
      return true;
    }
    const lazyTopicWidget = welcomeWidgetUsesLazyTopicTabs(plan.widgetRow);
    const batchListedWidget =
      welcomeBatchFetchSucceeded &&
      welcomeBatchWidgetIdsFromResponse?.has(w.id);
    const batchEnvelope = batchListedWidget
      ? queryClient.getQueryData(plan.queryKey)
      : null;
    const batchHasUsableKpi = welcomeEnvelopeHasKpiData(batchEnvelope);
    if (batchListedWidget && !lazyTopicWidget && batchHasUsableKpi) {
      if (welcomeGroupBatchQuery.isError) {
        return false;
      }
      if (welcomeEnvelopeHasKpiData(queryClient.getQueryData(plan.queryKey))) {
        return false;
      }
      return (
        welcomeGroupBatchQuery.isLoading || welcomeGroupBatchQuery.isFetching
      );
    }
    const idx = welcomeMainDataPlan.findIndex(
      (p) => p.widgetRow.id === w.id,
    );
    const q = welcomeMainDataResults[idx];
    if (q?.isError) {
      return false;
    }
    if (welcomeEnvelopeHasKpiData(q?.data)) {
      return false;
    }
    if (
      welcomeBatchFetchActive &&
      !welcomeBatchFetchSettled &&
      welcomeBatchEligiblePlans.some((p) => p.widgetRow.id === w.id)
    ) {
      return true;
    }
    return q.isLoading && !welcomeEnvelopeHasKpiData(q?.data);
  };

  /** Loading signal for page-load timing (header badge + brand KPI hero footer). */
  const resolveWelcomeWidgetPageDataLoadingForTiming = (w) =>
    isWelcomeWidgetPageDataLoading(w) ||
    (w?.status === "ready" &&
      (showWelcomeKpiBlockingSpin(w) ||
        !!widgetRefreshLoading[w?.id] ||
        !!widgetKpiLoading[w?.id]));

  const handleWelcomeWidgetRefresh = async (widgetId) => {
    const w = widgets.find((x) => x.id === widgetId);
    if (!w || !effectiveWorkspaceUserId) return;
    const plan = welcomeMainDataPlan.find((p) => p.widgetRow.id === widgetId);
    setWidgetRefreshLoading((prev) => ({ ...prev, [widgetId]: true }));
    try {
      if (plan?.queryKey) {
        await refetchWelcomeWidgetMainData(queryClient, plan.queryKey);
      } else {
        await queryClient.refetchQueries({
          queryKey: [
            ...welcomeWidgetKeys.all(effectiveWorkspaceUserId),
            "main",
            Number(widgetId),
          ],
        });
      }
      notification.success({
        message: t("common.success"),
        description: t("welcome.widgetRefreshed"),
      });
    } catch (e) {
      console.error("[Welcome] widget refresh failed", e);
      notification.error({
        message: t("common.error"),
        description: e?.message || t("welcome.errorFetchWidgetData"),
      });
    } finally {
      setWidgetRefreshLoading((prev) => {
        const next = { ...prev };
        delete next[widgetId];
        return next;
      });
    }
  };

  // Widget creation modal states
  const [currentStep, setCurrentStep] = useState(1);
  const [metricType, setMetricType] = useState("brand");
  const [selectedAccountMetric, setSelectedAccountMetric] = useState(3);

  // Brand metrics states
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [dashboards, setDashboards] = useState([]);
  const [selectedDashboards, setSelectedDashboards] = useState([]);
  const [selectedBrandMetrics, setSelectedBrandMetrics] = useState(new Set());
  const [metricSearchQuery, setMetricSearchQuery] = useState("");
  const [dashboardSearch, setDashboardSearch] = useState("");
  // Derived: first selected metric (for single-metric compat paths)
  const selectedBrandMetric = selectedBrandMetrics.size === 1 ? [...selectedBrandMetrics][0] : [...selectedBrandMetrics][0] ?? null;
  const toggleBrandMetric = (id) =>
    setSelectedBrandMetrics((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  // Competitive metrics states
  const [competitionType, setCompetitionType] = useState(1);
  const [availableTopics, setAvailableTopics] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedSentiment, setSelectedSentiment] = useState(null);

  // Loading states
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [loadingDashboards, setLoadingDashboards] = useState(false);
  const [loadingTopics, setLoadingTopics] = useState(false);
  /** Optional multi-topic scope (industry lib), wizard step after brand metric. */
  const [selectedBrandOptionalTopicIds, setSelectedBrandOptionalTopicIds] =
    useState([]);
  /** Hierarchical AI summaries (21 / 23 / 25), required multi-select on topic step. */
  const [selectedBrandAiTopicIds, setSelectedBrandAiTopicIds] = useState([]);
  const [brandDashboardCategories, setBrandDashboardCategories] = useState(
    [],
  );
  const [loadingBrandCategories, setLoadingBrandCategories] = useState(false);

  // Pivot states for brand metrics
  const [pivotLevelOptions, setPivotLevelOptions] = useState({ level1: [], level2: {} });
  const [pivotLevelSelections, setPivotLevelSelections] = useState({});
  const [pivotsLoading, setPivotsLoading] = useState(false);
  const [pivotData, setPivotData] = useState([]);

  // info modal states (object from welcome/widget/info)
  const [widgetInfo, setWidgetInfo] = useState(null);
  const [isWidgetInfoModalVisible, setIsWidgetInfoModalVisible] = useState(
    false,
  );
  const [isInsightEditorModalVisible, setIsInsightEditorModalVisible] = useState(false);
  const [currentInfoWidgetId, setCurrentInfoWidgetId] = useState(null);
  const [insightLoading, setInsightLoading] = useState(false);
  const [insightSaveLoading, setInsightSaveLoading] = useState(false);
  const [insightError, setInsightError] = useState("");
  const [insightKind, setInsightKind] = useState(null);
  const [insightItems, setInsightItems] = useState([]);
  const [insightSummaryDraft, setInsightSummaryDraft] = useState("");
  const [insightTableColumns, setInsightTableColumns] = useState([]);
  const [insightTableRows, setInsightTableRows] = useState([]);
  const [insightSourceReviewCount, setInsightSourceReviewCount] = useState(null);
  const [promptModalVisible, setPromptModalVisible] = useState(false);
  const [promptWidget, setPromptWidget] = useState(null);
  const [promptShort, setPromptShort] = useState("");
  const [promptLongMap, setPromptLongMap] = useState("");
  const [promptLongReduce, setPromptLongReduce] = useState("");
  const [promptLoading, setPromptLoading] = useState(false);
  const [promptSaving, setPromptSaving] = useState(false);
  const [promptCanEdit, setPromptCanEdit] = useState(false);
  const [promptModeTab, setPromptModeTab] = useState("small");
  const promptMapRef = useRef(null);
  const promptReduceRef = useRef(null);
  const promptShortRef = useRef(null);
  const [summaryTabsModalOpen, setSummaryTabsModalOpen] = useState(false);
  const [summaryTabsWidgetId, setSummaryTabsWidgetId] = useState(null);
  const [summaryTabsMetricId, setSummaryTabsMetricId] = useState(null);
  const [summaryTabsDraft, setSummaryTabsDraft] = useState([]);
  const [summaryTabsSaving, setSummaryTabsSaving] = useState(false);

  // Account metrics options with icons
  const accountMetricsOptions = [
    {
      value: 3,
      label: t("welcome.metricName_3"),
      icon: <CreditCardOutlined />,
      supportsChart: false,
      preferedView: "list",
    },
    {
      value: 4,
      label: t("welcome.metricName_4"),
      icon: <FileTextOutlined />,
      supportsChart: false,
      preferedView: "table",
    },
    {
      value: 5,
      label: t("welcome.metricName_5"),
      icon: <DownloadOutlined />,
      supportsChart: false,
      preferedView: "table",
    },
    {
      value: 6,
      label: t("welcome.metricName_6"),
      icon: <AlertOutlined />,
      supportsChart: false,
      preferedView: "list",
    },
    {
      value: 7,
      label: t("welcome.metricName_7"),
      icon: <EditOutlined />,
      supportsChart: false,
      preferedView: "list",
    },
    {
      value: 1,
      label: t("welcome.metricName_1"),
      icon: <ArrowUpOutlined />,
      supportsChart: true,
      preferedView: "chart",
    },
    {
      value: 2,
      label: t("welcome.metricName_2"),
      icon: <ArrowDownOutlined />,
      supportsChart: true,
      preferedView: "chart",
    },
  ];

  // Brand metrics options
  const brandMetricsOptions = [
    {
      category: t("welcome.brandMetricCategory_opinionFrequency"),
      metrics: [
        { value: 8,  label: t("welcome.metricName_8"),  preferedView: "chart", icon: <BarChartOutlined />, descKey: "welcome.metricDesc_8" },
        { value: 9,  label: t("welcome.metricName_9"),  preferedView: "list",  icon: <StarOutlined />,     descKey: "welcome.metricDesc_9" },
      ],
    },
    {
      category: t("welcome.brandMetricCategory_feel"),
      metrics: [
        { value: 18, label: t("welcome.metricName_18"), preferedView: "chart", icon: <DashboardOutlined />, descKey: "welcome.metricDesc_18", requiresMarketIntelligence: true },
        { value: 10, label: t("welcome.metricName_10"), preferedView: "list",  icon: <SmileOutlined />,     descKey: "welcome.metricDesc_10" },
        { value: 29, label: t("welcome.metricName_29"), preferedView: "list",  icon: <LikeOutlined />,      descKey: "welcome.metricDesc_29" },
        { value: 12, label: t("welcome.metricName_12"), preferedView: "chart", icon: <MessageOutlined />,   descKey: "welcome.metricDesc_12" },
        { value: 14, label: t("welcome.metricName_14"), preferedView: "chart", icon: <AimOutlined />,       descKey: "welcome.metricDesc_14" },
      ],
    },
    {
      category: t("welcome.brandMetricCategory_say"),
      metrics: [
        { value: 20, label: t("welcome.metricName_20"), preferedView: "smart_narrative", icon: <BulbOutlined />,        descKey: "welcome.metricDesc_20", isAi: true, isNew: true, aiTooltip: t("welcome.aiBadgeTooltipGenAi") },
        { value: 21, label: t("welcome.metricName_21"), preferedView: "smart_narrative", icon: <FileTextOutlined />,     descKey: "welcome.metricDesc_21", isAi: true, isNew: true, aiTooltip: t("welcome.aiBadgeTooltipGenAi") },
        { value: 23, label: t("welcome.metricName_23"), preferedView: "smart_narrative", icon: <RiseOutlined />,         descKey: "welcome.metricDesc_23", isAi: true, isNew: true, aiTooltip: t("welcome.aiBadgeTooltipGenAi") },
        { value: 25, label: t("welcome.metricName_25"), preferedView: "smart_narrative", icon: <HighlightOutlined />,    descKey: "welcome.metricDesc_25", isAi: true, isNew: true, aiTooltip: t("welcome.aiBadgeTooltipGenAi") },
        { value: 27, label: t("welcome.metricName_27"), preferedView: "chart",           icon: <RadarChartOutlined />,   descKey: "welcome.metricDesc_27", isAi: true, isNew: true, aiTooltip: t("welcome.aiBadgeTooltipClassification") },
        { value: 28, label: t("welcome.metricName_28"), preferedView: "chart",           icon: <FireOutlined />,         descKey: "welcome.metricDesc_28",             isNew: true },
      ],
    },
  ];

  // Helper function to find metric by value across all categories
  const findBrandMetric = (value) => {
    for (const category of brandMetricsOptions) {
      const found = category.metrics.find((metric) => metric.value === value);
      if (found) return found;
    }
    return null;
  };

  const resolveWidgetBaseDisplayName = (widget) => {
    const mid = widget?.metric_id;
    if (mid == null) {
      return humanizeUnderscoresForDisplay(decodeBasicHtmlEntities(widget?.name ?? ""));
    }
    const defaultEn = WELCOME_METRIC_DEFAULT_EN[mid];
    const name = widget?.name ?? "";

    if (welcomeMetricNameLooksStaleForId(name, mid)) {
      const key = `welcome.metricName_${mid}`;
      const translated = t(key);
      const base = translated !== key ? translated : defaultEn ?? name;
      return humanizeUnderscoresForDisplay(decodeBasicHtmlEntities(base));
    }

    // Stale snapshot: DB stored another metric's English catalog title for this metric_id
    for (const [otherIdStr, otherEn] of Object.entries(WELCOME_METRIC_DEFAULT_EN)) {
      const otherId = Number(otherIdStr);
      if (otherId !== mid && name === otherEn) {
        const key = `welcome.metricName_${mid}`;
        const translated = t(key);
        const base = translated !== key ? translated : defaultEn ?? name;
        return humanizeUnderscoresForDisplay(decodeBasicHtmlEntities(base));
      }
    }

    let base;
    if (!defaultEn || name !== defaultEn) {
      const isGenericMetricName = /^Metric\s+\d+$/i.test(String(name || "").trim());
      if (isGenericMetricName && defaultEn) {
        const key = `welcome.metricName_${mid}`;
        const translated = t(key);
        base = translated !== key ? translated : defaultEn;
      } else {
        base = name;
      }
    } else {
      const key = `welcome.metricName_${mid}`;
      const translated = t(key);
      base = translated !== key ? translated : name;
    }
    return humanizeUnderscoresForDisplay(decodeBasicHtmlEntities(base));
  };

  const resolveWidgetDisplayName = (widget) => {
    return humanizeUnderscoresForDisplay(
      buildWelcomeWidgetTitleLine(widget, resolveWidgetBaseDisplayName(widget)),
    );
  };

  const resolveWidgetTitleMeta = (widget) => {
    const segments = [];
    const pivot = deriveWelcomePivotDisplayLabel(widget);
    if (pivot) segments.push(decodeBasicHtmlEntities(pivot));
    const topic = welcomeWidgetTopicScopeLine(widget);
    if (topic) segments.push(topic);
    if (!segments.length) return "";
    return humanizeUnderscoresForDisplay(segments.join(" · "));
  };

  const widgetSupportsOrgLlmPrompt = (w) => {
    const mid = w?.metric_id;
    const rep = w?.representation_type;
    if (mid == null || rep == null) return false;
    if (WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(mid) && rep === 4) return true;
    if (WELCOME_GENAI_TABLE_METRIC_IDS.has(mid) && rep === 3) return true;
    return false;
  };

  const openPromptEditor = async (widget) => {
    if (!widgetSupportsOrgLlmPrompt(widget)) return;
    setPromptWidget({
      id: widget.id,
      name: resolveWidgetDisplayName(widget),
      metric_id: widget.metric_id,
    });
    setPromptModalVisible(true);
    setPromptLoading(true);
    setPromptCanEdit(false);
    setPromptModeTab("small");
    setPromptShort("");
    setPromptLongMap("");
    setPromptLongReduce("");
    try {
      const uid = user?.uid;
      const mid = widget.metric_id;
      const params = new URLSearchParams();
      if (uid != null && uid !== "") {
        params.set("user_id", uid);
      }
      if (mid != null && mid !== "") {
        params.set("welcome_metric_id", String(mid));
      }
      const qs = params.toString();
      const llmPromptsUrl = qs
        ? `welcome/organization-llm-prompts?${qs}`
        : "welcome/organization-llm-prompts";
      const res = await apiRequest(llmPromptsUrl, "GET", undefined, true);
      setPromptCanEdit(res?.can_edit_organization_llm_prompts === true);
      const rows = res?.success;
      if (Array.isArray(rows)) {
        const row =
          rows.length === 1
            ? rows[0]
            : rows.find((r) => r.welcome_metric_id === mid);
        if (row) {
          const shortP = row.short_prompt ?? "";
          const mapP = row.long_map_template ?? "";
          const redP = row.long_reduce_template ?? "";
          setPromptShort(shortP);
          setPromptLongMap(mapP);
          setPromptLongReduce(redP);
          if (mapP.trim() || redP.trim()) {
            setPromptModeTab("large");
          } else {
            setPromptModeTab("small");
          }
        }
      } else if (res === false) {
        message.warning(t("welcome.promptLoadError"));
      }
    } catch (e) {
      console.error(e);
      message.error(t("welcome.promptLoadError"));
    } finally {
      setPromptLoading(false);
    }
  };

  const closePromptEditor = () => {
    setPromptModalVisible(false);
    setPromptWidget(null);
    setPromptShort("");
    setPromptLongMap("");
    setPromptLongReduce("");
    setPromptModeTab("small");
    setPromptCanEdit(false);
  };

  const insertPromptVariable = (token) => {
    if (!promptCanEdit) return;
    const mapTextArea = promptMapRef.current?.resizableTextArea?.textArea;
    const reduceTextArea = promptReduceRef.current?.resizableTextArea?.textArea;
    const smallTextArea = promptShortRef.current?.resizableTextArea?.textArea;
    const focusedElement = document.activeElement;

    let targetField = "map";
    if (promptModeTab === "small") {
      targetField = "small";
    } else if (focusedElement === reduceTextArea) {
      targetField = "reduce";
    } else if (focusedElement === mapTextArea) {
      targetField = "map";
    }

    const meta =
      targetField === "small"
        ? { value: promptShort, setValue: setPromptShort, textArea: smallTextArea }
        : targetField === "reduce"
          ? { value: promptLongReduce, setValue: setPromptLongReduce, textArea: reduceTextArea }
          : { value: promptLongMap, setValue: setPromptLongMap, textArea: mapTextArea };

    if (typeof meta.setValue !== "function") return;
    const textArea = meta.textArea;
    const current = String(meta.value || "");
    const start = textArea?.selectionStart ?? current.length;
    const end = textArea?.selectionEnd ?? start;
    const needsLeadingSpace = start > 0 && !/\s/.test(current.charAt(start - 1));
    const insertion = `${needsLeadingSpace ? " " : ""}${token}`;
    const next = `${current.slice(0, start)}${insertion}${current.slice(end)}`;
    meta.setValue(next);
    requestAnimationFrame(() => {
      const liveRef =
        targetField === "small"
          ? promptShortRef.current?.resizableTextArea?.textArea
          : targetField === "reduce"
            ? promptReduceRef.current?.resizableTextArea?.textArea
            : promptMapRef.current?.resizableTextArea?.textArea;
      if (!liveRef || typeof liveRef.focus !== "function") return;
      const pos = start + insertion.length;
      liveRef.focus();
      liveRef.setSelectionRange(pos, pos);
    });
  };

  const downloadPromptsCsv = () => {
    if (!promptCanEdit) return;
    downloadOrgLlmPromptsCsv({
      metricId: promptWidget?.metric_id,
      widgetName: promptWidget?.name,
      shortPrompt: promptShort,
      longMapPrompt: promptLongMap,
      longReducePrompt: promptLongReduce,
    });
    message.success(t("welcome.promptDownloadSuccess"));
  };

  const savePromptEditor = async () => {
    if (!promptWidget?.metric_id || !promptCanEdit) return;
    setPromptSaving(true);
    try {
      const uid = user?.uid;
      const res = await apiRequest(
        "welcome/organization-llm-prompts",
        "PUT",
        {
          welcome_metric_id: promptWidget.metric_id,
          ...(uid != null && uid !== "" ? { user_id: uid } : {}),
          short_prompt: promptShort.trim() === "" ? null : promptShort,
          long_map_template: promptLongMap.trim() === "" ? null : promptLongMap,
          long_reduce_template:
            promptLongReduce.trim() === "" ? null : promptLongReduce,
        },
        true,
      );
      if (res?.success) {
        message.success(t("welcome.promptSaveSuccess"));
        closePromptEditor();
      } else if (res?.error) {
        message.error(res.error);
      } else {
        message.error(t("welcome.promptSaveError"));
      }
    } catch (e) {
      console.error(e);
      message.error(t("welcome.promptSaveError"));
    } finally {
      setPromptSaving(false);
    }
  };

  //Sentiment Types
  const sentimentTypes = [
    { value: 0.0, label: t("welcome.sentimentNegative") },
    { value: 0.5, label: t("welcome.sentimentNeutral") },
    { value: 1.0, label: t("welcome.sentimentPositive") },
  ];

  // Competition types
  const competitionTypes = [
    { value: 1, label: t("welcome.competitionCategoryBased") },
    { value: 2, label: t("welcome.competitionBrandBased") },
    { value: 3, label: t("welcome.competitionTimeBased") },
    { value: 4, label: t("welcome.competitionVocScore") },
  ];

  // Widget type options
  const widgetTypes = [
    { value: "chart", label: t("welcome.chartWidget"), icon: <LineChartOutlined /> },
    { value: "list", label: t("welcome.listWidget"), icon: <UnorderedListOutlined /> },
    { value: "table", label: t("welcome.tableWidget"), icon: <TableOutlined /> },
    {
      value: "smart_narrative",
      label: t("welcome.smartNarrativeWidget"),
      icon: <SmartNarrativeIcon />,
    },
  ];
  useEffect(() => {
    if (!selectedBrandMetric || metricType !== "brand") return;
    setNewWidgetType((prev) => {
      if (WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(selectedBrandMetric)) {
        return "smart_narrative";
      }
      if (WELCOME_GENAI_TABLE_METRIC_IDS.has(selectedBrandMetric)) {
        return "table";
      }
      if (prev === "smart_narrative" || prev === "table") {
        return "chart";
      }
      return prev;
    });
  }, [metricType, selectedBrandMetric]);

  useEffect(() => {
    if (metricType !== "brand") return;
    if (
      newWidgetType === "smart_narrative" &&
      !WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(selectedBrandMetric)
    ) {
      setNewWidgetType(
        WELCOME_GENAI_TABLE_METRIC_IDS.has(selectedBrandMetric)
          ? "table"
          : "chart",
      );
    }
    if (
      newWidgetType === "table" &&
      WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(selectedBrandMetric)
    ) {
      setNewWidgetType("smart_narrative");
    }
    if (
      newWidgetType === "smart_narrative" &&
      WELCOME_GENAI_TABLE_METRIC_IDS.has(selectedBrandMetric)
    ) {
      setNewWidgetType("table");
    }
  }, [metricType, selectedBrandMetric, newWidgetType]);

  // Add time-based visualization options
  const timeBasedOptions = [
    {
      value: 1,
      label: t("welcome.timeSeriesAnalysisTitle"),
      description: t("welcome.timeSeriesAnalysisDesc"),
    },
  ];

  // Widget type options for competitive metrics
  const competitiveWidgetTypes = {
    category: {
      value: "category_chart",
      label: t("welcome.competitiveWidgetCategoryLabel"),
      description: t("welcome.competitiveWidgetCategoryDesc"),
      icon: <PieChartOutlined />,
    },
    brand: {
      value: "brand_chart",
      label: t("welcome.competitiveWidgetBrandLabel"),
      description: t("welcome.competitiveWidgetBrandDesc"),
      icon: <BarChartOutlined />,
    },
    time: {
      value: "time_chart",
      label: t("welcome.competitiveWidgetTimeLabel"),
      description: t("welcome.competitiveWidgetTimeDesc"),
      icon: <LineChartOutlined />,
    },
  };
  const checkQuotaForWidget = async () => {
    setQuotaCheckLoading(true);
    setQuotaCheckResult(null);
    setMetricCreditPreview(null);
    setMetricCreditPreviewLoading(false);
    setAiCreditConfirmOpen(false);
    try {
      const payload = {
        quota_type: "advanced_ai",
        dashboard_ids: selectedDashboards.map(String),
        start_date: quotaDateRange[0],
        end_date: quotaDateRange[1],
      };
      Object.assign(
        payload,
        buildWelcomePivotPayload(pivotLevelSelections),
      );
      payload.metric_type = 2;
      const billableMetricIds = getSelectedBillableAiMetricIds();
      payload.welcome_metric_ids =
        billableMetricIds.length > 0
          ? billableMetricIds
          : [...selectedBrandMetrics]
              .map(normalizeWelcomeMetricId)
              .filter((id) => id != null);
      const anyMultitopic = [...selectedBrandMetrics].some((m) =>
        WELCOME_BRAND_MULTITOPIC_WIZARD_METRIC_IDS.has(m),
      );
      const distTopicIds = selectedBrandDistTopicIds(
        selectedBrandAiTopicIds,
        selectedBrandOptionalTopicIds,
      );
      if (anyMultitopic && selectedBrandAiTopicIds?.length > 0) {
        payload.topic_ids = normalizeWelcomeIndustryTopicIds(selectedBrandAiTopicIds);
      } else if (distTopicIds.length > 0) {
        payload.topic_ids = distTopicIds;
      }
      const response = await apiRequest(
        "subscriptions/check_quota_for_target_params",
        "POST",
        payload,
        true,
      );
      setQuotaCheckResult(response);
    } catch (err) {
      console.error("Quota check error:", err);
      setQuotaCheckResult({ error: true });
    } finally {
      setQuotaCheckLoading(false);
    }
  };

  const buildWelcomeCreditPreviewPayload = () => {
    const until =
      quotaUntil || dayjs().format("YYYY-MM-DD");
    const since =
      quotaSince || dayjs().subtract(6, "days").format("YYYY-MM-DD");
    const billableSelected = getSelectedBillableAiMetricIds();
    const payload = {
      dashboard_ids: selectedDashboards.map((id) => Number(id)).filter((n) => Number.isFinite(n)),
      start_date: since,
      end_date: until,
      metric_type: 2,
      welcome_metric_ids:
        billableSelected.length > 0
          ? billableSelected
          : [...selectedBrandMetrics]
              .map(normalizeWelcomeMetricId)
              .filter((id) => id != null),
    };
    Object.assign(
      payload,
      buildWelcomePivotPayload(pivotLevelSelections),
    );
    const distTopicIds = selectedBrandDistTopicIds(
      selectedBrandAiTopicIds,
      selectedBrandOptionalTopicIds,
    );
    if (selectedBrandAiTopicIds?.length > 0) {
      payload.topic_ids = normalizeWelcomeIndustryTopicIds(selectedBrandAiTopicIds);
    } else if (distTopicIds.length > 0) {
      payload.topic_ids = distTopicIds;
    }
    return payload;
  };

  const fetchWelcomeMetricCreditPreview = async () => {
    if (!selectedDashboards?.length) {
      setMetricCreditPreview(null);
      return;
    }
    const requestId = ++creditPreviewRequestRef.current;
    setMetricCreditPreviewLoading(true);
    try {
      const response = await apiRequest(
        "welcome/widget/calculate-credits",
        "POST",
        buildWelcomeCreditPreviewPayload(),
        true,
      );
      if (requestId !== creditPreviewRequestRef.current) {
        return;
      }
      if (response?.success) {
        setMetricCreditPreview(response);
      } else {
        setMetricCreditPreview(null);
        notification.warning({
          message: t("common.warning"),
          description: t("welcome.aiCreditPreviewFailed"),
        });
      }
    } catch (err) {
      if (requestId !== creditPreviewRequestRef.current) {
        return;
      }
      console.error("Metric credit preview error:", err);
      setMetricCreditPreview(null);
      notification.warning({
        message: t("common.warning"),
        description: t("welcome.aiCreditPreviewFailed"),
      });
    } finally {
      if (requestId === creditPreviewRequestRef.current) {
        setMetricCreditPreviewLoading(false);
      }
    }
  };

  const getBillableMetricCreditCost = (metricId) => {
    const mid = normalizeWelcomeMetricId(metricId);
    if (mid == null || !WELCOME_AI_CREDIT_BILLABLE_METRIC_IDS.has(mid)) {
      return 0;
    }
    const fromPreview = metricCreditPreview?.by_metric_id?.[String(mid)];
    if (Number.isFinite(Number(fromPreview))) {
      return Number(fromPreview);
    }
    if (Number.isFinite(Number(metricCreditPreview?.credits_per_ai_widget))) {
      return Number(metricCreditPreview.credits_per_ai_widget);
    }
    return 1;
  };

  const getSelectedAiSummaryCreditTotal = () => {
    const aiSelected = getSelectedBillableAiMetricIds();
    if (!aiSelected.length) {
      return { aiSelected, hotelCount: 0, totalCost: 0 };
    }
    const hotelCount = Number(metricCreditPreview?.hotel_count) || 1;
    const totalCost = aiSelected.reduce(
      (sum, m) => sum + getBillableMetricCreditCost(m),
      0,
    );
    return { aiSelected, hotelCount, totalCost };
  };

  const shouldPromptAiCreditConfirm = () => {
    const { aiSelected, hotelCount, totalCost } = getSelectedAiSummaryCreditTotal();
    if (!aiSelected.length) {
      return false;
    }
    return hotelCount > 1 || totalCost > 1;
  };

  const normalizeWidgetIdList = (value) => {
    const raw = Array.isArray(value) ? value : value != null ? [value] : [];
    return raw
      .map((item) => String(item).trim())
      .filter((item) => item !== "");
  };

  const getWidgetStoredDateRange = (widget, kpi) => {
    const fallback = getWelcomeKpiSinceUntil(
      new URLSearchParams(location.search),
      dashboardReducer,
    );
    const d = kpi && typeof kpi === "object" ? kpi : {};
    return {
      since:
        widget?.since ||
        widget?.start_date ||
        d.source_since ||
        fallback.since,
      until:
        widget?.until ||
        widget?.end_date ||
        d.source_until ||
        fallback.until,
    };
  };

  const buildRegenerateQuotaPayload = (widget) => {
    const kpi = getWelcomeWidgetEffectiveKpiData(widget);
    const dashboardIds = normalizeWidgetIdList(
      widget?.dashboard_ids || kpi.source_dashboard_ids,
    );
    const { since, until } = getWidgetStoredDateRange(widget, kpi);
    const payload = {
      quota_type: "advanced_ai",
      dashboard_ids: dashboardIds,
      start_date: since,
      end_date: until,
      metric_type: 2,
    };
    if (widget?.pivot_filter || (widget?.pivot_key && widget?.pivot_values != null)) {
      Object.assign(
        payload,
        buildWelcomePivotPayload(
          pivotFilterToLevelSelections(welcomePivotFilterFromWidget(widget)),
          "AND",
        ),
      );
    } else if (kpi.source_pivot_key && kpi.source_pivot_values != null) {
      payload.pivot_key = kpi.source_pivot_key;
      payload.pivot_values = normalizeWidgetIdList(kpi.source_pivot_values);
    }
    const topicIds = normalizeWidgetIdList(widget?.topic_ids || kpi.topic_ids)
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id) && id > 0);
    if (topicIds.length > 0) {
      payload.topic_ids = topicIds;
    }
    const mid = Number(widget?.metric_id);
    if (Number.isFinite(mid) && mid > 0) {
      payload.welcome_metric_ids = [mid];
    }
    return payload;
  };

  const checkQuotaForRegenerateWidget = async (widget, { forceModal = false } = {}) => {
    const payload = buildRegenerateQuotaPayload(widget);
    if (!payload.dashboard_ids.length || !payload.start_date || !payload.end_date) {
      notification.error({
        message: t("common.error"),
        description: t("welcome.regenerateQuotaMissingScope"),
      });
      return;
    }
    setRegenerateQuotaLoading(true);
    if (forceModal) {
      setRegenerateQuotaWidget(widget);
      setRegenerateQuotaModalOpen(true);
      setRegenerateQuotaResult(null);
    }
    try {
      const response = await apiRequest(
        "subscriptions/check_quota_for_target_params",
        "POST",
        payload,
        true,
      );
      if (!forceModal && welcomeRegenerateCanProceedWithoutQuotaModal(response)) {
        await executeGenaiRequeue(widget.id);
        return;
      }
      setRegenerateQuotaWidget(widget);
      setRegenerateQuotaModalOpen(true);
      setRegenerateQuotaResult(response);
    } catch (err) {
      console.error("Regenerate quota check error:", err);
      setRegenerateQuotaWidget(widget);
      setRegenerateQuotaModalOpen(true);
      setRegenerateQuotaResult({ error: true });
    } finally {
      setRegenerateQuotaLoading(false);
    }
  };

  const closeRegenerateQuotaModal = () => {
    setRegenerateQuotaModalOpen(false);
    setRegenerateQuotaWidget(null);
    setRegenerateQuotaResult(null);
    setRegenerateQuotaLoading(false);
  };

  // Dashboard Data APIs
  const saveWidget = async (params) => {
    try {
      const response = await apiRequest(
        "welcome/widget/add",
        "POST",
        params,
        true,
      );
      return response;
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorSaveWidgetKpi"),
      });
      return null;
    }
  };
  // Fetch brands when modal opens
  useEffect(() => {
    if (isAddWidgetModalVisible) {
      fetchBrands();
    }
  }, [isAddWidgetModalVisible]);

  // Fetch dashboards when brand selection changes
  useEffect(() => {
    if (metricType === "brand" && selectedBrand) {
      fetchDashboards(selectedBrand);
    } else if (metricType === "competitive" && selectedBrands) {
      fetchDashboards(selectedBrands);
    }
  }, [selectedBrand, selectedBrands, metricType]);

  // Fetch pivots when dashboards are selected for brand metrics
  useEffect(() => {
    if (metricType === "brand" && selectedDashboards.length > 0) {
      setPivotLevelSelections({});
      setSelectedBrandOptionalTopicIds([]);
      setSelectedBrandAiTopicIds([]);
      setBrandDashboardCategories([]);
      getPivots(selectedDashboards);
    }
  }, [selectedDashboards, metricType]);

  // Re-fetch pivots when entering the pivot step if the initial fetch never completed
  useEffect(() => {
    if (
      !isAddWidgetModalVisible ||
      metricType !== "brand" ||
      currentStep !== 5 ||
      !selectedDashboards.length ||
      pivotsLoading
    ) {
      return;
    }
    if ((pivotData?.length || 0) > 0) {
      return;
    }
    getPivots(selectedDashboards);
  }, [
    isAddWidgetModalVisible,
    metricType,
    currentStep,
    selectedDashboards,
    pivotsLoading,
    pivotData?.length,
  ]);

  // Brand: POST industry_analysis/categories — topic step (after metric selection)
  useEffect(() => {
    if (!isAddWidgetModalVisible || metricType !== "brand") {
      return;
    }
    if (!selectedDashboards?.length) {
      setBrandDashboardCategories([]);
      return;
    }
    if (currentStep !== 6) {
      return;
    }
    let cancelled = false;
    (async () => {
      setLoadingBrandCategories(true);
      try {
        const response = await apiRequest(
          "industry_analysis/categories",
          "POST",
          { dashboard_ids: selectedDashboards.filter(Boolean) },
          true,
        );
        const raw = response?.data ?? response?.success;
        const list = Array.isArray(raw) ? raw : [];
        if (!cancelled) {
          setBrandDashboardCategories(list);
          console.log(
            `[Welcome][INFO] industry_analysis/categories rows=${list.length} dashboards=${selectedDashboards.length}`,
          );
        }
      } catch (e) {
        console.error("[Welcome][ERROR] industry_analysis/categories", e);
        if (!cancelled) {
          setBrandDashboardCategories([]);
          notification.error({
            message: t("common.error"),
            description: t("welcome.brandIndustryTopicsLoadError"),
          });
        }
      } finally {
        if (!cancelled) setLoadingBrandCategories(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isAddWidgetModalVisible, currentStep, metricType, selectedDashboards]);

  useEffect(() => {
    const valid = new Set(
      (brandDashboardCategories || []).map((c) =>
        Number(c.categoryId ?? c.category),
      ),
    );
    setSelectedBrandOptionalTopicIds((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      const next = prev.filter((id) => valid.has(Number(id)));
      return next.length === prev.length ? prev : next;
    });
    setSelectedBrandAiTopicIds((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      const next = prev.filter((id) => valid.has(Number(id)));
      return next.length === prev.length ? prev : next;
    });
  }, [brandDashboardCategories]);

  // AI metric credit preview — metric step (4) and date/quota steps; skip pivot step (5).
  useEffect(() => {
    if (!isAddWidgetModalVisible || metricType !== "brand") {
      return;
    }
    if (currentStep !== 4 && currentStep !== 7 && currentStep !== 8) {
      return;
    }
    if (!selectedDashboards?.length) {
      setMetricCreditPreview(null);
      return;
    }
    fetchWelcomeMetricCreditPreview();
  }, [
    isAddWidgetModalVisible,
    metricType,
    currentStep,
    selectedDashboards,
    pivotLevelSelections,
    selectedBrandAiTopicIds,
    selectedBrandOptionalTopicIds,
    quotaSince,
    quotaUntil,
  ]);

  // Fetch topics when competition type changes
  useEffect(() => {
    if (
      metricType === "competitive" &&
      competitionType &&
      competitionType !== 4 &&
      selectedDashboards.length > 0
    ) {
      fetchTopics(competitionType);
    }
  }, [competitionType, metricType]);

  // Fetch brands from API
  const fetchBrands = async () => {
    setLoadingBrands(true);
    try {
      const response = await apiRequest("welcome/brands", "GET");
      setBrands(response.success);
      setLoadingBrands(false);
    } catch (error) {
      console.error("Error fetching brands:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchBrands"),
      });
      setLoadingBrands(false);
    }
  };

  // Fetch dashboards for a single brand
  const fetchDashboards = async (brandIds) => {
    setLoadingDashboards(true);
    try {
      // This would be replaced with an actual API call
      const response = await apiRequest(
        "welcome/dashboards",
        "POST",
        { brand_ids: brandIds },
        true,
      );
      if (response?.success) {
        setDashboards(response?.success);
      }
      setLoadingDashboards(false);
    } catch (error) {
      console.error("Error fetching dashboards:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchDashboards"),
      });
      setLoadingDashboards(false);
    }
  };
  // Fetch topics based on competition type
  const fetchTopics = async (type) => {
    setLoadingTopics(true);
    try {
      const payload = {
        dashboard_ids: selectedDashboards,
      };
      // This would be replaced with an actual API call
      const response = await apiRequest(
        "welcome/topics",
        "POST",
        payload,
        true,
      );
      setAvailableTopics(response?.success);
      setLoadingTopics(false);
    } catch (error) {
      console.error("Error fetching topics:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchTopics"),
      });
      setLoadingTopics(false);
    }
  };

  // Fetch pivot columns for brand metrics (copied from NewReport.js)
  const getPivots = async (dashboardIds = selectedDashboards) => {
    const ids = (dashboardIds || [])
      .map((id) => Number(id))
      .filter((n) => Number.isFinite(n));
    if (!ids.length) {
      setPivotData([]);
      setPivotLevelOptions({ level1: [], level2: {} });
      setPivotsLoading(false);
      return;
    }
    const requestId = ++pivotFetchRequestRef.current;
    setPivotsLoading(true);
    try {
      const response = await apiRequest(
        "report/pivots",
        "POST",
        { dashboard_ids: ids },
        true,
      );
      if (requestId !== pivotFetchRequestRef.current) {
        return;
      }
      if (response?.success) {
        const data = response.success;
        setPivotData(data);
        setPivotLevelOptions(buildWelcomePivotLevelOptions(data));
      } else {
        setPivotLevelOptions({ level1: [], level2: {} });
        setPivotData([]);
        notification.error({
          message: response?.error ? response?.error : t("welcome.errorFetchPivots"),
        });
      }
    } catch (error) {
      if (requestId !== pivotFetchRequestRef.current) {
        return;
      }
      console.error("Error fetching pivots:", error);
      setPivotLevelOptions({ level1: [], level2: {} });
      setPivotData([]);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchPivots"),
      });
    } finally {
      if (requestId === pivotFetchRequestRef.current) {
        setPivotsLoading(false);
      }
    }
  };

  // Handle navigation between steps
  const handleSkipPivotStep = () => {
    setPivotLevelSelections({});
    setCurrentStep(6);
  };

  const handleNavigation = (direction) => {
    if (direction === "next") {
      // Validate current step before proceeding
      if (currentStep === 1 && !metricType) {
        notification.error({
          message: t("common.error"),
          description: t("welcome.wizardValidateMetricType"),
        });
        return;
      }

      // Brand metrics validation
      if (metricType === "brand") {
        if (
          currentStep === 2 &&
          (!selectedBrand || selectedBrand?.length === 0)
        ) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateBrand"),
          });
          return;
        }

        if (
          currentStep === 3 &&
          (!selectedDashboards || selectedDashboards?.length === 0)
        ) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateDashboard"),
          });
          return;
        }

        if (currentStep === 4 && selectedBrandMetrics.size === 0) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateBrandMetric"),
          });
          return;
        }
        if (
          currentStep === 6 &&
          metricType === "brand" &&
          [...selectedBrandMetrics].some((m) =>
            WELCOME_BRAND_MULTITOPIC_WIZARD_METRIC_IDS.has(m)
          ) &&
          (!selectedBrandAiTopicIds || selectedBrandAiTopicIds.length < 1)
        ) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.brandAiTopicsRequired"),
          });
          return;
        }

        if (
          currentStep === 6 &&
          metricType === "brand" &&
          selectedBrandMetricsNeedDistTopics(selectedBrandMetrics) &&
          selectedBrandDistTopicIds(
            selectedBrandAiTopicIds,
            selectedBrandOptionalTopicIds,
          ).length < 1
        ) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.brandTopicsRequired"),
          });
          return;
        }

      }

      // Competitive metrics validation
      if (metricType === "competitive") {
        if (currentStep === 2 && selectedBrands.length === 0) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateCompetitorBrands"),
          });
          return;
        }

        if (currentStep === 3 && selectedDashboards.length === 0) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateCompetitorDashboards"),
          });
          return;
        }

        if (currentStep === 4 && !competitionType) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateCompetitionType"),
          });
          return;
        }

        if (
          currentStep === 5 &&
          selectedTopics.length === 0 &&
          competitionType !== 4
        ) {
          notification.error({
            message: t("common.error"),
            description: t("welcome.wizardValidateTopics"),
          });
          return;
        }
      }

      // Account metrics validation
      if (
        metricType === "account" &&
        currentStep === 2 &&
        !selectedAccountMetric
      ) {
        notification.error({
          message: t("common.error"),
          description: t("welcome.wizardValidateAccountMetric"),
        });
        return;
      }
      if (currentStep === 2 && metricType === "account") {
        setNewWidgetType(
          accountMetricsOptions.find(
            (opt) => opt.value === selectedAccountMetric,
          )?.preferedView,
        );
      }
      if (currentStep === 4 && metricType === "competitive") {
        setNewWidgetType("chart");
      }

      // Credit confirmation is shown only on the final "Review & Create" step,
      // where the review count (and therefore the cost) is final and the widget
      // is actually created. No premature credit prompt on the pivot step.

      // Brand: after topics, go straight to date range (representation type is fixed per metric).
      if (metricType === "brand" && currentStep === 6) {
        if (!quotaDateRange[0]) {
          const defaultSince = dayjs().subtract(6, "days").format("YYYY-MM-DD");
          const defaultUntil = dayjs().format("YYYY-MM-DD");
          setQuotaDaysRange("last7d");
          setQuotaSince(defaultSince);
          setQuotaUntil(defaultUntil);
          setQuotaDateRange([defaultSince, defaultUntil]);
        }
        setCurrentStep(7);
        return;
      }

      if (currentStep === getTotalSteps()) {
        if (widgetCreateInFlightRef.current) {
          return;
        }
        if (metricType === "brand" && welcomeReviewStepCreateBlocked()) {
          if (welcomeGenaiReviewsInsufficient(quotaCheckResult)) {
            notification.warning({
              message: t("common.error"),
              description: t("welcome.quotaGenaiTooFewReviews", {
                count: Number(quotaCheckResult?.total_review_count) || 0,
                min: quotaCheckResult?.welcome_genai_minimum_reviews ?? 3,
              }),
            });
          } else {
            notification.warning({
              message: t("common.error"),
              description: t("welcome.insufficientQuota"),
            });
          }
          return;
        }
        if (
          metricType === "brand" &&
          needsQuotaCheck() &&
          shouldPromptAiCreditConfirm() &&
          !aiCreditConfirmedRef.current
        ) {
          const { hotelCount, totalCost } = getSelectedAiSummaryCreditTotal();
          setAiCreditConfirmMeta({
            hotel_count: hotelCount,
            credit_mode:
              quotaCheckResult?.credit_mode || metricCreditPreview?.credit_mode,
            review_count:
              Number(
                quotaCheckResult?.credit_review_count ??
                  metricCreditPreview?.review_count,
              ) || 0,
            review_chunk:
              Number(
                quotaCheckResult?.review_credits_chunk ??
                  metricCreditPreview?.review_credits_chunk,
              ) || 2000,
            total_credits:
              Number(quotaCheckResult?.required_amount) || totalCost,
          });
          setAiCreditConfirmTargetStep("create");
          setAiCreditConfirmOpen(true);
          return;
        }
        createWidget(groupId, metricType);
      } else {
        // When leaving date range step, always go to review (step 8) and load scope count.
        if (metricType === "brand" && currentStep === 7) {
          if (!quotaDateRange[0] || !quotaDateRange[1]) {
            notification.error({
              message: t("common.error"),
              description: t("welcome.wizardValidateDateRange"),
            });
            return;
          }
          setCurrentStep(8);
          checkQuotaForWidget();
          return;
        }
        // Default navigation for other cases
        setCurrentStep(currentStep + 1);
      }
    } else if (direction === "back") {
      // Handle going back
      if (currentStep === 1) {
        handleCloseModal();
      } else {
        // Going back from quota step → date range
        if (metricType === "brand" && currentStep === 8) {
          setCurrentStep(7);
          setQuotaCheckResult(null);
    setMetricCreditPreview(null);
    setMetricCreditPreviewLoading(false);
    setAiCreditConfirmOpen(false);
          return;
        }
        if (metricType === "brand" && currentStep === 7) {
          setCurrentStep(6);
          return;
        }
        setCurrentStep(currentStep - 1);
      }
    }
  };

  // Create a new widget based on selected options
  const createWidget = async (groupId, metricType) => {
    if (widgetCreateInFlightRef.current) {
      return;
    }
    widgetCreateInFlightRef.current = true;
    setIsWidgetCreateSubmitting(true);
    try {
      // For brand metrics: build one payload per selected metric ID.
      // For other types: single payload with the standard metric_id.
      let brandMetricIds =
        metricType === "brand" ? [...selectedBrandMetrics] : null;

      if (metricType === "brand" && brandMetricIds?.length) {
        const billableIds = getSelectedBillableAiMetricIds();
        const aiQuotaBlocked =
          billableIds.length > 0 &&
          quotaCheckResult &&
          (welcomeAiCreditsInsufficient(quotaCheckResult) ||
            welcomeGenaiReviewsInsufficient(quotaCheckResult));

        if (aiQuotaBlocked) {
          const tooFewReviews = welcomeGenaiReviewsInsufficient(quotaCheckResult);
          notification.error({
            message: t("common.error"),
            description: tooFewReviews
              ? t("welcome.quotaGenaiTooFewReviews", {
                  count: Number(quotaCheckResult.total_review_count) || 0,
                  min: quotaCheckResult.welcome_genai_minimum_reviews ?? 3,
                })
              : t("welcome.insufficientQuota"),
          });
          return;
        }
      }

      const buildBasePayload = (metricId) => {
        const base = {
          metric_type: metricType,
          metric_id:
            metricType === "account"
              ? selectedAccountMetric
              : metricType === "brand"
              ? metricId
              : 17,
          representation_type: resolveWelcomeRepresentationView(
            metricType,
            metricId,
            {
              findBrandMetric,
              accountMetricsOptions,
              selectedAccountMetric,
            },
          ),
          widget_group_id: groupId,
          topics: selectedTopics,
          dashboard_ids: selectedDashboards,
          group_ids: selectedBrands,
          comparison_type: competitionType,
          sentiment: selectedSentiment,
        };
        // Add pivot data if available (brand metrics only)
        if (metricType === "brand") {
          Object.assign(
            base,
            buildWelcomePivotPayload(pivotLevelSelections),
          );
        }
        // Add topic_ids for multi-topic or optional-topic brand metrics
        if (metricType === "brand") {
          const topicIds = resolveWelcomeBrandWidgetTopicIds(
            metricId,
            selectedBrandAiTopicIds,
            selectedBrandOptionalTopicIds,
          );
          if (topicIds?.length) {
            base.topic_ids = topicIds;
          }
        }
        return base;
      };

      // Single payload for non-brand or single-metric brand
      const payload = buildBasePayload(
        metricType === "brand" ? (brandMetricIds[0] ?? null) : null,
      );
      if (metricType === "brand" || metricType === "competitive") {
        const urlParams = new URLSearchParams(window.location.search);
        const fallbackSince = dayjs()
          .subtract(6, "days")
          .format("YYYY-MM-DD");
        const fallbackUntil = dayjs().format("YYYY-MM-DD");
        const brandUsesWizardDateStep = metricType === "brand";
        const genAiUsesWizardDates =
          metricType === "brand" &&
          needsQuotaCheck() &&
          Boolean(quotaSince) &&
          Boolean(quotaUntil);
        // GenAI: only use wizard dates when both set (validated before step 8).
        // Sentiment Distribution / Decision / Hot Terms: prefer step-8 dates; if missing,
        // use last-7-day fallback — do not inherit page URL alone (often too narrow → "no data").
        let sinceEff;
        let untilEff;
        if (genAiUsesWizardDates) {
          sinceEff = quotaSince;
          untilEff = quotaUntil;
        } else if (brandUsesWizardDateStep) {
          sinceEff =
            quotaSince && quotaUntil ? quotaSince : fallbackSince;
          untilEff =
            quotaSince && quotaUntil ? quotaUntil : fallbackUntil;
        } else {
          sinceEff =
            queryFilters?.since ||
            urlParams.get("since") ||
            fallbackSince;
          untilEff =
            queryFilters?.until ||
            urlParams.get("until") ||
            fallbackUntil;
        }
        payload.since = sinceEff;
        payload.until = untilEff;
      }

      // For brand metrics, create one widget per selected metric ID.
      const metricsToCreate =
        metricType === "brand" && brandMetricIds && brandMetricIds.length > 1
          ? brandMetricIds
          : [metricType === "brand" ? (brandMetricIds?.[0] ?? null) : null];

      // Fire POSTs in parallel: sequential summed latency (~6 widgets × backend time); parallel tracks ~one round-trip.
      const payloads = metricsToCreate.map((metricId) =>
        metricType === "brand" && brandMetricIds && brandMetricIds.length > 1
          ? { ...buildBasePayload(metricId), since: payload.since, until: payload.until }
          : payload,
      );

      const saveResponses = await Promise.all(
        payloads.map(async (perPayload) => {
          try {
            return await apiRequest(
              "welcome/widget/add",
              "POST",
              withWorkspaceOwnerPayload(perPayload),
              true,
            );
          } catch (e) {
            console.error("welcome/widget/add request failed:", e);
            return { error: String(e?.message || e || "network") };
          }
        }),
      );

      const createdWidgets = [];
      let creationErrorNotice = null;

      saveResponses.forEach((saveResponse) => {
        if (saveResponse?.success) {
          const newWidget = saveResponse.success;
          if (saveResponse.workspace_limits && setWorkspaceWidgetLimits) {
            setWorkspaceWidgetLimits(saveResponse.workspace_limits);
          }
          const pivotScope =
            metricType === "brand"
              ? buildWelcomePivotPayload(pivotLevelSelections)
              : {};
          const transformedWidget = {
            ...newWidget,
            ...(Object.keys(pivotScope).length ? pivotScope : {}),
            name: decodeBasicHtmlEntities(newWidget.name ?? ""),
            status: mapWelcomeWidgetJobStatusToUi(newWidget.status),
          };
          createdWidgets.push(transformedWidget);
          if (transformedWidget.status === "loading") {
            pollWidgetStatus(groupId, transformedWidget);
          }
        } else if (saveResponse?.error && !creationErrorNotice) {
          const errRaw = saveResponse.error;
          creationErrorNotice =
            errRaw === "INSUFFICIENT_AI_CREDITS" ||
            (typeof errRaw === "string" && errRaw.toUpperCase().includes("CREDIT"))
              ? t("welcome.insufficientAiCredits")
              : saveResponse.message || errRaw;
        }
      });

      if (creationErrorNotice && createdWidgets.length === 0) {
        notification.error({
          message: t("common.error"),
          description: creationErrorNotice,
        });
      } else if (creationErrorNotice) {
        notification.warning({
          message: t("common.error"),
          description: `${creationErrorNotice}\n${t(
            "welcome.partialWidgetCreateWarning",
            {
              succeeded: createdWidgets.length,
              failed: payloads.length - createdWidgets.length,
            },
          )}`,
        });
      }

      if (createdWidgets.length > 0) {
        setWidgets([...widgets, ...createdWidgets]);
        setGroups((prevG) =>
          prevG.map((g) =>
            g.id !== groupId
              ? g
              : {
                  ...g,
                  widgets: [...(g.widgets || []), ...createdWidgets],
                },
          ),
        );
        const groupName =
          groups.find((g) => g.id === groupId)?.name ??
          t("welcome.widgetCreatedUnknownGroup");

        if (createdWidgets.length === 1) {
          const wizardMetricLabel = (() => {
            if (metricType === "brand") {
              return findBrandMetric(selectedBrandMetric)?.label ?? "";
            }
            if (metricType === "account") {
              return (
                accountMetricsOptions.find(
                  (o) => o.value === selectedAccountMetric,
                )?.label ?? ""
              );
            }
            if (metricType === "competitive") {
              return (
                competitionTypes.find((o) => o.value === competitionType)
                  ?.label ?? ""
              );
            }
            return "";
          })();
          const widgetTitleForNotice = resolveWidgetDisplayName(createdWidgets[0]);
          let descriptionText = t("welcome.widgetCreatedNotificationBody", {
            name: widgetTitleForNotice,
            group: groupName,
            metric: wizardMetricLabel,
            view: "",
          });
          if (createdWidgets[0].status === "loading") {
            descriptionText = `${descriptionText} ${t("welcome.widgetCreatedProcessingSuffix")}`;
          }
          notification.success({
            message: t("welcome.widgetCreatedNotificationTitle"),
            description: descriptionText,
          });
        } else {
          notification.success({
            message: t("welcome.widgetCreatedNotificationTitle"),
            description: t("welcome.widgetsCreatedMultiple", {
              count: createdWidgets.length,
              group: groupName,
            }),
          });
        }
      }

      // Close the modal and reset state
      handleCloseModal();
    } catch (error) {
      console.error("Error creating/loading widget:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.widgetCreationError"),
      });
    } finally {
      setIsWidgetCreateSubmitting(false);
      widgetCreateInFlightRef.current = false;
    }
  };

  // Reset modal state when closing
  const handleCloseModal = () => {
    setIsWidgetCreateSubmitting(false);
    widgetCreateInFlightRef.current = false;
    setIsAddWidgetModalVisible(false);
    setCurrentStep(1);
    setMetricType("brand");
    setSelectedAccountMetric(3);
    setNewWidgetType(
      getDefaultWidgetTypeForMetric("brand", 18, "chart"),
    );
    setSelectedBrand(null);
    setSelectedBrands([]);
    setSelectedDashboards([]);
    setSelectedBrandMetrics(new Set());
    setMetricSearchQuery("");
    setDashboardSearch("");
    setCompetitionType(1);
    setSelectedTopics([]);
    setSelectedSentiment(null);
    setSelectedBrandOptionalTopicIds([]);
    setSelectedBrandAiTopicIds([]);
    setBrandDashboardCategories([]);
    setLoadingBrandCategories(false);
    // Reset pivot states
    setPivotLevelOptions({ level1: [], level2: {} });
    setPivotLevelSelections({});
    setPivotData([]);
    setQuotaDaysRange("last7d");
    // Reset quota states
    setQuotaSince("");
    setQuotaUntil("");
    setQuotaDateRange(["", ""]);
    setQuotaCheckResult(null);
    setMetricCreditPreview(null);
    setMetricCreditPreviewLoading(false);
    setAiCreditConfirmOpen(false);
    setAiCreditConfirmTargetStep(null);
    aiCreditConfirmedRef.current = false;
    setQuotaCheckLoading(false);
  };

  // Handle widget name editing
  const handleEditName = (id) => {
    const widget = widgets.find((w) => w.id === id);
    if (widget) {
      setEditingWidgetId(id);
      setNewWidgetName(resolveWidgetBaseDisplayName(widget));
      setIsEditNameModalVisible(true);
    }
  };

  const openMoveWidgetModal = (id) => {
    setMoveWidgetId(id);
    setMoveModalOpen(true);
  };

  const closeMoveWidgetModal = () => {
    setMoveModalOpen(false);
    setMoveWidgetId(null);
  };

  const persistWidgetOrder = async (reorderedWidgets, previousWidgets) => {
    const withOrder = withWelcomeWidgetDisplayOrder(reorderedWidgets);
    setWidgets(withOrder);
    setWidgetReorderLoading(true);
    try {
      const response = await apiRequest(
        "welcome/widget/reorder",
        "PUT",
        withWorkspaceOwnerPayload({
          widget_group_id: groupId,
          widget_ids: withOrder.map((w) => w.id),
        }),
        true,
      );
      if (!response?.success) {
        throw new Error(t("welcome.reorderWidgetError"));
      }
      setGroups((prevG) =>
        prevG.map((g) =>
          g.id === groupId ? { ...g, widgets: withOrder } : g,
        ),
      );
      notification.success({
        message: t("common.success"),
        description: t("welcome.reorderWidgetSuccess"),
      });
    } catch (error) {
      console.error("Error reordering widgets:", error);
      setWidgets(previousWidgets);
      notification.error({
        message: t("common.error"),
        description: error?.message || t("welcome.reorderWidgetError"),
      });
    } finally {
      setWidgetReorderLoading(false);
    }
  };

  const handleMoveWidgetStep = (widgetId, delta) => {
    if (!workspaceContentEditable || widgetReorderLoading) return;
    const idx = widgets.findIndex((w) => Number(w.id) === Number(widgetId));
    if (idx < 0) return;
    const targetIdx = idx + delta;
    if (targetIdx < 0 || targetIdx >= widgets.length) return;
    const reordered = [...widgets];
    const [item] = reordered.splice(idx, 1);
    reordered.splice(targetIdx, 0, item);
    void persistWidgetOrder(reordered, widgets);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToWorkspaceWidgetElement(widgetId, "smooth");
      });
    });
  };

  const handleWidgetDragEnd = (result) => {
    if (!workspaceContentEditable || widgetReorderLoading) return;
    if (!result.destination) return;
    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;
    if (sourceIndex === destIndex) return;
    const reordered = [...widgets];
    const [item] = reordered.splice(sourceIndex, 1);
    reordered.splice(destIndex, 0, item);
    void persistWidgetOrder(reordered, widgets);
  };

  const handleMoveWidget = async (targetGroupId) => {
    if (!moveWidgetId || moveLoading || targetGroupId === groupId) return;

    const movedWidgetId = moveWidgetId;
    const normalizedTargetGroupId = normalizeWorkspaceGroupId(targetGroupId);

    setMoveLoading(true);
    try {
      const response = await apiRequest(
        "welcome/widget/move",
        "PUT",
        withWorkspaceOwnerPayload({
          widget_id: moveWidgetId,
          widget_group_id: targetGroupId,
        }),
        true,
      );

      if (response?.success) {
        if (!response.unchanged) {
          const widget = widgets.find((w) => w.id === moveWidgetId);
          if (widget) {
            setWidgets(widgets.filter((w) => w.id !== moveWidgetId));
            setGroups((prevG) =>
              prevG.map((g) => {
                if (g.id === groupId) {
                  return {
                    ...g,
                    widgets: (g.widgets || []).filter((w) => w.id !== moveWidgetId),
                  };
                }
                if (g.id === targetGroupId) {
                  return {
                    ...g,
                    widgets: [...(g.widgets || []), widget],
                  };
                }
                return g;
              }),
            );
          }
        }
        notification.success({
          message: t("common.success"),
          description: t("welcome.moveWidgetSuccess"),
        });
        closeMoveWidgetModal();
        if (
          normalizedTargetGroupId != null &&
          movedWidgetId != null &&
          onWidgetMovedToGroup
        ) {
          onWidgetMovedToGroup(normalizedTargetGroupId, movedWidgetId);
        }
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.moveWidgetError"),
        });
      }
    } catch (error) {
      console.error("Error moving widget:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.moveWidgetError"),
      });
    } finally {
      setMoveLoading(false);
    }
  };

  // Handle widget removal
  const handleRemoveWidget = async (id) => {
    try {
      const response = await apiRequest(
        "welcome/widget/delete",
        "DELETE",
        withWorkspaceOwnerPayload({ widget_id: id }),
        true,
      );

      if (response?.success) {
        if (response.workspace_limits && setWorkspaceWidgetLimits) {
          setWorkspaceWidgetLimits(response.workspace_limits);
        }
        setWidgets(widgets.filter((widget) => widget.id !== id));
        setGroups((prevG) =>
          prevG.map((g) =>
            g.id !== groupId
              ? g
              : {
                  ...g,
                  widgets: (g.widgets || []).filter((w) => w.id !== id),
                },
          ),
        );
        notification.success({
          message: t("common.success"),
          description: t("welcome.widgetDeletedSuccess"),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.widgetDeletedError"),
        });
      }
    } catch (error) {
      console.error("Error deleting widget:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.errorDeletingWidget"),
      });
    }
  };

  /** Menu "Regenerate": all brand widgets (KPI refetch or job; server routes by metric_id). */
  const isWelcomeRegenerableWidget = (w) =>
    w?.metricType === "brand" && Number.isFinite(Number(w?.metric_id));

  /** Brand GenAI metrics (table + narrative): regenerate hits LLM worker and AI credits. */
  const isWelcomeGenAiRegenerableWidget = (w) => {
    if (!isWelcomeRegenerableWidget(w)) return false;
    const mid = Number(w?.metric_id);
    return (
      WELCOME_GENAI_TABLE_METRIC_IDS.has(mid) ||
      WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(mid)
    );
  };

  /** KPI snapshot refresh (no welcomeWidgetJob): metrics 8–18, 28, etc. — not GenAI 20/21/23/25 or 27. */
  const isWelcomeKpiOnlyRegenerateWidget = (w) => {
    if (!isWelcomeRegenerableWidget(w)) return false;
    const mid = Number(w?.metric_id);
    if (isWelcomeGenAiRegenerableWidget(w)) return false;
    if (mid === 27) return false;
    return true;
  };

  const clearWelcomeWidgetKpiCacheForRegenerate = (widgetId) => {
    if (!effectiveWorkspaceUserId) return;
    const plan = welcomeMainDataPlan.find((p) => p.widgetRow.id === widgetId);
    if (plan?.queryKey) {
      clearWelcomeWidgetMainDataCache(queryClient, plan.queryKey);
      return;
    }
    queryClient.removeQueries({
      queryKey: [
        ...welcomeWidgetKeys.all(effectiveWorkspaceUserId),
        "main",
        Number(widgetId),
      ],
    });
  };

  const hasHierarchicalSummaryTabs = (w) => {
    const kpi = getWelcomeWidgetEffectiveKpiData(w);
    return (
      Array.isArray(kpi?.summary_tabs) &&
      kpi.summary_tabs.length > 1 &&
      WELCOME_HIERARCHICAL_SUMMARY_METRIC_IDS.has(Number(w?.metric_id)) &&
      Number(w?.representation_type) === 4
    );
  };

  const canEditInsightFromMenu = (w) => {
    if (!workspaceContentEditable) return false;
    if (hasHierarchicalSummaryTabs(w)) return false;
    const metricId = Number(w?.metric_id);
    const repr = Number(w?.representation_type);
    const isNarrative =
      WELCOME_GENAI_NARRATIVE_METRIC_IDS.has(metricId) && (repr === 4 || !repr);
    const isTable = WELCOME_GENAI_TABLE_METRIC_IDS.has(metricId) && (repr === 3 || !repr);
    return isNarrative || isTable;
  };

  const canEditSummaryTabsFromMenu = (w) => hasHierarchicalSummaryTabs(w);

  const openSummaryTabsEditor = (widgetId) => {
    const w = widgets.find((x) => x.id === widgetId);
    const kpi = w ? getWelcomeWidgetEffectiveKpiData(w) : null;
    const data = kpi?.data && typeof kpi.data === "object" ? kpi.data : kpi || {};
    const editable = Array.isArray(data.summary_tabs_editable)
      ? data.summary_tabs_editable
      : null;
    let tabs = editable && editable.length > 0
      ? editable
      : Array.isArray(data.summary_tabs)
        ? data.summary_tabs
        : Array.isArray(kpi?.summary_tabs)
          ? kpi.summary_tabs
          : [];
    if (Number(w?.metric_id) === 25) {
      tabs = tabs.filter(
        (tab) =>
          tab && !["general", "global"].includes(String(tab.id || "").toLowerCase()),
      );
    }
    if (!editable || editable.length === 0) {
      tabs = tabs.filter((tab) => {
        const id = String(tab?.id || "");
        const lower = id.toLowerCase();
        if (lower === "general" || lower === "global") return true;
        if (/^topic_\d+$/i.test(id)) return true;
        if (/^topic-\d+$/i.test(id)) return false;
        return Boolean(id);
      });
    }
    if (!Array.isArray(tabs) || tabs.length < 1) return;
    setSummaryTabsWidgetId(widgetId);
    setSummaryTabsMetricId(
      Number.isFinite(Number(w?.metric_id)) ? Number(w.metric_id) : null,
    );
    setSummaryTabsDraft(
      tabs.map((tab) => ({
        id: String(tab.id),
        label: String(tab.label || tab.id),
        content: String(tab.content ?? ""),
      })),
    );
    setSummaryTabsModalOpen(true);
  };

  const closeSummaryTabsEditor = () => {
    setSummaryTabsModalOpen(false);
    setSummaryTabsWidgetId(null);
    setSummaryTabsMetricId(null);
    setSummaryTabsDraft([]);
  };

  const saveSummaryTabsEditor = async () => {
    if (!summaryTabsWidgetId) return;
    setSummaryTabsSaving(true);
    try {
      const res = await apiRequest(
        "welcome/widget/narrative-tabs",
        "PUT",
        {
          widget_id: summaryTabsWidgetId,
          updates: summaryTabsDraft.map((row) => ({
            tab_id: row.id,
            content: row.content,
          })),
        },
        true,
      );
      if (res?.success) {
        message.success(t("welcome.summaryTabsSaveSuccess"));
        const wid = summaryTabsWidgetId;
        const draft = summaryTabsDraft;
        const nextTabs = draft.map((row) => ({
          id: row.id,
          label: row.label,
          content: row.content,
        }));
        const globalBody =
          draft.find((r) => r.id === "global" || r.id === "general")?.content ?? "";
        setWidgets((prev) =>
          prev.map((x) =>
            x.id === wid
              ? {
                  ...x,
                  data: {
                    ...(x.data || {}),
                    summary_tabs: nextTabs,
                    narrative: {
                      ...(x.data?.narrative || {}),
                      summary: globalBody,
                    },
                  },
                }
              : x,
          ),
        );
        setGroups((prevG) =>
          prevG.map((g) =>
            g.id !== groupId
              ? g
              : {
                  ...g,
                  widgets: (g.widgets || []).map((x) =>
                    x.id === wid
                      ? {
                          ...x,
                          data: {
                            ...(x.data || {}),
                            summary_tabs: nextTabs,
                            narrative: {
                              ...(x.data?.narrative || {}),
                              summary: globalBody,
                            },
                          },
                        }
                      : x,
                  ),
                },
          ),
        );
        closeSummaryTabsEditor();
      } else {
        message.error(t("welcome.summaryTabsSaveError"));
      }
    } catch (e) {
      console.error(e);
      message.error(t("welcome.summaryTabsSaveError"));
    } finally {
      setSummaryTabsSaving(false);
    }
  };

  const handleOpenInsightEditor = async (widgetId) => {
    if (!workspaceContentEditable) {
      message.warning(t("welcome.editContentReadOnlyUser"));
      return;
    }
    resetInsightEditorState();
    setCurrentInfoWidgetId(widgetId);
    setIsInsightEditorModalVisible(true);
    await fetchInfoInsight(widgetId);
  };

  const executeGenaiRequeue = async (widgetId) => {
    const w = widgets.find((x) => x.id === widgetId);
    const kpiOnlyRegenerate = isWelcomeKpiOnlyRegenerateWidget(w);
    if (kpiOnlyRegenerate) {
      setWidgetKpiLoading((prev) => ({ ...prev, [widgetId]: true }));
      clearWelcomeWidgetKpiCacheForRegenerate(widgetId);
      const kpiRefreshPatch = { status: "ready", data: {} };
      setWidgets((prev) =>
        prev.map((x) =>
          x.id === widgetId ? { ...x, ...kpiRefreshPatch } : x,
        ),
      );
      setGroups((prevGroups) =>
        prevGroups.map((g) =>
          g.id === groupId
            ? {
                ...g,
                widgets: (g.widgets || []).map((x) =>
                  x.id === widgetId ? { ...x, ...kpiRefreshPatch } : x,
                ),
              }
            : g,
        ),
      );
    }
    try {
      console.log(
        `[Welcome][INFO] genai-requeue POST welcome/widget/genai-requeue widget_id=${widgetId}`,
      );
      const response = await apiRequest(
        "welcome/widget/genai-requeue",
        "POST",
        { widget_id: widgetId },
        true,
      );
      if (response?.success) {
        console.log(
          `[Welcome][INFO] genai-requeue OK widget_id=${widgetId} job_id=${response.job_id}`,
        );
        const isKpiOnlyRefresh =
          response.job_id == null || response.job_id === undefined;
        // Hot Terms (28), Sentiment (11), Intent (12), and other KPI-only metrics: no job — refetch KPI.
        if (isKpiOnlyRefresh) {
          try {
            if (effectiveWorkspaceUserId) {
              const plan = welcomeMainDataPlan.find(
                (p) => p.widgetRow.id === widgetId,
              );
              if (plan?.queryKey) {
                await refetchWelcomeWidgetMainData(queryClient, plan.queryKey);
              } else {
                const mainKeyPrefix = [
                  ...welcomeWidgetKeys.all(effectiveWorkspaceUserId),
                  "main",
                  Number(widgetId),
                ];
                queryClient.removeQueries({ queryKey: mainKeyPrefix });
                await queryClient.refetchQueries({
                  queryKey: mainKeyPrefix,
                });
              }
            }
            notification.success({
              message: t("common.success"),
              description: t("welcome.regenerateSuccess"),
            });
            trackWelcomeWidgetRegenerated(widgetId, {
              metricId: w?.metric_id,
              groupId,
              kpiOnly: true,
            });
          } finally {
            setWidgetKpiLoading((prev) => {
              const next = { ...prev };
              delete next[widgetId];
              return next;
            });
          }
          return;
        }
        if (kpiOnlyRegenerate) {
          setWidgetKpiLoading((prev) => {
            const next = { ...prev };
            delete next[widgetId];
            return next;
          });
        }
        // Drop cached KPI so only this widget refetches when job completes; avoid
        // re-running welcome/widget/data for every other ready widget in the group.
        // Reset job timing locally so the AI elapsed clock does not show the previous run.
        const requeuedAt = new Date().toISOString();
        const loadingPatch = {
          status: "loading",
          data: {},
          job_created_at: response.job_created_at ?? requeuedAt,
          job_updated_at: response.job_updated_at ?? requeuedAt,
          job_in_progress_at: response.job_in_progress_at ?? null,
          ready_duration_seconds: null,
          queued_duration_seconds: null,
          processing_duration_seconds: null,
        };
        const nextWidget = w
          ? { ...w, ...loadingPatch }
          : { id: widgetId, ...loadingPatch };
        setWidgets((prev) =>
          prev.map((x) => (x.id === widgetId ? { ...x, ...loadingPatch } : x)),
        );
        setGroups((prevGroups) =>
          prevGroups.map((g) =>
            g.id === groupId
              ? {
                  ...g,
                  widgets: (g.widgets || []).map((x) =>
                    x.id === widgetId ? { ...x, ...loadingPatch } : x,
                  ),
                }
              : g,
          ),
        );
        if (effectiveWorkspaceUserId) {
          void queryClient.removeQueries({
            queryKey: [
              ...welcomeWidgetKeys.all(effectiveWorkspaceUserId),
              "main",
              Number(widgetId),
            ],
          });
        }
        pollWidgetStatus(groupId, nextWidget);
        notification.success({
          message: t("common.success"),
          description: t("welcome.genaiRequeueSuccess"),
        });
        trackWelcomeWidgetRegenerated(widgetId, {
          metricId: w?.metric_id,
          groupId,
          kpiOnly: false,
        });
      } else {
        const errRaw = response && response.error;
        const isQuotaError =
          errRaw === "INSUFFICIENT_AI_CREDITS" ||
          (typeof errRaw === "string" && errRaw.toUpperCase().includes("CREDIT"));
        const errMsg = isQuotaError
          ? t("welcome.insufficientAiCredits")
          : typeof errRaw === "string"
          ? errRaw
          : t("welcome.genaiRequeueError");
        console.warn(
          `[Welcome][WARNING] genai-requeue failed widget_id=${widgetId} error=${errRaw}`,
        );
        notification.error({
          message: t("common.error"),
          description: errMsg,
        });
        if (kpiOnlyRegenerate) {
          setWidgetKpiLoading((prev) => {
            const next = { ...prev };
            delete next[widgetId];
            return next;
          });
        }
      }
    } catch (error) {
      console.error(
        `[Welcome][ERROR] genai-requeue exception widget_id=${widgetId}`,
        error,
      );
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.genaiRequeueError"),
      });
      if (kpiOnlyRegenerate) {
        setWidgetKpiLoading((prev) => {
          const next = { ...prev };
          delete next[widgetId];
          return next;
        });
      }
    }
  };

  const handleGenaiRequeue = (widgetId) => {
    const w = widgets.find((x) => x.id === widgetId);
    if (!w) return;
    const jobStatus =
      w.welcomeWidgetJob?.status ??
      w.job_status ??
      (w.status === "ready" ? 3 : w.status === "error" ? 4 : null);
    if (
      welcomeGenaiRegenerateSkipsCreditCharge(jobStatus) ||
      welcomeRegenerateSkipsQuotaCheck(w)
    ) {
      void executeGenaiRequeue(widgetId);
      return;
    }
    checkQuotaForRegenerateWidget(w);
  };

  const handleConfirmRegenerate = async () => {
    if (!regenerateQuotaWidget?.id) return;
    await executeGenaiRequeue(regenerateQuotaWidget.id);
    closeRegenerateQuotaModal();
  };

  // Save the edited widget name
  const handleSaveName = async () => {
    if (editingWidgetId === null) return;

    try {
      const response = await apiRequest(
        "welcome/widget/rename",
        "PUT",
        withWorkspaceOwnerPayload({
          widget_id: editingWidgetId,
          name: newWidgetName,
        }),
        true,
      );

      if (response?.success) {
        setWidgets(
          widgets.map((widget) =>
            widget.id === editingWidgetId
              ? { ...widget, name: newWidgetName }
              : widget,
          ),
        );
        notification.success({
          message: t("common.success"),
          description: t("welcome.widgetRenamedSuccess"),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.errorRenamingWidget"),
        });
      }
    } catch (error) {
      console.error("Error renaming widget:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.errorRenamingWidget"),
      });
    } finally {
      setIsEditNameModalVisible(false);
      setEditingWidgetId(null);
      setNewWidgetName("");
    }
  };

  const getReviewsDrawerApi = () => {
    const ref = welcomeReviewsDrawerRef;
    return ref && ref.current ? ref.current : null;
  };

  const fetchReviewsForIssue = async (issue) => {
    trackWelcomeReviewsOpened({
      source: "root_cause",
      label: issue?.label || "",
    });
    const drawer = getReviewsDrawerApi();
    if (drawer) {
      drawer.openLoading({
        label: issue?.label || "",
        root_cause: issue?.root_cause || "",
      });
    }
    try {
      const payload = { rc_id: issue.rc_id };
      const response = await apiRequest(
        "dashboards/root-cause/reviews",
        "POST",
        payload,
        true,
      );
      if (drawer) {
        drawer.setReviews(extractWelcomeReviewsFromApiResponse(response));
      }
    } catch (error) {
      if (drawer) {
        drawer.setReviews([]);
      }
    }
  };

  const fetchMetric20GenaiReviews = async (
    sourceItem,
    row,
    widgetId,
    topicTabLabel,
  ) => {
    const reviewIds = collectGenaiItemReviewIds(sourceItem);
    if (!widgetId || !Number.isFinite(Number(widgetId))) {
      return;
    }
    const widgetRow = (widgets || []).find(
      (w) => Number(w.id) === Number(widgetId),
    );
    let effectiveTabLabel = topicTabLabel;
    if (isGenericWelcomeTopicTabLabel(effectiveTabLabel) && widgetRow) {
      const libId = Number(sourceItem?.topic_lib_id);
      if (Number.isFinite(libId) && libId > 0) {
        const cat = (brandDashboardCategories || []).find(
          (c) => Number(c.categoryId ?? c.category) === libId,
        );
        const catName = cat?.name ?? cat?.category;
        if (catName != null && String(catName).trim() !== "") {
          effectiveTabLabel = String(catName).trim();
        } else {
          const idx = (widgetRow.topic_ids || []).findIndex(
            (tid) => Number(tid) === libId,
          );
          const wl = widgetRow.topic_labels?.[idx];
          if (wl != null && String(wl).trim() !== "") {
            effectiveTabLabel = String(wl).trim();
          }
        }
      }
    }
    const drawerTitle = decodeBasicHtmlEntities(
      resolveWelcomeReviewsDrawerTopicTitle(
        sourceItem,
        row,
        effectiveTabLabel,
      ),
    );
    trackWelcomeReviewsOpened({
      widgetId,
      widgetName: widgetRow?.name || widgetRow?.title,
      metricId: 20,
      source: "metric_20",
      label: drawerTitle,
      topicLabel: effectiveTabLabel,
    });
    const drawer = getReviewsDrawerApi();
    if (drawer) {
      drawer.openLoading({
        label: drawerTitle,
        root_cause: row?.root_cause || sourceItem?.root_cause || "",
      });
    }
    if (!reviewIds.length) {
      if (drawer) {
        drawer.setLoading(false);
      }
      message.info(t("welcome.rootCauseNoAssociatedReviews"));
      return;
    }
    try {
      const { reviews } = await fetchWelcomeWidgetMetricReviews(20, {
        widget_id: Number(widgetId),
        review_ids: reviewIds,
      });
      if (drawer) {
        drawer.setReviews(reviews);
      }
    } catch (error) {
      if (drawer) {
        drawer.setReviews([]);
      }
      notification.error({ message: t("ai_services.load_error") });
    }
  };

  const fetchWelcomeWidgetScopeReviews = async (
    widgetRow,
    metricId,
    { topicLibId, topicLabel, reviewCount } = {},
  ) => {
    const mid = Number(metricId);
    if (!widgetRow?.id || !WELCOME_WIDGET_SCOPE_REVIEW_METRIC_IDS.has(mid)) {
      return;
    }
    const drawer = getReviewsDrawerApi();
    const drawerTitle =
      topicLabel || widgetRow?.name || widgetRow?.title || "";
    trackWelcomeReviewsOpened({
      widgetId: widgetRow?.id,
      widgetName: widgetRow?.name || widgetRow?.title,
      metricId: mid,
      source: "widget_scope_tab",
      label: drawerTitle,
      topicLabel,
    });
    if (drawer) {
      drawer.openLoading({
        label: drawerTitle,
        root_cause: topicLabel || "",
      });
    }
    try {
      const body = { widget_id: widgetRow.id };
      if (topicLibId != null && Number.isFinite(Number(topicLibId))) {
        body.topic_lib_id = Number(topicLibId);
      }
      const rc = Number(reviewCount);
      if (Number.isFinite(rc) && rc > 0) {
        body.max_reviews = Math.min(Math.max(Math.round(rc), 1), 200);
      }
      const { reviews } = await fetchWelcomeWidgetMetricReviews(mid, body);
      if (drawer) {
        drawer.setReviews(reviews);
      }
    } catch (error) {
      if (drawer) {
        drawer.setReviews([]);
      }
    }
  };

  const fetchMetric27DecisionReviews = async (
    widgetRow,
    decisionKey,
    decisionTrue,
    topicLibId,
  ) => {
    if (!widgetRow?.id) return;
    const drawer = getReviewsDrawerApi();
    const sliceCfg = DECISION_DISTRIBUTION_CONFIG.find(
      (c) => c.key === decisionKey,
    );
    const labels = sliceCfg
      ? sliceCfg.labels.map((k) => t(k))
      : [String(decisionKey)];
    const sliceLabel = decisionTrue ? labels[1] : labels[0];
    trackWelcomeReviewsOpened({
      widgetId: widgetRow?.id,
      widgetName: widgetRow?.name || widgetRow?.title,
      metricId: 27,
      source: "metric_27",
      label: sliceCfg ? t(sliceCfg.titleKey) : String(decisionKey),
      topicLabel: sliceLabel,
    });
    if (drawer) {
      drawer.openLoading({
        label: sliceCfg ? t(sliceCfg.titleKey) : String(decisionKey),
        root_cause: sliceLabel,
      });
    }
    try {
      const body = {
        widget_id: widgetRow.id,
        decision: decisionKey,
        decision_true: Boolean(decisionTrue),
      };
      if (topicLibId != null && Number.isFinite(Number(topicLibId))) {
        body.topic_lib_id = Number(topicLibId);
      }
      const { reviews } = await fetchWelcomeWidgetMetricReviews(27, body);
      if (drawer) {
        drawer.setReviews(reviews);
      }
    } catch (error) {
      if (drawer) {
        drawer.setReviews([]);
      }
    }
  };

  // Get sample data based on widget type and metric
  const generateWidgetData = async (groupId, metricType, widgetType) => {
    try {
      // Set loading state for the widget
      // setLoadingWidgets((prev) => ({ ...prev, [widgetId]: true }));

      // Fetch data based on widget type and metric
      const data = await saveWidget({
        metric_type: metricType,
        metric_id:
          metricType === "account"
            ? selectedAccountMetric
            : metricType === "brand"
            ? selectedBrandMetric
            : 17,
        representation_type: resolveWelcomeRepresentationView(
          metricType,
          metricType === "brand"
            ? selectedBrandMetric
            : metricType === "account"
              ? selectedAccountMetric
              : 17,
          {
            findBrandMetric,
            accountMetricsOptions,
            selectedAccountMetric,
          },
        ),
        widget_group_id: groupId,
        topics: selectedTopics,
        dashboard_ids: selectedDashboards,
        group_ids: selectedBrands,
        competition_type: competitionType,
        sentiment: selectedSentiment,
      });
      if (data?.success) {
        return data?.success;
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.errorFetchWidgetData"),
        });
      }
    } catch (error) {
      console.error("Error fetching widget data:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchWidgetData"),
      });
      return null;
    }
    // } finally {
    //   // Reset loading state for the widget
    //   setLoadingWidgets((prev) => ({ ...prev, [widgetId]: false }));
    // }
  };

  // Add copy to clipboard function
  const copyToClipboard = async (text, setCopyState) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopyState(true);
      // Reset icon after 2 seconds
      setTimeout(() => setCopyState(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopyState(true);
      // Reset icon after 2 seconds
      setTimeout(() => setCopyState(false), 2000);
    }
  };

  const aiInsightsColumn = [
    {
      title: t("welcome.insightTableColId"),
      dataIndex: "ID",
      key: "rc_id",
      width: 60,
      sorter: (a, b) => a.rc_id - b.rc_id,
      render: (text, record) => <span>{record.rc_id}</span>,
    },
    {
      title: t("welcome.insightTableColArea"),
      dataIndex: "label",
      key: "label",
      width: 120,
      sorter: (a, b) => {
        const emptyLbl = t("welcome.insightTableNoTopic");
        const labelA = a.label || emptyLbl;
        const labelB = b.label || emptyLbl;
        return labelA.localeCompare(labelB);
      },
      render: (text, record) => {
        // Handle empty or null labels
        if (!text || text.trim() === "") {
          return (
            <span
              style={{
                color: theme === "dark" ? "#8c8c8c" : "#999",
                fontStyle: "italic",
              }}
            ></span>
          );
        }

        const displayText = text.replace(/^.\s/, "");
        const emoji = text.match(/^.\s/) ? text.split(" ")[0] : "";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              minWidth: 0,
            }}
          >
            <span
              style={{
                flex: 1,
                minWidth: 0,
                wordBreak: "break-word",
                whiteSpace: "normal",
              }}
            >
              <span className="areaEmoji">{emoji}</span>
              {displayText}
            </span>
          </div>
        );
      },
    },
    {
      title: t("welcome.insightTableColRootCause"),
      dataIndex: "root_cause",
      key: "root_cause",
      width: 180,
      sorter: (a, b) => a.root_cause.localeCompare(b.root_cause),
      render: (text, record) => {
        return (
          <div
            style={{
              cursor: "pointer",
              padding: "4px",
              borderRadius: "4px",
              transition: "text-decoration 0.2s",
              position: "relative",
              minWidth: 0,
            }}
            onMouseEnter={(e) => {
              e.target.style.textDecoration = "underline";
            }}
            onMouseLeave={(e) => {
              e.target.style.textDecoration = "none";
            }}
            onClick={() => fetchReviewsForIssue(record)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "4px",
                minWidth: 0,
              }}
            >
              <span
                style={{
                  flex: 1,
                  minWidth: 0,
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {text}
                <ArrowUpOutlined
                  style={{
                    color: theme === "dark" ? "#8c8c8c" : "#666",
                    fontSize: "12px",
                    marginLeft: "4px",
                    transform: "rotate(45deg)",
                  }}
                />
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: t("welcome.insightTableColRecommendation"),
      dataIndex: "recommendation",
      key: "recommendation",
      width: 200,
      sorter: (a, b) => a.recommendation.localeCompare(b.recommendation),
      render: (text, record) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "4px",
              minWidth: 0,
            }}
          >
            <span
              style={{
                flex: 1,
                minWidth: 0,
                wordBreak: "break-word",
                whiteSpace: "normal",
              }}
            >
              {text}
            </span>
          </div>
        );
      },
    },
    {
      title: t("welcome.insightTableColStatus"),
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => {
        if (a.status === b.status) return 0;
        return a.status ? 1 : -1;
      },
      width: 120,
      render: (status, record) => <StatusUpdateComponent record={record} />,
    },
    {
      title: t("welcome.insightTableColUpdatedBy"),
      dataIndex: "updated_by",
      key: "updated_by",
      width: 100,
      sorter: (a, b) => (a.updated_by || 0) - (b.updated_by || 0),
      render: (_, record) => {
        return (
          <span
            style={{
              fontSize: "12px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
              width: "80px",
              maxWidth: "80px",
            }}
          >
            {record?.updated_by || ""}
          </span>
        );
      },
    },
  ];

  const welcomeWorkspaceWidgetRenderDeps = useMemo(
    () => ({
      theme,
      t,
      i18n,
      groupId,
      setWidgets,
      setGroups,
      fetchWelcomeTopicTabPartial,
      welcomeLazyTopicTabKeyByWidget,
      setWelcomeLazyTopicTabKeyByWidget,
      isWelcomeTopicTabPartialLoading,
      brandDashboardCategories,
      aiInsightsColumn,
      fetchMetric27DecisionReviews,
      fetchMetric20GenaiReviews,
      fetchWelcomeWidgetScopeReviews,
      handleWelcomeWidgetRefresh,
      handleGenaiRequeue,
      isWelcomeRegenerableWidget,
      widgetRefreshLoading,
      loadingWidgets,
      isWelcomeWidgetPageDataLoading,
      isWelcomeWidgetVisible,
      resolveWelcomeWidgetPageDataLoadingForTiming,
      workspaceContentEditable,
    }),
    [
      theme,
      t,
      i18n,
      groupId,
      setWidgets,
      setGroups,
      fetchWelcomeTopicTabPartial,
      welcomeLazyTopicTabKeyByWidget,
      setWelcomeLazyTopicTabKeyByWidget,
      isWelcomeTopicTabPartialLoading,
      brandDashboardCategories,
      aiInsightsColumn,
      fetchMetric27DecisionReviews,
      fetchMetric20GenaiReviews,
      fetchWelcomeWidgetScopeReviews,
      handleWelcomeWidgetRefresh,
      handleGenaiRequeue,
      isWelcomeRegenerableWidget,
      widgetRefreshLoading,
      loadingWidgets,
      isWelcomeWidgetPageDataLoading,
      isWelcomeWidgetVisible,
      resolveWelcomeWidgetPageDataLoadingForTiming,
      workspaceContentEditable,
    ],
  );

  // Determine the total number of steps based on metric type
  const getTotalSteps = () => {
    if (metricType === "brand") {
      // Topics (6) → date (7) → review & create (8) for all brand metrics
      return 8;
    } else if (metricType === "competitive" && competitionType !== 4) {
      return 5;
    } else if (metricType === "competitive" && competitionType === 4) {
      return 4;
    } else {
      return 2;
    }
  };

  // Returns the milestone index (0-based) that is currently active, and the full milestone list
  const getWizardMilestones = () => {
    if (metricType === "brand") {
      const milestones = [
        { label: t("welcome.stepperMetricType"), steps: [1] },
        { label: t("welcome.stepperGroupDashboard"), steps: [2, 3] },
        { label: t("welcome.stepperMetrics"), steps: [4] },
        { label: t("welcome.stepperPivot"), steps: [5] },
        { label: t("welcome.stepperTopics"), steps: [6] },
        { label: t("welcome.stepperDateRange"), steps: [7] },
        { label: t("welcome.stepperReviewCreate"), steps: [8] },
      ];
      const activeIdx = milestones.findIndex((m) => m.steps.includes(currentStep));
      return { milestones, activeIdx: activeIdx === -1 ? milestones.length - 1 : activeIdx };
    } else if (metricType === "competitive") {
      const milestones = [
        { label: t("welcome.stepperMetricType"), steps: [1] },
        { label: t("welcome.stepperGroupDashboard"), steps: [2, 3] },
        { label: t("welcome.stepperCompetition"), steps: [4] },
        { label: t("welcome.stepperTopics"), steps: [5] },
        { label: t("welcome.stepperDateRange"), steps: [6] },
      ];
      const activeIdx = milestones.findIndex((m) => m.steps.includes(currentStep));
      return { milestones, activeIdx: activeIdx === -1 ? milestones.length - 1 : activeIdx };
    } else {
      const milestones = [
        { label: t("welcome.stepperMetricType"), steps: [1] },
        { label: t("welcome.stepperMetrics"), steps: [2] },
        { label: t("welcome.stepperDateRange"), steps: [3] },
      ];
      const activeIdx = milestones.findIndex((m) => m.steps.includes(currentStep));
      return { milestones, activeIdx: activeIdx === -1 ? milestones.length - 1 : activeIdx };
    }
  };

  const getCurrentStepLabel = () => {
    const { milestones, activeIdx } = getWizardMilestones();
    return milestones[activeIdx]?.label ?? "";
  };

  const formatReviewSummaryBrandTopic = () => {
    const distIds = selectedBrandDistTopicIds(
      selectedBrandAiTopicIds,
      selectedBrandOptionalTopicIds,
    );
    if (distIds.length > 0) {
      const names = distIds
        .map((rawId) => {
          const id = Number(rawId);
          const cat = (brandDashboardCategories || []).find(
            (c) => Number(c.categoryId ?? c.category) === id,
          );
          const n = cat?.name ?? cat?.category;
          return n != null && String(n).trim() !== "" ? String(n) : null;
        })
        .filter(Boolean);
      if (names.length > 0) {
        return names.join(", ");
      }
    }
    return t("welcome.reviewSummaryTopicAll");
  };

  const handleMoveGroupToUser = async () => {
    if (!moveGroupTargetUserId || moveGroupToUserLoading) return;

    setMoveGroupToUserLoading(true);
    try {
      const response = await apiRequest(
        "welcome/groups/move",
        "PUT",
        withWorkspaceOwnerPayload({
          group_id: groupId,
          target_workspace_user_id: moveGroupTargetUserId,
        }),
        true,
      );

      if (response?.error) {
        notification.error({
          message: t("common.error"),
          description: response.error,
        });
        return;
      }

      if (response?.success) {
        const targetLabel =
          moveGroupTargetOptions.find(
            (opt) => opt.value === moveGroupTargetUserId,
          )?.label || moveGroupTargetUserId;
        closeMoveGroupToUserModal();
        await fetchGroupsAndWidgets();
        notification.success({
          message: t("common.success"),
          description: t("welcome.moveGroupToUserSuccess", {
            name: groupName,
            user: targetLabel,
          }),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.moveGroupToUserError"),
        });
      }
    } catch (error) {
      console.error("Error moving group to user:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.moveGroupToUserError"),
      });
    } finally {
      setMoveGroupToUserLoading(false);
    }
  };

  const handleArchiveGroupMenuClick = () => {
    if (!groupInteractionsEnabled) return;
    if (!widgets.length) {
      showArchiveGroupValidationToast(t, "empty");
      return;
    }
    const notReady = widgets.filter((widget) => widget.status !== "ready");
    if (notReady.length) {
      showArchiveGroupValidationToast(t, "not_ready", notReady);
      return;
    }
    setIsArchiveGroupModalVisible(true);
  };

  const handleArchiveGroupConfirm = async () => {
    if (!groupInteractionsEnabled || archiveGroupLoading) return;
    setArchiveGroupLoading(true);
    try {
      const response = await apiRequest(
        "welcome/groups/archive",
        "POST",
        withWorkspaceOwnerPayload({ group_id: groupId }),
        true,
      );
      if (response?.error === "empty_group") {
        showArchiveGroupValidationToast(t, "empty");
        setIsArchiveGroupModalVisible(false);
        return;
      }
      if (response?.error === "widgets_not_ready") {
        const apiWidgets = (response.widgets || []).map((widget) => ({
          id: widget.id,
          name: widget.name,
          status:
            widget.status === "failed"
              ? "error"
              : widget.status === "ready"
              ? "ready"
              : "loading",
        }));
        showArchiveGroupValidationToast(t, "not_ready", apiWidgets);
        setIsArchiveGroupModalVisible(false);
        return;
      }
      if (response?.error) {
        notification.error({
          message: t("common.error"),
          description: response.error,
        });
        return;
      }
      setIsArchiveGroupModalVisible(false);
      if (onGroupArchived) {
        onGroupArchived(groupId, groupName);
      }
      notification.success({
        message: t("common.success"),
        description: t("welcome.archiveGroupSuccess", { name: groupName }),
      });
    } catch (error) {
      notification.error({
        message: t("common.error"),
        description: error?.message || t("welcome.archiveGroupError"),
      });
    } finally {
      setArchiveGroupLoading(false);
    }
  };

  const handleRestoreGroup = async () => {
    if (!isArchivedGroupView || restoreGroupLoading) return;
    const maxWidgets =
      workspaceWidgetLimits?.max_widgets ??
      DEFAULT_WORKSPACE_WIDGET_LIMITS.max_widgets;
    const currentActive = workspaceWidgetLimits?.total_widgets ?? 0;
    const groupCount = widgets.length;
    const totalAttempted = currentActive + groupCount;
    if (totalAttempted > maxWidgets) {
      showRestoreGroupLimitToast(
        t,
        currentActive,
        groupCount,
        maxWidgets,
        totalAttempted,
      );
      return;
    }
    setRestoreGroupLoading(true);
    try {
      const response = await apiRequest(
        "welcome/groups/restore",
        "POST",
        withWorkspaceOwnerPayload({ group_id: groupId }),
        true,
      );
      if (response?.error === "restore_widget_limit_exceeded") {
        showRestoreGroupLimitToast(
          t,
          Number(response.current_widgets) || currentActive,
          Number(response.group_widgets) || groupCount,
          Number(response.max_widgets) || maxWidgets,
          Number(response.total_attempted) || totalAttempted,
        );
        return;
      }
      if (response?.error) {
        notification.error({
          message: t("common.error"),
          description: response.error,
        });
        return;
      }
      if (onGroupRestored) {
        onGroupRestored(groupId, groupName);
      }
      notification.success({
        message: t("common.success"),
        description: t("welcome.restoreGroupSuccess", { name: groupName }),
      });
    } catch (error) {
      notification.error({
        message: t("common.error"),
        description: error?.message || t("welcome.restoreGroupError"),
      });
    } finally {
      setRestoreGroupLoading(false);
    }
  };

  const handleDeleteGroup = async () => {
    try {
      setWorkspaceLoading(true);
      const hasWidgets = widgets.length > 0;
      const response = hasWidgets
        ? await apiRequest(
            "welcome/groups/bulk-delete",
            "DELETE",
            withWorkspaceOwnerPayload({
              group_ids: [groupId],
              select_all: false,
              archived_only: isArchivedGroupView,
            }),
            true,
          )
        : await apiRequest(
            "welcome/groups/delete",
            "DELETE",
            withWorkspaceOwnerPayload({
              group_id: groupId,
            }),
            true,
          );

      if (response?.error) {
        const errorCode = response.error_code || response.error;
        const errorDescription =
          errorCode === "GROUP_DELETE_REQUIRES_ARCHIVED"
            ? t("welcome.deleteGroupRequiresArchived")
            : errorCode === "GROUP_DELETE_REQUIRES_EMPTY"
              ? t("welcome.deleteGroupRequiresEmptyWidgets")
              : response.error || t("welcome.groupDeletedError");
        notification.error({
          message: t("welcome.deleteGroup"),
          description: errorDescription,
        });
        setIsDeleteGroupModalVisible(false);
        return;
      }

      if (response && response?.success) {
        if (response.workspace_limits) {
          setWorkspaceWidgetLimits(response.workspace_limits);
        }
        await fetchGroupsAndWidgets();
        setIsDeleteGroupModalVisible(false);

        notification.success({
          message: t("common.success"),
          description: hasWidgets
            ? t("welcome.bulkDeleteGroupsSuccess", {
                groups: Number(response.deleted_group_count) || 1,
                widgets:
                  Number(response.deleted_widget_count) || widgets.length,
              })
            : t("welcome.groupDeletedSuccess", { name: groupName }),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.groupDeletedError"),
        });
      }
    } catch (error) {
      console.error("Error deleting group:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.groupDeletedError"),
      });
    } finally {
      setWorkspaceLoading(false);
    }
  };
  const resetInsightEditorState = () => {
    setInsightLoading(false);
    setInsightSaveLoading(false);
    setInsightError("");
    setInsightKind(null);
    setInsightItems([]);
    setInsightSummaryDraft("");
    setInsightTableColumns([]);
    setInsightTableRows([]);
    setInsightSourceReviewCount(null);
  };

  const normalizeInsightTableCellValue = (value) => {
    if (value == null) return "";
    if (typeof value === "string") return decodeBasicHtmlEntities(value);
    if (typeof value === "number" || typeof value === "boolean") return String(value);
    try {
      return JSON.stringify(value);
    } catch (_e) {
      return String(value);
    }
  };

  const mapInsightItemsToTableDraft = (items) => {
    const safeItems = Array.isArray(items) ? items : [];
    const objectRows = safeItems.filter(
      (item) => item != null && typeof item === "object" && !Array.isArray(item),
    );

    const columnSet = new Set();
    objectRows.forEach((row) => {
      Object.keys(row).forEach((key) => {
        const normalizedKey = String(key || "").trim();
        if (normalizedKey) columnSet.add(normalizedKey);
      });
    });

    let columns = Array.from(columnSet);
    let rows = [];

    if (columns.length > 0) {
      rows = objectRows.map((row) =>
        columns.reduce((acc, col) => {
          acc[col] = normalizeInsightTableCellValue(row[col]);
          return acc;
        }, {}),
      );
    } else if (safeItems.length > 0) {
      columns = ["value"];
      rows = safeItems.map((item) => ({
        value: normalizeInsightTableCellValue(item),
      }));
    }

    return { columns, rows };
  };

  /** Edit table columns: metric 20 → ID, root_cause, recommendation, status. */
  const finalizeBrandGenaiTableColumnsAndRows = (columns, rows, metricId) => {
    const mid = Number(metricId);
    const ordered = orderInsightTableColumnsForEditModal(columns, mid);
    const normRows = normalizeInsightRowsForEdit(rows);
    return { columns: ordered, rows: normRows };
  };

  /** Content modal save: narratives from draft; status/comment/label/topic from load snapshot. */
  const mergeWelcomeMetric20DraftWithOriginalMeta = (draftRows, originalItems) => {
    const draft = mapInsightItemsToTableDraft(originalItems || []);
    const { rows: initialNormRows } = finalizeBrandGenaiTableColumnsAndRows(
      draft.columns,
      draft.rows,
      20,
    );
    const initialRows = normalizeInsightRowsForEdit(initialNormRows);
    const byRc = new Map();
    initialRows.forEach((r) => {
      const id = String(r?.rc_id ?? r?.ID ?? "").trim();
      if (id) byRc.set(id, r);
    });
    return (Array.isArray(draftRows) ? draftRows : []).map((row) => {
      const id = String(row?.rc_id ?? row?.ID ?? "").trim();
      const orig = id ? byRc.get(id) : undefined;
      const merged = { ...(orig || {}), ...row };
      merged.root_cause = String(row?.root_cause ?? "").trim();
      merged.recommendation = String(row?.recommendation ?? "").trim();
      merged.rc_id = id || String(merged.rc_id ?? "").trim();
      if (orig) {
        merged.status = String(orig.status ?? "").trim();
        merged.comment = String(orig.comment ?? "").trim();
        merged.label = String(orig.label ?? merged.label ?? "").trim();
        merged.topic = String(orig.topic ?? merged.topic ?? "").trim();
      }
      return merged;
    });
  };

  const buildComparableInsightTable = (items) => {
    const draft = mapInsightItemsToTableDraft(items);
    const w = widgets.find((x) => x.id === currentInfoWidgetId);
    const mid = w ? Number(w.metric_id) : NaN;
    return finalizeBrandGenaiTableColumnsAndRows(draft.columns, draft.rows, mid);
  };

  const hydrateInsightDraft = (kind, items, metricId) => {
    const safeItems = Array.isArray(items) ? items : [];
    const mid = Number(metricId);
    setInsightKind(kind || null);
    setInsightItems(safeItems);
    if (kind === "brand_genai_narrative") {
      const summary = safeItems?.[0]?.description ?? "";
      setInsightSummaryDraft(decodeBasicHtmlEntities(String(summary)));
    } else if (kind === "brand_genai_table") {
      const { columns, rows } = mapInsightItemsToTableDraft(safeItems);
      const { columns: ordered, rows: normRows } = finalizeBrandGenaiTableColumnsAndRows(
        columns,
        rows,
        mid,
      );
      setInsightTableColumns(ordered);
      setInsightTableRows(normRows);
    } else {
      setInsightTableColumns([]);
      setInsightTableRows([]);
    }
  };

  const fetchInfoInsight = async (widgetId) => {
    setInsightLoading(true);
    setInsightError("");
    try {
      const response = await apiRequest(
        "welcome/widget/genai-insight",
        "POST",
        { widget_id: widgetId },
        true,
      );
      if (response?.success) {
        hydrateInsightDraft(
          response.success.insight_kind,
          response.success.items,
          response.success.metric_id,
        );
        setInsightSourceReviewCount(
          Number.isFinite(Number(response.success.source_review_count))
            ? Number(response.success.source_review_count)
            : null,
        );
      } else {
        setInsightError(response?.error || t("welcome.infoInsightLoadError"));
      }
    } catch (error) {
      setInsightError(t("welcome.infoInsightLoadError"));
    } finally {
      setInsightLoading(false);
    }
  };

  const handleShowInfo = async (id) => {
    const widgetRow = widgets.find((w) => Number(w.id) === Number(id));
    trackWelcomeWidgetAction("info", {
      widgetId: id,
      widgetName: resolveWidgetInfoDisplayName(widgetRow, t, widgetRow) || widgetRow?.name,
      metricId: widgetRow?.metric_id,
      groupId: widgetRow?.group_id,
    });
    const response = await apiRequest(
      "welcome/widget/info",
      "POST",
      {
        widget_id: id,
      },
      true,
    );
    if (response && response?.success) {
      setWidgetInfo(mergeWidgetInfoPayload(response.success, widgetRow));
      setIsWidgetInfoModalVisible(true);
    } else {
      notification.error({
        message: t("common.error"),
        description: response?.error || t("welcome.errorGettingInfo"),
      });
    }
  };

  const formatWidgetInfoDate = (iso) => {
    if (iso == null || iso === "") return null;
    const formatted = formatAppDate(iso, i18n.language);
    return formatted || String(iso);
  };

  const formatWidgetInfoDateTime = (iso) => {
    if (iso == null || iso === "") return null;
    const formatted = formatAppDateTime(iso, i18n.language, { useDayjs: false });
    return formatted || String(iso);
  };

  const formatInfoList = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      return value.join(", ");
    }
    return null;
  };

  const renderJobStatusTag = (status) => {
    if (status === "not_found" || status == null) {
      return <Tag>{t("welcome.infoJobNotFound")}</Tag>;
    }
    const n = Number(status);
    const map = {
      1: { color: "default", label: t("welcome.infoJobPending") },
      2: { color: "processing", label: t("welcome.infoJobInProgress") },
      3: { color: "success", label: t("welcome.infoJobReady") },
      4: { color: "error", label: t("welcome.infoJobFailed") },
    };
    const cfg = map[n];
    if (!cfg) {
      return <Tag>{String(status)}</Tag>;
    }
    return <Tag color={cfg.color}>{cfg.label}</Tag>;
  };

  const isNarrativeInsight = insightKind === "brand_genai_narrative";
  const isTableInsight = insightKind === "brand_genai_table";
  const canEditInsight =
    workspaceContentEditable && (isNarrativeInsight || isTableInsight);
  const insightFieldsReadOnly = !workspaceContentEditable;
  const insightEditWidgetMetricId = (() => {
    const w = widgets.find((x) => x.id === currentInfoWidgetId);
    return w ? Number(w.metric_id) : NaN;
  })();
  const insightEditorModeTitle = isNarrativeInsight
    ? t("welcome.infoInsightNarrativeTitle")
    : isTableInsight
      ? t("welcome.infoInsightTableTitle")
      : t("welcome.infoSectionAiContent");
  const handleCloseInsightEditor = () => {
    setIsInsightEditorModalVisible(false);
    setCurrentInfoWidgetId(null);
    resetInsightEditorState();
  };

  const handleInsightTableCellChange = (rowIndex, columnKey, value) => {
    setInsightTableRows((prevRows) =>
      prevRows.map((row, idx) => {
        if (idx !== rowIndex) return row;
        return {
          ...row,
          [columnKey]: value,
        };
      }),
    );
  };

  const isLongTextInsightColumn = (columnKey) => {
    const key = String(columnKey || "").toLowerCase();
    return (
      key.includes("root_cause") ||
      key.includes("recommendation") ||
      key.includes("summary") ||
      key.includes("drivers") ||
      key.includes("highlight") ||
      key.includes("description")
    );
  };

  const serializeInsightTableRows = (columns, rows) => {
    const safeColumns = Array.isArray(columns) ? columns : [];
    const safeRows = Array.isArray(rows) ? rows : [];
    const hasStatus = safeColumns.some((c) => String(c).toLowerCase() === "status");
    return safeRows
      .map((row) => {
        const acc = safeColumns.reduce((obj, col) => {
          obj[col] = String(row?.[col] ?? "").trim();
          return obj;
        }, {});
        if (hasStatus) {
          acc.comment = String(row?.comment ?? "").trim();
        }
        return acc;
      })
      .filter((row) => safeColumns.some((col) => row[col] !== ""));
  };

  const isInsightDirty = (() => {
    if (isNarrativeInsight) {
      const initialSummary = String(insightItems?.[0]?.description ?? "").trim();
      const currentSummary = String(insightSummaryDraft ?? "").trim();
      return initialSummary !== currentSummary;
    }
    if (isTableInsight) {
      if (insightEditWidgetMetricId === 20) {
        const draftI = mapInsightItemsToTableDraft(insightItems || []);
        const { rows: initRows } = finalizeBrandGenaiTableColumnsAndRows(
          draftI.columns,
          draftI.rows,
          20,
        );
        const initialSnap = serializeWelcomeMetric20InsightRowsContentOnly(
          normalizeInsightRowsForEdit(initRows),
        );
        const currentSnap = serializeWelcomeMetric20InsightRowsContentOnly(
          normalizeInsightRowsForEdit(insightTableRows),
        );
        return JSON.stringify(initialSnap) !== JSON.stringify(currentSnap);
      }
      const initial = buildComparableInsightTable(insightItems || []);
      const initialRows = serializeInsightTableRows(initial.columns, initial.rows);
      const currentRows = serializeInsightTableRows(
        insightTableColumns,
        insightTableRows,
      );
      return JSON.stringify(initialRows) !== JSON.stringify(currentRows);
    }
    return false;
  })();

  const handleSaveInsightEdit = async () => {
    if (!currentInfoWidgetId || !canEditInsight) return;
    if (!isInsightDirty) return;
    setInsightSaveLoading(true);
    try {
      if (isNarrativeInsight) {
        const summary = String(insightSummaryDraft || "").trim();
        if (!summary) {
          notification.warning({
            message: t("common.error"),
            description: t("welcome.infoInsightSummaryRequired"),
          });
          setInsightSaveLoading(false);
          return;
        }
        const resp = await apiRequest(
          "welcome/widget/insight-summary",
          "PATCH",
          {
            widget_id: currentInfoWidgetId,
            summary,
          },
          true,
        );
        if (!resp?.success) {
          throw new Error(resp?.error || t("welcome.infoInsightSaveError"));
        }
      } else if (isTableInsight) {
        const columns = Array.isArray(insightTableColumns) ? insightTableColumns : [];
        const rows = Array.isArray(insightTableRows) ? insightTableRows : [];
        const hasStructure =
          rows.length > 0 &&
          (insightEditWidgetMetricId === 20 || columns.length > 0);
        if (!hasStructure) {
          notification.warning({
            message: t("common.error"),
            description: t("welcome.infoInsightItemsRequired"),
          });
          setInsightSaveLoading(false);
          return;
        }

        const serializedRows =
          insightEditWidgetMetricId === 20
            ? serializeWelcomeMetric20InsightRowsForPatch(
                normalizeInsightRowsForEdit(
                  mergeWelcomeMetric20DraftWithOriginalMeta(
                    rows,
                    insightItems,
                  ),
                ),
              )
            : serializeInsightTableRows(columns, rows);

        if (serializedRows.length === 0) {
          notification.warning({
            message: t("common.error"),
            description: t("welcome.infoInsightItemsRequired"),
          });
          setInsightSaveLoading(false);
          return;
        }

        const resp = await apiRequest(
          "welcome/widget/insight-items",
          "PATCH",
          {
            widget_id: currentInfoWidgetId,
            items: serializedRows,
          },
          true,
        );
        if (!resp?.success) {
          throw new Error(resp?.error || t("welcome.infoInsightSaveError"));
        }
      }

      notification.success({
        message: t("common.success"),
        description: t("welcome.infoInsightSaveSuccess"),
      });
      handleCloseInsightEditor();
      await fetchGroupsAndWidgets();
    } catch (error) {
      notification.error({
        message: t("common.error"),
        description: error?.message || t("welcome.infoInsightSaveError"),
      });
    } finally {
      setInsightSaveLoading(false);
    }
  };
  return (
    <WelcomeWorkspaceWidgetRenderContext.Provider
      value={welcomeWorkspaceWidgetRenderDeps}
    >
    <div
      className={`${styles.groupSection}${
        suppressGroupTitle ? ` ${styles.groupSectionNavActive}` : ""
      }${isArchivedGroupView ? ` ${styles.groupSectionArchived}` : ""}`.trim()}
    >
      <div
        className={`${styles.groupHeader}${
          suppressGroupTitle ? ` ${styles.groupHeaderCompact}` : ""
        }`.trim()}
      >
        <div
          className={`${styles.groupTitleWrapper}${
            suppressGroupTitle ? ` ${styles.groupTitleWrapperMuted}` : ""
          }`.trim()}
        >
          <h3>
            <span className={styles.groupTitleText}>{groupName}</span>
            <WorkspaceGroupWidgetStatusBadges widgets={widgets} />
          </h3>
          {isArchivedGroupView ? (
            <span className={styles.archivedGroupBadge}>
              {t("welcome.archivedGroupBadge")}
            </span>
          ) : null}
        </div>
        <div className={styles.groupActionsWrapper}>
          {isArchivedGroupView ? (
            showRestoreGroup ? (
              <Button
                type="default"
                loading={restoreGroupLoading}
                onClick={handleRestoreGroup}
                className={styles.restoreGroupButton}
              >
                {t("welcome.restoreGroup")}
              </Button>
            ) : null
          ) : groupInteractionsEnabled ? (
          <Dropdown
            menu={{
              items: [
                {
                  key: "rename",
                  label: t("welcome.renameGroupMenu"),
                  onClick: () => onRenameGroup(groupId),
                  icon: <EditOutlined />,
                  disabled: !groupInteractionsEnabled,
                },
                ...(canMoveGroupToUser
                  ? [
                      {
                        key: "move-to-user",
                        label: t("welcome.moveGroupToUserMenu"),
                        onClick: openMoveGroupToUserModal,
                        icon: <TeamOutlined />,
                      },
                    ]
                  : []),
                ...(groupInteractionsEnabled
                  ? [
                      {
                        key: "archive",
                        label: t("welcome.archiveGroupMenu"),
                        onClick: handleArchiveGroupMenuClick,
                        icon: <InboxOutlined />,
                      },
                    ]
                  : []),
                {
                  type: "divider",
                },
                {
                  key: "delete",
                  label: t("welcome.deleteGroup"),
                  danger: true,
                  onClick: () => setIsDeleteGroupModalVisible(true),
                  icon: <CloseOutlined />,
                  disabled: !groupInteractionsEnabled,
                },
              ],
            }}
            trigger={["click"]}
            placement="bottomRight"
            overlayClassName="widget-actions-dropdown"
          >
            <Button
              type="text"
              icon={<MoreOutlined />}
              className={styles.groupMoreButton}
            />
          </Dropdown>
          ) : null}
        </div>
      </div>

      <DragDropContext onDragEnd={handleWidgetDragEnd}>
        <Droppable droppableId={`welcome-group-widgets-${groupId}`}>
          {(droppableProvided) => (
      <div
        ref={droppableProvided.innerRef}
        {...droppableProvided.droppableProps}
        className={`${styles.widgetsContainer}${
          copilotOpen ? ` ${styles.widgetsContainerCopilotOpen}` : ""
        }`}
      >
            {/* ============================================
                Progressive widget loading with status tracking
                - Load group containers immediately
                - Load widgets with status checking
                - Show skeleton loaders for in-progress widgets
                - Render widget when status becomes 'ready'
                ============================================ */}
            {widgets.length === 0 ? (
              !isArchivedGroupView && groupInteractionsEnabled ? (
                <GroupConfigureEmptyState
                  onConfigure={() => setIsAddWidgetModalVisible(true)}
                  disabled={isWorkspaceWidgetLimitReached}
                  disabledTooltip={
                    isWorkspaceWidgetLimitReached
                      ? t("welcome.maxWidgetsLimit", {
                          max: maxWorkspaceWidgets,
                        })
                      : undefined
                  }
                />
              ) : null
            ) : (
              widgets.map((widget, index) => (
                <Draggable
                  key={widget.id}
                  draggableId={String(widget.id)}
                  index={index}
                  isDragDisabled={
                    !workspaceContentEditable || widgetReorderLoading
                  }
                >
                  {(dragProvided, snapshot) => (
                <div
                  ref={(el) => {
                    dragProvided.innerRef(el);
                    widgetRefs.current[widget.id] = el;
                    if (el && intersectionObserverRef.current) {
                      intersectionObserverRef.current.observe(el);
                    }
                  }}
                  {...dragProvided.draggableProps}
                  id={workspaceWidgetDomId(widget.id)}
                  data-widget-id={widget.id}
                  className={`${styles.widgetCard} ${
                    Number(deepLinkHighlightWidgetId) === Number(widget.id)
                      ? styles.widgetCardDeepLinkHighlight
                      : ""
                  } ${
                    snapshot.isDragging ? styles.widgetCardDragging : ""
                  } ${
                    widget?.metricType === "competitive" ||
                    widget?.metric_id === 19
                      ? styles.competitiveWidget
                      : ""
                  } ${
                    isWelcomeFullGridRowWidget(widget)
                      ? styles.welcomeFullGridRow
                      : ""
                  } ${
                    welcomeWidgetUsesDoubleGridColumn(widget)
                      ? styles.welcomeDoubleGridColumn
                      : ""
                  }`}
                >
                      <div className={styles.widgetHeader}>
                        <div className={styles.widgetTitleSection}>
                          <div className={styles.widgetTitleRow}>
                            {workspaceContentEditable ? (
                              <span
                                {...dragProvided.dragHandleProps}
                                className={styles.widgetDragHandle}
                                title={t("welcome.widgetDragHandleHint")}
                                aria-label={t("welcome.widgetDragHandleHint")}
                              >
                                <HolderOutlined />
                              </span>
                            ) : null}
                            <InfoCircleOutlined
                              onClick={() => handleShowInfo(widget.id)}
                              className={styles.infoIcon}
                            />
                            <div className={styles.widgetTitleText}>
                              <h4 className={styles.widgetTitlePrimary}>
                                <span className={styles.widgetTitleName}>
                                  {resolveWidgetBaseDisplayName(widget)}
                                </span>
                                {(() => {
                                  const dateRange = formatWelcomeWidgetDateRangeLabel(
                                    widget,
                                    i18n.language,
                                  );
                                  return dateRange ? (
                                    <span className={styles.widgetTitleDateRange}>
                                      {dateRange}
                                    </span>
                                  ) : null;
                                })()}
                              </h4>
                              {(() => {
                                const meta = resolveWidgetTitleMeta(widget);
                                return meta ? (
                                  <p className={styles.widgetTitleMeta}>{meta}</p>
                                ) : null;
                              })()}
                            </div>
                          </div>
                        </div>
                        <div className={styles.widgetHeaderActions}>
                          <div className={styles.widgetStatusGroup}>
                          {widget?.status === "loading" && (
                            <div className={styles.statusBadge + " " + styles.statusLoading}>
                              <Spin size="small" style={{ marginRight: "6px" }} />
                              {t("welcome.widgetBadgeLoading")}
                            </div>
                          )}
                          {widget?.status === "error" &&
                          !welcomeWidgetFailedJobShowsContentState(widget) ? (
                            <div className={styles.statusBadge + " " + styles.statusError}>
                              ⚠ {t("welcome.widgetBadgeFailed")}
                            </div>
                          ) : null}
                          {widget?.status === "error" &&
                          welcomeWidgetFailedJobShowsContentState(widget) ? (
                            <div
                              className={
                                styles.statusBadge + " " + styles.statusInsufficient
                              }
                            >
                              {t("welcome.widgetBadgeInsufficient")}
                            </div>
                          ) : null}
                          {welcomeWidgetRenderAsReady(widget) &&
                          (showWelcomeKpiBlockingSpin(widget) ||
                            widgetRefreshLoading[widget.id] ||
                            widgetKpiLoading[widget.id]) ? (
                            <div className={styles.statusBadge + " " + styles.statusLoading}>
                              <Spin size="small" style={{ marginRight: "6px" }} />
                              {t("welcome.widgetBadgeDataLoading")}
                            </div>
                          ) : null}
                          {widget?.status === "ready" &&
                          !showWelcomeKpiBlockingSpin(widget) &&
                          !widgetRefreshLoading[widget.id] &&
                          !widgetKpiLoading[widget.id] ? (
                            (() => {
                              const insufficientCounts =
                                resolveWelcomeInsufficientReviewCounts(
                                  getWelcomeWidgetEffectiveKpiData(widget),
                                  widget?.metric_id,
                                  widget,
                                );
                              const emptyGenaiSignal =
                                welcomeWidgetShowsEmptyGenaiSignal(
                                  getWelcomeWidgetEffectiveKpiData(widget),
                                  widget,
                                );
                              if (insufficientCounts || emptyGenaiSignal) {
                                return (
                                  <div
                                    className={
                                      styles.statusBadge +
                                      " " +
                                      styles.statusInsufficient
                                    }
                                  >
                                    {t("welcome.widgetBadgeInsufficient")}
                                  </div>
                                );
                              }
                              return (
                                <div
                                  className={
                                    styles.statusBadge + " " + styles.statusReady
                                  }
                                >
                                  ✓ {t("welcome.widgetBadgeReady")}
                                </div>
                              );
                            })()
                          ) : null}
                          <WelcomeWidgetStatusTiming
                            widget={mergeWelcomeWidgetJobTimingFields(
                              widget,
                              welcomeMainDataPlan
                                .filter((p) => p.widgetRow.id === widget.id)
                                .map((p) => queryClient.getQueryData(p.queryKey))
                                .find(Boolean),
                            )}
                            t={t}
                            className={styles.statusBadgeTiming}
                            isPageDataLoading={resolveWelcomeWidgetPageDataLoadingForTiming(widget)}
                            isWidgetVisible={isWelcomeWidgetVisible?.(widget.id) ?? true}
                            progressClassNames={welcomeWidgetJobProgressClassNames}
                          />
                          </div>
                        {/* Three-dot menu for widget actions */}
                        <Dropdown
                          menu={{
                            items: [
                              {
                                key: "info",
                                label: t("welcome.widgetActionInfo"),
                                onClick: () => handleShowInfo(widget.id),
                                icon: <InfoCircleOutlined />,
                              },
                              {
                                key: "rename",
                                label: t("welcome.widgetActionRename"),
                                onClick: () => handleEditName(widget.id),
                                icon: <EditOutlined />,
                              },
                              ...(canEditInsightFromMenu(widget)
                                ? [
                                    {
                                      key: "edit-content",
                                      label: t("welcome.infoEditContent"),
                                      icon: <EditOutlined />,
                                      onClick: () => handleOpenInsightEditor(widget.id),
                                    },
                                  ]
                                : []),
                              ...(canEditSummaryTabsFromMenu(widget)
                                ? [
                                    {
                                      key: "edit-summary-tabs",
                                      label: t("welcome.editSummaryTabs"),
                                      icon: <FileTextOutlined />,
                                      onClick: () =>
                                        openSummaryTabsEditor(widget.id),
                                    },
                                  ]
                                : []),
                              ...(widgetSupportsOrgLlmPrompt(widget) &&
                              isEnterprisePowerUser
                                ? [
                                    {
                                      key: "editPrompt",
                                      label: t("welcome.editPrompt"),
                                      onClick: () => openPromptEditor(widget),
                                      icon: <EditOutlined />,
                                    },
                                  ]
                                : []),
                              {
                                key: "refresh-widget-data",
                                label: t("welcome.refreshWidgetData"),
                                icon: <SyncOutlined />,
                                disabled:
                                  widget.status === "loading" ||
                                  !!loadingWidgets[widget.id] ||
                                  !!widgetRefreshLoading[widget.id],
                                onClick: () =>
                                  handleWelcomeWidgetRefresh(widget.id),
                              },
                              ...(isWelcomeGenAiRegenerableWidget(widget)
                                ? [
                                    {
                                      key: "regenerate-ai",
                                      label: t("welcome.regenerateAiResults"),
                                      icon: <ThunderboltOutlined />,
                                      disabled:
                                        widget.status === "loading" ||
                                        !!loadingWidgets[widget.id],
                                      onClick: () => handleGenaiRequeue(widget.id),
                                    },
                                  ]
                                : isWelcomeRegenerableWidget(widget)
                                  ? [
                                      {
                                        key: "regenerate",
                                        label: t("welcome.regenerate"),
                                        icon: <ReloadOutlined />,
                                        disabled:
                                          widget.status === "loading" ||
                                          !!loadingWidgets[widget.id],
                                        onClick: () => handleGenaiRequeue(widget.id),
                                      },
                                    ]
                                  : []),
                              {
                                key: "move-up",
                                label: t("welcome.widgetActionMoveUp"),
                                icon: <ArrowUpOutlined />,
                                disabled:
                                  index === 0 ||
                                  widgetReorderLoading ||
                                  !workspaceContentEditable,
                                onClick: () => handleMoveWidgetStep(widget.id, -1),
                              },
                              {
                                key: "move-down",
                                label: t("welcome.widgetActionMoveDown"),
                                icon: <ArrowDownOutlined />,
                                disabled:
                                  index === widgets.length - 1 ||
                                  widgetReorderLoading ||
                                  !workspaceContentEditable,
                                onClick: () => handleMoveWidgetStep(widget.id, 1),
                              },
                              {
                                key: "move",
                                label: t("welcome.widgetActionMoveToGroup"),
                                icon: <SwapOutlined />,
                                onClick: () => openMoveWidgetModal(widget.id),
                              },
                              {
                                type: "divider",
                              },
                              {
                                key: "delete",
                                label: t("welcome.widgetActionDelete"),
                                danger: true,
                                onClick: () => handleRemoveWidget(widget.id),
                                icon: <CloseOutlined />,
                              },
                            ],
                          }}
                          trigger={["click"]}
                          placement="bottomRight"
                          overlayClassName="widget-actions-dropdown"
                        >
                          <Button
                            type="text"
                            icon={<MoreOutlined />}
                            className={styles.moreButton}
                          />
                        </Dropdown>
                        </div>
                      </div>

                      {/* ============================================
                          Widget Content Rendering:
                          - If status is 'loading': Show skeleton loader (Ant Design Skeleton)
                          - If status is 'ready': Render actual widget data
                          - If status is 'error': Show error message
                          ============================================ */}
                      {widget?.status === "loading" ||
                      loadingWidgets[widget.id] ? (
                        isWelcomeGenAiContentMetricWidget(widget) &&
                        widget?.status === "loading" ? (
                          <WelcomeWidgetGenaiPendingState
                            t={t}
                            widget={widget}
                            className={styles.widgetGenaiPending}
                            progressClassNames={welcomeWidgetJobProgressClassNames}
                          />
                        ) : (
                        <div className={styles.widgetLoading}>
                          <Skeleton active>
                            <div style={{ height: "300px" }}>
                              <Skeleton.Image
                                active
                                style={{ width: "100%", height: "250px" }}
                              />
                              <Skeleton active paragraph={{ rows: 2 }} />
                            </div>
                          </Skeleton>
                        </div>
                        )
                      ) : widget?.status === "error" &&
                        !welcomeWidgetFailedJobShowsContentState(widget) ? (
                        <WelcomeWidgetDataStateMessage
                          status={WELCOME_WIDGET_DATA_STATUS_FAILED}
                          t={t}
                          onRefresh={() => handleWelcomeWidgetRefresh(widget.id)}
                          refreshing={!!widgetRefreshLoading[widget.id]}
                          onRegenerate={
                            workspaceContentEditable &&
                            isWelcomeRegenerableWidget(widget)
                              ? () => handleGenaiRequeue(widget.id)
                              : undefined
                          }
                          regenerating={
                            widget.status === "loading" ||
                            !!loadingWidgets[widget.id]
                          }
                          failedClassName={styles.widgetDataLoadFailed}
                          failedActionsClassName={styles.widgetDataLoadFailedActions}
                        />
                      ) : welcomeWidgetRenderAsReady(widget) ? (
                        showWelcomeKpiBlockingSpin(widget) ||
                        widgetRefreshLoading[widget.id] ||
                        widgetKpiLoading[widget.id] ? (
                          <div className={styles.widgetKpiLoading}>
                            <Spin size="large" />
                          </div>
                        ) : (
                          <WelcomeWidgetRenderBody
                            widgetRow={widget}
                            locationSearch={location.search}
                            plan={welcomeMainDataPlan.find(
                              (p) => p.widgetRow.id === widget.id,
                            )}
                          />
                        )
                      ) : (
                        <WelcomeWidgetRenderBody
                          widgetRow={widget}
                          locationSearch={location.search}
                          plan={welcomeMainDataPlan.find(
                            (p) => p.widgetRow.id === widget.id,
                          )}
                        />
                      )}
                      {widget?.status === "ready" &&
                      welcomeWidgetSupportsGenaiFeedback(widget) ? (
                        <WelcomeGenaiFeedback
                          widget={{
                            ...widget,
                            data: getWelcomeWidgetEffectiveKpiData(widget),
                          }}
                          extraWidgetContext={{ source: "my_workspace" }}
                          disabled={!!loadingWidgets[widget.id]}
                          variant="footer"
                        />
                      ) : null}
                    </div>
                  )}
                </Draggable>
              ))
            )}
            {droppableProvided.placeholder}

            {/* Primary empty CTA is GroupConfigureEmptyState above; this covers
                archived / read-only empty groups only (avoid double empty UI). */}
            {widgets.length === 0 &&
            (isArchivedGroupView || !groupInteractionsEnabled) ? (
              <WelcomeGroupConfigureEmptyState
                t={t}
                onConfigure={() => setIsAddWidgetModalVisible(true)}
                configureDisabled={isWorkspaceWidgetLimitReached}
                limitTooltip={
                  isWorkspaceWidgetLimitReached
                    ? t("welcome.maxWidgetsLimit", {
                        max: maxWorkspaceWidgets,
                      })
                    : undefined
                }
                showConfigureAction={groupInteractionsEnabled}
              />
            ) : groupInteractionsEnabled && widgets.length > 0 ? (
              <div
                className={`${styles.addMetricCard}${
                  widgets.some(isWelcomeFullGridRowWidget)
                    ? ` ${styles.addMetricCardFullRow}`
                    : ""
                }`}
              >
                <Tooltip
                  title={
                    isWorkspaceWidgetLimitReached
                      ? t("welcome.maxWidgetsLimit", {
                          max: maxWorkspaceWidgets,
                        })
                      : undefined
                  }
                >
                  <span
                    style={
                      isWorkspaceWidgetLimitReached
                        ? { display: "inline-block", width: "100%" }
                        : undefined
                    }
                  >
                    <Button
                      type="primary"
                      size="large"
                      icon={<PlusOutlined />}
                      onClick={() => setIsAddWidgetModalVisible(true)}
                      className={styles.addMetricButtonInCard}
                      disabled={isWorkspaceWidgetLimitReached}
                    >
                      {t("welcome.addWidget")}
                    </Button>
                  </span>
                </Tooltip>
                <p className={styles.addMetricCardSubtext}>
                  {t("welcome.addWidgetSubtext")}
                </p>
              </div>
            ) : null}
          </div>
          )}
        </Droppable>
      </DragDropContext>

      {/* Widget Creation Modal */}
      <Modal
        title={(() => {
          const { milestones, activeIdx } = getWizardMilestones();
          const isBrandPivotStep = metricType === "brand" && currentStep === 5;
          return (
            <div className={styles.wizardModalHeader}>
              <div className={styles.wizardModalHeaderTop}>
                <span className={styles.wizardModalTitle}>{t("welcome.addMetricWizard")}</span>
                <span className={styles.wizardModalTitleSep}>|</span>
                <span className={styles.wizardModalStepName}>
                  {isBrandPivotStep
                    ? t("welcome.stepperPivotFilter")
                    : getCurrentStepLabel()}
                </span>
              </div>
              {isBrandPivotStep ? (
                <WelcomePivotCompressedStepper
                  activeStepNumber={activeIdx + 1}
                  activeLabel={t("welcome.stepperPivotFilter")}
                  completedLabel={t("welcome.pivotStepperCompleted", {
                    count: activeIdx,
                  })}
                  remainingLabel={t("welcome.pivotStepperRemaining", {
                    count: milestones.length - activeIdx - 1,
                  })}
                />
              ) : (
              <div className={styles.wizardStepper}>
                {milestones.map((m, idx) => {
                  const isDone = idx < activeIdx;
                  const isActive = idx === activeIdx;
                  return (
                    <React.Fragment key={idx}>
                      <div className={`${styles.wizardStepItem} ${isDone ? styles.wizardStepDone : isActive ? styles.wizardStepActive : styles.wizardStepUpcoming}`}>
                        <div className={styles.wizardStepCircle}>
                          {isDone ? <CheckOutlined /> : idx + 1}
                        </div>
                        {isActive && (
                          <span className={styles.wizardStepLabel}>{m.label}</span>
                        )}
                      </div>
                      {idx < milestones.length - 1 && (
                        <div className={`${styles.wizardStepLine} ${isDone ? styles.wizardStepLineDone : ""}`} />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
              )}
            </div>
          );
        })()}
        open={isAddWidgetModalVisible}
        onCancel={() => {
          if (isWidgetCreateSubmitting) {
            return;
          }
          handleCloseModal();
        }}
        maskClosable={false}
        closable={!isWidgetCreateSubmitting}
        keyboard={!isWidgetCreateSubmitting}
        footer={
          metricType === "brand" && currentStep === 5
            ? [
                <Button
                  className={styles.widgetModalSecondaryButton}
                  key="back"
                  onClick={() => handleNavigation("back")}
                  disabled={isWidgetCreateSubmitting}
                  icon={<LeftOutlined />}
                >
                  {t("common.back")}
                </Button>,
                <span key="pivot-footer-actions" className={styles.pivotWizardFooterRight}>
                  <Button
                    key="skip-pivot"
                    className={styles.widgetModalSecondaryButton}
                    onClick={handleSkipPivotStep}
                    disabled={isWidgetCreateSubmitting}
                  >
                    {t("welcome.pivotWizardSkipStep")}
                  </Button>
                  <Button
                    key="pivot-continue"
                    type="primary"
                    onClick={() => handleNavigation("next")}
                    className={styles.widgetModalPrimaryButton}
                  >
                    {t("welcome.pivotWizardContinue")}
                  </Button>
                </span>,
              ]
            : [
          <Button
            className={styles.widgetModalSecondaryButton}
            key="back"
            onClick={() => handleNavigation("back")}
            disabled={isWidgetCreateSubmitting}
            icon={
              currentStep > 1 ? <LeftOutlined /> : undefined
            }
          >
            {currentStep === 1 ? t("common.cancel") : t("common.back")}
          </Button>,
          <Button
            type="primary"
            key="next"
            onClick={() => handleNavigation("next")}
            className={styles.widgetModalPrimaryButton}
            loading={
              currentStep === getTotalSteps() && isWidgetCreateSubmitting
            }
            disabled={
              currentStep === getTotalSteps() &&
              metricType === "brand" &&
              welcomeReviewStepCreateBlocked()
            }
          >
            {currentStep === getTotalSteps()
              ? <>{t("common.create")} ✨</>
              : currentStep === 4 && metricType === "brand" && selectedBrandMetrics.size > 0
              ? t("welcome.addSelectedMetrics", { count: selectedBrandMetrics.size })
              : t("common.next")}
          </Button>,
        ]}
        width={740}
        className={`${styles.widgetModal} ${styles.widgetModalPivotStep}`}
        styles={{
          content: {
            maxHeight: "calc(100vh - 48px)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
          header: { flexShrink: 0 },
          body: {
            flex: "1 1 auto",
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            padding: "24px",
          },
          footer: { flexShrink: 0 },
        }}
      >
        {/* Step 1: Metric Type Selection */}
        {currentStep === 1 && (
          <div className={styles.metricSelection}>
            <h4>{t("welcome.selectMetricType")}</h4>
            <div className={styles.metricOptions}>
              <div
                className={`${styles.metricOption} ${
                  metricType === "account" ? styles.selected : ""
                }`}
                onClick={() => setMetricType("account")}
              >
                <div className={styles.metricIcon}>
                  <TeamOutlined />
                </div>
                <div className={styles.metricContent}>
                  <h5>{t("welcome.accountMetric")}</h5>
                  <p>{t("welcome.accountMetricDesc")}</p>
                </div>
              </div>
              <div
                className={`${styles.metricOption} ${
                  metricType === "brand" ? styles.selected : ""
                }`}
                onClick={() => setMetricType("brand")}
              >
                <div className={styles.metricIcon}>
                  <DashboardOutlined />
                </div>
                <div className={styles.metricContent}>
                  <h5>{t("welcome.brandMetric")}</h5>
                  <p>{t("welcome.brandMetricDesc")}</p>
                </div>
              </div>
              <div
                className={`${styles.metricOption} ${
                  metricType === "competitive" ? styles.selected : ""
                }`}
                onClick={() => setMetricType("competitive")}
              >
                <div className={styles.metricIcon}>
                  <ThunderboltOutlined />
                </div>
                <div className={styles.metricContent}>
                  <h5>{t("welcome.competitiveMetric")}</h5>
                  <p>{t("welcome.competitiveMetricDesc")}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Step 2: Brand Selection (for Brand metrics) */}
        {currentStep === 2 && metricType === "brand" && (
          <div className={styles.metricSelection}>
            <h4>
              {t("welcome.selectBrand")}
              <Tooltip title={t("welcome.selectBrandHintLong")} placement="right">
                <InfoCircleOutlined className={styles.stepTitleInfoIcon} />
              </Tooltip>
            </h4>
            <p className={styles.stepHelperText}>{t("welcome.selectBrandHint")}</p>
            {loadingBrands ? (
              <div className={styles.brandGroupLoading}>
                <Spin size="small" />
              </div>
            ) : (
              <div className={styles.brandGroupList}>
                {brands.map((brand) => {
                  const isSelected =
                    Array.isArray(selectedBrand)
                      ? selectedBrand.includes(brand.groupId)
                      : selectedBrand === brand.groupId;
                  return (
                    <div
                      key={brand.groupId}
                      className={`${styles.brandGroupCard} ${isSelected ? styles.selected : ""}`}
                      onClick={() =>
                        setSelectedBrand(isSelected ? [] : [brand.groupId])
                      }
                    >
                      <div className={styles.brandGroupCardInner}>
                        <span className={styles.brandGroupName}>{brand.name}</span>
                        {brand.dashboardCount != null && (
                          <span className={styles.brandGroupCount}>
                            {brand.dashboardCount} {t("welcome.dashboardsCount")}
                          </span>
                        )}
                      </div>
                      {isSelected && (
                        <CheckOutlined className={styles.brandGroupCheck} />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Step 2: Brand Selection (for Competitive metrics) */}
        {currentStep === 2 && metricType === "competitive" && (
          <div className={styles.metricSelection}>
            <h4>{t("welcome.selectBrands")}</h4>
            <p className={styles.stepHelperText}>{t("welcome.selectBrandHint")}</p>
            {loadingBrands ? (
              <div className={styles.brandGroupLoading}>
                <Spin size="small" />
              </div>
            ) : (
              <div className={styles.brandGroupList}>
                {brands.map((brand) => {
                  const isSelected = Array.isArray(selectedBrands)
                    ? selectedBrands.includes(brand.groupId)
                    : false;
                  return (
                    <div
                      key={brand.groupId}
                      className={`${styles.brandGroupCard} ${isSelected ? styles.selected : ""}`}
                      onClick={() =>
                        setSelectedBrands((prev) => {
                          const arr = Array.isArray(prev) ? prev : [];
                          return isSelected
                            ? arr.filter((id) => id !== brand.groupId)
                            : [...arr, brand.groupId];
                        })
                      }
                    >
                      <div className={styles.brandGroupCardInner}>
                        <span className={styles.brandGroupName}>{brand.name}</span>
                        {brand.dashboardCount != null && (
                          <span className={styles.brandGroupCount}>
                            {brand.dashboardCount} {t("welcome.dashboardsCount")}
                          </span>
                        )}
                      </div>
                      {isSelected && (
                        <CheckOutlined className={styles.brandGroupCheck} />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Step 2: Account Metrics Selection (for Account metrics) */}
        {currentStep === 2 && metricType === "account" && (
          <div className={styles.accountMetricsOptions}>
            {accountMetricsOptions.map((option, idx) => (
              <div
                key={option.value}
                className={`${styles.accountMetricOption} ${
                  selectedAccountMetric === option.value ||
                  (!selectedAccountMetric && idx === 0)
                    ? styles.selected
                    : ""
                }`}
                onClick={() => {
                  setNewWidgetType(option.preferedView);
                  setSelectedAccountMetric(option.value);
                }}
              >
                <div className={styles.optionIcon}>{option.icon}</div>
                <div className={styles.optionLabel}>{option.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* Step 3: Dashboard Selection (Brand + Competitive) */}
        {currentStep === 3 && (metricType === "brand" || metricType === "competitive") && (() => {
          const filteredDashboards = dashboards.filter((d) =>
            d.name.toLowerCase().includes(dashboardSearch.toLowerCase())
          );
          const allSelected = dashboards.length > 0 && dashboards.every((d) => selectedDashboards.includes(d.id));
          const toggleDashboard = (id) => {
            setSelectedDashboards((prev) =>
              prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
            );
          };
          const selectAll = () => setSelectedDashboards(dashboards.map((d) => d.id));
          const clearAll = () => setSelectedDashboards([]);
          return (
            <div className={styles.dashboardPicker}>
              {/* Selected chips */}
              <div className={styles.dashboardChipInput}>
                {selectedDashboards.map((id) => {
                  const d = dashboards.find((x) => x.id === id);
                  if (!d) return null;
                  return (
                    <span key={id} className={styles.dashboardChip}>
                      {d.name}
                      <button
                        className={styles.dashboardChipRemove}
                        onClick={() => toggleDashboard(id)}
                        aria-label="Remove"
                      >×</button>
                    </span>
                  );
                })}
                <input
                  className={styles.dashboardChipInputField}
                  placeholder={selectedDashboards.length === 0 ? t("welcome.selectDashboardsPlaceholder") : ""}
                  value={dashboardSearch}
                  onChange={(e) => setDashboardSearch(e.target.value)}
                />
                <SearchOutlined className={styles.dashboardChipInputIcon} />
              </div>

              {/* List */}
              <div className={styles.dashboardPickerList}>
                {loadingDashboards ? (
                  <div className={styles.dashboardPickerLoading}><Spin size="small" /></div>
                ) : filteredDashboards.length === 0 ? (
                  <div className={styles.dashboardPickerEmpty}>{t("common.noData")}</div>
                ) : (
                  filteredDashboards.map((d) => {
                    const checked = selectedDashboards.includes(d.id);
                    return (
                      <div
                        key={d.id}
                        className={`${styles.dashboardPickerItem} ${checked ? styles.dashboardPickerItemChecked : ""}`}
                        onClick={() => toggleDashboard(d.id)}
                      >
                        <input
                          type="checkbox"
                          className={styles.dashboardPickerCheckbox}
                          checked={checked}
                          onChange={() => toggleDashboard(d.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <span className={styles.dashboardPickerItemName}>{d.name}</span>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Select All / Clear All */}
              {!loadingDashboards && dashboards.length > 0 && (
                <div className={styles.dashboardPickerActions}>
                  <button
                    className={styles.dashboardPickerActionBtn}
                    onClick={allSelected ? clearAll : selectAll}
                  >
                    {allSelected ? t("welcome.clearAll") : t("welcome.selectAll")}
                  </button>
                  {selectedDashboards.length > 0 && !allSelected && (
                    <>
                      <span className={styles.dashboardPickerActionSep}>|</span>
                      <button className={styles.dashboardPickerActionBtn} onClick={clearAll}>
                        {t("welcome.clearAll")}
                      </button>
                    </>
                  )}
                </div>
              )}

              <p className={styles.dashboardPickerHint}>{t("welcome.dashboardPickerHint")}</p>
            </div>
          );
        })()}

        {/* Step 4: Brand metric — pivot on next step */}
        {currentStep === 4 && metricType === "brand" && (
          <div className={styles.metricSelectionV2}>
            <div className={styles.metricSearchWrap}>
              <SearchOutlined className={styles.metricSearchIcon} />
              <input
                className={styles.metricSearchInput}
                placeholder={t("welcome.searchMetrics")}
                value={metricSearchQuery}
                onChange={(e) => setMetricSearchQuery(e.target.value)}
              />
            </div>
            <div className={styles.metricSelectAllRow}>
              <button
                className={styles.metricSelectAllBtn}
                onClick={() => {
                  const allIds = brandMetricsOptions
                    .flatMap((g) => g.metrics)
                    .filter((m) => !(m.requiresMarketIntelligence && !canAccessMarketIntelligence))
                    .map((m) => m.value);
                  setSelectedBrandMetrics(new Set(allIds));
                }}
              >
                {t("welcome.selectAll")}
              </button>
              <span className={styles.metricSelectAllDivider}>|</span>
              <button
                className={styles.metricSelectAllBtn}
                onClick={() => setSelectedBrandMetrics(new Set())}
              >
                {t("welcome.deselectAll")}
              </button>
            </div>
            <div className={styles.metricCategoryList}>
              {brandMetricsOptions.map((categoryGroup) => {
                const filtered = categoryGroup.metrics.filter((m) =>
                  !metricSearchQuery ||
                  m.label.toLowerCase().includes(metricSearchQuery.toLowerCase()) ||
                  t(m.descKey).toLowerCase().includes(metricSearchQuery.toLowerCase())
                );
                if (!filtered.length) return null;
                return (
                  <div key={categoryGroup.category} className={styles.metricCategorySection}>
                    <h5 className={styles.metricCategoryHeading}>
                      {categoryGroup.category}
                    </h5>
                    <div className={styles.metricCardGrid}>
                      {filtered.map((option) => {
                        const isSelected = selectedBrandMetrics.has(option.value);
                        const planLocked =
                          option.requiresMarketIntelligence &&
                          !canAccessMarketIntelligence;
                        const card = (
                          <div
                            key={option.value}
                            className={`${styles.metricCardV2} ${isSelected ? styles.selected : ""} ${
                              planLocked ? styles.planLocked : ""
                            }`}
                            onClick={() => {
                              if (planLocked) return;
                              toggleBrandMetric(option.value);
                              setQuotaDaysRange("last7d");
                              setQuotaSince("");
                              setQuotaUntil("");
                              setQuotaDateRange(["", ""]);
                              setQuotaCheckResult(null);
    setMetricCreditPreview(null);
    setMetricCreditPreviewLoading(false);
    setAiCreditConfirmOpen(false);
                              setQuotaCheckLoading(false);
                            }}
                          >
                            <div className={`${styles.metricCardIconWrap} ${isSelected ? styles.selected : ""}`}>
                              {option.icon}
                            </div>
                            <div className={styles.metricCardBody}>
                              <div className={styles.metricCardTop}>
                                <span className={styles.metricCardLabel}>
                                  {option.label}
                                  {option.isAi && (
                                    <Tooltip title={option.aiTooltip} placement="top">
                                      <span className={styles.metricSparkle}>✦</span>
                                    </Tooltip>
                                  )}
                                </span>
                                <div className={styles.metricCardBadges}>
                                  {AI_SUMMARY_METRIC_IDS.includes(option.value) && (
                                    metricCreditPreviewLoading ? (
                                      <span className={styles.metricCreditBadgeLoading}>
                                        <Spin size="small" />
                                      </span>
                                    ) : (
                                      (() => {
                                        const creditCost = getBillableMetricCreditCost(option.value);
                                        if (!creditCost) return null;
                                        return (
                                          <span className={styles.metricCreditBadge}>
                                            {t("welcome.metricCreditUsesAi")}
                                          </span>
                                        );
                                      })()
                                    )
                                  )}
                                  {option.isNew && !isSelected && (
                                    <span className={styles.metricNewBadge}>{t("welcome.badgeNew")}</span>
                                  )}
                                  {isSelected && (
                                    <span className={styles.metricSelectedLabel}>
                                      <CheckOutlined /> {t("welcome.badgeSelected")}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <p className={styles.metricCardDesc}>{t(option.descKey)}</p>
                            </div>
                          </div>
                        );
                        if (!planLocked) {
                          return card;
                        }
                        return (
                          <Tooltip
                            key={option.value}
                            title={t("welcome.desPlanRequiredTooltip")}
                            placement="top"
                          >
                            {card}
                          </Tooltip>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Step 6: Topics — required multi for hierarchical summaries; optional multi otherwise */}
        {currentStep === 6 && metricType === "brand" && (
          <div className={styles.metricSelection}>
            {[...selectedBrandMetrics].some((m) =>
              WELCOME_BRAND_MULTITOPIC_WIZARD_METRIC_IDS.has(m),
            ) ? (
              <>
                <h4>{t("welcome.brandAiTopicsStepTitle")}</h4>
                <p className={styles.stepHelperText}>
                  {t("welcome.brandAiTopicsStepHint")}
                  {selectedBrandMetricsNeedDistTopics(selectedBrandMetrics)
                    ? ` ${t("welcome.brandAiTopicsAlsoForDistributionHint")}`
                    : ""}
                </p>
                <SearchableTopicChecklist
                  options={(brandDashboardCategories || []).map((c) => ({
                    id: Number(c.categoryId ?? c.category),
                    label: String(c.name ?? c.category ?? ""),
                  }))}
                  value={selectedBrandAiTopicIds}
                  onChange={setSelectedBrandAiTopicIds}
                  loading={loadingBrandCategories}
                  placeholder={t("welcome.searchAvailableTopics")}
                />
              </>
            ) : selectedBrandMetricsNeedDistTopics(selectedBrandMetrics) ? (
              <>
                <h4 className={styles.brandTopicStepHeading}>
                  {t("welcome.brandRequiredTopicsStepTitle")}
                </h4>
                <p className={styles.stepHelperText}>
                  {t("welcome.brandRequiredTopicsStepHint")}
                </p>
                <div
                  id="welcome-brand-required-topics"
                  style={{ marginTop: 8 }}
                  aria-label={t("welcome.brandRequiredTopicsFieldLabel")}
                >
                  <SearchableTopicChecklist
                    options={(brandDashboardCategories || []).map((c) => ({
                      id: Number(c.categoryId ?? c.category),
                      label: String(c.name ?? c.category ?? ""),
                    }))}
                    value={selectedBrandOptionalTopicIds}
                    onChange={setSelectedBrandOptionalTopicIds}
                    loading={loadingBrandCategories}
                    placeholder={t("welcome.searchAvailableTopics")}
                  />
                </div>
              </>
            ) : (
              <>
                <h4 className={styles.brandTopicStepHeading}>
                  {t("welcome.brandOptionalTopicsStepTitle")}
                </h4>
                <p className={styles.stepHelperText}>
                  {t("welcome.brandOptionalTopicsStepHint")}
                </p>
                <div
                  id="welcome-brand-optional-topics"
                  style={{ marginTop: 8 }}
                  aria-label={t("welcome.brandOptionalTopicsFieldLabel")}
                >
                  <SearchableTopicChecklist
                    options={(brandDashboardCategories || []).map((c) => ({
                      id: Number(c.categoryId ?? c.category),
                      label: String(c.name ?? c.category ?? ""),
                    }))}
                    value={selectedBrandOptionalTopicIds}
                    onChange={setSelectedBrandOptionalTopicIds}
                    loading={loadingBrandCategories}
                    placeholder={t("welcome.searchAvailableTopics")}
                  />
                </div>
              </>
            )}
          </div>
        )}

        {/* Step 4: Competition Type Selection (for Competitive metrics) */}
        {currentStep === 4 && metricType === "competitive" && (
          <div className={styles.metricSelection}>
            <h4>{t("welcome.selectCompetitionType")}</h4>
            <div className={styles.metricOptions}>
              {competitionTypes.map((option, idx) => (
                <div
                  key={option.value}
                  className={`${styles.metricOption} ${
                    competitionType === option.value ||
                    (!competitionType && idx === 0)
                      ? styles.selected
                      : ""
                  }`}
                  onClick={() => setCompetitionType(option.value)}
                >
                  <div className={styles.metricContent}>
                    <h5>{option.label}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Step 5: Topics Selection (for Competitive metrics) */}
        {currentStep === 5 &&
          metricType === "competitive" &&
          competitionType !== 4 && (
            <div className={styles.metricSelection}>
              <h4>{t("welcome.selectSentiment")}</h4>
              <Select
                placeholder={t("welcome.selectSentiment")}
                value={selectedSentiment}
                onChange={setSelectedSentiment}
                className={styles.selectSentiment}
                dropdownRender={(menu) => (
                  <div
                    onMouseLeave={() => {
                      if (document.activeElement) {
                        document.activeElement.blur();
                      }
                    }}
                  >
                    {menu}
                  </div>
                )}
              >
                {sentimentTypes.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>

              <h4 style={{ marginTop: "20px" }}>
                {t("welcome.selectTopics")}
              </h4>
              <SearchableTopicChecklist
                options={(availableTopics || []).map((topic) => ({
                  id: topic.categoryId,
                  label: topic.name,
                }))}
                value={selectedTopics}
                onChange={setSelectedTopics}
                loading={loadingTopics}
                placeholder={t("welcome.searchAvailableTopics")}
              />
            </div>
          )}

        {/* Step 5: Pivot selection — redesigned optional filter step */}
        {currentStep === 5 && metricType === "brand" && (
          <WelcomePivotWizardStep
            levelWiseOptions={pivotLevelOptions}
            levelWiseSelections={pivotLevelSelections}
            setLevelWiseSelections={setPivotLevelSelections}
            loading={pivotsLoading}
          />
        )}

        {/* Step 7: Date range — all brand metrics */}
        {currentStep === 7 &&
          metricType === "brand" &&
          needsBrandDateRangeStep() && (
          <div className={styles.dateRangeStep}>
            <p className={styles.dateRangeStepHint}>{t("welcome.selectDateRangeDesc")}</p>
            <div className={styles.datePresetGrid}>
              {quotaRangePresets.map((val) => {
                const s = dayjs().subtract(val.days, "days").format("YYYY-MM-DD");
                const u = dayjs().format("YYYY-MM-DD");
                const isSelected = quotaDaysRange === val.id;
                return (
                  <div
                    key={val.id}
                    className={`${styles.datePresetCard} ${isSelected ? styles.datePresetCardSelected : ""}`}
                    onClick={() => {
                      setQuotaDaysRange(val.id);
                      setQuotaSince(s);
                      setQuotaUntil(u);
                      setQuotaDateRange([s, u]);
                    }}
                  >
                    <CalendarOutlined className={styles.datePresetIcon} />
                    <span className={styles.datePresetLabel}>{val.label}</span>
                    <span className={styles.datePresetRange}>{s} – {u}</span>
                  </div>
                );
              })}
              <div
                className={`${styles.datePresetCard} ${quotaDaysRange === "custom" ? styles.datePresetCardSelected : ""}`}
                onClick={() => {
                  setQuotaDaysRange("custom");
                  if (!quotaSince || !quotaUntil) {
                    const today = dayjs().format("YYYY-MM-DD");
                    setQuotaSince(today);
                    setQuotaUntil(today);
                    setQuotaDateRange([today, today]);
                  }
                }}
              >
                <CalendarOutlined className={styles.datePresetIcon} />
                <span className={styles.datePresetLabel}>{t("filter.20") || "Custom"}</span>
                <span className={styles.datePresetRange}>{t("welcome.dateRangeCustomHint")}</span>
              </div>
            </div>
            {quotaDaysRange === "custom" && (
              <div className={styles.dateCustomPickers}>
                <div className={styles.dateCustomPickerGroup}>
                  <label className={styles.dateCustomPickerLabel}>{t("welcome.startDate")}</label>
                  <DatePicker
                    value={quotaSince ? dayjs(quotaSince, "YYYY-MM-DD") : null}
                    onChange={(date, dateString) => {
                      setQuotaSince(dateString);
                      setQuotaDateRange([dateString, quotaUntil]);
                    }}
                    allowClear={false}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className={styles.dateCustomPickerGroup}>
                  <label className={styles.dateCustomPickerLabel}>{t("welcome.endDate")}</label>
                  <DatePicker
                    value={quotaUntil ? dayjs(quotaUntil, "YYYY-MM-DD") : null}
                    onChange={(date, dateString) => {
                      setQuotaUntil(dateString);
                      setQuotaDateRange([quotaSince, dateString]);
                    }}
                    allowClear={false}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {/* Step 8: Review & Create */}
        {currentStep === 8 && metricType === "brand" && (() => {
          const showAiQuota = needsQuotaCheck();
          const nonBillableMetricIds = getSelectedNonBillableMetricIds();
          const aiQuotaBlocksBillableCreate =
            showAiQuota &&
            !quotaCheckLoading &&
            welcomeAiCreditsInsufficient(quotaCheckResult);
          const mixedMetricAiQuotaBlocked =
            aiQuotaBlocksBillableCreate && nonBillableMetricIds.length > 0;
          const reviewDayCount = quotaSince && quotaUntil
            ? dayjs(quotaUntil).diff(dayjs(quotaSince), "day") + 1
            : null;
          const sourceNames = selectedDashboards.length > 0
            ? dashboards.filter((d) => selectedDashboards.includes(d.id)).map((d) => d.name).join(", ")
            : t("welcome.reviewSummaryNotSelected");
          const metricNames = selectedBrandMetrics.size > 0
            ? [...selectedBrandMetrics].map((m) => findBrandMetric(m)?.label ?? `#${m}`).join(", ")
            : t("welcome.reviewSummaryNotSelected");
          const pivotKeyLabel = deriveWelcomePivotTitleDetail({
            pivot_filter: pivotSelectionsToFilter(pivotLevelSelections),
            pivot_key: Object.keys(pivotSelectionsToFilter(pivotLevelSelections) || {})[0],
            pivot_values: Object.values(
              pivotSelectionsToFilter(pivotLevelSelections) || {},
            )[0],
          }) || null;
          const creditBreakdownText = showAiQuota
            ? formatWelcomeAiCreditBreakdown(quotaCheckResult, t, { pivotKeyLabel })
            : null;
          const scopedReviewTotal = Number(quotaCheckResult?.total_review_count);
          const genaiReviewBlocked = welcomeGenaiReviewsInsufficient(quotaCheckResult);
          const genaiCreditsBlocked = welcomeAiCreditsInsufficient(quotaCheckResult);
          const reviewScopeCapped = showAiQuota && isWelcomeGenaiReviewScopeCapped(scopedReviewTotal);
          const quotaReviewNf = new Intl.NumberFormat(
            getIntlLocale(i18n.language),
          );

          const renderReviewScopeFooter = () => {
            if (!Number.isFinite(scopedReviewTotal)) return null;
            return (
              <div className={styles.quotaCardV2Footer}>
                <span>
                  {reviewScopeCapped
                    ? formatWelcomeReviewScopeLabel(t, quotaReviewNf, {
                        analyzed: WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                        scopeTotal: scopedReviewTotal,
                        capped: true,
                        limit: WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                      })
                    : t("welcome.quotaScopedReviewCount", {
                        count: scopedReviewTotal,
                        dashboards:
                          quotaCheckResult?.accessible_dashboards_count || 1,
                      })}
                </span>
                <button
                  type="button"
                  className={styles.quotaRecheckLink}
                  onClick={checkQuotaForWidget}
                >
                  {t("welcome.recheckQuota")}
                </button>
              </div>
            );
          };

          const renderQuotaCycleSummary = () => {
            const { total, used, available } =
              resolveWelcomeQuotaDisplayCredits(quotaCheckResult);
            if (total == null || total <= 0) return null;
            const usedVal =
              used != null ? used : Math.max(0, total - (available ?? 0));
            return (
              <div className={styles.quotaCreditBreakdown}>
                {t("welcome.aiCreditsCycleSummary", {
                  total,
                  used: usedVal,
                  remaining: available ?? 0,
                })}
              </div>
            );
          };

          return (
            <div className={styles.reviewCreateStep}>
              {/* Request Summary Cards */}
              <p className={styles.reviewCreateTitle}>{t("welcome.reviewSelectionTitle")}</p>
              <div className={styles.requestSummaryCards}>
                <div className={styles.requestSummaryCard}>
                  <div className={styles.requestSummaryCardIcon}><DashboardOutlined /></div>
                  <div className={styles.requestSummaryCardLabel}>{t("welcome.reviewSummaryMetric").toUpperCase()}</div>
                  <div className={styles.requestSummaryCardValue}>{metricNames}</div>
                </div>
                <div className={styles.requestSummaryCard}>
                  <div className={styles.requestSummaryCardIcon}><FileTextOutlined /></div>
                  <div className={styles.requestSummaryCardLabel}>{t("welcome.reviewSummaryDashboards").toUpperCase()}</div>
                  <div className={styles.requestSummaryCardValue}>{sourceNames}</div>
                  {renderWelcomePivotReviewTags(pivotLevelSelections, t, styles)}
                </div>
                <div className={styles.requestSummaryCard}>
                  <div className={styles.requestSummaryCardIcon}><CalendarOutlined /></div>
                  <div className={styles.requestSummaryCardLabel}>{t("welcome.reviewSummaryDateRange").toUpperCase()}</div>
                  <div className={styles.requestSummaryCardValue}>
                    {quotaSince && quotaUntil
                      ? `${quotaSince} – ${quotaUntil}${reviewDayCount ? ` (${reviewDayCount} ${t("common.days")})` : ""}`
                      : t("welcome.reviewSummaryNotSelected")}
                  </div>
                </div>
              </div>

              <p className={styles.reviewCreateTitle}>
                {showAiQuota
                  ? t("welcome.aiQuotaCheckTitle")
                  : t("welcome.reviewScopeCheckTitle")}
              </p>

              {!showAiQuota ? (
                <div className={`${styles.quotaCardV2} ${
                  quotaCheckLoading || !quotaCheckResult
                    ? styles.quotaCardV2Loading
                    : styles.quotaCardV2Success
                }`}>
                  {quotaCheckLoading ? (
                    <div className={styles.quotaCardV2Inner}>
                      <Spin size="small" />
                      <span style={{ marginLeft: 10, color: "#888" }}>
                        {t("welcome.checkingReviewScope")}...
                      </span>
                    </div>
                  ) : !quotaCheckResult ? (
                    <div className={styles.quotaCardV2Inner}>
                      <span style={{ color: "#888" }}>{t("welcome.preparingQuotaCheck")}...</span>
                    </div>
                  ) : quotaCheckResult?.error ? (
                    <div className={styles.quotaCardV2Inner}>
                      <CloseCircleOutlined className={styles.quotaCardV2ErrorIcon} />
                      <span style={{ marginLeft: 10 }}>{t("welcome.reviewScopeCheckFailed")}</span>
                      <button
                        type="button"
                        className={styles.quotaCardV2Recheck}
                        onClick={checkQuotaForWidget}
                      >
                        <ReloadOutlined />
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className={styles.quotaCardV2Header}>
                        <div className={styles.quotaCardV2Status}>
                          <CheckOutlined className={styles.quotaCardV2StatusIcon} />
                          <span className={styles.quotaCardV2StatusText}>
                            {t("welcome.zeroAiCreditsWillUse")}
                          </span>
                        </div>
                        <button
                          type="button"
                          className={styles.quotaCardV2Recheck}
                          onClick={checkQuotaForWidget}
                        >
                          <ReloadOutlined />
                        </button>
                      </div>
                      <div className={styles.quotaCardV2Body}>
                        <p className={styles.quotaCreditBreakdown}>
                          {t("welcome.zeroAiCreditsHint")}
                        </p>
                        {renderWelcomeQuotaCreditPills(
                          quotaCheckResult,
                          t,
                          styles,
                          "success",
                        )}
                        {renderReviewScopeFooter()}
                      </div>
                    </>
                  )}
                </div>
              ) : (
              <>
              {/* AI Quota Check */}
              {!quotaCheckLoading && quotaCheckResult?.welcome_genai_insufficient_reviews && (
                <Alert type="warning" showIcon style={{ marginBottom: 12 }}
                  message={t("welcome.quotaGenaiTooFewReviews", {
                    count: Number(quotaCheckResult.total_review_count) || 0,
                    min: quotaCheckResult.welcome_genai_minimum_reviews ?? 3,
                  })}
                />
              )}

              {mixedMetricAiQuotaBlocked && (
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={t("welcome.partialAiQuotaCreateBlocked", {
                    aiCount: getSelectedBillableAiMetricIds().length,
                    standardCount: nonBillableMetricIds.length,
                  })}
                />
              )}

              {!quotaCheckLoading &&
                reviewScopeCapped &&
                !genaiReviewBlocked &&
                !genaiCreditsBlocked && (
                  <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 12 }}
                    message={t("welcome.quotaGenaiReviewCapWarningTitle")}
                    description={t("welcome.quotaGenaiReviewCapWarning", {
                      total: quotaReviewNf.format(scopedReviewTotal),
                      limit: quotaReviewNf.format(
                        WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                      ),
                    })}
                  />
                )}

              <div className={`${styles.quotaCardV2} ${
                quotaCheckLoading || !quotaCheckResult ? styles.quotaCardV2Loading
                : genaiReviewBlocked ? styles.quotaCardV2Error
                : genaiCreditsBlocked ? styles.quotaCardV2Error
                : quotaCheckResult?.sufficient === true ? styles.quotaCardV2Success
                : styles.quotaCardV2Warning
              }`}>
                {quotaCheckLoading ? (
                  <div className={styles.quotaCardV2Inner}>
                    <Spin size="small" />
                    <span style={{ marginLeft: 10, color: "#888" }}>{t("welcome.checkingQuota")}...</span>
                  </div>
                ) : !quotaCheckResult ? (
                  <div className={styles.quotaCardV2Inner}>
                    <span style={{ color: "#888" }}>{t("welcome.preparingQuotaCheck")}...</span>
                  </div>
                ) : genaiReviewBlocked ? (
                  <>
                    <div className={styles.quotaCardV2Header}>
                      <div className={styles.quotaCardV2Status}>
                        <CloseCircleOutlined className={styles.quotaCardV2ErrorIcon} />
                        <span className={`${styles.quotaCardV2StatusText} ${styles.quotaCardV2StatusTextError}`}>
                          {t("welcome.quotaGenaiTooFewReviews", {
                            count: Number(quotaCheckResult.total_review_count) || 0,
                            min: quotaCheckResult.welcome_genai_minimum_reviews ?? 3,
                          })}
                        </span>
                      </div>
                      <button className={styles.quotaCardV2Recheck} onClick={checkQuotaForWidget}>
                        <ReloadOutlined />
                      </button>
                    </div>
                    <div className={styles.quotaCardV2Body}>
                      {renderWelcomeQuotaCreditPills(
                        quotaCheckResult,
                        t,
                        styles,
                        genaiCreditsBlocked ? "insufficient" : "success",
                      )}
                      {creditBreakdownText && (
                        <div className={styles.quotaCreditBreakdown}>{creditBreakdownText}</div>
                      )}
                      {renderQuotaCycleSummary()}
                      {renderReviewScopeFooter()}
                    </div>
                  </>
                ) : genaiCreditsBlocked ? (
                  <>
                    <div className={styles.quotaCardV2Header}>
                      <div className={styles.quotaCardV2Status}>
                        <CloseCircleOutlined className={styles.quotaCardV2ErrorIcon} />
                        <span className={`${styles.quotaCardV2StatusText} ${styles.quotaCardV2StatusTextError}`}>
                          {t("welcome.insufficientQuota")}
                        </span>
                      </div>
                      <button className={styles.quotaCardV2Recheck} onClick={checkQuotaForWidget}><ReloadOutlined /></button>
                    </div>
                    <div className={styles.quotaCardV2Body}>
                      {renderWelcomeQuotaCreditPills(
                        quotaCheckResult,
                        t,
                        styles,
                        "insufficient",
                      )}
                      {creditBreakdownText && (
                        <div className={styles.quotaCreditBreakdown}>{creditBreakdownText}</div>
                      )}
                      {renderQuotaCycleSummary()}
                      {renderReviewScopeFooter()}
                      <div className={styles.quotaInsufficientAction}>
                        <WarningOutlined className={styles.quotaInsufficientActionIcon} />
                        <span>{t("welcome.contactAdminForQuota")}</span>
                      </div>
                    </div>
                  </>
                ) : quotaCheckResult?.sufficient === true ? (
                  <>
                    <div className={styles.quotaCardV2Header}>
                      <div className={styles.quotaCardV2Status}>
                        <CheckOutlined className={styles.quotaCardV2StatusIcon} />
                        <span className={styles.quotaCardV2StatusText}>
                          {quotaCheckResult?.unlimited ? t("welcome.unlimitedQuota") : t("welcome.quotaVerified")}
                        </span>
                      </div>
                      <button className={styles.quotaCardV2Recheck} onClick={checkQuotaForWidget}>
                        <ReloadOutlined />
                      </button>
                    </div>
                    {!quotaCheckResult?.unlimited && (
                      <div className={styles.quotaCardV2Body}>
                        {renderWelcomeQuotaCreditPills(
                          quotaCheckResult,
                          t,
                          styles,
                          "success",
                        )}
                        {creditBreakdownText && (
                          <div className={styles.quotaCreditBreakdown}>{creditBreakdownText}</div>
                        )}
                        {renderQuotaCycleSummary()}
                        {Number.isFinite(scopedReviewTotal) && (
                          <div className={styles.quotaCardV2Footer}>
                            <span>
                              {reviewScopeCapped
                                ? formatWelcomeReviewScopeLabel(
                                    t,
                                    quotaReviewNf,
                                    {
                                      analyzed:
                                        WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                                      scopeTotal: scopedReviewTotal,
                                      capped: true,
                                      limit: WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                                    },
                                  )
                                : t("welcome.quotaScopedReviewCount", {
                                    count: scopedReviewTotal,
                                    dashboards:
                                      quotaCheckResult?.accessible_dashboards_count ||
                                      1,
                                  })}
                            </span>
                            <button className={styles.quotaRecheckLink} onClick={checkQuotaForWidget}>{t("welcome.recheckQuota")}</button>
                          </div>
                        )}
                        {quotaCheckResult?.reset_date && (
                          <div className={styles.quotaResetDate}>
                            {t("welcome.quotaResetsOn", { date: new Date(quotaCheckResult.reset_date).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" }) })}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : quotaCheckResult?.applicable === false ? (
                  <div className={styles.quotaCardV2Inner}>
                    <InfoCircleOutlined style={{ color: "#faad14", fontSize: 16 }} />
                    <span style={{ marginLeft: 10 }}>{resolveQuotaNotApplicableMessage(quotaCheckResult, t)}</span>
                  </div>
                ) : null}
              </div>
              </>
              )}
            </div>
          );
        })()}
      </Modal>

      <Modal
        title={t("welcome.aiCreditConfirmTitle")}
        open={aiCreditConfirmOpen}
        onCancel={() => setAiCreditConfirmOpen(false)}
        onOk={() => {
          aiCreditConfirmedRef.current = true;
          setAiCreditConfirmOpen(false);
          if (aiCreditConfirmTargetStep === "create") {
            createWidget(groupId, metricType);
          } else if (Number.isFinite(Number(aiCreditConfirmTargetStep))) {
            setCurrentStep(Number(aiCreditConfirmTargetStep));
          } else {
            setCurrentStep((s) => s + 1);
          }
          setAiCreditConfirmTargetStep(null);
        }}
        okText={t("welcome.aiCreditConfirmOk")}
        cancelText={t("welcome.aiCreditConfirmCancel")}
        destroyOnClose
      >
        <p style={{ margin: 0, lineHeight: 1.55 }}>
          {aiCreditConfirmMeta.credit_mode === "review"
            ? t("welcome.aiCreditConfirmBodyReview", {
                review_count: aiCreditConfirmMeta.review_count,
                credits: aiCreditConfirmMeta.total_credits,
                chunk: aiCreditConfirmMeta.review_chunk,
              })
            : t("welcome.aiCreditConfirmBody", {
                hotel_count: aiCreditConfirmMeta.hotel_count,
              })}
        </p>
      </Modal>

      {/* Widget Modal Info display */}
      <Modal
        title={null}
        className={styles.widgetInfoPopupModal}
        open={isWidgetInfoModalVisible}
        onCancel={() => {
          setIsWidgetInfoModalVisible(false);
          setWidgetInfo(null);
        }}
        width={800}
        destroyOnClose
        closeIcon={null}
        footer={
          <Button
            type="primary"
            className={styles.widgetInfoFooterClose}
            onClick={() => {
              setIsWidgetInfoModalVisible(false);
              setWidgetInfo(null);
            }}
          >
            {t("welcome.infoClose")}
          </Button>
        }
      >
        {widgetInfo ? (() => {
          const infoWidgetRow = widgets.find(
            (w) => Number(w.id) === Number(widgetInfo.widget_id),
          );
          return (
          <div className={styles.widgetInfoModalContent}>
            <div className={styles.widgetInfoTitleBox}>
              <span className={styles.widgetInfoTitleLeft}>
                <InfoCircleOutlined className={styles.widgetInfoTitleIcon} />
                <span>{t("welcome.widgetInfoTitle")}</span>
              </span>
              <Button
                type="text"
                icon={<CloseOutlined />}
                className={styles.widgetInfoTitleClose}
                onClick={() => {
                  setIsWidgetInfoModalVisible(false);
                  setWidgetInfo(null);
                }}
              />
            </div>

            <div className={styles.widgetInfoBelowContent}>
              <div className={styles.widgetInfoColumns}>
                <div className={styles.widgetInfoColumn}>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <TeamOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoName")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {resolveWidgetInfoDisplayName(widgetInfo, t, infoWidgetRow)}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <FileTextOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoRepresentationType")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {widgetInfo["Representation Type"] ?? "—"}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <ThunderboltOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoJobLabel")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {renderJobStatusTag(widgetInfo.job_status)}
                    </span>
                  </div>
                  {Number(widgetInfo.job_status) === 3 &&
                    widgetInfo.ready_duration_seconds != null &&
                    Number.isFinite(Number(widgetInfo.ready_duration_seconds)) && (
                      <div className={styles.widgetInfoItem}>
                        <span className={styles.widgetInfoItemLabel}>
                          <ThunderboltOutlined className={styles.widgetInfoItemIcon} />
                          {Number.isFinite(Number(widgetInfo.queued_duration_seconds)) &&
                          Number.isFinite(Number(widgetInfo.processing_duration_seconds))
                            ? t("welcome.infoJobReadyDurationSplit")
                            : t("welcome.infoJobReadyDuration")}
                        </span>
                        <span className={styles.widgetInfoItemValue}>
                          {Number.isFinite(Number(widgetInfo.queued_duration_seconds)) &&
                          Number.isFinite(Number(widgetInfo.processing_duration_seconds)) ? (
                            <>
                              {formatWelcomeWidgetDuration(
                                widgetInfo.ready_duration_seconds,
                                t,
                              )}
                              {" "}
                              (
                              {formatWelcomeWidgetDuration(
                                widgetInfo.queued_duration_seconds,
                                t,
                              )}
                              {" / "}
                              {formatWelcomeWidgetDuration(
                                widgetInfo.processing_duration_seconds,
                                t,
                              )}
                              )
                            </>
                          ) : (
                            formatWelcomeWidgetDuration(
                              widgetInfo.ready_duration_seconds,
                              t,
                            )
                          )}
                        </span>
                      </div>
                    )}

                  <div
                    className={`${styles.widgetInfoSection} ${styles.widgetInfoSectionInColumn}`}
                  >
                    <h4 className={styles.widgetInfoSectionTitle}>
                      {t("welcome.infoSectionDateRange")}
                    </h4>
                    {widgetInfo.since || widgetInfo.until ? (
                      <div className={styles.widgetInfoDateRangeBox}>
                        <div className={styles.widgetInfoDateRangeItem}>
                          <span className={styles.widgetInfoDateRangeLabel}>
                            <CalendarOutlined
                              className={styles.widgetInfoDateRangeLabelIcon}
                              aria-hidden
                            />
                            {t("welcome.infoDateStart")}
                          </span>
                          <span className={styles.widgetInfoDateRangeValue}>
                            {widgetInfo.since
                              ? formatWidgetInfoDate(widgetInfo.since)
                              : "—"}
                          </span>
                        </div>
                        <div className={styles.widgetInfoDateRangeItem}>
                          <span className={styles.widgetInfoDateRangeLabel}>
                            <CalendarOutlined
                              className={styles.widgetInfoDateRangeLabelIcon}
                              aria-hidden
                            />
                            {t("welcome.infoDateEnd")}
                          </span>
                          <span className={styles.widgetInfoDateRangeValue}>
                            {widgetInfo.until
                              ? formatWidgetInfoDate(widgetInfo.until)
                              : "—"}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <span className={styles.widgetInfoMutedText}>
                        {t("welcome.infoNoDateStored")}
                      </span>
                    )}
                  </div>

                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <TeamOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoBrands")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {formatInfoList(widgetInfo.brands) ??
                        t("welcome.infoNoSources")}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <UnorderedListOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoTopics")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {formatInfoList(widgetInfo.Topics) ??
                        t("welcome.infoNoTopics")}
                    </span>
                  </div>

                  <div
                    className={`${styles.widgetInfoSection} ${styles.widgetInfoSectionInColumn}`}
                  >
                    <h4 className={styles.widgetInfoSectionTitle}>
                      {t("welcome.infoSectionPivot")}
                    </h4>
                    {(() => {
                      const rowPivotFilter = resolveWelcomeWidgetPivotFilter(
                        infoWidgetRow,
                        widgetInfo,
                      );
                      const booleanExpr =
                        formatWelcomePivotFilterBooleanExpr(rowPivotFilter);
                      if (!booleanExpr) {
                        return (
                          <span className={styles.widgetInfoMutedText}>
                            {t("welcome.infoNoPivot")}
                          </span>
                        );
                      }
                      return (
                        <>
                          <div className={styles.widgetInfoPivotBooleanLabel}>
                            {t("welcome.pivotFilterBooleanLogic").toUpperCase()}
                          </div>
                          <div className={styles.widgetInfoPivotBooleanExpr}>
                            {booleanExpr}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>

                <div className={styles.widgetInfoColumn}>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <FileTextOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoWidgetType")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {resolveWidgetInfoMetricTypeName(widgetInfo, t, infoWidgetRow)}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <DashboardOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoMetricType")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {widgetInfo["metric Type"] ?? "—"}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <ClockCircleOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoCreatedAt")}
                    </span>
                    <span
                      className={styles.widgetInfoItemValue}
                      title={
                        widgetInfo.created_at
                          ? undefined
                          : t("welcome.infoCreatedUnknown")
                      }
                    >
                      {widgetInfo.created_at
                        ? formatWidgetInfoDateTime(widgetInfo.created_at)
                        : "—"}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <DashboardOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoDashboards")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {formatInfoList(widgetInfo.dashboards) ??
                        t("welcome.infoNoSources")}
                    </span>
                  </div>
                  <div className={styles.widgetInfoItem}>
                    <span className={styles.widgetInfoItemLabel}>
                      <DatabaseOutlined className={styles.widgetInfoItemIcon} />
                      {t("welcome.infoNumReviews")}
                    </span>
                    <span className={styles.widgetInfoItemValue}>
                      {(() => {
                        const nfInfo = new Intl.NumberFormat(
                          getIntlLocale(i18n.language),
                        );
                        const scope = resolveWelcomeReviewScopeFromData(
                          widgetInfo,
                          widgetInfo,
                        );
                        const cappedLabel = formatWelcomeReviewScopeLabel(
                          t,
                          nfInfo,
                          scope,
                        );
                        if (cappedLabel) return cappedLabel;
                        if (
                          widgetInfo.review_count_total != null &&
                          widgetInfo.review_count_total !== ""
                        ) {
                          return t("welcome.infoNumReviewsTotal", {
                            count: nfInfo.format(
                              Number(widgetInfo.review_count_total),
                            ),
                          });
                        }
                        return "—";
                      })()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {(widgetInfo.widget_id != null || infoWidgetRow?.id != null) && (
              <div className={styles.widgetInfoWidgetId}>
                {t("welcome.infoWidgetId", {
                  id: widgetInfo.widget_id ?? infoWidgetRow?.id,
                })}
              </div>
            )}
          </div>
          );
        })() : null}
      </Modal>

      <Modal
        title={null}
        className={styles.editContentModal}
        open={isInsightEditorModalVisible}
        onCancel={handleCloseInsightEditor}
        width="min(896px, 80vw)"
        destroyOnClose
        closeIcon={null}
        footer={null}
      >
        <div className={styles.editContentModalShell}>
          <div className={styles.editContentHeader}>
            <h3 className={styles.editContentTitle}>{t("welcome.infoEditContent")}</h3>
            <Button
              type="text"
              icon={<CloseOutlined />}
              className={styles.editContentCloseButton}
              onClick={handleCloseInsightEditor}
            />
          </div>

          <div className={styles.editContentBody}>
            <div className={styles.editContentPanel}>
              <h4 className={styles.editContentSectionTitle}>{insightEditorModeTitle}</h4>

              {insightFieldsReadOnly ? (
                <Alert
                  type="info"
                  showIcon
                  message={t("welcome.editContentReadOnlyUser")}
                  style={{ marginBottom: 12 }}
                />
              ) : null}

              {insightLoading ? (
                <div className={styles.editContentLoading}>
                  <Spin size="small" />
                </div>
              ) : insightError ? (
                <span className={styles.widgetInfoMutedText}>{insightError}</span>
              ) : isNarrativeInsight ? (
                <div className={styles.editContentNarrativeWrap}>
                  <Input.TextArea
                    rows={10}
                    value={insightSummaryDraft}
                    onChange={(e) => setInsightSummaryDraft(e.target.value)}
                    className={styles.editContentNarrativeEditor}
                    readOnly={insightFieldsReadOnly}
                  />
                </div>
              ) : isTableInsight ? (
                insightTableColumns.length > 0 && insightTableRows.length > 0 ? (
                  <div className={styles.editContentCardsEditor}>
                    <div className={styles.editContentCardsScroll}>
                      {insightTableRows.map((row, rowIndex) => {
                        const cardIdRaw = String(
                          row?.rc_id ?? row?.ID ?? rowIndex + 1,
                        ).trim();
                        const cardId = cardIdRaw || String(rowIndex + 1);
                        const bodyCols = getInsightEditCardBodyColumnKeys(
                          insightTableColumns,
                        );
                        const isM20 = insightEditWidgetMetricId === 20;
                        const rootCol =
                          insightTableColumns.find((c) =>
                            String(c).toLowerCase().includes("root_cause"),
                          ) || "root_cause";
                        const recCol =
                          insightTableColumns.find((c) =>
                            String(c).toLowerCase().includes("recommendation"),
                          ) || "recommendation";

                        const metric20Fields = isM20 ? (
                          <>
                            <div className={styles.editContentCardField}>
                              <div
                                className={`${styles.editContentCardFieldLabel} ${styles.editContentCardFieldLabelEmphasis}`}
                              >
                                {t("welcome.rootCauseCardProblem")}
                              </div>
                              <Input.TextArea
                                autoSize={{ minRows: 2, maxRows: 12 }}
                                value={String(row?.[rootCol] ?? "")}
                                onChange={(e) =>
                                  handleInsightTableCellChange(
                                    rowIndex,
                                    rootCol,
                                    e.target.value,
                                  )
                                }
                                className={styles.editContentCardTextArea}
                                readOnly={insightFieldsReadOnly}
                              />
                            </div>
                            <div className={styles.editContentCardField}>
                              <div
                                className={`${styles.editContentCardFieldLabel} ${styles.editContentCardFieldLabelEmphasis}`}
                              >
                                {t("welcome.rootCauseCardSolution")}
                              </div>
                              <div
                                className={styles.editContentCardRecommendationBox}
                              >
                                <Input.TextArea
                                  autoSize={{ minRows: 2, maxRows: 12 }}
                                  value={String(row?.[recCol] ?? "")}
                                  onChange={(e) =>
                                    handleInsightTableCellChange(
                                      rowIndex,
                                      recCol,
                                      e.target.value,
                                    )
                                  }
                                  className={styles.editContentCardTextArea}
                                  readOnly={insightFieldsReadOnly}
                                />
                              </div>
                            </div>
                          </>
                        ) : null;

                        return (
                          <div
                            key={`insight-edit-card-${rowIndex}`}
                            className={styles.editContentCard}
                          >
                            <div className={styles.editContentCardHeader}>
                              <span
                                className={styles.editContentCardId}
                                title={cardId}
                              >
                                #{cardId}
                              </span>
                            </div>
                            {isM20 ? (
                              metric20Fields
                            ) : (
                              bodyCols.map((column) => {
                                const colLower = String(column).toLowerCase();
                                const isRec = colLower.includes("recommendation");
                                const isRoot = colLower.includes("root_cause");
                                const labelText = isRoot
                                  ? t("welcome.rootCauseCardProblem")
                                  : isRec
                                    ? t("welcome.rootCauseCardSolution")
                                    : getInsightEditTableColumnLabel(
                                        column,
                                        insightEditWidgetMetricId,
                                        t,
                                      );
                                const cellStr = String(row?.[column] ?? "");
                                const long = isLongTextInsightColumn(column);
                                const fieldInner = long ? (
                                  <Input.TextArea
                                    autoSize={{ minRows: 2, maxRows: 12 }}
                                    value={cellStr}
                                    onChange={(e) =>
                                      handleInsightTableCellChange(
                                        rowIndex,
                                        column,
                                        e.target.value,
                                      )
                                    }
                                    className={styles.editContentCardTextArea}
                                    readOnly={insightFieldsReadOnly}
                                  />
                                ) : (
                                  <Input
                                    value={cellStr}
                                    onChange={(e) =>
                                      handleInsightTableCellChange(
                                        rowIndex,
                                        column,
                                        e.target.value,
                                      )
                                    }
                                    className={styles.editContentCardInput}
                                    readOnly={insightFieldsReadOnly}
                                  />
                                );
                                return (
                                  <div
                                    key={`${rowIndex}-${column}`}
                                    className={styles.editContentCardField}
                                  >
                                    <div
                                      className={`${styles.editContentCardFieldLabel} ${
                                        isRoot || isRec
                                          ? styles.editContentCardFieldLabelEmphasis
                                          : ""
                                      }`}
                                    >
                                      {labelText}
                                    </div>
                                    {isRec ? (
                                      <div
                                        className={
                                          styles.editContentCardRecommendationBox
                                        }
                                      >
                                        {fieldInner}
                                      </div>
                                    ) : (
                                      fieldInner
                                    )}
                                  </div>
                                );
                              })
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <span className={styles.widgetInfoMutedText}>
                    {insightSourceReviewCount != null
                      ? t("welcome.infoNoRootCauseForPeriodWithCount", {
                          count: insightSourceReviewCount,
                        })
                      : t("welcome.infoRootCauseReviewCountUnavailable")}
                  </span>
                )
              ) : (
                <span className={styles.widgetInfoMutedText}>
                  {t("welcome.infoNoAiContent")}
                </span>
              )}
            </div>
          </div>

          <div className={styles.editContentFooter}>
            <Button
              className={styles.editContentFooterCancel}
              type="default"
              ghost
              onClick={handleCloseInsightEditor}
              disabled={insightSaveLoading}
            >
              {t("welcome.infoCancelEdit")}
            </Button>
            <Button
              className={styles.editContentFooterSave}
              type="primary"
              onClick={handleSaveInsightEdit}
              loading={insightSaveLoading}
              disabled={
                insightLoading || !canEditInsight || !isInsightDirty
              }
            >
              {t("welcome.infoSaveAllChanges")}
            </Button>
          </div>
        </div>
      </Modal>

      {/* Regenerate Quota Confirmation Modal */}
      <Modal
        title={t("welcome.regenerateQuotaTitle")}
        open={regenerateQuotaModalOpen}
        onOk={handleConfirmRegenerate}
        onCancel={closeRegenerateQuotaModal}
        okText={
          regenerateQuotaWidget &&
          isWelcomeGenAiRegenerableWidget(regenerateQuotaWidget)
            ? t("welcome.regenerateAiResults")
            : t("welcome.regenerate")
        }
        cancelText={t("common.cancel")}
        width={760}
        destroyOnClose
        confirmLoading={!!loadingWidgets[regenerateQuotaWidget?.id]}
        okButtonProps={{
          disabled:
            regenerateQuotaLoading ||
            !regenerateQuotaResult ||
            regenerateQuotaResult?.error === true ||
            regenerateQuotaResult?.sufficient === false ||
            regenerateQuotaResult?.applicable === false ||
            regenerateQuotaResult?.welcome_genai_insufficient_reviews === true,
        }}
      >
        {(() => {
          const widget = regenerateQuotaWidget;
          const payload = widget ? buildRegenerateQuotaPayload(widget) : null;
          const dateRangeText = payload?.start_date && payload?.end_date
            ? `${payload.start_date} – ${payload.end_date}`
            : t("welcome.reviewSummaryNotSelected");
          // Prefer names resolved by the quota-check API (dashboard_details).
          // While loading, fall back to the local dashboards cache, then bare ID.
          const dashboardText = payload?.dashboard_ids?.length
            ? payload.dashboard_ids
                .map((id) => {
                  const fromResult = regenerateQuotaResult?.dashboard_details?.find(
                    (d) => String(d.dashboard_id) === String(id)
                  )?.dashboard_name;
                  if (fromResult) return fromResult;
                  const fromCache = dashboards.find((d) => String(d.id) === String(id))?.name;
                  if (fromCache) return fromCache;
                  return regenerateQuotaLoading ? `#${id}` : `#${id}`;
                })
                .join(", ")
            : t("welcome.reviewSummaryNotSelected");
          const regeneratePivotKeyLabel =
            deriveWelcomePivotTitleDetail(widget) || null;
          const regenerateCreditBreakdownText = formatWelcomeAiCreditBreakdown(
            regenerateQuotaResult,
            t,
            { pivotKeyLabel: regeneratePivotKeyLabel },
          );
          const regenerateScopedReviewTotal = Number(
            regenerateQuotaResult?.total_review_count,
          );
          const regenerateReviewScopeCapped = isWelcomeGenaiReviewScopeCapped(
            regenerateScopedReviewTotal,
          );
          const regenerateQuotaReviewNf = new Intl.NumberFormat(
            getIntlLocale(i18n.language),
          );

          return (
            <div className={styles.reviewCreateStep}>
              <p className={styles.reviewCreateTitle}>{t("welcome.regenerateQuotaSubtitle")}</p>
              {widget && isWelcomeGenAiRegenerableWidget(widget) ? (
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 16 }}
                  message={t("welcome.regenerateAiCreditNote")}
                />
              ) : null}
              <div className={styles.requestSummaryCards}>
                <div className={styles.requestSummaryCard}>
                  <div className={styles.requestSummaryCardIcon}><ReloadOutlined /></div>
                  <div className={styles.requestSummaryCardLabel}>
                    {t("welcome.reviewSummaryMetric").toUpperCase()}
                  </div>
                  <div className={styles.requestSummaryCardValue}>
                    {widget ? resolveWidgetDisplayName(widget) : t("welcome.reviewSummaryNotSelected")}
                  </div>
                </div>
                <div className={styles.requestSummaryCard}>
                  <div className={styles.requestSummaryCardIcon}><FileTextOutlined /></div>
                  <div className={styles.requestSummaryCardLabel}>
                    {t("welcome.reviewSummaryDashboards").toUpperCase()}
                  </div>
                  <div className={styles.requestSummaryCardValue}>{dashboardText}</div>
                  {renderWelcomePivotReviewTags(
                    pivotFilterToLevelSelections(welcomePivotFilterFromWidget(widget)),
                    t,
                    styles,
                  )}
                </div>
                <div className={styles.requestSummaryCard}>
                  <div className={styles.requestSummaryCardIcon}><CalendarOutlined /></div>
                  <div className={styles.requestSummaryCardLabel}>
                    {t("welcome.reviewSummaryDateRange").toUpperCase()}
                  </div>
                  <div className={styles.requestSummaryCardValue}>{dateRangeText}</div>
                </div>
              </div>

              <p className={styles.reviewCreateTitle}>{t("welcome.aiQuotaCheckTitle")}</p>
              {!regenerateQuotaLoading && regenerateQuotaResult?.welcome_genai_insufficient_reviews && (
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={t("welcome.quotaGenaiTooFewReviews", {
                    count: Number(regenerateQuotaResult.total_review_count) || 0,
                    min: regenerateQuotaResult.welcome_genai_minimum_reviews ?? 3,
                  })}
                />
              )}

              {!regenerateQuotaLoading &&
                regenerateReviewScopeCapped &&
                regenerateQuotaResult?.sufficient === true && (
                  <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 12 }}
                    message={t("welcome.quotaGenaiReviewCapWarningTitle")}
                    description={t("welcome.quotaGenaiReviewCapWarning", {
                      total: regenerateQuotaReviewNf.format(
                        regenerateScopedReviewTotal,
                      ),
                      limit: regenerateQuotaReviewNf.format(
                        WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                      ),
                    })}
                  />
                )}

              <div className={`${styles.quotaCardV2} ${
                regenerateQuotaLoading || !regenerateQuotaResult ? styles.quotaCardV2Loading
                : regenerateQuotaResult?.sufficient === true ? styles.quotaCardV2Success
                : regenerateQuotaResult?.sufficient === false ? styles.quotaCardV2Error
                : styles.quotaCardV2Warning
              }`}>
                {regenerateQuotaLoading ? (
                  <div className={styles.quotaCardV2Inner}>
                    <Spin size="small" />
                    <span style={{ marginLeft: 10, color: "#888" }}>
                      {t("welcome.checkingQuota")}...
                    </span>
                  </div>
                ) : !regenerateQuotaResult ? (
                  <div className={styles.quotaCardV2Inner}>
                    <span style={{ color: "#888" }}>{t("welcome.preparingQuotaCheck")}...</span>
                  </div>
                ) : regenerateQuotaResult?.sufficient === true ? (
                  <>
                    <div className={styles.quotaCardV2Header}>
                      <div className={styles.quotaCardV2Status}>
                        <CheckOutlined className={styles.quotaCardV2StatusIcon} />
                        <span className={styles.quotaCardV2StatusText}>
                          {regenerateQuotaResult?.unlimited
                            ? t("welcome.unlimitedQuota")
                            : t("welcome.quotaVerified")}
                        </span>
                      </div>
                      <button
                        className={styles.quotaCardV2Recheck}
                        onClick={() => regenerateQuotaWidget && checkQuotaForRegenerateWidget(regenerateQuotaWidget, { forceModal: true })}
                      >
                        <ReloadOutlined />
                      </button>
                    </div>
                    {!regenerateQuotaResult?.unlimited && (
                      <div className={styles.quotaCardV2Body}>
                        {renderWelcomeQuotaCreditPills(
                          regenerateQuotaResult,
                          t,
                          styles,
                          "success",
                        )}
                        {regenerateCreditBreakdownText && (
                          <div className={styles.quotaCreditBreakdown}>
                            {regenerateCreditBreakdownText}
                          </div>
                        )}
                        {Number.isFinite(regenerateScopedReviewTotal) && (
                          <div className={styles.quotaCardV2Footer}>
                            <span>
                              {regenerateReviewScopeCapped
                                ? formatWelcomeReviewScopeLabel(
                                    t,
                                    regenerateQuotaReviewNf,
                                    {
                                      analyzed:
                                        WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                                      scopeTotal: regenerateScopedReviewTotal,
                                      capped: true,
                                      limit: WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                                    },
                                  )
                                : t("welcome.quotaScopedReviewCount", {
                                    count: regenerateScopedReviewTotal,
                                    dashboards:
                                      regenerateQuotaResult?.accessible_dashboards_count ||
                                      1,
                                  })}
                            </span>
                            <button
                              className={styles.quotaRecheckLink}
                              onClick={() => regenerateQuotaWidget && checkQuotaForRegenerateWidget(regenerateQuotaWidget, { forceModal: true })}
                            >
                              {t("welcome.recheckQuota")}
                            </button>
                          </div>
                        )}
                        {regenerateQuotaResult?.reset_date && (
                          <div className={styles.quotaResetDate}>
                            {t("welcome.quotaResetsOn", {
                              date: new Date(regenerateQuotaResult.reset_date).toLocaleDateString("tr-TR", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              }),
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : regenerateQuotaResult?.sufficient === false ? (
                  <>
                    <div className={styles.quotaCardV2Header}>
                      <div className={styles.quotaCardV2Status}>
                        <CloseCircleOutlined className={styles.quotaCardV2ErrorIcon} />
                        <span className={`${styles.quotaCardV2StatusText} ${styles.quotaCardV2StatusTextError}`}>
                          {t("welcome.insufficientQuota")}
                        </span>
                      </div>
                      <button
                        className={styles.quotaCardV2Recheck}
                        onClick={() => regenerateQuotaWidget && checkQuotaForRegenerateWidget(regenerateQuotaWidget, { forceModal: true })}
                      >
                        <ReloadOutlined />
                      </button>
                    </div>
                    <div className={styles.quotaCardV2Body}>
                      {renderWelcomeQuotaCreditPills(
                        regenerateQuotaResult,
                        t,
                        styles,
                        "insufficient",
                      )}
                      {regenerateCreditBreakdownText && (
                        <div className={styles.quotaCreditBreakdown}>
                          {regenerateCreditBreakdownText}
                        </div>
                      )}
                      {Number.isFinite(regenerateScopedReviewTotal) && (
                        <div className={styles.quotaCardV2Footer}>
                          <span>
                            {regenerateReviewScopeCapped
                              ? formatWelcomeReviewScopeLabel(
                                  t,
                                  regenerateQuotaReviewNf,
                                  {
                                    analyzed: WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                                    scopeTotal: regenerateScopedReviewTotal,
                                    capped: true,
                                    limit: WELCOME_GENAI_ANALYSIS_REVIEW_LIMIT,
                                  },
                                )
                              : t("welcome.quotaScopedReviewCount", {
                                  count: regenerateScopedReviewTotal,
                                  dashboards:
                                    regenerateQuotaResult?.accessible_dashboards_count || 1,
                                })}
                          </span>
                        </div>
                      )}
                      <div className={styles.quotaInsufficientAction}>
                        <WarningOutlined className={styles.quotaInsufficientActionIcon} />
                        <span>{t("welcome.contactAdminForQuota")}</span>
                      </div>
                    </div>
                  </>
                ) : regenerateQuotaResult?.applicable === false ? (
                  <div className={styles.quotaCardV2Inner}>
                    <InfoCircleOutlined style={{ color: "#faad14", fontSize: 16 }} />
                    <span style={{ marginLeft: 10 }}>
                      {resolveQuotaNotApplicableMessage(regenerateQuotaResult, t)}
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })()}
      </Modal>

      {/* Widget Name Edit Modal */}
      <Modal
        title={t("welcome.editWidgetName")}
        open={isEditNameModalVisible}
        onOk={handleSaveName}
        onCancel={() => {
          setIsEditNameModalVisible(false);
          setEditingWidgetId(null);
          setNewWidgetName("");
        }}
      >
        <Input
          value={newWidgetName}
          onChange={(e) => setNewWidgetName(e.target.value)}
          placeholder={t("welcome.enterWidgetName")}
        />
      </Modal>

      <Modal
        title={t("welcome.moveWidgetTitle")}
        open={moveModalOpen}
        onCancel={closeMoveWidgetModal}
        footer={null}
        destroyOnClose
        width={480}
        closable={!moveLoading}
        maskClosable={!moveLoading}
      >
        <p className={styles.moveWidgetHint}>{t("welcome.moveWidgetHint")}</p>
        <div className={styles.moveWidgetGroupList}>
          {[...(groups || [])]
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((g) => {
              const isCurrent = g.id === groupId;
              const widgetCount = Array.isArray(g.widgets) ? g.widgets.length : 0;
              return (
                <button
                  key={g.id}
                  type="button"
                  className={`${styles.moveWidgetGroupRow}${isCurrent ? ` ${styles.moveWidgetGroupRowCurrent}` : ""}`}
                  disabled={isCurrent || moveLoading}
                  onClick={() => handleMoveWidget(g.id)}
                >
                  <span className={styles.moveWidgetGroupName}>
                    {g.name || `${t("welcome.enterGroupNameLabel")} #${g.id}`}
                  </span>
                  <span className={styles.moveWidgetGroupMeta}>
                    {isCurrent ? (
                      <Tag color="blue">{t("welcome.moveWidgetCurrentGroup")}</Tag>
                    ) : (
                      <span className={styles.moveWidgetGroupCount}>
                        {t("welcome.moveWidgetGroupWidgetCount", { count: widgetCount })}
                      </span>
                    )}
                  </span>
                </button>
              );
            })}
        </div>
      </Modal>

      <Modal
        title={
          <span className={styles.promptEditorModalTitle}>
            {t("welcome.editPrompt")}
            {promptWidget?.name
              ? ` — ${formatNameForPromptModalChrome(promptWidget.name)}`
              : ""}
          </span>
        }
        open={promptModalVisible}
        onCancel={closePromptEditor}
        width={1120}
        centered
        destroyOnClose
        wrapClassName={styles.promptEditorModal}
        styles={{
          content: {
            maxHeight: "calc(100vh - 48px)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
          body: {
            flex: "1 1 auto",
            minHeight: 0,
            overflowY: "auto",
          },
        }}
        footer={
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {!promptCanEdit && (
              <Alert type="info" showIcon message={t("welcome.promptViewOnlyNotice")} />
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              {promptCanEdit ? (
                <Button
                  key="download"
                  icon={<DownloadOutlined />}
                  disabled={promptLoading}
                  onClick={downloadPromptsCsv}
                >
                  {t("welcome.downloadPrompts")}
                </Button>
              ) : null}
              <Button
                key="cancel"
                className={styles.promptModalCancelBtn}
                onClick={closePromptEditor}
              >
                {t("common.cancel")}
              </Button>
              {promptCanEdit ? (
                <Button
                  key="save"
                  type="primary"
                  loading={promptSaving}
                  onClick={savePromptEditor}
                >
                  {t("common.save")}
                </Button>
              ) : null}
            </div>
          </div>
        }
      >
        <Spin spinning={promptLoading}>
          <div className={styles.promptBuilderLayout}>
            <aside className={styles.promptVariableSidebar}>
              <div className={styles.promptVariableSidebarTitle}>
                <PanelLeft size={15} />
                {t("welcome.promptVarsPanelTitle")}
              </div>
              {getPromptVariableGroupsForMetric(promptWidget?.metric_id).map((group) => (
                <div key={group.key} className={styles.promptVariableGroup}>
                  <h5>{t(group.titleKey)}</h5>
                  <div className={styles.promptVariableButtons}>
                    {group.items.map((item) => (
                      <Tooltip key={item.token} title={t(item.descriptionKey)} placement="right">
                        <button
                          type="button"
                          className={styles.promptVariableButton}
                          disabled={!promptCanEdit}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => insertPromptVariable(item.token)}
                        >
                          <Braces size={13} />
                          {item.token}
                        </button>
                      </Tooltip>
                    ))}
                  </div>
                </div>
              ))}
            </aside>

            <div className={styles.promptFlowPanel}>
              <div className={styles.promptModeTabRow}>
                <button
                  type="button"
                  className={`${styles.promptModeTabButton} ${
                    promptModeTab === "small" ? styles.promptModeTabButtonActive : ""
                  }`}
                  onClick={() => {
                    setPromptModeTab("small");
                  }}
                >
                  {t("welcome.promptModeSmallTab")}
                </button>
                <button
                  type="button"
                  className={`${styles.promptModeTabButton} ${
                    promptModeTab === "large" ? styles.promptModeTabButtonActive : ""
                  }`}
                  onClick={() => {
                    setPromptModeTab("large");
                  }}
                >
                  {t("welcome.promptModeLargeTab")}
                </button>
              </div>
              <div className={styles.promptFlowHeader}>
                <div className={styles.promptFlowHeaderTitle}>
                  <Sparkles size={16} />
                  {promptModeTab === "small"
                    ? t("welcome.promptPhaseSmallSet")
                    : t("welcome.promptFlowTitle")}
                </div>
              </div>

              <div className={styles.promptFlowScroll}>
                {promptModeTab === "small" ? (
                  <section className={styles.promptPhaseSection}>
                    <label className={styles.promptPhaseLabel} htmlFor="welcome-prompt-small-phase">
                      <Wand2 size={15} />
                      {t("welcome.promptPhaseSmallSet")}
                    </label>
                    <Input.TextArea
                      id="welcome-prompt-small-phase"
                      className={styles.promptEditorTextarea}
                      value={promptShort}
                      onChange={(e) => setPromptShort(e.target.value)}
                      placeholder={t("welcome.promptPlaceholderSmall")}
                      ref={promptShortRef}
                      readOnly={!promptCanEdit}
                      autoSize={{ minRows: 16, maxRows: 36 }}
                    />
                    <PromptUnknownTokensNote
                      metricId={promptWidget?.metric_id}
                      text={promptShort}
                    />
                  </section>
                ) : (
                  <PromptMapReduceAccordion
                    styles={styles}
                    metricId={promptWidget?.metric_id}
                    mapValue={promptLongMap}
                    onMapChange={(e) => setPromptLongMap(e.target.value)}
                    reduceValue={promptLongReduce}
                    onReduceChange={(e) => setPromptLongReduce(e.target.value)}
                    mapRef={promptMapRef}
                    reduceRef={promptReduceRef}
                    canEdit={promptCanEdit}
                  />
                )}

              </div>
            </div>
          </div>
        </Spin>
      </Modal>

      <Modal
        title={t("welcome.editSummaryTabs")}
        open={summaryTabsModalOpen}
        onCancel={closeSummaryTabsEditor}
        width={920}
        centered
        destroyOnClose
        footer={[
          <Button key="cancel" onClick={closeSummaryTabsEditor}>
            {t("common.cancel")}
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={summaryTabsSaving}
            onClick={saveSummaryTabsEditor}
          >
            {t("common.save")}
          </Button>,
        ]}
      >
        <Tabs
          items={summaryTabsDraft.map((row) => ({
            key: row.id,
            label: row.label || row.id,
            children:
              summaryTabsMetricId === 25 ? (
                <HighlightMetric25TabEditorPane
                  key={row.id}
                  content={row.content}
                  onContentChange={(next) => {
                    const rid = row.id;
                    setSummaryTabsDraft((prev) =>
                      prev.map((p) =>
                        p.id === rid ? { ...p, content: next } : p,
                      ),
                    );
                  }}
                />
              ) : summaryTabsMetricId === 23 ? (
                <KeyDriverMetric23TabEditorPane
                  key={row.id}
                  tabLabel={row.label || row.id}
                  content={row.content}
                  onContentChange={(next) => {
                    const rid = row.id;
                    setSummaryTabsDraft((prev) =>
                      prev.map((p) =>
                        p.id === rid ? { ...p, content: next } : p,
                      ),
                    );
                  }}
                />
              ) : (
                <Input.TextArea
                  value={row.content}
                  onChange={(e) => {
                    const v = e.target.value;
                    const rid = row.id;
                    setSummaryTabsDraft((prev) =>
                      prev.map((p) =>
                        p.id === rid ? { ...p, content: v } : p,
                      ),
                    );
                  }}
                  autoSize={{ minRows: 16, maxRows: 40 }}
                />
              ),
          }))}
        />
      </Modal>

      <Modal
        title={t("welcome.moveGroupToUserTitle")}
        open={isMoveGroupToUserModalVisible}
        onOk={handleMoveGroupToUser}
        onCancel={closeMoveGroupToUserModal}
        okText={t("welcome.moveGroupToUserConfirm")}
        cancelText={t("common.cancel")}
        confirmLoading={moveGroupToUserLoading}
        destroyOnClose
        width={480}
        closable={!moveGroupToUserLoading}
        maskClosable={!moveGroupToUserLoading}
        okButtonProps={{
          disabled: !moveGroupTargetUserId,
        }}
      >
        <p className={styles.moveWidgetHint}>
          {t("welcome.moveGroupToUserHint", {
            name: groupName,
            count: widgets.length,
          })}
        </p>
        <Select
          showSearch
          optionFilterProp="label"
          placeholder={t("welcome.moveGroupToUserSelectPlaceholder")}
          options={moveGroupTargetOptions}
          value={moveGroupTargetUserId}
          onChange={setMoveGroupTargetUserId}
          style={{ width: "100%" }}
          disabled={moveGroupToUserLoading}
        />
      </Modal>

      {/* Archive Group Confirmation Modal */}
      <Modal
        title={t("welcome.archiveGroupConfirmTitle", { name: groupName })}
        open={isArchiveGroupModalVisible}
        onOk={handleArchiveGroupConfirm}
        onCancel={() => setIsArchiveGroupModalVisible(false)}
        okText={t("welcome.archiveGroupConfirmButton")}
        cancelText={t("common.cancel")}
        confirmLoading={archiveGroupLoading}
        destroyOnClose
      >
        <p>{t("welcome.archiveGroupConfirmDescription")}</p>
      </Modal>

      {/* Delete Group Confirmation Modal */}
      <Modal
        title={t("welcome.deleteGroup")}
        open={isDeleteGroupModalVisible}
        onOk={handleDeleteGroup}
        onCancel={() => setIsDeleteGroupModalVisible(false)}
        okText={t("common.delete")}
        cancelText={t("common.cancel")}
        okButtonProps={{ danger: true }}
      >
        <div className={styles.deleteConfirmation}>
          <ExclamationCircleOutlined className={styles.warningIcon} />
          <p>
            {widgets.length > 0
              ? t("welcome.deleteGroupConfirmationWithWidgets", {
                  name: groupName,
                  widgetCount: widgets.length,
                })
              : t("welcome.deleteGroupConfirmation", { name: groupName })}
          </p>
          <div className={styles.deleteGroupWarningBox}>
            {widgets.length === 0 ? (
              <p>{t("welcome.deleteGroupEmptyOnlyHint")}</p>
            ) : (
              <>
                <p>{t("welcome.deleteGroupWidgetsWarning")}</p>
                <p>{t("welcome.deleteGroupAIQuotaWarning")}</p>
              </>
            )}
            <p>{t("welcome.deleteGroupWarning")}</p>
          </div>
        </div>
      </Modal>
    </div>
    </WelcomeWorkspaceWidgetRenderContext.Provider>
  );
}

function WelcomeAddGroupModal({
  open,
  onClose,
  groups,
  onCreated,
  setWorkspaceLoading,
  workspaceOwnerId,
  currentUserId,
}) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (!open) {
      setName("");
      setNameError("");
    }
  }, [open]);

  const handleCreate = async () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      setNameError("Group name cannot be empty");
      return;
    }
    const isDuplicate = groups.some(
      (group) => group.name.toLowerCase() === trimmedName.toLowerCase(),
    );
    if (isDuplicate) {
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorDuplicateGroupName"),
      });
      return;
    }
    try {
      setWorkspaceLoading(true);
      const response = await apiRequest(
        "welcome/groupWidget/create",
        "POST",
        appendWorkspaceUserId({ name: trimmedName }, workspaceOwnerId, currentUserId),
        true,
      );
      if (response?.success) {
        await onCreated();
        onClose();
        notification.success({
          message: t("common.success"),
          description: t("welcome.groupCreatedSuccess", {
            name: trimmedName,
          }),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.groupCreatedError", { name: trimmedName }),
        });
      }
    } catch (error) {
      console.error("Error creating group:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.groupCreatedError"),
      });
    } finally {
      setWorkspaceLoading(false);
    }
  };

  return (
    <Modal
      title={t("welcome.addGroup")}
      open={open}
      onOk={handleCreate}
      onCancel={onClose}
      okText={t("welcome.createGroupButton")}
      cancelText={t("common.cancel")}
      className={styles.addGroupModal}
      okButtonProps={{ disabled: !name.trim() }}
      destroyOnClose
      aria-labelledby="add-group-title"
      aria-describedby="add-group-description"
      role="dialog"
    >
      <div id="add-group-description" className="sr-only">
        Create a new group to organize your metrics and KPIs
      </div>
      <p
        style={{ fontStyle: "normal", fontSize: "12px" }}
        id="add-group-title"
      >
        {t("welcome.addGroupLabel")}
      </p>
      <div role="form" aria-label="Add group form">
        <p style={{ fontWeight: "600" }}>{t("welcome.enterGroupNameLabel")}</p>
        <Input
          value={name}
          onChange={(event) => {
            setName(event.target.value);
            setNameError("");
          }}
          placeholder={t("welcome.enterGroupName")}
          onPressEnter={handleCreate}
          autoFocus
          size="large"
          className={styles.inputCommon}
          status={nameError ? "error" : ""}
          aria-label={t("welcome_page.group_name_aria", "Group name")}
          aria-required="true"
          aria-invalid={nameError ? "true" : "false"}
          aria-describedby={nameError ? "group-name-error" : undefined}
        />
        {nameError ? (
          <div
            id="group-name-error"
            role="alert"
            aria-live="polite"
            style={{ color: "#ff4d4f", marginTop: "4px", fontSize: "14px" }}
          >
            {nameError}
          </div>
        ) : null}
      </div>
    </Modal>
  );
}

function WelcomeEditGroupNameModal({
  open,
  groupId,
  initialName,
  groups,
  onClose,
  onSaved,
  setWorkspaceLoading,
  workspaceOwnerId,
  currentUserId,
}) {
  const { t } = useTranslation();
  const [name, setName] = useState("");

  useEffect(() => {
    if (open) {
      setName(initialName ?? "");
    }
  }, [open, initialName]);

  const handleSave = async () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorEmptyGroupName"),
      });
      return;
    }
    const normalizedGroupId = normalizeWorkspaceGroupId(groupId);
    if (normalizedGroupId == null) {
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorRenameGroup"),
      });
      return;
    }
    const isDuplicate = groups.some(
      (group) =>
        normalizeWorkspaceGroupId(group.id) !== normalizedGroupId &&
        String(group.name || "").trim().toLowerCase() ===
          trimmedName.toLowerCase(),
    );
    if (isDuplicate) {
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorDuplicateGroupName"),
      });
      return;
    }
    try {
      setWorkspaceLoading(true);
      const response = await apiRequest(
        "welcome/groups/rename",
        "PUT",
        appendWorkspaceUserId(
          { group_id: normalizedGroupId, name: trimmedName },
          workspaceOwnerId,
          currentUserId,
        ),
        true,
      );
      if (response?.success) {
        await onSaved();
        onClose();
        notification.success({
          message: t("common.success"),
          description: t("welcome.groupRenamedSuccess", { name: trimmedName }),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description:
            response?.error || t("welcome.errorRenameGroup"),
        });
      }
    } catch (error) {
      console.error("Error renaming group:", error);
      notification.error({
        message: t("common.error"),
        description: error.message || t("welcome.errorRenameGroup"),
      });
    } finally {
      setWorkspaceLoading(false);
    }
  };

  return (
    <Modal
      title={t("welcome.editGroupName")}
      open={open}
      onOk={handleSave}
      onCancel={onClose}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      className={styles.editGroupModal}
      destroyOnClose
    >
      <Input
        value={name}
        onChange={(event) => setName(event.target.value)}
        placeholder={t("welcome.enterGroupName")}
        onPressEnter={handleSave}
        autoFocus
        size="large"
      />
    </Modal>
  );
}

const MemoizedWelcomeGroupWidgets = memo(
  WelcomeGroupWidgets,
  (prev, next) =>
    prev.groupId === next.groupId &&
    prev.groupName === next.groupName &&
    prev.widgets === next.widgets &&
    prev.groups === next.groups &&
    prev.queryFilters === next.queryFilters &&
    prev.user === next.user &&
    prev.workspaceOwnerId === next.workspaceOwnerId &&
    prev.workspaceContentEditable === next.workspaceContentEditable &&
    prev.workspaceMembers === next.workspaceMembers &&
    prev.workspaceWidgetLimits === next.workspaceWidgetLimits &&
    prev.suppressGroupTitle === next.suppressGroupTitle &&
    prev.isArchivedGroupView === next.isArchivedGroupView &&
    prev.showRestoreGroup === next.showRestoreGroup &&
    prev.onGroupArchived === next.onGroupArchived &&
    prev.onGroupRestored === next.onGroupRestored &&
    prev.onWidgetMovedToGroup === next.onWidgetMovedToGroup &&
    prev.deepLinkWidgetId === next.deepLinkWidgetId &&
    prev.deepLinkHighlightWidgetId === next.deepLinkHighlightWidgetId &&
    prev.onDeepLinkWidgetFocused === next.onDeepLinkWidgetFocused &&
    prev.isActiveGroup === next.isActiveGroup &&
    prev.onRenameGroup === next.onRenameGroup &&
    prev.pollWidgetStatus === next.pollWidgetStatus &&
    prev.stopWelcomeWidgetStatusPoll === next.stopWelcomeWidgetStatusPoll &&
    prev.fetchGroupsAndWidgets === next.fetchGroupsAndWidgets &&
    prev.setGroups === next.setGroups &&
    prev.setWorkspaceWidgetLimits === next.setWorkspaceWidgetLimits &&
    prev.setWorkspaceLoading === next.setWorkspaceLoading,
);

function WelcomeWorkspaceDashboard({
  groups,
  setGroups,
  workspaceWidgetLimits,
  setWorkspaceWidgetLimits,
  loadingGroups,
  loading,
  setLoading,
  fetchGroupsAndWidgets,
  pollWidgetStatus,
  stopWelcomeWidgetStatusPoll,
  queryFilters,
  user,
  workspaceOwnerId,
  workspaceMembers,
  canManageMemberWorkspaces,
  workspaceContentEditable,
  onWorkspaceOwnerChange,
  archivedGroupCount,
  setArchivedGroupCount,
  archivedGroups,
  setArchivedGroups,
  loadingArchivedGroups,
  fetchArchivedGroups,
}) {
  const history = useHistory();
  const location = useLocation();
  const isArchivedView =
    new URLSearchParams(location.search).get("view") === "archived";
  const navGroups = isArchivedView ? archivedGroups : groups;
  const navGroupsLoading = isArchivedView ? loadingArchivedGroups : loadingGroups;
  const [videoData, setVideoData] = useState({
    thumbnailUrl: "",
    videoUrl: "",
    isNew: true,
  });
  const [loadingVideo, setLoadingVideo] = useState(true);
  const [isAddGroupModalVisible, setIsAddGroupModalVisible] = useState(false);
  const [
    isEditGroupNameModalVisible,
    setIsEditGroupNameModalVisible,
  ] = useState(false);
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [isLoomModalVisible, setIsLoomModalVisible] = useState(false);
  const { t } = useTranslation();
  const { openPdfExportModal, isCreatingReport, hasExportableGroups, hasArchivedExportableGroups } =
    useWelcomePdfExport();
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [bulkDeleteModalOpen, setBulkDeleteModalOpen] = useState(false);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);

  const selectableGroups = useMemo(
    () => navGroups.filter((group) => !group.is_auto_report),
    [navGroups],
  );
  const allGroupIds = useMemo(
    () => selectableGroups.map((group) => group.id).filter((id) => id != null),
    [selectableGroups],
  );
  const allGroupsSelected =
    allGroupIds.length > 0 &&
    allGroupIds.every((id) => selectedGroupIds.includes(id));
  const someGroupsSelected =
    selectedGroupIds.length > 0 && !allGroupsSelected;
  const selectedBulkDeleteStats = useMemo(() => {
    const selectedGroups = selectableGroups.filter((group) =>
      selectedGroupIds.includes(group.id),
    );
    return {
      groupCount: selectedGroups.length,
      widgetCount: selectedGroups.reduce(
        (sum, group) => sum + (Array.isArray(group.widgets) ? group.widgets.length : 0),
        0,
      ),
    };
  }, [selectableGroups, selectedGroupIds]);

  useEffect(() => {
    setSelectedGroupIds([]);
  }, [isArchivedView, workspaceOwnerId, allGroupIds.join(",")]);

  const toggleGroupSelection = useCallback((groupId, checked) => {
    setSelectedGroupIds((prev) => {
      if (checked) {
        return prev.includes(groupId) ? prev : [...prev, groupId];
      }
      return prev.filter((id) => id !== groupId);
    });
  }, []);

  const handleSelectAllGroups = useCallback(
    (checked) => {
      setSelectedGroupIds(checked ? [...allGroupIds] : []);
    },
    [allGroupIds],
  );

  const handleBulkDeleteGroups = useCallback(async () => {
    if (!selectedGroupIds.length) return;
    setBulkDeleteLoading(true);
    try {
      const useSelectAll =
        selectedGroupIds.length === allGroupIds.length && allGroupIds.length > 0;
      const response = await apiRequest(
        "welcome/groups/bulk-delete",
        "DELETE",
        appendWorkspaceUserId(
          {
            group_ids: useSelectAll ? [] : selectedGroupIds,
            select_all: useSelectAll,
            archived_only: isArchivedView,
          },
          workspaceOwnerId,
          user?.uid,
        ),
        true,
      );

      if (response?.error) {
        notification.error({
          message: t("welcome.bulkDeleteGroupsModalTitle"),
          description: response.error,
        });
        return;
      }

      if (response?.success) {
        setSelectedGroupIds([]);
        setBulkDeleteModalOpen(false);
        if (response.workspace_limits) {
          setWorkspaceWidgetLimits(response.workspace_limits);
        }
        if (isArchivedView) {
          await fetchArchivedGroups();
          setArchivedGroupCount((prev) =>
            Math.max(0, prev - (Number(response.deleted_group_count) || 0)),
          );
        } else {
          await fetchGroupsAndWidgets();
        }
        notification.success({
          message: t("common.success"),
          description: t("welcome.bulkDeleteGroupsSuccess", {
            groups: Number(response.deleted_group_count) || 0,
            widgets: Number(response.deleted_widget_count) || 0,
          }),
        });
      } else {
        notification.error({
          message: t("common.error"),
          description: t("welcome.bulkDeleteGroupsError"),
        });
      }
    } catch (error) {
      notification.error({
        message: t("common.error"),
        description: error?.message || t("welcome.bulkDeleteGroupsError"),
      });
    } finally {
      setBulkDeleteLoading(false);
    }
  }, [
    allGroupIds.length,
    fetchArchivedGroups,
    fetchGroupsAndWidgets,
    isArchivedView,
    selectedGroupIds,
    setArchivedGroupCount,
    setWorkspaceWidgetLimits,
    t,
    user?.uid,
    workspaceOwnerId,
  ]);

  const openArchivedView = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.set("view", "archived");
    history.push({ search: params.toString() });
  }, [history, location.search]);

  const closeArchivedView = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete("view");
    history.push({ search: params.toString() });
  }, [history, location.search]);

  useEffect(() => {
    if (isArchivedView) {
      fetchArchivedGroups();
    }
  }, [isArchivedView, workspaceOwnerId, fetchArchivedGroups]);

  const handleGroupArchived = useCallback(
    (groupId, groupName) => {
      setGroups((prev) => prev.filter((group) => group.id !== groupId));
      setArchivedGroupCount((prev) => prev + 1);
      if (isArchivedView) {
        fetchArchivedGroups();
      }
    },
    [isArchivedView, fetchArchivedGroups, setGroups, setArchivedGroupCount],
  );

  const handleGroupRestored = useCallback(
    (groupId, groupName) => {
      setArchivedGroups((prev) => prev.filter((group) => group.id !== groupId));
      setArchivedGroupCount((prev) => Math.max(0, prev - 1));
      fetchGroupsAndWidgets();
    },
    [
      fetchGroupsAndWidgets,
      setArchivedGroups,
      setArchivedGroupCount,
    ],
  );

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        const response = await apiRequest("welcome/video", "GET");
        if (response?.success) {
          setVideoData({
            thumbnailUrl: response?.success?.thumbnail_url,
            videoUrl: response?.success?.video_url,
            isNew: true,
          });
        }
      } catch (error) {
        console.error("Error fetching video data:", error);
      } finally {
        setLoadingVideo(false);
      }
    };
    fetchVideoData();
  }, []);

  const [activeGroupId, setActiveGroupId] = useState(() => {
    const { groupId } = readWorkspaceDeepLinkFromSearch(
      typeof window !== "undefined" ? window.location.search : "",
    );
    return groupId != null ? normalizeWorkspaceGroupId(groupId) : null;
  });
  const [groupPickerOpen, setGroupPickerOpen] = useState(false);
  const [groupPickerSearch, setGroupPickerSearch] = useState("");
  const groupNavScrollLockRef = useRef(false);
  const groupNavScrollTimerRef = useRef(null);

  const getWorkspaceGroupLabel = useCallback(
    (group) =>
      (group?.name && String(group.name).trim()) ||
      `${t("welcome.enterGroupNameLabel")} #${group?.id}`,
    [t],
  );

  const scrollToWorkspaceGroup = useCallback((groupId, behavior = "smooth") => {
    const normalizedId = normalizeWorkspaceGroupId(groupId);
    if (normalizedId == null) return;

    const runScroll = (attempt = 0) => {
      const didScroll = scrollToWorkspaceGroupElement(normalizedId, behavior);
      if (!didScroll && attempt < 20) {
        window.setTimeout(() => runScroll(attempt + 1), 100);
      }
    };

    runScroll();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => runScroll());
    });
  }, []);

  const lockGroupNavScrollTracking = useCallback((durationMs = 2500) => {
    groupNavScrollLockRef.current = true;
    if (groupNavScrollTimerRef.current) {
      clearTimeout(groupNavScrollTimerRef.current);
    }
    groupNavScrollTimerRef.current = setTimeout(() => {
      groupNavScrollLockRef.current = false;
      groupNavScrollTimerRef.current = null;
    }, durationMs);
  }, []);

  const workspaceDeepLink = useMemo(
    () => readWorkspaceDeepLinkFromSearch(location.search),
    [location.search],
  );
  const urlWorkspaceOwnerId = useMemo(
    () => readWorkspaceUserIdFromSearch(location.search),
    [location.search],
  );
  const deepLinkOwnerReady = useMemo(() => {
    if (!urlWorkspaceOwnerId || urlWorkspaceOwnerId === user?.uid) {
      return true;
    }
    return workspaceOwnerId === urlWorkspaceOwnerId;
  }, [urlWorkspaceOwnerId, user?.uid, workspaceOwnerId]);
  const workspaceDeepLinkAppliedRef = useRef(false);
  const workspaceDeepLinkNavStartedRef = useRef(false);
  const deepLinkWidgetFocusStartedRef = useRef(false);
  const deepLinkWidgetFocusTimerRef = useRef(null);
  const deepLinkHighlightTimerRef = useRef(null);
  const [deepLinkHighlightWidgetId, setDeepLinkHighlightWidgetId] = useState(null);

  const triggerDeepLinkWidgetHighlight = useCallback((widgetId) => {
    const wid = Number(widgetId);
    if (!Number.isFinite(wid) || wid <= 0) return;
    if (deepLinkHighlightTimerRef.current) {
      clearTimeout(deepLinkHighlightTimerRef.current);
    }
    setDeepLinkHighlightWidgetId(wid);
    deepLinkHighlightTimerRef.current = setTimeout(() => {
      setDeepLinkHighlightWidgetId(null);
      deepLinkHighlightTimerRef.current = null;
    }, WORKSPACE_DEEP_LINK_HIGHLIGHT_MS);
  }, []);

  const handleDeepLinkWidgetFocused = useCallback(
    (widgetId) => {
      triggerDeepLinkWidgetHighlight(widgetId);
      workspaceDeepLinkAppliedRef.current = true;
    },
    [triggerDeepLinkWidgetHighlight],
  );

  useEffect(() => {
    workspaceDeepLinkAppliedRef.current = false;
    workspaceDeepLinkNavStartedRef.current = false;
    deepLinkWidgetFocusStartedRef.current = false;
    setDeepLinkHighlightWidgetId(null);
    if (deepLinkHighlightTimerRef.current) {
      clearTimeout(deepLinkHighlightTimerRef.current);
      deepLinkHighlightTimerRef.current = null;
    }
    if (deepLinkWidgetFocusTimerRef.current) {
      clearTimeout(deepLinkWidgetFocusTimerRef.current);
      deepLinkWidgetFocusTimerRef.current = null;
    }
  }, [location.search, workspaceOwnerId]);

  useEffect(() => {
    return () => {
      if (deepLinkHighlightTimerRef.current) {
        clearTimeout(deepLinkHighlightTimerRef.current);
      }
      if (deepLinkWidgetFocusTimerRef.current) {
        clearTimeout(deepLinkWidgetFocusTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      if (groupNavScrollTimerRef.current) {
        clearTimeout(groupNavScrollTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!navGroups.length) {
      if (workspaceDeepLink.groupId == null && workspaceDeepLink.widgetId == null) {
        setActiveGroupId(null);
      }
      return;
    }
    setActiveGroupId((prev) => {
      if (
        prev != null &&
        navGroups.some((g) => workspaceGroupIdsMatch(g.id, prev))
      ) {
        return normalizeWorkspaceGroupId(prev);
      }
      const urlGroupId = workspaceDeepLink.groupId;
      if (urlGroupId != null) {
        const normalizedUrlGroupId = normalizeWorkspaceGroupId(urlGroupId);
        if (
          navGroups.some((g) =>
            workspaceGroupIdsMatch(g.id, normalizedUrlGroupId),
          )
        ) {
          return normalizedUrlGroupId;
        }
        return normalizeWorkspaceGroupId(navGroups[0].id);
      }
      return normalizeWorkspaceGroupId(navGroups[0].id);
    });
  }, [navGroups, workspaceDeepLink.groupId, workspaceDeepLink.widgetId]);

  useEffect(() => {
    if (navGroupsLoading || navGroups.length === 0) {
      return undefined;
    }
    const hasPendingDeepLink =
      (workspaceDeepLink.groupId != null ||
        workspaceDeepLink.widgetId != null) &&
      !workspaceDeepLinkAppliedRef.current;
    if (hasPendingDeepLink) {
      return undefined;
    }

    const scrollRoot = getWorkspaceScrollContainer();

    const observer = new IntersectionObserver(
      (entries) => {
        if (groupNavScrollLockRef.current) return;
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (!visible.length) return;
        const nextId = normalizeWorkspaceGroupId(
          visible[0].target.getAttribute("data-group-id"),
        );
        if (nextId != null) {
          setActiveGroupId(nextId);
        }
      },
      {
        root: scrollRoot,
        rootMargin: `-${WORKSPACE_GROUP_SCROLL_OFFSET}px 0px -55% 0px`,
        threshold: [0, 0.15, 0.35, 0.55, 0.75],
      },
    );

    navGroups.forEach((group) => {
      const el = document.getElementById(workspaceGroupDomId(group.id));
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [navGroups, navGroupsLoading, workspaceDeepLink.groupId, workspaceDeepLink.widgetId]);

  const activeGroupIndex = useMemo(() => {
    if (activeGroupId == null) return -1;
    return navGroups.findIndex((g) =>
      workspaceGroupIdsMatch(g.id, activeGroupId),
    );
  }, [navGroups, activeGroupId]);

  const activeGroupLabel = useMemo(() => {
    if (activeGroupIndex < 0) return t("welcome.jumpToGroup");
    return getWorkspaceGroupLabel(navGroups[activeGroupIndex]);
  }, [activeGroupIndex, navGroups, getWorkspaceGroupLabel, t]);

  const activeGroupWidgetStatusCounts = useMemo(() => {
    if (activeGroupIndex < 0) return { ready: 0, inProgress: 0 };
    return countWorkspaceGroupWidgetStatuses(
      navGroups[activeGroupIndex]?.widgets,
    );
  }, [activeGroupIndex, navGroups]);

  const filteredPickerGroups = useMemo(() => {
    const query = groupPickerSearch.trim().toLowerCase();
    if (!query || navGroups.length <= 8) return navGroups;
    return navGroups.filter((group) =>
      getWorkspaceGroupLabel(group).toLowerCase().includes(query),
    );
  }, [navGroups, groupPickerSearch, getWorkspaceGroupLabel]);

  useEffect(() => {
    if (!groupPickerOpen) {
      setGroupPickerSearch("");
    }
  }, [groupPickerOpen]);

  const navigateToWorkspaceGroupById = useCallback(
    (groupId, { behavior = "smooth", lockMs = 2500 } = {}) => {
      const normalizedId = normalizeWorkspaceGroupId(groupId);
      if (normalizedId == null) return false;
      const groupExists = navGroups.some((g) =>
        workspaceGroupIdsMatch(g.id, normalizedId),
      );
      lockGroupNavScrollTracking(lockMs);
      if (groupExists) {
        setActiveGroupId(normalizedId);
      }
      scrollToWorkspaceGroup(normalizedId, behavior);
      return groupExists;
    },
    [lockGroupNavScrollTracking, scrollToWorkspaceGroup, navGroups],
  );

  const handleGroupJumpSelect = useCallback(
    (groupId) => {
      navigateToWorkspaceGroupById(groupId);
    },
    [navigateToWorkspaceGroupById],
  );

  const navGroupsDeepLinkWidgetKey = useMemo(() => {
    const wid = Number(workspaceDeepLink.widgetId);
    if (!Number.isFinite(wid) || wid <= 0) {
      return "";
    }
    for (const group of navGroups) {
      if ((group.widgets || []).some((w) => Number(w.id) === wid)) {
        return `${normalizeWorkspaceGroupId(group.id)}:${wid}`;
      }
    }
    return `pending:${wid}`;
  }, [navGroups, workspaceDeepLink.widgetId]);

  const startDeepLinkWidgetFocus = useCallback(
    (widgetId) => {
      const normalizedWidgetId = Number(widgetId);
      if (!Number.isFinite(normalizedWidgetId) || normalizedWidgetId <= 0) {
        return;
      }
      if (deepLinkWidgetFocusStartedRef.current) {
        return;
      }
      deepLinkWidgetFocusStartedRef.current = true;

      let attempt = 0;
      const tick = () => {
        deepLinkWidgetFocusTimerRef.current = null;
        if (workspaceDeepLinkAppliedRef.current) {
          return;
        }
        const el = findWorkspaceWidgetElement(normalizedWidgetId);
        if (el) {
          scrollToWorkspaceWidgetElement(normalizedWidgetId, "auto");
          handleDeepLinkWidgetFocused(normalizedWidgetId);
          return;
        }
        attempt += 1;
        if (attempt >= 100) {
          workspaceDeepLinkAppliedRef.current = true;
          return;
        }
        deepLinkWidgetFocusTimerRef.current = window.setTimeout(tick, 100);
      };

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(tick);
      });
    },
    [handleDeepLinkWidgetFocused],
  );

  useEffect(() => {
    if (!deepLinkOwnerReady) return;
    if (navGroupsLoading || loadingGroups) return;
    const { groupId, widgetId } = workspaceDeepLink;
    if (groupId == null && widgetId == null) return;
    if (workspaceDeepLinkAppliedRef.current) return;

    const normalizedWidgetId =
      widgetId != null ? Number(widgetId) : Number.NaN;
    let resolvedGroupId =
      groupId != null ? normalizeWorkspaceGroupId(groupId) : null;

    if (Number.isFinite(normalizedWidgetId) && normalizedWidgetId > 0) {
      const ownerGroup = navGroups.find((g) =>
        (g.widgets || []).some((w) => Number(w.id) === normalizedWidgetId),
      );
      if (ownerGroup) {
        resolvedGroupId = normalizeWorkspaceGroupId(ownerGroup.id);
      } else if (resolvedGroupId == null) {
        return;
      }
    } else if (resolvedGroupId != null) {
      const groupReady = navGroups.some((g) =>
        workspaceGroupIdsMatch(g.id, resolvedGroupId),
      );
      if (!groupReady) {
        return;
      }
    }

    if (resolvedGroupId == null) {
      return;
    }

    const groupInNav = navGroups.some((g) =>
      workspaceGroupIdsMatch(g.id, resolvedGroupId),
    );
    if (!groupInNav) {
      workspaceDeepLinkNavStartedRef.current = false;
      return;
    }

    if (!workspaceDeepLinkNavStartedRef.current) {
      workspaceDeepLinkNavStartedRef.current = true;
      navigateToWorkspaceGroupById(resolvedGroupId, {
        behavior: "auto",
        lockMs: 8000,
      });
    }

    if (!Number.isFinite(normalizedWidgetId) || normalizedWidgetId <= 0) {
      workspaceDeepLinkAppliedRef.current = true;
      return;
    }

    startDeepLinkWidgetFocus(normalizedWidgetId);
  }, [
    deepLinkOwnerReady,
    navGroupsLoading,
    loadingGroups,
    workspaceDeepLink.groupId,
    workspaceDeepLink.widgetId,
    navGroupsDeepLinkWidgetKey,
    navigateToWorkspaceGroupById,
    startDeepLinkWidgetFocus,
  ]);

  const handleWidgetMovedToGroup = useCallback(
    (targetGroupId, widgetId) => {
      const normalizedId = normalizeWorkspaceGroupId(targetGroupId);
      if (normalizedId == null || widgetId == null) return;
      navigateToWorkspaceGroupById(normalizedId, { lockMs: 1800 });
      focusWorkspaceWidgetInGroup(normalizedId, widgetId, "smooth");
      triggerDeepLinkWidgetHighlight(widgetId);
    },
    [navigateToWorkspaceGroupById, triggerDeepLinkWidgetHighlight],
  );

  const navigateWorkspaceGroup = useCallback(
    (direction) => {
      if (activeGroupIndex < 0) return;
      const nextIndex = activeGroupIndex + direction;
      if (nextIndex < 0 || nextIndex >= navGroups.length) return;
      const nextGroup = navGroups[nextIndex];
      navigateToWorkspaceGroupById(nextGroup.id);
    },
    [activeGroupIndex, navGroups, navigateToWorkspaceGroupById],
  );

  const workspaceGroupPickerMenu = useMemo(
    () => ({
      selectedKeys:
        activeGroupId != null
          ? [String(normalizeWorkspaceGroupId(activeGroupId))]
          : [],
      onClick: ({ key }) => {
        handleGroupJumpSelect(key);
        setGroupPickerOpen(false);
      },
      items: filteredPickerGroups.map((group) => ({
        key: String(group.id),
        label: (
          <span className={styles.workspaceGroupPickerItem}>
            <span className={styles.workspaceGroupPickerItemName}>
              {getWorkspaceGroupLabel(group)}
            </span>
            <WorkspaceGroupWidgetStatusBadges
              widgets={group.widgets}
              className={styles.workspaceGroupPickerItemStatus}
              compact
            />
          </span>
        ),
      })),
    }),
    [
      activeGroupId,
      filteredPickerGroups,
      getWorkspaceGroupLabel,
      handleGroupJumpSelect,
    ],
  );

  const showWorkspaceGroupNav =
    navGroups.length >= 2 && !navGroupsLoading;
  const showWorkspaceOwnerSelect = workspaceMembers.length > 1;

  const workspaceOwnerSelectOptions = useMemo(
    () =>
      workspaceMembers.map((member) => ({
        value: member.user_id,
        label: member.is_self
          ? t("welcome.workspaceOwnerSelf")
          : member.display_name || member.email || member.user_id,
      })),
    [workspaceMembers, t],
  );

  // Loading skeleton component
  const LoadingSkeleton = () => (
    <div className={styles.skeletonContainer}>
      <Skeleton active paragraph={{ rows: 12 }} />
    </div>
  );

  // Empty state component
  const EmptyState = () => (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateContent}>
        <DashboardOutlined className={styles.emptyStateIcon} />
        <h2>{t("welcome.noGroupsTitle")}</h2>
        <p>{t("welcome.noGroupsDescription")}</p>
        <div className={styles.emptyStateButton}>
          {workspaceContentEditable && !isArchivedView ? (
            <Button
              size="large"
              onClick={() => setIsAddGroupModalVisible(true)}
              icon={<PlusOutlined />}
            >
              {t("welcome.createFirstGroup")}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );

  const ArchivedEmptyState = () => (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateContent}>
        <InboxOutlined className={styles.emptyStateIcon} />
        <h2>{t("welcome.noArchivedGroupsTitle")}</h2>
        <p>{t("welcome.noArchivedGroupsDescription")}</p>
      </div>
    </div>
  );


  const handleRenameGroup = useCallback((groupId) => {
    setEditingGroupId(normalizeWorkspaceGroupId(groupId));
    setIsEditGroupNameModalVisible(true);
  }, []);

  const handleCloseEditGroupModal = useCallback(() => {
    setIsEditGroupNameModalVisible(false);
    setEditingGroupId(null);
  }, []);

  const editingGroupInitialName = useMemo(() => {
    if (editingGroupId == null) return "";
    const group = groups.find((g) =>
      workspaceGroupIdsMatch(g.id, editingGroupId),
    );
    return group?.name ?? "";
  }, [editingGroupId, groups]);

  const renderSelectableGroupContainer = useCallback(
    ({ group, listGroups, setListGroups, archivedView = false }) => {
      const isSelected = selectedGroupIds.includes(group.id);
      const isAutoReportGroup = Boolean(group.is_auto_report);
      return (
        <div
          key={group.id}
          id={workspaceGroupDomId(group.id)}
          data-group-id={group.id}
          className={`${styles.groupContainer}${
            workspaceContentEditable && !isAutoReportGroup
              ? ` ${styles.groupContainerSelectable}`
              : ""
          }${isSelected ? ` ${styles.groupContainerSelected}` : ""}${
            archivedView ? ` ${styles.groupContainerArchived}` : ""
          }`.trim()}
        >
          {workspaceContentEditable && !isAutoReportGroup ? (
            <Checkbox
              className={styles.groupSelectCheckbox}
              checked={isSelected}
              onChange={(event) => toggleGroupSelection(group.id, event.target.checked)}
              aria-label={getWorkspaceGroupLabel(group)}
            />
          ) : null}
          <MemoizedWelcomeGroupWidgets
            user={user}
            workspaceOwnerId={workspaceOwnerId}
            workspaceContentEditable={archivedView ? false : workspaceContentEditable}
            workspaceMembers={workspaceMembers}
            groupId={group.id}
            groupName={group.name}
            onRenameGroup={handleRenameGroup}
            widgets={group.widgets}
            groups={listGroups}
            setGroups={setListGroups}
            workspaceWidgetLimits={workspaceWidgetLimits}
            setWorkspaceWidgetLimits={setWorkspaceWidgetLimits}
            queryFilters={queryFilters}
            pollWidgetStatus={pollWidgetStatus}
            stopWelcomeWidgetStatusPoll={stopWelcomeWidgetStatusPoll}
            fetchGroupsAndWidgets={
              archivedView ? fetchArchivedGroups : fetchGroupsAndWidgets
            }
            setWorkspaceLoading={setLoading}
            suppressGroupTitle={archivedView ? false : showWorkspaceGroupNav}
            isActiveGroup={
              archivedView ? true : workspaceGroupIdsMatch(group.id, activeGroupId)
            }
            deepLinkWidgetId={archivedView ? null : workspaceDeepLink.widgetId}
            deepLinkHighlightWidgetId={
              archivedView ? null : deepLinkHighlightWidgetId
            }
            onDeepLinkWidgetFocused={
              archivedView ? undefined : handleDeepLinkWidgetFocused
            }
            onGroupArchived={archivedView ? undefined : handleGroupArchived}
            isArchivedGroupView={archivedView}
            showRestoreGroup={archivedView ? workspaceContentEditable : false}
            onGroupRestored={archivedView ? handleGroupRestored : undefined}
            onWidgetMovedToGroup={archivedView ? undefined : handleWidgetMovedToGroup}
          />
        </div>
      );
    },
    [
      activeGroupId,
      fetchArchivedGroups,
      fetchGroupsAndWidgets,
      getWorkspaceGroupLabel,
      handleGroupArchived,
      handleGroupRestored,
      handleRenameGroup,
      handleWidgetMovedToGroup,
      pollWidgetStatus,
      queryFilters,
      selectedGroupIds,
      setLoading,
      setWorkspaceWidgetLimits,
      showWorkspaceGroupNav,
      stopWelcomeWidgetStatusPoll,
      toggleGroupSelection,
      user,
      workspaceContentEditable,
      workspaceDeepLink.widgetId,
      deepLinkHighlightWidgetId,
      handleDeepLinkWidgetFocused,
      workspaceMembers,
      workspaceOwnerId,
      workspaceWidgetLimits,
    ],
  );

  return (
    <div className={styles.dashboardSection}>
      {/* <div className={styles.introSection}>
					<div className={styles.introContent}>
						<div className={styles.top}>
							<div className={styles.title}>
								<div className={styles.text}>
									<h5>{t("welcome.1")} 🚀</h5>
								</div>
							</div>
						</div>

						<div className={styles.introCTA}>
							<div>
								<Trans i18nKey="welcome.2" t={t} tOptions={{ interpolation: { escapeValue: false } }} />
							</div>
							<div className={styles.ctaGroupButton}>
								<Row gutter={16}>
									<Button
										className={styles.ctaButton}
										icon={<FileDoneOutlined />}
										onClick={() => history.push("/console/report")}
									>
										{t("welcome.3")}
									</Button>
									<Button
										className={styles.ctaButton}
										icon={<DashboardOutlined />}
										onClick={() => history.push("/console/global_executive")}
									>
										{t("welcome.4")}
									</Button>
									<Button
										className={styles.ctaButton}
										icon={<ThunderboltOutlined />}
										onClick={() => history.push("/console/industryTopics")}
									>
										{t("welcome.5")}
									</Button>
								</Row>
							</div>
						</div>
					</div> */}

      {/* Video Preview */}
      {/* {loadingVideo ? (
						<div className={styles.videoPreviewContainer}>
							<div className={styles.loadingOverlay}>
								<div className={styles.pulseAnimation} />
							</div>
						</div>
					) : videoData.thumbnailUrl ? (
						<div className={styles.videoPreviewContainer} onClick={() => setIsLoomModalVisible(true)}>
							<img src={videoData.thumbnailUrl} alt="Tutorial Video Preview" className={styles.thumbnail} />
							<div className={styles.playOverlay}>
								<div className={styles.playButton}>
									<div className={styles.pulseRing} />
									<PlayCircleOutlined className={styles.playIcon} />
								</div>
								<div className={styles.guideText}>{t("welcome.discoverFeatures")}</div>
							</div>
							<div className={styles.newBadge}>{t("common.learn")}</div>
						</div>
					) : null}
				</div> */}

      {/* Date filter & Pivot filter buttons — temporarily hidden
          <Button
            className={styles.timeIndicator}
            onClick={() => {
              setShowDateFilterPopup(!showDateFilterPopup);
            }}
            disabled={loading || loadingGroups}
          >
            <CalendarFilled />
            {selectedDaysRange !== "custom"
              ? rangePresets[selectedDaysRange]
              : `${params.get("since") ? params.get("since") : ""} - ${
                  params.get("until") ? params.get("until") : ""
                }`}
          </Button>
          <Button
            className={styles.timeIndicator}
            icon={<FilterOutlined />}
            onClick={openPivotFilterModal}
            disabled={loading || loadingGroups}
          >
            {t("welcome.pivotFilterButton")}
          </Button>
          {(() => {
            const raw = params.get("pivotFilter");
            if (!raw) return null;
            try {
              const obj = JSON.parse(raw);
              const col = Object.keys(obj)[0];
              if (!col) return null;
              const vals = obj[col];
              const n = Array.isArray(vals)
                ? vals.length
                : vals != null
                ? 1
                : 0;
              return (
                <Tag color="blue">
                  {col}
                  {n ? ` (${n})` : ""}
                </Tag>
              );
            } catch {
              return null;
            }
          })()}
          */}
      <div
        className={`${styles.dashboardHeader}${
          showWorkspaceGroupNav || showWorkspaceOwnerSelect || isArchivedView
            ? ` ${styles.dashboardHeaderWithGroupNav}`
            : ""
        }`.trim()}
      >
        {isArchivedView || showWorkspaceOwnerSelect || showWorkspaceGroupNav ? (
          <div className={styles.headerLeft}>
            {isArchivedView ? (
              <div className={styles.archivedViewHeader}>
                <Button
                  type="text"
                  icon={<LeftOutlined />}
                  onClick={closeArchivedView}
                  className={styles.archivedViewBackButton}
                  aria-label={t("welcome.backToActiveWorkspace")}
                />
                <div className={styles.archivedViewTitles}>
                  <h2 className={styles.archivedViewTitle}>
                    {t("welcome.archivedGroupsTitle")}
                  </h2>
                  <p className={styles.archivedViewSubtitle}>
                    {t("welcome.workspaceOwnerSelf")}
                  </p>
                </div>
              </div>
            ) : showWorkspaceOwnerSelect ? (
              <div className={styles.workspaceOwnerSelectWrap}>
                <span className={styles.workspaceOwnerSelectLabel}>
                  {t("welcome.workspaceOwnerLabel")}
                </span>
                <Select
                  className={styles.workspaceOwnerSelect}
                  value={workspaceOwnerId}
                  onChange={onWorkspaceOwnerChange}
                  options={workspaceOwnerSelectOptions}
                  disabled={loading || loadingGroups}
                  showSearch
                  optionFilterProp="label"
                  popupMatchSelectWidth={false}
                />
              </div>
            ) : null}
            {showWorkspaceGroupNav ? (
            <nav
              className={styles.workspaceGroupNav}
              role="navigation"
              aria-label={t("welcome.groupStickyNavAria")}
            >
              <div className={styles.workspaceGroupNavCluster}>
                <span
                  role="button"
                  tabIndex={activeGroupIndex <= 0 ? -1 : 0}
                  className={`${styles.workspaceGroupNavBtn}${
                    activeGroupIndex <= 0
                      ? ` ${styles.workspaceGroupNavBtnDisabled}`
                      : ""
                  }`.trim()}
                  aria-disabled={activeGroupIndex <= 0}
                  onClick={() => {
                    if (activeGroupIndex <= 0) return;
                    navigateWorkspaceGroup(-1);
                  }}
                  onKeyDown={(event) => {
                    if (activeGroupIndex <= 0) return;
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      navigateWorkspaceGroup(-1);
                    }
                  }}
                  aria-label={t("welcome.groupNavPrevious")}
                >
                  <LeftOutlined />
                </span>
                <Dropdown
                  open={groupPickerOpen}
                  onOpenChange={setGroupPickerOpen}
                  trigger={["click"]}
                  placement="bottomLeft"
                  disabled={loading || navGroupsLoading}
                  overlayClassName="workspace-group-nav-menu-dropdown"
                  menu={workspaceGroupPickerMenu}
                  dropdownRender={(menu) => (
                    <div className={styles.workspaceGroupNavMenuPanel}>
                      {navGroups.length > 8 ? (
                        <Input
                          allowClear
                          size="small"
                          placeholder={t("welcome.jumpToGroup")}
                          value={groupPickerSearch}
                          onChange={(event) =>
                            setGroupPickerSearch(event.target.value)
                          }
                          className={styles.workspaceGroupNavMenuSearch}
                          onKeyDown={(event) => event.stopPropagation()}
                        />
                      ) : null}
                      {menu}
                    </div>
                  )}
                >
                  <button
                    type="button"
                    className={styles.workspaceGroupNavTrigger}
                    aria-label={t("welcome.jumpToGroup")}
                    aria-haspopup="listbox"
                    aria-expanded={groupPickerOpen}
                  >
                    <Tooltip
                      title={
                        activeGroupIndex >= 0
                          ? `${activeGroupLabel} — ${t("welcome.groupWidgetStatusAria", activeGroupWidgetStatusCounts)}`
                          : activeGroupLabel
                      }
                      placement="bottom"
                    >
                      <span className={styles.workspaceGroupNavTriggerNameWrap}>
                        <span className={styles.workspaceGroupNavTriggerName}>
                          <span className={styles.workspaceGroupNavTriggerNameText}>
                            {activeGroupLabel}
                          </span>
                        </span>
                      </span>
                    </Tooltip>
                    <span className={styles.workspaceGroupNavCountInline}>
                      {t("welcome.groupNavPosition", {
                        current: activeGroupIndex + 1,
                        total: navGroups.length,
                      })}
                    </span>
                    <DownOutlined
                      className={styles.workspaceGroupNavTriggerChevron}
                    />
                  </button>
                </Dropdown>
                <span
                  role="button"
                  tabIndex={
                    activeGroupIndex < 0 ||
                    activeGroupIndex >= navGroups.length - 1
                      ? -1
                      : 0
                  }
                  className={`${styles.workspaceGroupNavBtn}${
                    activeGroupIndex < 0 ||
                    activeGroupIndex >= navGroups.length - 1
                      ? ` ${styles.workspaceGroupNavBtnDisabled}`
                      : ""
                  }`.trim()}
                  aria-disabled={
                    activeGroupIndex < 0 ||
                    activeGroupIndex >= navGroups.length - 1
                  }
                  onClick={() => {
                    if (
                      activeGroupIndex < 0 ||
                      activeGroupIndex >= navGroups.length - 1
                    ) {
                      return;
                    }
                    navigateWorkspaceGroup(1);
                  }}
                  onKeyDown={(event) => {
                    if (
                      activeGroupIndex < 0 ||
                      activeGroupIndex >= navGroups.length - 1
                    ) {
                      return;
                    }
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      navigateWorkspaceGroup(1);
                    }
                  }}
                  aria-label={t("welcome.groupNavNext")}
                >
                  <RightOutlined />
                </span>
              </div>
            </nav>
            ) : null}
          </div>
        ) : null}
        <div className={styles.headerRight}>
          {isArchivedView ? (
            <>
              <Button
                icon={<FilePdfOutlined />}
                onClick={() => openPdfExportModal({ archived: true })}
                loading={isCreatingReport}
                disabled={
                  loading || loadingArchivedGroups || !hasArchivedExportableGroups
                }
                className={styles.workspaceToolbarButton}
              >
                {t("welcome.49")}
              </Button>
              {workspaceContentEditable && selectableGroups.length > 0 ? (
                <div className={styles.bulkSelectToolbar}>
                  <Checkbox
                    indeterminate={someGroupsSelected}
                    checked={allGroupsSelected}
                    onChange={(event) => handleSelectAllGroups(event.target.checked)}
                  >
                    {t("welcome.selectAll")}
                  </Checkbox>
                  {selectedGroupIds.length > 0 ? (
                    <Button
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => setBulkDeleteModalOpen(true)}
                      loading={bulkDeleteLoading}
                      className={styles.workspaceToolbarButton}
                    >
                      {t("welcome.bulkDeleteGroupsButton", {
                        count: selectedGroupIds.length,
                      })}
                    </Button>
                  ) : null}
                </div>
              ) : null}
              <Button
                onClick={closeArchivedView}
                className={styles.workspaceToolbarButton}
              >
                {t("welcome.backToActiveWorkspace")}
              </Button>
            </>
          ) : (
            <>
          {workspaceContentEditable ? (
            <Button
              icon={<PlusOutlined />}
              onClick={() => setIsAddGroupModalVisible(true)}
              className={styles.workspaceToolbarButton}
              disabled={loading || loadingGroups}
            >
              {t("welcome.addNewGroup")}
            </Button>
          ) : null}
          <Badge
            count={archivedGroupCount > 0 ? archivedGroupCount : 0}
            overflowCount={99}
            size="small"
            showZero={false}
          >
            <Button
              icon={<InboxOutlined />}
              onClick={openArchivedView}
              className={styles.workspaceToolbarButton}
              disabled={loading || loadingGroups}
            >
              {t("welcome.archivedGroupsButton")}
            </Button>
          </Badge>
          <Button
            icon={<FilePdfOutlined />}
            onClick={openPdfExportModal}
            loading={isCreatingReport}
            disabled={loading || loadingGroups || !hasExportableGroups}
            className={styles.workspaceToolbarButton}
          >
            {t("welcome.49")}
          </Button>
          {workspaceContentEditable && selectableGroups.length > 0 ? (
            <div className={styles.bulkSelectToolbar}>
              <Checkbox
                indeterminate={someGroupsSelected}
                checked={allGroupsSelected}
                onChange={(event) => handleSelectAllGroups(event.target.checked)}
              >
                {t("welcome.selectAll")}
              </Checkbox>
              {selectedGroupIds.length > 0 ? (
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => setBulkDeleteModalOpen(true)}
                  loading={bulkDeleteLoading}
                  className={styles.workspaceToolbarButton}
                >
                  {t("welcome.bulkDeleteGroupsButton", {
                    count: selectedGroupIds.length,
                  })}
                </Button>
              ) : null}
            </div>
          ) : null}
            </>
          )}
        </div>
      </div>

      <div className="dashboard-content">
        {isArchivedView ? (
          loadingArchivedGroups ? (
            <LoadingSkeleton />
          ) : archivedGroups.length === 0 ? (
            <ArchivedEmptyState />
          ) : (
            <div className={styles.groupsContainer}>
              {archivedGroups.map((group) =>
                renderSelectableGroupContainer({
                  group,
                  listGroups: archivedGroups,
                  setListGroups: setArchivedGroups,
                  archivedView: true,
                }),
              )}
            </div>
          )
        ) : (
        <>
        {loadingGroups ? (
          <LoadingSkeleton />
        ) : groups.length === 0 ? (
          <EmptyState />
        ) : (
          <div className={styles.groupsContainer}>
            {groups.map((group) =>
              renderSelectableGroupContainer({
                group,
                listGroups: groups,
                setListGroups: setGroups,
              }),
            )}
          </div>
        )}
        {!loadingGroups && groups.length > 0 ? (
          <div className={styles.workspaceWidgetQuota}>
            <Link
              to="/settings/ai-credits"
              className={styles.aiCreditHistoryLink}
            >
              {t("ai_credits_page.viewHistoryLink")}
            </Link>
            {workspaceWidgetLimits ? (
              <Tooltip
                title={t("welcome.widgetLimitTooltip", {
                  max: workspaceWidgetLimits.max_widgets,
                })}
              >
                <span className={styles.workspaceWidgetCount}>
                  {t("welcome.widgetCountLabel", {
                    total: workspaceWidgetLimits.total_widgets,
                    max: workspaceWidgetLimits.max_widgets,
                  })}
                </span>
              </Tooltip>
            ) : (
              <span className={styles.workspaceWidgetCount}>
                {t("welcome.widgetCountCalculating")}
              </span>
            )}
          </div>
        ) : null}
        {!loadingGroups && archivedGroupCount > 0 ? (
          <div className={styles.archivedGroupsFooter}>
            {t("welcome.archivedGroupsFooter", { count: archivedGroupCount })}
            <button
              type="button"
              className={styles.viewArchivedGroupsLink}
              onClick={openArchivedView}
            >
              {t("welcome.viewArchivedGroupsLink")}
            </button>
          </div>
        ) : null}
        </>
        )}
      </div>

      <WelcomeAddGroupModal
        open={isAddGroupModalVisible}
        onClose={() => setIsAddGroupModalVisible(false)}
        groups={groups}
        onCreated={fetchGroupsAndWidgets}
        setWorkspaceLoading={setLoading}
        workspaceOwnerId={workspaceOwnerId}
        currentUserId={user?.uid}
      />

      <WelcomeEditGroupNameModal
        open={isEditGroupNameModalVisible}
        groupId={editingGroupId}
        initialName={editingGroupInitialName}
        groups={groups}
        onClose={handleCloseEditGroupModal}
        onSaved={fetchGroupsAndWidgets}
        setWorkspaceLoading={setLoading}
        workspaceOwnerId={workspaceOwnerId}
        currentUserId={user?.uid}
      />

      <Modal
        title={t("welcome.bulkDeleteGroupsModalTitle")}
        open={bulkDeleteModalOpen}
        onCancel={() => {
          if (bulkDeleteLoading) return;
          setBulkDeleteModalOpen(false);
        }}
        onOk={handleBulkDeleteGroups}
        okText={t("welcome.deleteGroup")}
        cancelText={t("common.cancel")}
        okButtonProps={{ danger: true, loading: bulkDeleteLoading }}
        destroyOnClose
      >
        <p>
          {t("welcome.bulkDeleteGroupsConfirmation", {
            groupCount: selectedBulkDeleteStats.groupCount,
            widgetCount: selectedBulkDeleteStats.widgetCount,
          })}
        </p>
        <div className={styles.bulkDeleteModalWarnings}>
          <p>{t("welcome.deleteGroupWarning")}</p>
          {selectedBulkDeleteStats.widgetCount > 0 ? (
            <p>{t("welcome.deleteGroupWidgetsWarning")}</p>
          ) : null}
          {selectedBulkDeleteStats.widgetCount > 0 ? (
            <p>{t("welcome.deleteGroupAIQuotaWarning")}</p>
          ) : null}
        </div>
      </Modal>
      {/* DateFilterPopUp & Pivot Filter Modal — temporarily hidden
      {showDateFilterPopup && (
        <div ref={dateFilterRef}>
          <DateFilterPopUp
            onChange={(dateString, daysRange) => {
              setChangeDateRange(true);
              if (dateString[0]) {
                updateQParams("since", dateString[0]);
              } else {
                params.delete("since");
              }
              if (dateString[1]) {
                updateQParams("until", dateString[1]);
              } else {
                params.delete("until");
              }
              if (setShowDateFilter) setShowDateFilter(true);
              params.delete("match_date");
              updateQParams("daysRange", daysRange);
              setShowDateFilterPopup(false);
              setSelectedDaysRange(daysRange);
            }}
            close={() => {
              setShowDateFilterPopup(false);
            }}
            selectedDaysRange={selectedDaysRange}
            defaultStartDate={
              queryFilters?.since && queryFilters?.until
                ? queryFilters.since
                : new Date()
            }
            defaultEndDate={
              queryFilters?.since && queryFilters?.until
                ? queryFilters.until
                : new Date()
            }
            searchPeriod={[queryFilters?.since, queryFilters?.until]}
          />
        </div>
      )}

      <Modal
        title={t("welcome.pivotFilterModalTitle")}
        open={showPivotFilterModal}
        onCancel={() => setShowPivotFilterModal(false)}
        destroyOnClose
        footer={[
          <Button key="clear" onClick={clearWelcomePivotFilter}>
            {t("welcome.clearPivotFilter")}
          </Button>,
          <Button key="apply" type="primary" onClick={applyWelcomePivotFilter}>
            {t("welcome.applyPivotFilter")}
          </Button>,
        ]}
      >
        <Spin spinning={pivotCtxLoading}>
          <Space direction="vertical" style={{ width: "100%" }} size="middle">
            <div>
              <div style={{ marginBottom: 8 }}>{t("welcome.selectDashboard")}</div>
              <Select
                showSearch
                optionFilterProp="label"
                placeholder={t("welcome.selectDashboardPlaceholder")}
                style={{ width: "100%" }}
                allowClear
                value={pivotCtxDashboardId ?? undefined}
                onChange={(v) => handlePivotDashboardChange(v ?? null)}
                options={pivotCtxDashboards.map((d) => ({
                  label: d.name,
                  value: d.id,
                }))}
              />
            </div>
            {pivotCtxDashboardId ? (
              <>
                <div>
                  <div style={{ marginBottom: 8 }}>
                    {t("welcome.selectPivotColumn")}
                  </div>
                  <Select
                    style={{ width: "100%" }}
                    placeholder={t("welcome.selectPivotColumn")}
                    allowClear
                    value={pivotCtxColumn ?? undefined}
                    onChange={(c) => {
                      setPivotCtxColumn(c ?? null);
                      setPivotCtxValues([]);
                    }}
                    options={Object.keys(pivotCtxOptions).map((k) => ({
                      label: k,
                      value: k,
                    }))}
                  />
                </div>
                {pivotCtxColumn ? (
                  <div>
                    <div style={{ marginBottom: 8 }}>
                      {t("welcome.selectPivotValues")}
                    </div>
                    <Select
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder={t("welcome.selectPivotValues")}
                      value={pivotCtxValues}
                      onChange={setPivotCtxValues}
                      options={(pivotCtxOptions[pivotCtxColumn] || []).map(
                        (v) => ({
                          label: String(v),
                          value: String(v),
                        }),
                      )}
                    />
                  </div>
                ) : null}
              </>
            ) : null}
          </Space>
        </Spin>
      </Modal>
      */}

      {/* Loom Video Modal */}
      <Modal
        open={isLoomModalVisible}
        onCancel={() => setIsLoomModalVisible(false)}
        footer={null}
        width="80%"
        centered
        destroyOnHidden
        className={styles.videoModal}
      >
        {videoData.videoUrl && (
          <iframe
            src={videoData.videoUrl}
            frameBorder="0"
            allowFullScreen
            style={{ width: "100%", height: "100%" }}
            title="Tutorial Video"
          />
        )}
      </Modal>
    </div>
  );
}

const WelcomePage = ({ match, shared, authenticated, user }) => {
  const { copilotOpen } = useCopilotShell();
  const history = useHistory();
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const dashboardReducer = useSelector((state) => state.DashboardReducer);
  const workspaceContentEditable = useSelector(
    (state) => state.userReducer?.WorkspaceContentEditable === true,
  );
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [showPivotFilterModal, setShowPivotFilterModal] = useState(false);
  const [pivotCtxDashboards, setPivotCtxDashboards] = useState([]);
  const [pivotCtxDashboardId, setPivotCtxDashboardId] = useState(null);
  const [pivotCtxOptions, setPivotCtxOptions] = useState({});
  const [pivotCtxColumn, setPivotCtxColumn] = useState(null);
  const [pivotCtxValues, setPivotCtxValues] = useState([]);
  const [pivotCtxLoading, setPivotCtxLoading] = useState(false);

  const [metricType, setMetricType] = useState("brand");
  const [showMetricConfig, setShowMetricConfig] = useState(false);
  const [showDateFilterPopup, setShowDateFilterPopup] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(true);
  const [changeDateRange, setChangeDateRange] = useState(false);
  const welcomeReviewsDrawerRef = useRef(null);
  const dateFilterRef = useRef();
  const [copyStates, setCopyStates] = useState({});
  const [queryFilters, setQueryFilters] = useState({});
  useEngagementQueryFilterTracking(queryFilters, null, "welcome");
  const [groups, setGroups] = useState([]);
  const [archivedGroupCount, setArchivedGroupCount] = useState(0);
  const [archivedGroups, setArchivedGroups] = useState([]);
  const [loadingArchivedGroups, setLoadingArchivedGroups] = useState(false);
  const [workspaceWidgetLimits, setWorkspaceWidgetLimits] = useState(null);
  const [loadingGroups, setLoadingGroups] = useState(true);
  const [workspaceOwnerId, setWorkspaceOwnerId] = useState(() => {
    const urlOwnerId = readWorkspaceUserIdFromSearch(
      typeof window !== "undefined" ? window.location.search : "",
    );
    return urlOwnerId || null;
  });
  const [workspaceMembers, setWorkspaceMembers] = useState([]);
  const [workspaceMembersLoaded, setWorkspaceMembersLoaded] = useState(false);
  const [canManageMemberWorkspaces, setCanManageMemberWorkspaces] =
    useState(false);
  const effectiveWorkspaceEditable = useMemo(
    () =>
      workspaceContentEditable &&
      (!workspaceOwnerId ||
        workspaceOwnerId === user?.uid ||
        canManageMemberWorkspaces),
    [
      workspaceContentEditable,
      workspaceOwnerId,
      user?.uid,
      canManageMemberWorkspaces,
    ],
  );
  /** Shared poll for all in-progress widgets (one groups/all request per tick). */
  const welcomeWidgetPollTargetsRef = useRef(new Map());
  const welcomeGroupsPollTimerRef = useRef(null);
  const welcomeGroupsPollTickInFlightRef = useRef(false);
  const groupsRequestInflightRef = useRef(null);
  const queryClient = useQueryClient();
  const workspaceOwnerIdRef = useRef(workspaceOwnerId);
  workspaceOwnerIdRef.current = workspaceOwnerId;
  const groupsFetchIdRef = useRef(0);
  const skipWorkspaceOwnerUrlSyncRef = useRef(false);

  useEffect(() => {
    if (!user?.uid) {
      return;
    }
    if (skipWorkspaceOwnerUrlSyncRef.current) {
      skipWorkspaceOwnerUrlSyncRef.current = false;
      return;
    }

    const urlOwnerId = readWorkspaceUserIdFromSearch(location.search);

    if (!urlOwnerId) {
      if (workspaceOwnerId == null) {
        setWorkspaceOwnerId(user.uid);
      }
      return;
    }

    if (urlOwnerId === user.uid) {
      if (workspaceOwnerId !== user.uid) {
        setWorkspaceOwnerId(user.uid);
      }
      return;
    }

    if (!workspaceMembersLoaded) {
      if (workspaceOwnerId !== urlOwnerId) {
        setWorkspaceOwnerId(urlOwnerId);
      }
      return;
    }

    const isValidMember = workspaceMembers.some(
      (member) => member.user_id === urlOwnerId,
    );
    if (isValidMember || canManageMemberWorkspaces) {
      if (workspaceOwnerId !== urlOwnerId) {
        setWorkspaceOwnerId(urlOwnerId);
      }
      return;
    }

    const { groupId: deepLinkGroupId } = readWorkspaceDeepLinkFromSearch(
      location.search,
    );
    if (deepLinkGroupId != null) {
      if (workspaceOwnerId !== urlOwnerId) {
        setWorkspaceOwnerId(urlOwnerId);
      }
      return;
    }

    const params = new URLSearchParams(location.search);
    applyWorkspaceUserIdToSearchParams(params, user.uid, user.uid);
    history.replace({ pathname: location.pathname, search: params.toString() });
    if (workspaceOwnerId !== user.uid) {
      setWorkspaceOwnerId(user.uid);
    }
  }, [
    user?.uid,
    location.search,
    location.pathname,
    workspaceMembers,
    workspaceMembersLoaded,
    canManageMemberWorkspaces,
    workspaceOwnerId,
    history,
  ]);

  const applyWelcomePivotToUrl = (filterObj, dashboardId) => {
    const next = new URLSearchParams(window.location.search);
    next.set("pivotFilter", JSON.stringify(filterObj));
    if (dashboardId != null) next.set("pivotDashboardId", String(dashboardId));
    history.push({ search: next.toString() });
  };

  const clearWelcomePivotFromUrl = () => {
    const next = new URLSearchParams(window.location.search);
    next.delete("pivotFilter");
    next.delete("pivotDashboardId");
    history.push({ search: next.toString() });
  };

  const loadPivotGenerationOptions = async (dashboardId) => {
    if (!dashboardId) {
      setPivotCtxOptions({});
      return;
    }
    setPivotCtxLoading(true);
    try {
      const res = await apiRequest(
        "dashboards/root-cause/pivot-options/generation",
        "POST",
        { dashboard_id: dashboardId },
        true,
      );
      setPivotCtxOptions(
        res?.success && typeof res.success === "object" ? res.success : {},
      );
    } catch (e) {
      console.error("[Welcome] ERROR pivot generation options", e);
      notification.error({
        message: t("common.error"),
        description: t("welcome.pivotOptionsLoadError"),
      });
      setPivotCtxOptions({});
    } finally {
      setPivotCtxLoading(false);
    }
  };

  const openPivotFilterModal = async () => {
    setShowPivotFilterModal(true);
    setPivotCtxLoading(true);
    setPivotCtxColumn(null);
    setPivotCtxValues([]);
    setPivotCtxDashboardId(null);
    setPivotCtxOptions({});
    setPivotCtxDashboards([]);
    try {
      const res = await apiRequest("welcome/brands", "GET");
      const brands = res?.success || [];
      const allBrandIds = brands.map((b) => b.groupId).filter(Boolean);
      if (allBrandIds.length === 0) {
        return;
      }
      const dashRes = await apiRequest(
        "welcome/dashboards",
        "POST",
        { brand_ids: allBrandIds },
        true,
      );
      const dashes = dashRes?.success || [];
      setPivotCtxDashboards(dashes);
      const savedDashIdRaw = new URLSearchParams(window.location.search).get(
        "pivotDashboardId",
      );
      const savedDashId = savedDashIdRaw ? parseInt(savedDashIdRaw, 10) : null;
      const validSaved =
        savedDashId &&
        !Number.isNaN(savedDashId) &&
        dashes.some((d) => d.id === savedDashId);
      if (validSaved) {
        setPivotCtxDashboardId(savedDashId);
        await loadPivotGenerationOptions(savedDashId);
      }
      const raw = new URLSearchParams(window.location.search).get("pivotFilter");
      if (raw) {
        try {
          const obj = JSON.parse(raw);
          const col = Object.keys(obj)[0];
          if (col) {
            setPivotCtxColumn(col);
            const vals = obj[col];
            if (Array.isArray(vals))
              setPivotCtxValues(vals.map((v) => String(v)));
            else if (vals != null) setPivotCtxValues([String(vals)]);
          }
        } catch (e) {
          console.warn("[Welcome] WARN invalid pivotFilter in URL", e);
        }
      }
    } catch (e) {
      console.error("[Welcome] ERROR pivot modal open", e);
      notification.error({
        message: t("common.error"),
        description: t("welcome.pivotModalOpenError"),
      });
    } finally {
      setPivotCtxLoading(false);
    }
  };

  const handlePivotDashboardChange = (dashId) => {
    setPivotCtxDashboardId(dashId);
    setPivotCtxColumn(null);
    setPivotCtxValues([]);
    if (dashId) loadPivotGenerationOptions(dashId);
    else setPivotCtxOptions({});
  };

  const applyWelcomePivotFilter = () => {
    if (!pivotCtxColumn || !pivotCtxValues?.length) {
      message.warning(t("welcome.pivotSelectColumnAndValues"));
      return;
    }
    if (!pivotCtxDashboardId) {
      message.warning(t("welcome.pivotSelectDashboardFirst"));
      return;
    }
    applyWelcomePivotToUrl({ [pivotCtxColumn]: pivotCtxValues }, pivotCtxDashboardId);
    setShowPivotFilterModal(false);
    message.success(t("welcome.pivotApplied"));
  };

  const clearWelcomePivotFilter = () => {
    clearWelcomePivotFromUrl();
    setShowPivotFilterModal(false);
    message.info(t("welcome.pivotCleared"));
  };

  const rangePresets = {
    last24: t("filter.15"),
    last7d: t("filter.16"),
    last14d: t("filter.17"),
    last30d: t("filter.18"),
    last90d: t("filter.19"),
    allTime: t("filter.21"),
  };
  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const values = Array.from(searchParams);
    const queryObj = values.reduce((acc, [key, val]) => {
      if (
        key === "keyword" ||
        key === "pivotFilter" ||
        key === "top_topics" ||
        key === "level1Selection" ||
        key === "level2Selection" ||
        key === "level1OfSelected" ||
        key === "level2OfSelected" ||
        key === "decisionFilter" ||
        key === "child_others" ||
        key === "parent_others" ||
        key === "hotterm"
      ) {
        try {
          acc[key] = JSON.parse(val);
        } catch {
          acc[key] = val;
        }
      } else {
        acc[key] = val;
      }
      return acc;
    }, {});
    setQueryFilters(queryObj);
  }, [location.search]);

  const updateQParams = (attr, val) => {
    params.delete(attr);
    params.append(attr, val);
    history.push({ search: params.toString() });
  };
  const [selectedDaysRange, setSelectedDaysRange] = useState(
    params.get("daysRange") || "last7d",
  );

  // ============================================
  // ORIGINAL: Group and Widget Fetching Logic
  // ============================================
  // const getGroups = async () => {
  //   try {
  //     const response = await apiRequest("welcome/groups/all", "GET");
  //     return response?.success;
  //   } catch (error) {
  //     console.error("Error fetching groups:", error);
  //     notification.error({
  //       message: "Error",
  //       description: "Failed to fetch groups. Please try again later.",
  //     });
  //     return [];
  //   }
  // };
  // // Widget Management APIs
  // const getWidgets = async (groupId) => {
  //   try {
  //     const payload = {
  //       widget_group_id: groupId,
  //     };
  //     if (params.get("since")) {
  //       payload.since = params.get("since");
  //     } else if (params.get("DaysRange") !== "AllTime") {
  //       payload.since = dayjs()
  //         .subtract(6, "days")
  //         .format("YYYY-MM-DD");
  //     }

  //     if (params.get("until")) {
  //       payload.until = params.get("until");
  //     } else if (params.get("DaysRange") !== "AllTime") {
  //       payload.until = dayjs().format("YYYY-MM-DD");
  //     }

  //     const response = await apiRequest(
  //       "welcome/widgets/load",
  //       "POST",
  //       payload,
  //       true,
  //     );
  //     return response;
  //   } catch (error) {
  //     console.error("Error fetching widgets:", error);
  //     notification.error({
  //       message: "Error",
  //       description: "Failed to fetch widgets. Please try again later.",
  //     });
  //     return [];
  //   }
  // };
  // // Fetch groups and their widgets
  // const fetchGroupsAndWidgets = async () => {
  //   try {
  //     setLoadingGroups(true);

  //     // Fetch groups
  //     let groupsData = await getGroups();
  //     if (groupsData && Array.isArray(groupsData)) {
  //       // Fetch widgets for each group
  //       groupsData = groupsData.sort((a, b) => a.order - b.order);
  //       const groupsWithWidgets = await Promise.all(
  //         groupsData.map(async (group) => {
  //           try {
  //             const payload = {
  //               widget_group_id: group.id,
  //             };
  //             if (params.get("since")) {
  //               payload.since = params.get("since");
  //             } else if (params.get("DaysRange") !== "AllTime") {
  //               payload.since = dayjs()
  //                 .subtract(6, "days")
  //                 .format("YYYY-MM-DD");
  //             }

  //             if (params.get("until")) {
  //               payload.until = params.get("until");
  //             } else if (params.get("DaysRange") !== "AllTime") {
  //               payload.until = dayjs().format("YYYY-MM-DD");
  //             }
  //             const widgetsResponse = await apiRequest(
  //               "welcome/widgets/load",
  //               "POST",
  //               payload,
  //               true,
  //             );

  //             const sortedWidgets = (widgetsResponse?.success || []).sort(
  //               (a, b) => a.order - b.order,
  //             );

  //             return {
  //               ...group,
  //               widgets: sortedWidgets,
  //             };
  //           } catch (error) {
  //             console.error(
  //               `Error fetching widgets for group ${group.id}:`,
  //               error,
  //             );
  //             return {
  //               ...group,
  //               widgets: [],
  //             };
  //           }
  //         }),
  //       );

  //       setGroups(groupsWithWidgets);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching groups:", error);
  //     notification.error({
  //       message: t("common.error"),
  //       description: t("welcome.errorFetchingGroups"),
  //     });
  //   } finally {
  //     setLoadingGroups(false);
  //   }
  // };

  // ============================================
  // NEW: Optimized Group and Widget Loading
  // ============================================
  // Step 1: Fetch all groups with their widgets (single API call)
  // API Response Format:
  // {
  //   "success": [
  //     {
  //       "id": 1,
  //       "name": "Group Name",
  //       "widgets": [
  //         { "id": 1, "name": "Widget 1", "status": 1|2|3|4 }  // job: pending|in_progress|completed|failed
  //       ]
  //     }
  //   ]
  // }
  const getGroups = async (ownerIdOverride, { skipPrefetch = false, dedupe = true } = {}) => {
    if (dedupe && groupsRequestInflightRef.current) {
      return groupsRequestInflightRef.current;
    }

    const run = async () => {
      try {
        const ownerId = getEffectiveWorkspaceUserId(
          ownerIdOverride ?? workspaceOwnerIdRef.current,
          user?.uid,
        );
        const response = await apiRequest(
          buildWorkspaceGroupsUrl(ownerId, user?.uid, { skipPrefetch }),
          "GET",
        );
        if (!response || response.cancel) {
          return { groups: [], workspaceLimits: null, failed: true };
        }
        const groupsData = Array.isArray(response?.success) ? response.success : [];
        const workspaceLimits = response?.workspace_limits ?? null;
        if (typeof response?.archived_group_count === "number") {
          setArchivedGroupCount(response.archived_group_count);
        }

        // Transform API response to match our UI requirements (job status integers)
        const groups = groupsData.map((group) => ({
          ...group,
          widgets: sortWelcomeGroupWidgets(
            (group.widgets || []).map((widget) => ({
              ...widget,
              status: mapWelcomeWidgetJobStatusToUi(widget.status),
            })),
          ),
        }));
        return { groups, workspaceLimits, failed: false };
      } catch (error) {
        console.error("Error fetching groups:", error);
        return { groups: [], workspaceLimits: null, failed: true };
      }
    };

    const promise = run();
    if (dedupe) {
      groupsRequestInflightRef.current = promise;
      promise.finally(() => {
        if (groupsRequestInflightRef.current === promise) {
          groupsRequestInflightRef.current = null;
        }
      });
    }
    return promise;
  };

  const fetchArchivedGroups = useCallback(async () => {
    try {
      setLoadingArchivedGroups(true);
      const ownerId = getEffectiveWorkspaceUserId(
        workspaceOwnerIdRef.current,
        user?.uid,
      );
      const response = await apiRequest(
        buildWorkspaceArchivedGroupsUrl(ownerId, user?.uid),
        "GET",
      );
      const groupsData = Array.isArray(response?.success) ? response.success : [];
      const groups = groupsData.map((group) => ({
        ...group,
        widgets: sortWelcomeGroupWidgets(
          (group.widgets || []).map((widget) => ({
            ...widget,
            status: mapWelcomeWidgetJobStatusToUi(widget.status),
          })),
        ),
      }));
      setArchivedGroups(groups);
    } catch (error) {
      console.error("Error fetching archived groups:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchingArchivedGroups"),
      });
      setArchivedGroups([]);
    } finally {
      setLoadingArchivedGroups(false);
    }
  }, [user?.uid, t]);

  const stopWelcomeWidgetStatusPoll = useCallback((widgetId) => {
    welcomeWidgetPollTargetsRef.current.delete(widgetId);
    if (
      welcomeWidgetPollTargetsRef.current.size === 0 &&
      welcomeGroupsPollTimerRef.current != null
    ) {
      clearInterval(welcomeGroupsPollTimerRef.current);
      welcomeGroupsPollTimerRef.current = null;
    }
  }, []);

  const runWelcomeGroupsPollTickRef = useRef(async () => {});

  runWelcomeGroupsPollTickRef.current = async () => {
    if (welcomeGroupsPollTickInFlightRef.current) return;
    if (welcomeWidgetPollTargetsRef.current.size === 0) return;

    welcomeGroupsPollTickInFlightRef.current = true;
    try {
      const { groups: freshGroups, workspaceLimits, failed } = await getGroups(
        undefined,
        { skipPrefetch: true },
      );
      if (failed || !Array.isArray(freshGroups) || freshGroups.length === 0) {
        return;
      }
      if (workspaceLimits) {
        setWorkspaceWidgetLimits(workspaceLimits);
      }

      const sorted = [...freshGroups].sort(
        (a, b) => (a.order || 0) - (b.order || 0),
      );
      const targets = Array.from(welcomeWidgetPollTargetsRef.current.entries());

      for (const [widgetId, groupId] of targets) {
        let foundGroupId = null;
        let foundWidget = null;
        for (const g of sorted) {
          const w = (g.widgets || []).find((x) => x.id === widgetId);
          if (w) {
            foundGroupId = g.id;
            foundWidget = w;
            break;
          }
        }

        if (!foundWidget) {
          stopWelcomeWidgetStatusPoll(widgetId);
          continue;
        }

        const uiStatus = foundWidget.status;

        if (uiStatus === "loading") {
          setGroups((prevGroups) =>
            prevGroups.map((group) => {
              if (group.id !== foundGroupId) return group;
              return {
                ...group,
                widgets: (group.widgets || []).map((w) =>
                  w.id === widgetId ? { ...w, ...foundWidget } : w,
                ),
              };
            }),
          );
          continue;
        }

        if (uiStatus === "ready" || uiStatus === "error") {
          stopWelcomeWidgetStatusPoll(widgetId);
          setGroups((prevGroups) =>
            prevGroups.map((group) => {
              if (group.id !== foundGroupId) return group;
              return {
                ...group,
                widgets: (group.widgets || []).map((w) =>
                  w.id === widgetId ? { ...w, ...foundWidget } : w,
                ),
              };
            }),
          );
          if (uiStatus === "ready" && user?.uid) {
            const effectiveOwnerId = getEffectiveWorkspaceUserId(
              workspaceOwnerIdRef.current,
              user.uid,
            );
            void queryClient.invalidateQueries({
              queryKey: [
                ...welcomeWidgetKeys.all(effectiveOwnerId),
                "main",
                Number(widgetId),
              ],
            });
          }
        }
      }
    } catch (error) {
      console.warn("[Welcome] widget status poll failed", error);
    } finally {
      welcomeGroupsPollTickInFlightRef.current = false;
    }
  };

  const ensureWelcomeGroupsPollRunning = useCallback(() => {
    if (welcomeGroupsPollTimerRef.current != null) return;
    const POLL_MS = 10000;
    welcomeGroupsPollTimerRef.current = setInterval(() => {
      void runWelcomeGroupsPollTickRef.current();
    }, POLL_MS);
    void runWelcomeGroupsPollTickRef.current();
  }, []);

  // Step 2: Poll widget status until completed (in-progress jobs: welcome/groups/all)
  const pollWidgetStatus = useCallback((groupId, widget) => {
    if (widget.status !== "loading") {
      return;
    }
    welcomeWidgetPollTargetsRef.current.set(widget.id, groupId);
    ensureWelcomeGroupsPollRunning();
  }, [ensureWelcomeGroupsPollRunning]);

  const mergeWelcomeDeepLinkGroup = async (groupsData) => {
    const { groupId, widgetId } = readWorkspaceDeepLinkFromSearch(location.search);
    if (groupId == null && widgetId == null) {
      return groupsData;
    }

    const groupPresent = (id) =>
      (groupsData || []).some((g) =>
        workspaceGroupIdsMatch(g.id, id),
      );
    const widgetPresent = (wid) =>
      (groupsData || []).some((g) =>
        (g.widgets || []).some((w) => Number(w.id) === Number(wid)),
      );

    if (
      groupId != null &&
      groupPresent(groupId) &&
      (widgetId == null || widgetPresent(widgetId))
    ) {
      return groupsData;
    }
    if (widgetId != null && widgetPresent(widgetId)) {
      return groupsData;
    }

    const ownerId = getEffectiveWorkspaceUserId(
      workspaceOwnerIdRef.current,
      user?.uid,
    );
    const params = new URLSearchParams();
    if (groupId != null) params.set("group_id", String(groupId));
    if (widgetId != null) params.set("widget_id", String(widgetId));
    if (ownerId && ownerId !== user?.uid) {
      params.set("workspace_user_id", ownerId);
    }

    try {
      const response = await apiRequest(
        `welcome/deep-link/group?${params.toString()}`,
        "GET",
      );
      const extra = response?.success?.group;
      if (!extra?.id) {
        return groupsData;
      }
      const transformed = {
        ...extra,
        widgets: sortWelcomeGroupWidgets(
          (extra.widgets || []).map((widget) => ({
            ...widget,
            status: mapWelcomeWidgetJobStatusToUi(widget.status),
          })),
        ),
      };
      if (groupPresent(transformed.id)) {
        return (groupsData || []).map((g) =>
          workspaceGroupIdsMatch(g.id, transformed.id) ? transformed : g,
        );
      }
      return [...(groupsData || []), transformed].sort(
        (a, b) => (a.order || 0) - (b.order || 0) || Number(a.id) - Number(b.id),
      );
    } catch (error) {
      console.warn("[Welcome] deep-link group hydrate failed", error);
      return groupsData;
    }
  };

  // Step 3: Simplified loading - Groups already contain widgets, just poll for in-progress ones
  const fetchGroupsAndWidgets = async () => {
    const fetchId = ++groupsFetchIdRef.current;
    try {
      setLoadingGroups(true);

      // ============================================
      // STEP 1: Load all groups with their widgets (SINGLE API CALL)
      // ============================================
      // The API now returns groups with widgets already populated
      // Widget job status from API: 1–4 (see mapWelcomeWidgetJobStatusToUi)
      // We transform it to: 'ready' | 'loading'
      let { groups: groupsData, workspaceLimits, failed } = await getGroups();
      if (fetchId !== groupsFetchIdRef.current) {
        return;
      }
      if (failed) {
        notification.error({
          message: t("common.error"),
          description: t("welcome.errorFetchingGroups"),
        });
        return;
      }
      if (!groupsData || !Array.isArray(groupsData)) {
        groupsData = [];
      }
      if (workspaceLimits) {
        setWorkspaceWidgetLimits(workspaceLimits);
      }

      // Sort groups by order if available
      groupsData = groupsData.sort((a, b) => (a.order || 0) - (b.order || 0));

      groupsData = await mergeWelcomeDeepLinkGroup(groupsData);

      // Set groups with widgets immediately (no waiting!)
      setGroups(groupsData);
      console.log("✓ Groups and widgets loaded:", groupsData);

      // Widget status polling runs only for the active workspace group (see
      // WelcomeGroupWidgets) so we do not hit groups/all once per loading widget
      // across every auto-report group on the page.
    } catch (error) {
      if (fetchId !== groupsFetchIdRef.current) {
        return;
      }
      console.error("Error fetching groups:", error);
      notification.error({
        message: t("common.error"),
        description: t("welcome.errorFetchingGroups"),
      });
    } finally {
      if (fetchId === groupsFetchIdRef.current) {
        setLoadingGroups(false);
      }
    }
  };

  useEffect(() => {
    if (authenticated === UNLOGGED) {
      history.push("/");
      return;
    }
    trackWelcomePageViewed();
  }, [authenticated, history]);

  useEffect(() => {
    if (authenticated === UNLOGGED || !user?.uid) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const response = await apiRequest("welcome/workspace/members", "GET");
        if (cancelled) return;
        const members = Array.isArray(response?.success) ? response.success : [];
        setWorkspaceMembers(members);
        setCanManageMemberWorkspaces(
          response?.can_manage_member_workspaces === true,
        );
      } catch (error) {
        console.error("Error fetching workspace members:", error);
      } finally {
        if (!cancelled) {
          setWorkspaceMembersLoaded(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authenticated, user?.uid]);

  const handleWorkspaceOwnerChange = useCallback(
    (nextOwnerId) => {
      if (!nextOwnerId || nextOwnerId === workspaceOwnerId) {
        return;
      }
      const effectiveId = getEffectiveWorkspaceUserId(nextOwnerId, user?.uid);
      queryClient.removeQueries({
        queryKey: welcomeWidgetKeys.all(effectiveId),
      });
      if (workspaceOwnerId && workspaceOwnerId !== effectiveId) {
        queryClient.removeQueries({
          queryKey: welcomeWidgetKeys.all(
            getEffectiveWorkspaceUserId(workspaceOwnerId, user?.uid),
          ),
        });
      }
      skipWorkspaceOwnerUrlSyncRef.current = true;
      const params = new URLSearchParams(location.search);
      applyWorkspaceUserIdToSearchParams(params, nextOwnerId, user?.uid);
      history.replace({ pathname: location.pathname, search: params.toString() });
      setLoadingGroups(true);
      setWorkspaceOwnerId(nextOwnerId);
    },
    [
      workspaceOwnerId,
      user?.uid,
      queryClient,
      location.search,
      location.pathname,
      history,
    ],
  );

  const deepLinkWorkspaceOwnerResolvedRef = useRef(null);

  useEffect(() => {
    deepLinkWorkspaceOwnerResolvedRef.current = null;
  }, [location.search]);

  useEffect(() => {
    if (authenticated === UNLOGGED || !user?.uid) {
      return undefined;
    }
    const { groupId, widgetId } = readWorkspaceDeepLinkFromSearch(location.search);
    if (groupId == null && widgetId == null) {
      return undefined;
    }
    const resolveKey = `${groupId ?? ""}:${widgetId ?? ""}:${readWorkspaceUserIdFromSearch(location.search) || ""}`;
    if (deepLinkWorkspaceOwnerResolvedRef.current === resolveKey) {
      return undefined;
    }

    let cancelled = false;
    (async () => {
      try {
        const params = new URLSearchParams();
        if (groupId != null) params.set("group_id", String(groupId));
        if (widgetId != null) params.set("widget_id", String(widgetId));
        const urlOwnerId = readWorkspaceUserIdFromSearch(location.search);
        if (urlOwnerId) params.set("workspace_user_id", urlOwnerId);
        const response = await apiRequest(
          `welcome/deep-link/resolve?${params.toString()}`,
          "GET",
        );
        if (cancelled) return;
        deepLinkWorkspaceOwnerResolvedRef.current = resolveKey;
        const resolved = response?.success;
        if (!resolved?.found || !resolved?.workspace_user_id) {
          return;
        }
        const resolvedOwnerId = String(resolved.workspace_user_id).trim();
        if (!resolvedOwnerId || resolvedOwnerId === workspaceOwnerId) {
          return;
        }
        handleWorkspaceOwnerChange(resolvedOwnerId);
      } catch (error) {
        console.warn("[Welcome] deep-link workspace resolve failed", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    authenticated,
    user?.uid,
    location.search,
    workspaceOwnerId,
    handleWorkspaceOwnerChange,
  ]);

  useEffect(() => {
    if (authenticated === UNLOGGED || workspaceOwnerId == null) {
      return;
    }
    fetchGroupsAndWidgets();
  }, [location.search, workspaceOwnerId]);

  useEffect(() => {
    return () => {
      if (welcomeGroupsPollTimerRef.current != null) {
        clearInterval(welcomeGroupsPollTimerRef.current);
        welcomeGroupsPollTimerRef.current = null;
      }
      welcomeWidgetPollTargetsRef.current.clear();
    };
  }, []);

  const handleMetricTypeSelect = (value) => {
    setMetricType(value);
    setShowMetricConfig(true);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Content className={styles.mainContent}>
        <WelcomeReviewsDrawerRefContext.Provider value={welcomeReviewsDrawerRef}>
          <WelcomePdfExportProvider
            groups={groups}
            archivedGroups={archivedGroups}
            loadingGroups={loadingGroups}
            loadingArchivedGroups={loadingArchivedGroups}
            dashboardReducer={dashboardReducer}
            workspaceOwnerId={workspaceOwnerId ?? user?.uid}
            currentUserId={user?.uid}
          >
            <WelcomeWorkspaceDashboard
              groups={groups}
              setGroups={setGroups}
              workspaceWidgetLimits={workspaceWidgetLimits}
              setWorkspaceWidgetLimits={setWorkspaceWidgetLimits}
              loadingGroups={loadingGroups}
              loading={loading}
              setLoading={setLoading}
              fetchGroupsAndWidgets={fetchGroupsAndWidgets}
              pollWidgetStatus={pollWidgetStatus}
              stopWelcomeWidgetStatusPoll={stopWelcomeWidgetStatusPoll}
              queryFilters={queryFilters}
              user={user}
              workspaceOwnerId={workspaceOwnerId ?? user?.uid}
              workspaceMembers={workspaceMembers}
              canManageMemberWorkspaces={canManageMemberWorkspaces}
              workspaceContentEditable={effectiveWorkspaceEditable}
              onWorkspaceOwnerChange={handleWorkspaceOwnerChange}
              archivedGroupCount={archivedGroupCount}
              setArchivedGroupCount={setArchivedGroupCount}
              archivedGroups={archivedGroups}
              setArchivedGroups={setArchivedGroups}
              loadingArchivedGroups={loadingArchivedGroups}
              fetchArchivedGroups={fetchArchivedGroups}
            />
          </WelcomePdfExportProvider>
          <WelcomeReviewsDrawerHost ref={welcomeReviewsDrawerRef} />
        </WelcomeReviewsDrawerRefContext.Provider>
      </Content>
    </Layout>
  );
};

export default WelcomePage;

export { parseTopicLibIdFromWidgetTab };
export { collectGenaiItemReviewIds } from "pages/Welcome/welcomeGenaiReviewIds";
